(function () {
  'use strict';

  angular.module('zoomerRestaurant', [
    'angularMoment',
    'angular-ladda',
    'ngRaven',
    'ionic',
    'ionic.service.core',
    'ngCordova',
    'ngMessages',
    'ngPinchZoom',
    'pusher-angular',
    'restangular',
    'toastr',
    'zComponents',
    'zComponents.paginatedRestangular', // Ilya: This restangular needs to be above autocomplete (see PR #831)
    'zComponents.preventDoubleClick',
    'zoomerRestaurant.autoComplete',
    'zoomerRestaurant.driverFeedback',
    'zoomerRestaurant.externalOrders',
    'zoomerRestaurant.login',
    'zoomerRestaurant.ordersQueue',
    'zoomerRestaurant.rbtArbitratorV1',
    'zoomerRestaurant.receipts',
    'zoomerRestaurant.support',
    'zComponents.paginatedRestangular' // Ilya: This restangular needs to be below receipts because the binding is lost if any operations are performed direcly with restangular receips model (see PR #814)
  ]);

}());

(function () {
  'use strict';

  var run = angular.noop;
  run.$inject = [ 'AutoComplete', 'Geocoder', 'Place' ];

  angular.module('zoomerRestaurant.autoComplete', [])
    .run(run);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.driverFeedback', []);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.externalOrders', []);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.login', []);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.ordersQueue', []);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.rbtArbitratorV1', []);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.receipts', []);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.support', []);
}());

(function () {
  'use strict';

  /** @ngInject */
  function config($httpProvider, laddaProvider, RestangularProvider, $ionicConfigProvider, Config, $animateProvider, $compileProvider, toastrConfig, $fullStoryProvider, paginatedRestangularProvider) {
    if (Config.ENV === 'production' && location.href.indexOf('file://') < 0) {
      // TODO: This causes the ui to not load properly. 
      // https://www.dropbox.com/s/1zfrxgtboezkxzp/Screenshot%202017-04-20%2010.20.26.png?dl=0
      // $fullStoryProvider.setToken('11nT');
    }

    paginatedRestangularProvider.setPerPage(50);
    toastrConfig.allowHtml = true;
    toastrConfig.positionClass = 'toast-bottom-left';

    $compileProvider.debugInfoEnabled(Config.ANGULAR_DEBUG_INFO);

    $ionicConfigProvider.views.transition('android');

    RestangularProvider.setBaseUrl(Config.API_BASEURL);
    RestangularProvider.setFullResponse(true);
    RestangularProvider.setRestangularFields({
      options: '$options'
    });
    $httpProvider.interceptors.push('authInterceptor');

    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);

    laddaProvider.setOption({
      style: 'slide-down'
    });
  }

  angular.module('zoomerRestaurant')
    .config(config);

}());

(function () {
  'use strict';

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, Config) {
    /**
     * There is an issue with angular ui-router whereby triggering preventDefault()
     * in the $rootScope.$on('$stateChangeStart') callback (see ApplicationCtrl.js)
     * caused an explosion of $digest cycles.
     *
     * See: https://github.com/angular-ui/ui-router/issues/1240
     */
    $urlRouterProvider.otherwise(function ($injector) {
      var session = $injector.get('Session'),
        state = $injector.get('$state'),
        goTo = session.isLoggedIn() ? Config.ROOT_LOGGED_IN_STATE : Config.ROOT_LOGGED_OUT_STATE;
      return state.go(goTo);
    });

    function bindView(params) {
      return {
        'menu-content': params
      };
    }

    var states = {
      'app': {
        url: '/app',
        abstract: true,
        templateUrl: 'app/views/menu.html',
        controller: 'MenuCtrl as MenuCtrl'
      },
      'app.new-order': {
        url: '/orders/new',
        cache: false,
        title: 'New order',
        params: {
          cached: null
        },
        views: bindView({
          templateUrl: 'app/views/orders/edit.html',
          controller: 'EditOrderCtrl as EditCtrl'
        })
      },
      'app.edit-order': {
        url: '/orders/:orderId/edit',
        cache: false,
        title: 'Edit Order',
        views: bindView({
          templateUrl: 'app/views/orders/edit.html',
          controller: 'EditOrderCtrl as EditCtrl'
        })
      },
      'app.view-order': {
        url: '/orders/:orderId/view',
        cache: false,
        views: bindView({
          templateUrl: 'app/views/orders/view.html',
          controller: 'ViewOrderCtrl as ViewOrderCtrl'
        })
      },
      'app.new-reorder': {
        url: '/orders/:orderId/reorder/new',
        cache: false,
        title: 'Re-order',
        views: bindView({
          templateUrl: 'app/views/orders/reorder.html',
          controller: 'ReorderCtrl as ReorderCtrl'
        })
      },
      'app.edit-reorder': {
        url: '/orders/:orderId/reorder/edit',
        cache: false,
        title: 'Edit re-order',
        views: bindView({
          templateUrl: 'app/views/orders/reorder.html',
          controller: 'ReorderCtrl as ReorderCtrl'
        })
      },
      'app.new-specialorder': {
        url: '/orders/special/new',
        cache: false,
        title: 'New Special Order',
        params: {
          cached: null,
          setAsLargeOrder: false
        },
        views: bindView({
          templateUrl: 'app/views/orders/edit-specialorder.html',
          controller: 'EditOrderCtrl as EditCtrl'
        })
      },
      'app.edit-specialorder': {
        url: '/orders/special/:orderId/edit',
        cache: false,
        title: 'Edit Special Order',
        params: {
          cached: null,
          setAsLargeOrder: false
        },
        views: bindView({
          templateUrl: 'app/views/orders/edit-specialorder.html',
          controller: 'EditOrderCtrl as EditCtrl'
        })
      },
      'app.dropoffs': {
        url: '/dropoffs',
        views: bindView({
          templateUrl: 'app/views/dropoffs/index.html',
          controller: 'OrdersQueueCtrl as DropoffsCtrl'
        })
      },
      'app.history': {
        url: '/history',
        views: bindView({
          templateUrl: 'app/views/history/index.html',
          controller: 'HistoryCtrl as HistoryCtrl'
        })
      },
      'app.receipts': {
        url: '/receipts',
        views: bindView({
          templateUrl: 'app/views/receipts/index.html',
          controller: 'ReceiptsCtrl as ReceiptsCtrl'
        })
      },
      'app.settings': {
        url:'/settings',
        views: bindView({
          templateUrl: 'app/views/settings/index.html',
          controller: 'SettingsCtrl as SettingsCtrl'
        })
      },
      'app.menu-list': {
        url:'/menu-list/:eatstreetId',
        views: bindView({
          templateUrl: 'app/views/menu-list/index.html',
          controller: 'MenuListCtrl as MenuListCtrl'
        })
      }
    };

    angular.forEach(states, function (state, key) {
      $stateProvider.state(key, state);
    });
  }

  angular.module('zoomerRestaurant')
    .config(routeConfig);

}());

(function () {
  'use strict';

  /** @ngInject */
  function run($window, $rootScope, $cordovaStatusbar, Restangular, Config, Device, Features, InAppMessages, IonicDeploy, offline, sentry, audioAlert) {
    offline.init();
    $rootScope.device = Device;
    $rootScope.deployChannel = Config.IONIC_DEPLOY_CHANNEL;
    $rootScope.zoomerAppVersion = Config.ZOOMER_APP_VERSION;
    Features.init();
    sentry.init();
    audioAlert.init();

    IonicDeploy.then(function () {
      var ionic = $window.ionic,
        cordova = $window.cordova;

      ionic.Platform.fullScreen(true, true);

      if (cordova) {
        if (!!cordova.plugins && !!cordova.plugins.backgroundMode) {
          cordova.plugins.backgroundMode.enable();
        }

        Device.init();

        $cordovaStatusbar.overlaysWebView(true);
        $cordovaStatusbar.style(1);
      }
    });

    Restangular.addResponseInterceptor(function(data, operation, what, url, response) {
      InAppMessages.updateIfChanged(response.headers('x-restaurant-in-app-message'));

      // TODO (gil): until we know where the source of truth for subscription issues is, don't alert issues
      // PaymentStatus.updateRestrictOrWarnRestaurant(response.headers('x-restaurant-subscription-status'));
      return data;
    });

  }

  angular.module('zoomerRestaurant')
    .run(run);

}());

(function () {
  'use strict';

  /** @ngInject */
  function AutoCompleteCtrl($document, $element, $scope, $timeout, $window, AutoComplete, Features, Geocoder, Place) {
    var vm = this,
      keys;

    keys = {
      space: 32,
      enter: 13,
      up: 38,
      down: 40
    };

    vm.index = 0;
    vm.loading = false;
    vm.position = {};
    vm.predictions = [];
    vm.previousInput = null;
    vm.toast = null;
    vm.visible = false;

    /**
     * @method getPosition
     */
    vm.getPosition = function () {
      var domEl = $element[0],
        rect = domEl.getBoundingClientRect(),
        docEl = $document[0].documentElement,
        body = $document[0].body,
        scrollTop = $window.pageYOffset || docEl.scrollTop || body.scrollTop,
        scrollLeft = $window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

      return {
        width: rect.width,
        height: rect.height,
        top: rect.top + rect.height + scrollTop,
        left: rect.left + scrollLeft
      };
    };

    /**
     * @method getPositionStyles
     * @return {Object}
     */
    vm.getPositionStyles = function () {
      var position = vm.getPosition(),
        px = 'px';

      return {
        top: position.top + px,
        left: position.left + px,
        width: position.width + px
      };
    };

    /**
     * @method getPredictions
     * @param {String} text
     */
    vm.getPredictions = function (text) {
      if (!text || text === '' || text === vm.previousInput) {
        return text;
      }

      vm.previousInput = text;

      AutoComplete.getPredictions(text).then(function (response) {
        response = response || {};
        vm.predictions = response.predictions || [];
        vm.getPosition();
      });
      return text;
    };

    /**
     * @method getPlace
     * @param {Object} prediction
     */
    vm.getPlace = function (prediction) {
      prediction = prediction || vm.predictions[vm.index] || {};

      Place.get(prediction).then(function (response) {
        response = response || {};
        if (response.status !== 'OK') {
          return;
        }

        if (response.place.scope === 'MAPQUEST') {
          return vm.completed(response.place);
        }

        if (Features.checkEnabled('restaurant_multiple_locations')) {
          vm.geocodePlace(response.place, prediction);
        } else {
          vm.completed(response.place);
        }
      });
    };

    /**
     * @method geocodePlace
     * @param {Object} place
     * @param {Object} prediction
     */
    vm.geocodePlace = function (place, prediction) {
      Geocoder.geocode(place, prediction).then(function (response) {
        response = response || {};
        vm.completed(place, response.locations);
      });
    };

    /**
     * @method completed
     * @param {Object} place
     * @param {Array} multipleLocations
     */
    vm.completed = function (place, multipleLocations) {
      $scope.$evalAsync(function () {
        vm.reset();

        $scope.onComplete({
          place: place,
          multipleLocations: multipleLocations || []
        });
      });
    };

    /**
     * @method isVisible
     * @return {Boolean}
     */
    vm.isVisible = function () {
      return vm.visible && vm.predictions.length > 0;
    };

    /**
     * @method parseArrows
     * @param {Number} keyCode
     */
    vm.parseArrows = function (keyCode) {
      var predictionsLength = vm.predictions.length || 0;
      if (!predictionsLength) {
        return;
      }

      if (keyCode === keys.up && vm.index > 0) {
        vm.index -= 1;
        return;
      }

      if (keyCode === keys.down && vm.index < (predictionsLength - 1)) {
        vm.index += 1;
      }
    };

    /**
     * @method onKeyUp
     * @param {Object} e
     */
    vm.onKeyUp = function (e) {
      function onKeyUp() {
        var keyCode = e.keyCode;

        if (keyCode === keys.enter) {
          e.preventDefault();
          e.stopPropagation();
          return vm.getPlace();
        }

        if (keyCode === keys.up || keyCode === keys.down) {
          return vm.parseArrows(keyCode);
        }
      }

      $scope.$evalAsync(onKeyUp);
    };

    /**
     * @method onKeyDown
     * @param {Object} e
     */
    vm.onKeyDown = function (e) {
      if ((e || {}).keyCode === keys.enter) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    /**
     * @method onBlur
     */
    vm.onBlur = function () {
      $timeout(function () {
        vm.visible = false;
      }, 300);
    };

    /**
     * @method onFocus
     */
    vm.onFocus = function () {
      $timeout(function () {
        vm.visible = true;
      }, 0);
    };

    /**
     * @method reset
     */
    vm.reset = function () {
      vm.index = 0;
      vm.position = {};
      vm.predictions = [];
      vm.previousInput = null;
      vm.visible = false;
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      var keyup = 'keyup',
        keydown = 'keydown',
        blur = 'blur',
        focus = 'focus';

      $element
        .unbind(keyup)
        .bind(keyup, vm.onKeyUp);
      $element
        .unbind(keydown)
        .bind(keydown, vm.onKeyDown);
      $element
        .unbind(blur)
        .bind(blur, vm.onBlur);
      $element
        .unbind(focus)
        .bind(focus, vm.onFocus);

    };

  }

  angular.module('zoomerRestaurant')
    .controller('AutoCompleteCtrl', AutoCompleteCtrl);

}());

/* global angular:false */

(function () {
  'use strict';

  /** @ngInject */
  function autoComplete($compile, $document) {

    function link(scope, element, attributes, vm) {
      var controller = scope.autoCompleteVm,
        drawerElement = angular.element('<div auto-complete-drawer></div>'),
        body = angular.element($document[0].body),
        destroyPromise,
        drawer;

      drawer = $compile(drawerElement)(scope);
      body.append(drawer);

      vm.$parsers.push(controller.getPredictions);

      destroyPromise = scope.$on('$destroy', function () {
        destroyPromise();
        drawerElement.remove();
      });
    }

    return {
      controller: 'AutoCompleteCtrl as autoCompleteVm',
      link: link,
      require: '^ngModel',
      scope: {
        onComplete: '&'
      }
    };
  }

  angular.module('zoomerRestaurant')
    .directive('autoComplete', autoComplete);
}());

(function () {
  'use strict';

  /** @ngInject */
  function AutoComplete($log, $q, $rootScope, Config, GoogleMaps, LogEntries, MapQuestAutoComplete, Restaurant, googleMapsResponseStatuses) {
    var deferred = $q.defer(),
      factory;

    factory = {
      maps: null,
      service: null,
      location: null,
      error: false,
      loaded: false,

      /**
       * @method initForRestaurant
       * @param {Object} e
       * @param {Object} maps
       */
      initForRestaurant: function (e, maps) {
        factory.maps = maps;
        factory.loaded = Boolean(maps);

        if (!factory.service && factory.loaded) {
          factory.service = new maps.places.AutocompleteService();
          factory.setLocation();
          deferred.resolve(factory.service);
        }

        return factory;
      },

      /**
       * @method getLocation
       * @return {Object}
       */
      setLocation: function () {
        var restaurant = Restaurant.info || {},
          latitude = restaurant.latitude || restaurant.lat,
          longitude = restaurant.longitude || restaurant.long || restaurant.lon;

        factory.location = new factory.maps.LatLng(latitude, longitude);
      },

      /**
       * @method getOptions
       * @param {String} text
       * @return {Object}
       */
      getOptions: function (text) {
        var fiveMiles = 5,
          radius = fiveMiles * Config.MILES_TO_METRES;

        return {
          input: text,
          radius: radius,
          location: factory.location
        };
      },

      /**
       * @method getPredictions
       */
      getPredictions: function (input) {
        var options = factory.getOptions(input),
          result = $q.defer();

        if (!factory.maps) {
          GoogleMaps.get().then(factory.initForRestaurant);
        }

        deferred.promise.then(function () {
          factory.error = false;
          factory.service.getQueryPredictions(options, function (predictions, status) {
            if (googleMapsResponseStatuses.isSuccess(status)) {
              return result.resolve({ predictions: predictions, status: status });
            }

            MapQuestAutoComplete.getPredictions(input).then(function (predictions) {
              result.resolve({ predictions: predictions, status: 'OK' });
            }, function (error) {
              factory.error = status;
              factory.log(input, status, error);
              result.reject(status);
            });
          });
        });

        return result.promise;
      },

      /**
       * @method log
       * @param {String} input
       * @param {String} status
       * @param {Object} mapQuestError
       */
      log: function (input, status, mapQuestError) {
        var restaurant = Restaurant.info || {},
          extra;

        extra = {
          autocomplete: input,
          appVersion: Config.ZOOMER_APP_VERSION,
          restaurant: {
            id: restaurant.id,
            name: restaurant.name
          }
        };

        if (mapQuestError) {
          extra.mapQuestError = mapQuestError;
        }
        $log.error(status);
        LogEntries.log(status, { extra: extra });
      }
    };

    $rootScope.$on('$initGoogleMaps', factory.initForRestaurant);

    return factory;
  }

  angular.module('zoomerRestaurant.autoComplete')
    .factory('AutoComplete', AutoComplete);

}());

(function () {
  'use strict';

  function autoCompleteDrawer() {
    return {
      templateUrl: 'app/autoComplete/autoCompleteDrawer.html'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('autoCompleteDrawer', autoCompleteDrawer);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.autoComplete')
    .component('autoCompleteWarnings', {
      bindings: {
        error: '<'
      },
      bindToController: true,
      templateUrl: 'app/autoComplete/autoCompleteWarnings.html'
    });

}());

(function () {
  'use strict';

  var GOOGLE_SCOPE = 'GOOGLE',
    MAPQUEST_SCOPE = 'MAPQUEST';

  function getComponentByName(contexts, name) {
    contexts = contexts || [];
    return (contexts.find(function (c) {
      return (c.id || '').indexOf(name) > -1;
    })) || {};
  }

  /** @ngInject */
  function Diner(data, prediction) {
    data = data || {};
    this.coordinates = {
      lat: null,
      lon: null
    };

    this.address_components = {};
    this.formatted_address = null;
    this.prediction = null;
    this.scope = data.scope;

    if (this.scope === GOOGLE_SCOPE) {
      this.parseForGoogle(data, prediction);
    } else if (this.scope === MAPQUEST_SCOPE) {
      this.parseForMapQuest(data);
    }
  }

  Diner.prototype = {

    /**
     * @method parseForGoogle
     * @param {Object} data
     * @param {Object} autoCompletePrediction
     */
    parseForGoogle: function (data, autoCompletePrediction) {
      data = data || {};
      var components = data.address_components || [],
        geometry = data.geometry || {},
        type;

      this.coordinates.lat = geometry.location.lat();
      this.coordinates.lon = geometry.location.lng();
      this.formatted_address = data.formatted_address;
      this.name = data.name;
      this.prediction = autoCompletePrediction || {};

      angular.forEach(components, function (component) {
        type = component.types[0];
        if (!type) {
          return;
        }

        this.address_components[type] = component.short_name;
      }, this);
    },

    /**
     * @method parseForMapQuest
     * @param {Object} data
     */
    parseForMapQuest: function (data) {
      data = data || {};
      var latLng = data.latLng || {};

      this.coordinates.lat = latLng.lat;
      this.coordinates.lon = latLng.lng;

      this.formatted_address = data.street + ', ' + data.adminArea5 + ', ' + data.adminArea3;
      this.address_components = {
        street_number: data.street,                    // Street Address
        route: data.adminArea6,                         // Neighborhood
        locality: data.adminArea5,                      // city
        administrative_area_level_1: data.adminArea3,   // state
        postal_code: data.postalCode
      };
    },

    /**
     * @method getRawStreetName returns string containing the street number to be displayed in the address_1 field
     * @return {String}
     */
    getRawStreetName: function () {
      var prediction = this.prediction || {},
        address;

      address = prediction.description || this.formatted_address || '';
      return address.split(',')[0];
    }
  };

  angular.module('zoomerRestaurant.autoComplete')
    .value('Diner', Diner);

}());

(function () {
  'use strict';

  /** @ngInject */
  function Geocoder($q, $rootScope, Diner, GoogleMaps, Restaurant, googleMapsResponseStatuses) {
    var deferred = $q.defer(),
      factory;

    factory = {
      maps: null,
      service: null,
      location: null,
      bounds: null,

      error: false,
      loaded: false,

      /**
       * @method initForRestaurant
       * @param {Object} e
       * @param {Object} googleMaps
       */
      initForRestaurant: function (e, googleMaps) {
        factory.maps = googleMaps;
        factory.loaded = Boolean(googleMaps);

        if (!factory.service && factory.loaded) {
          factory.service = new googleMaps.Geocoder();
          factory.setBounds();
          deferred.resolve(factory.service);
        }

        return factory;
      },

      /**
       * @method setBounds
       */
      setBounds: function () {
        var bounds = new factory.maps.LatLngBounds(),
          restaurant = Restaurant.info || {},
          deliveryZone = restaurant.delivery_zone,
          extendedDeliveryZone = restaurant.extended_delivery_zone || {},
          json;

        if (!deliveryZone) {
          factory.bounds = null;
          return;
        }

        function extendBounds(coordinateArray) {
          (coordinateArray || []).forEach(function (coordinate) {
            bounds.extend(new factory.maps.LatLng(coordinate[1], coordinate[0]));
          });
        }

        json = deliveryZone.geo_json || {};
        (json.coordinates || []).forEach(extendBounds);

        json = extendedDeliveryZone.geo_json || {};
        (json.coordinates || []).forEach(extendBounds);

        factory.bounds = bounds;
      },

      /**
       * @method mapLocations
       * @param {Array} locations
       * @param {Object} prediction
       * @return {Array}
       */
      mapLocations: function (locations, prediction) {
        return (locations || []).map(function (location) {
          location.scope = 'GOOGLE';
          return new Diner(location, prediction);
        });
      },

      /**
       * @method geocode
       * @param {Object} place
       * @param {Object} prediction
       * @return {Object} $promise
       */
      geocode: function (place, prediction) {
        var result = $q.defer(),
          params = {
            address: place.name,
            bounds: factory.bounds
          };

        if (!factory.maps) {
          GoogleMaps.get().then(factory.initForRestaurant);
        }

        deferred.promise.then(function () {
          factory.error = false;
          factory.service.geocode(params, function (locations, status) {
            if (googleMapsResponseStatuses.isSuccess(status)) {
              return result.resolve({ locations: factory.mapLocations(locations, prediction), status: status });
            }

            factory.error = status;
            result.reject(status);
          });
        });

        return result.promise;
      }
    };

    $rootScope.$on('$initGoogleMaps', factory.initForRestaurant);

    return factory;
  }

  angular.module('zoomerRestaurant.autoComplete')
    .factory('Geocoder', Geocoder);

}());

(function () {
  'use strict';
  var successStates,
    failedStates,
    statuses;

  successStates = [
    'OK'
  ];
  failedStates = [
    'ERROR',
    'INVALID_REQUEST',
    'OVER_QUERY_LIMIT',
    'REQUEST_DENIED',
    'UNKNOWN_ERROR'
  ];
  statuses = [].concat(successStates, failedStates);

  /**
   * @method isSuccess
   * @param {String} status
   * @return {Boolean}
   */
  statuses.isSuccess = function (status) {
    return failedStates.indexOf(status) === -1;
  };

  angular.module('zoomerRestaurant.autoComplete')
    .constant('googleMapsResponseStatuses', statuses);

}());

(function () {
  'use strict';

  /** @ngInject */
  function MapQuestAutoComplete($q, Config, Diner, Restangular, Restaurant) {
    var baseUrl = 'http://www.mapquestapi.com/geocoding/v1',
      service;

    service = Restangular.withConfig(function (configurer) {
      configurer.setBaseUrl(baseUrl);
      configurer.addResponseInterceptor(function (data) {

        //filter out results without valid street addresses
        var predictions = (data.results[0].locations || []).filter(function (prediction) {  //there is only ever one result since we're not requesting them in bulk
          return prediction.street !== '';
        });

        return predictions.map(function (prediction) {
          console.log(prediction);
          prediction.scope = 'MAPQUEST';              // tag as mapquest prediction
          return new Diner(prediction);
        });
      });
    });

    return angular.extend(service, {

      /**
       * @method getParams
       * @return {Object}
       */
      getParams: function (input) {
        return {
          key: Config.MAPQUEST_KEY,
          location: input + ', United States',
          ignoreLatLngInput: true,
          thumbMaps: false
        };
      },

      /**
       * @method getPredictions
       * @param {String} input
       * @return {Object} $promise
       */
      getPredictions: function (input) {
        var params = this.getParams(input);

        return this.one('address').get(params).then(function (response) {
          return $q.resolve(response.data);
        });
      }

    });
  }

  angular.module('zoomerRestaurant.autoComplete')
    .factory('MapQuestAutoComplete', MapQuestAutoComplete);

}());

(function () {
  'use strict';

  /** @ngInject */
  function PlaceFactory($q, $rootScope, $window, GoogleMaps, Diner, googleMapsResponseStatuses) {
    var deferred = $q.defer(),
      div = $window.document.createElement('div'),
      factory;

    factory = {
      maps: null,
      service: null,
      location: null,

      error: false,
      loaded: false,

      /**
       * @method initForRestaurant
       * @param {Object} e
       * @param {Object} googleMaps
       */
      initForRestaurant: function (e, googleMaps) {
        factory.maps = googleMaps;
        factory.loaded = Boolean(googleMaps);

        if (!factory.service && factory.loaded) {
          factory.service = new googleMaps.places.PlacesService(div);
          deferred.resolve(factory.service);
        }

        return factory;
      },

      /**
       * @method get
       * @param {Number} prediction
       * @return {Object} $promise
       */
      get: function (prediction) {
        var result = $q.defer(),
          placeId = prediction.place_id;

        if (!factory.maps) {
          GoogleMaps.get().then(factory.initForRestaurant);
        }

        if (prediction.scope === 'MAPQUEST') {
          return $q.resolve({ place: prediction, status: 'OK' });
        }

        deferred.promise.then(function () {
          factory.error = false;
          factory.service.getDetails({ placeId: placeId }, function (place, status) {
            if (googleMapsResponseStatuses.isSuccess(status)) {
              return result.resolve({ place: new Diner(place, prediction), status: status });
            }
            factory.error = status;
            result.reject(status);
          });
        });

        return result.promise;
      }
    };

    $rootScope.$on('$initGoogleMaps', factory.initForRestaurant);

    return factory;

  }

  angular.module('zoomerRestaurant.autoComplete')
    .factory('Place', PlaceFactory);

}());

var Config,
  development,
  staging,
  production,
  merged = {};

Config = {
  ZOOMER_APP_VERSION:       '1.5.11',
  ROOT_LOGGED_IN_STATE:     'app.orders',
  ROOT_LOGGED_OUT_STATE:    'login',
  MILES_TO_METRES: 1609.34,
  LOWEST_PRIORITY_TIER:     1,
  DEFAULT_ORDER_SIZE:       'unknown_size',
  IONIC_APP_ID:             'f7f67dc8'
};

development = {
  ANGULAR_DEBUG_INFO:       true,
  API_BASEURL:              'http://localhost:9000/api/v1',
  APP_URL:                  'http://localhost:9000',
  ENV:                      'dev',
  GEO_PUSHER_APP_KEY:       'ebf0dae35ef58f4f4c13',   //not used anywhere in the app, but updated anyway
  IONIC_DEPLOY_CHANNEL:     'Dev',
  IONIC_DEPLOY_CHECK_INTERVAL: 1,
  LOGENTRIES_JS_API_KEY:    '28f7a98b-a486-464c-af67-aaf8a7ed54bb',
  MAPQUEST_KEY:             'KULhrz1saBG88CLPVbxL4BNdAwrvaLLL',
  MIXPANEL_TOKEN:           '121b86bd993dc0ed29b9a63332fd24e5',
  PUSHER_APP_KEY:           'ecd606bb48887ea62394',
  PUSHER_CLUSTER:           'us2',
  RAVEN_DSN:                'https://5ac41850437e48018d0157e6a3cf2db3@sentry.io/159845',
  THUNDERFOREST_API_KEY:    '497b47b71a0f4c3a9730a131156fcfc6',
  GOOGLE_MAPS_TOKEN:        'AIzaSyAYT_oagkcgDxfjUiE_-KUHM3rXE5XBIog'
  };

staging = {
  ANGULAR_DEBUG_INFO:       false,
  API_BASEURL:              'https://zoomer-staging.eatstreet.com/api/v1',
  APP_URL:                  'https://zoomer-staging.eatstreet.com',
  ENV:                      'staging',
  IONIC_DEPLOY_CHANNEL:     'Master',
  IONIC_DEPLOY_CHECK_INTERVAL: 5,
  GEO_PUSHER_APP_KEY:       'ebf0dae35ef58f4f4c13',   //not used anywhere in the app, but updated anyway
  LOGENTRIES_JS_API_KEY:    '8498be1e-a33c-4d52-b752-1ccdcba20879',
  MAPQUEST_KEY:             'KULhrz1saBG88CLPVbxL4BNdAwrvaLLL',
  MIXPANEL_TOKEN:           '121b86bd993dc0ed29b9a63332fd24e5',
  PUSHER_APP_KEY:           '0b83e452e871da2c0938',
  PUSHER_CLUSTER:           'mt1',
  RAVEN_DSN:                'https://5ac41850437e48018d0157e6a3cf2db3@sentry.io/159845',
  THUNDERFOREST_API_KEY:    '497b47b71a0f4c3a9730a131156fcfc6',
  GOOGLE_MAPS_TOKEN:        'AIzaSyDuFSq6TSw3AqHd7yvRoP26Ui0woPz_YsA'
};

production = {
  ANGULAR_DEBUG_INFO:       false,
  API_BASEURL:              'https://zoomer-api.eatstreet.com/api/v1',
  APP_URL:                  'https://zoomer-api.eatstreet.com',
  ENV:                      'production',
  GEO_PUSHER_APP_KEY:       'ebf0dae35ef58f4f4c13',   //not used anywhere in the app, but updated anyway
  IONIC_DEPLOY_CHANNEL:     'Production',
  IONIC_DEPLOY_CHECK_INTERVAL: 5,
  LOGENTRIES_JS_API_KEY:    '0c46d6d6-eb6e-44f5-8eda-a9aadcc32244',
  MAPQUEST_KEY:             'KULhrz1saBG88CLPVbxL4BNdAwrvaLLL',
  MIXPANEL_TOKEN:           'f8c8aeecd03f9d36a1ac893cd8ba302a',
  PUSHER_APP_KEY:           'f05c73d47d1fa85d4b9b',
  PUSHER_CLUSTER:           'mt1',
  RAVEN_DSN:                'https://5ac41850437e48018d0157e6a3cf2db3@sentry.io/159845',
  THUNDERFOREST_API_KEY:    'c3e80f51eeab4c729cb8aabd6d492341',
  GOOGLE_MAPS_TOKEN:        'AIzaSyAYT_oagkcgDxfjUiE_-KUHM3rXE5XBIog'
};

angular.extend(merged, Config, production);

angular.module('zoomerRestaurant').constant('Config', merged);

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .constant('MixPanelTranslations', {
      'open-announcements-modal': 'Open announcements modal',
      'close-announcements-modal': 'Close announcements modal',
      'new-order': 'New order',
      'new-special-order': 'New special order',
      'order-queue': 'View order queue',
      'in-progress': 'View orders in-progress',
      'delivered': 'View orders delivered',
      'deliver-later': 'View Deliver Later queue',
      'under-review': 'View Under Review queue',
      'order-update': 'Zoom it - order update',
      'order-create': 'Zoom it - order create',
      'order-reorder': 'Zoom it - order reorder',
      'edit-order': 'Edit order',
      'edit-special-order': 'Edit special order',
      'edit-reorder': 'Edit re-order',
      'view-order-html': 'View email-order HTML',
      'view-order': 'View order details',
      'view-order-loc': 'View order location',
      'reorder': 'Re-order an order',
      'logout': 'Logout',
      'login': 'Login',
      'pause-orders': 'Pause accepting orders',
      'unpause-orders': 'Resume accepting orders',
      'close-receipt': 'Close check',
      'open-receipt': 'Open check',
      'set-food_ready_now': 'Food Ready Now',
      'oozo-view-on-map': 'View OOZO on map',
      'oozo-send-for-review': 'Send OOZO for review',
      'dismiss-pickup-order': 'Mark order as picked up',
      'menu-accessed': 'Opened Menu',
      'menu-product-marked-available': 'Product marked available',
      'menu-product-marked-sold-out': 'Product marked sold out',
      'menu-product-marked-temporarily-sold-out': 'Product marked temporarily sold out',
      'menu-category-toggled': 'Category expanded/collapsed',
      'orders-queue-accessed': 'Opened Orders',
      'settings-accessed': 'Opened Settings',
      'hours-accessed': 'Checked Update Hours Modal'
    });
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .constant('Modals', {
      CANNOT_EDIT_ORDER: {
        title: 'Cannot edit this order',
        template: 'Sorry, but this order is no longer editable as it is either in progress or has been completed / cancelled / marked as picked up.'
      },
      CONFIRM_LOGOUT: {
        template: 'Are you sure you want to log out?',
        title: 'Log out?'
      },
      SKIP_EXTERNAL_ORDER: {
        template: 'Are you sure you want to skip this order?',
        title: 'Skip this order?'
      },
      SKIP_ALL_EXTERNAL_ORDERS: {
        template: 'Are you sure you wish to skip all open orders?',
        title: 'Skip all?'
      },
      SKIP_NON_EATSTREET_EXTERNAL_ORDERS: {
        template: 'Are you sure you wish to skip all open orders?<br><br>NOTE: Per your contract, orders originating from EatStreet can\'t be skipped.',
        title: 'Skip non-EatStreet orders?'
      },
      SKIP_NON_GRUBHUB_EXTERNAL_ORDERS: {
        template: 'Are you sure you wish to skip all open orders?<br><br>NOTE: Per your contract, orders originating from GrubHub can\'t be skipped.',
        title: 'Skip non-GrubHub orders?'
      },
      SKIP_NON_EATSTREET_NON_GRUBHUB_EXTERNAL_ORDERS: {
        template: 'Are you sure you wish to skip all open orders?<br><br>NOTE: Per your contract, orders originating from EatStreet and GrubHub can\'t be skipped.',
        title: 'Skip non-EatStreet/non-GrubHub orders?'
      },
      SNOOZED_ORDERS_HELP: {
        title: 'What are snoozed orders?',
        template: 'Snoozed orders are external orders placed significantly ahead of time. Don\'t worry, they\'ll appear once they are within 45 minutes of the delivery time.'
      },
      DELIVERY_ZONE_VALIDATION_WARNING: {
        title: 'Cannot confirm address',
        template: 'There was a problem attempting to validate your chosen address. Please try again.'
      },
      CONFIRM_CANCEL_ORDER: {
        cancelText: 'Close',
        okText: 'Cancel Order',
        okType: 'button-assertive',
        template: 'Are you sure you wish to cancel this order?',
        title: 'Cancel order'
      },
      CONFIRM_READY_BY_TIME: {
        cancelText: 'No, let me edit it',
        okText: 'Yes',
        okType: 'button-assertive',
        title: 'Confirm Ready By Time'
      },
      getSetOrderIouConfirm: function (order) {
        var id = order.id,
          driver = order.driver_assigned || {},
          driverName = driver.name || 'The driver',
          orderText = id ? (' #' + id) : '',
          iou = order.driver_iou;

        return {
          defaultText: iou || '',
          inputType: 'number',
          inputPlaceholder: 'IOU amount',
          template: driverName + ' will be reminded that this is the amount they owe for Order' + orderText,
          title: 'IOU for Order' + orderText
        };
      }
    });

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').constant('OrderFilterTypes', [
    {
      key: 'Driver waited',
      prop: 'not_ready_at',
      equals: true
    },
    {
      key: 'Longer than 45mins TDT',
      prop: 'dropoff_minutes',
      greaterThan: 45
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .constant('receiptDisputeTypes', {
      incorrect_tip: 'Incorrect tip amount',
      bad_image: 'Incorrect or bad photo',
      no_image: 'No image attached'
    });
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('ApplicationCtrl', [
    '$window', '$scope', '$rootScope', '$state', 'Session', 'Restaurant', 'ExternalOrders', 'Config', 'Utilities', 'Features', 'ZoomerState', 'FullStory', 'PaymentStatus', '$ionicNavBarDelegate', 'externalOrdersModal', 'ordersQueue', 'sentry', 'externalOrderPoll', 'audioAlert', 'ThermalPrinter', '$ionicPlatform',
    function ($window, $scope, $rootScope, $state, Session, Restaurant, ExternalOrders, Config, Utilities, Features, ZoomerState, FullStory, PaymentStatus, $ionicNavBarDelegate, externalOrdersModal, ordersQueue, sentry, externalOrderPoll, audioAlert, ThermalPrinter, $ionicPlatform) {
      var vm = this,
        userAgent = ($window.navigator.userAgent || '').toLowerCase();

      // If the user is already logged in when refreshing the app (or upon Ionic Deploy) - re-init services
      if (Session.isLoggedIn()) {
        Session.init().then(function () {
          ordersQueue.getAll();
          externalOrderPoll.start();
        });
      }

      $rootScope.isRestaurantOpen = true;
      $rootScope.isMobileDevice = (/iphone|ipad|android/gi).test(userAgent);
      $rootScope.session = Session;
      $rootScope.restaurant = Restaurant;
      $rootScope.externalOrders = ExternalOrders;
      $rootScope.features = Features;
      $rootScope.pageClass = '';
      $rootScope.showRootNav = false;      

      /**
       * @method canShowExternalOrdersModal
       * @return {Boolean}
       */
      vm.canShowExternalOrdersModal = function () {
        var current = $state.current,
          name = current.name;

        return Utilities.state.isAnyRootState(name) &&
          !ExternalOrders.dismissPage &&
          ExternalOrders.total;
      };

      /**
       * @method isLoggedInStateInvalid
       * @param {String} name
       * @return {Boolean}
       */
      vm.isLoggedInStateInvalid = function (name) {
        var newOrderStates = [ 'app.new-order', 'app.new-reorder', 'app.new-specialorder' ];

        return name === Config.ROOT_LOGGED_OUT_STATE ||
          (newOrderStates.indexOf(name) > -1 && Restaurant.isPreLaunch());
      };

      /**
       * Determine if paused restaurant is short-term pause based on long RBT select
       * or if paused until next day
       * @method isTempPaused
       * @param {object} rest
       * @return {Boolean}
       */
      vm.isTempPaused = function (rest) {
        if (!rest) return;
        if (rest.pauseLength) {
          return rest.pauseLength <= 60;
        } else {
          return false;
        }
      };

      $rootScope.$watch('restaurant.info', function (restaurant) {
        var fullStoryId;

        sentry.setRestaurant(restaurant);

        if (!restaurant) {
          return FullStory.clear();
        }

        fullStoryId = (restaurant.id || '').toString();
        FullStory.identify(fullStoryId, { displayName: restaurant.name });

        $rootScope.isRestaurantOpen = restaurant.status === 'active';
        if (!$rootScope.isRestaurantOpen) {
          externalOrderPoll.stop();
        } else {
          externalOrderPoll.start();
          if (ExternalOrders.total) {
            externalOrdersModal.show();
          }
        }
      });

      $rootScope.$watch('externalOrders.total', function (newTotal, oldTotal) {
        newTotal = Number(newTotal);
        oldTotal = Number(oldTotal);
        var current = $state.current || {},
          name = current.name;

        if (!newTotal || PaymentStatus.restrictRestaurant || $rootScope.isSupportDashboardActive) {
          audioAlert.stop();
          return externalOrdersModal.hide();
        }

        if (Utilities.state.isAnyRootState(name) && newTotal && newTotal > oldTotal) {
          audioAlert.play();
          ExternalOrders.toggleDismiss(false);
          if (!Features.checkEnabled('disable_external_order_flashing')) {
            externalOrdersModal.showNotificationScreen();
          } else {
            externalOrdersModal.show();
          }
        }
      });

      $scope.$on('$stateChangeStart', function (e, toState, toParams, fromState) {
        var isLoggedIn = Session.isLoggedIn(),
          name = toState.name;

        if (!isLoggedIn && name !== Config.ROOT_LOGGED_OUT_STATE && name !== 'forgot-password') {
          e.preventDefault();
          return $state.go(Config.ROOT_LOGGED_OUT_STATE);
        }

        if (isLoggedIn) {
          if (vm.isLoggedInStateInvalid(name)) {
            e.preventDefault();
            return $state.go(Config.ROOT_LOGGED_IN_STATE);
          }
        }

        if (toState) {
          ZoomerState.update(toState, fromState);
        }
      });

      $scope.$on('$ionicView.beforeEnter', function () {
        var current = $state.current,
          fullScreenStates = ['login'],
          name = current.name,
          showBar = fullScreenStates.indexOf(name) === -1;

        $ionicNavBarDelegate.showBar(showBar);
        $rootScope.pageClass = name.replace('app.', 'page-');
        $rootScope.showRootNav = Utilities.state.isAnyRootState();

        if (vm.canShowExternalOrdersModal()) {
          externalOrdersModal.show();
        }
      });

      $ionicPlatform.on("pause", function() {
        //code for action on pause
        ThermalPrinter.disconnect()
          .then(function() {}, function() {});
      }, false);

      $ionicPlatform.on("resume", function() {
        //code for action on resume
        ThermalPrinter.attemptConnectToDefault()
          .then(function() {}, function() {});
      }, false);

    }
  ]);
}());

(function () {
  'use strict';

  var specialOrderStates = [
      'app.edit-specialorder',
      'app.new-specialorder'
    ];


  angular.module('zoomerRestaurant').controller('EditOrderCtrl', [
    '$scope', '$state', '$stateParams', '$ionicLoading', 'zIonicPopup', 'Config', 'ExternalOrders', 'Modals', 'Utilities', 'Order', 'Toast', 'ordersQueue', 'pendingOrders', 'orderSubmitErrorModal',
    function ($scope, $state, $stateParams, $ionicLoading, zIonicPopup, Config, ExternalOrders, Modals, Utilities, Order, Toast, ordersQueue, pendingOrders, orderSubmitErrorModal) {
      var self = this,
        stateParams = $stateParams || {},
        deliveryNotesPromise,
        enterPromise,
        paymentMethodPromise,
        destroyPromise;

      $scope.utilities = Utilities;
      $scope.isEdit = !!stateParams.orderId;
      $scope.order = {};
      $scope.hasAddressChanged = false;
      $scope.oozoReview = null;
      $scope.deliveryZoneStatus = {
        isWithinInner: true,
        isWithinOuter: false,
        isOutsideSnowZone: false,
        isOutsideDeliveryZone: false
      };

      /**
       * Forcibly set the Form as pristine
       */
      $scope.setPristine = function () {
        if ($scope.orderForm) {   // Avoid race condition with opening 2 editors in rapid sequence (i.e. from accepting multiple pickup orders and viewing them immediately)
          $scope.orderForm.$setPristine();
        }
      };

      this.submitting = false;

      /**
       * @method goBack
       */
      this.goBack = function () {
        ordersQueue.getAll();
        ExternalOrders.getAll();
        $state.go(Config.ROOT_LOGGED_IN_STATE);
        Order.reset();
      };

      /**
       * @method onComplete
       */
      this.onComplete = function () {
        $ionicLoading.hide();
        self.submitting = false;
      };

      /**
       * @method warnIfCannotEditOrder
       */
      this.warnIfCannotEditOrder = function () {
        var order = $scope.order || {};
        if (order.isEditable || order.isDeliveryInProgress) {
          return;
        }

        zIonicPopup.alert(Modals.CANNOT_EDIT_ORDER).then(function () {
          $state.go(Config.ROOT_LOGGED_IN_STATE);
        });
      };

      /**
       * @method scheduledOrderSubmit
       * @desc Check first the deliver_at and ready_by_time are still valid; NB: if there's
       * no `deliver_at` set, and the RBT is a Number, we can assume this is a 'normal' order
       */
      this.scheduledOrderSubmit = function () {
        var order = $scope.order,
          deliverAt = order.deliver_at;

        if (!deliverAt && !isNaN(order.ready_by_time)) {
          return this.submit();
        }

        if ($scope.orderForm.deliverAt) {
          $scope.orderForm.deliverAt.$validate();
        }

        if ($scope.orderForm.readyByTime) {
          $scope.orderForm.readyByTime.$validate();
        }

        if ($scope.orderForm.$valid) {
          self.submit();
        }
      };

      /**
       * Submit changes or new Order to the server
       */
      this.submit = function () {
        var loadingMsg = '<i class="fa fa-refresh fa-spin"></i> ' + ($scope.isEdit ? 'Updating' : 'Zooming') + ' order',
          params;

        if (this.submitting) {
          return;
        }

        this.submitting = true;
        $ionicLoading.show({ template: loadingMsg });
        if ($scope.isEdit) {
          return $scope.order.update().then(this.goBack, orderSubmitErrorModal.show).finally(this.onComplete);
        }

        params = Utilities.orders.getParams($scope.order);
        pendingOrders.create(params).then(this.goBack, orderSubmitErrorModal.show).finally(this.onComplete);
      };

      /**
       * Does this Order have 'completed' OOZO review status?
       *
       * @return {Boolean}
       */
      this.hasOozoReview = function () {
        var order = $scope.order,
          oozoReview = $scope.oozoReview || {};

        return oozoReview.status === 'approved' || oozoReview.status === 'rejected' || Boolean(order.oozo_pricing_accepted);
      };

      /**
       * @method getOozoReview
       */
      this.getOozoReview = function () {
        var order = $scope.order || {};

        if (order.outside_inner_delivery_zone) {
          order.getOozoReview().then(function (response) {
            $scope.oozoReview = response.data;
          });
        }
      };

      /**
       * @method redirectOrderAsSpecial
       */
      this.redirectOrderAsSpecial = function () {
        var order = angular.copy($scope.order),
          orderId = order.id,
          current = $state.current || {},
          params = {
            setAsLargeOrder: true
          },
          goState;

        if (specialOrderStates.indexOf(current.name) > -1) {
          return;
        }

        goState = orderId ? 'app.edit-specialorder' : 'app.new-specialorder';
        if (orderId) {
          params.orderId = orderId;
        } else {
          params.cached = {
            deliveryZoneStatus: $scope.deliveryZoneStatus,
            order: order
          };
        }

        $state.go(goState, params);
        Toast.warnExtraLargeOrder();
      };

      /**
       * @method mergeOrderFromStateParams
       */
      this.mergeDataFromStateParams = function () {
        var cached = $stateParams.cached || {},
          mergeWith = {
            deliver_at: null,
            ready_by_time: null
          };

        if (!cached.order) {
          return;
        }

        if (!$stateParams.setAsLargeOrder && !$stateParams.orderId) {
          mergeWith.size = null;
        }

        angular.extend($scope.order, cached.order, mergeWith);
        angular.extend($scope.deliveryZoneStatus, cached.deliveryZoneStatus);
        Order.setIou($scope.order.driver_iou);
      };

      /**
       * @method init
       */
      this.init = function () {
        var setAsLargeOrder = $stateParams.setAsLargeOrder,
          orderId = $stateParams.orderId;

        Order.init(orderId).then(function (order) {
          order = order || {};
          $scope.order = angular.extend(($scope.order || {}), order);

          self.mergeDataFromStateParams();
          if (!order.id) {
            return;
          }

          self.getOozoReview();
          self.warnIfCannotEditOrder();

          if (order.deliver_at) {
            $scope.$broadcast('$specialOrderLoaded', order);
          }

          $scope.order = order;
          $scope.order.size = setAsLargeOrder ? 'extra_large' : $scope.order.size;
          $scope.setPristine();
        });
      };

      deliveryNotesPromise = $scope.$on('$setOrderDeliveryNotes', function (e, deliveryNotes) {
        $scope.order.delivery_notes = deliveryNotes || '';
      });

      enterPromise = $scope.$on('$ionicView.enter', this.init.bind(this));

      paymentMethodPromise = $scope.$watch('order.payment_method', Order.updatePaymentMethod.bind(Order));

      destroyPromise = $scope.$on('$destroy', function () {
        deliveryNotesPromise();
        enterPromise();
        destroyPromise();
        paymentMethodPromise();
      });

    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('HistoryCtrl', [
    '$window', '$controller', '$rootScope', '$scope', 'Features', 'OrderFilterTypes', 'Utilities', 'orderPopoverMenu', 'ordersQueue', 'zDateRangeLauncher', 'orderHistoryStatistics',
    function ($window, $controller, $rootScope, $scope, Features, OrderFilterTypes, Utilities, orderPopoverMenu, ordersQueue, zDateRangeLauncher, orderHistoryStatistics) {
      var self = this,
        moment = $window.moment,
        onPromise,
        pollingPromise,
        rangePromise,
        enterPromise,
        destroyPromise;

      angular.extend(this, $controller('PageCtrl', { $scope: $scope }), this);

      moment.locale('en', {
        calendar : {
          lastDay : '[Yesterday]',
          sameDay : '[Today]',
          nextDay : '[Tomorrow] LT',
          lastWeek : '[Last] dddd',
          nextWeek : 'dddd [at] LT',
          sameElse : 'L'
        }
      });

      this.filterTypes = OrderFilterTypes;
      this.filterTypeIndex = 'all';

      this.features = Features;
      this.utilities = Utilities;
      this.orders = [];
      this.statistics = {};
      this.filterText = '';
      this.loading = false;
      this.loadingStats = false;
      this.orderPopoverMenu = orderPopoverMenu;

      this.period = null;

      /**
       * Reset historical Orders
       */
      this.reset = function () {
        this.orders = [];
        this.scroller.reset();
      };

      /**
       * Assign stats for requested period
       */
      this.getOrderStatistics = function () {
        this.loadingStats = true;
        orderHistoryStatistics.get(this.getParams()).then(function (response) {
          self.statistics = response.data.plain();
        }).finally(function () {
          self.loadingStats = false;
        });
      };

      /**
       * @method getParams
       * @return {Object}
       */
      this.getParams = function () {
        var period = this.period || {};
        return {
          delivered_after: period.after,
          delivered_before: period.before,
          status: 'delivered,cancelled,undeliverable,oozo_review_rejected,do_not_deliver_dismissed'
        };// Optional: Switch history to queue-based API, but don’t feature flag “do_not_deliver_dismissed”
        //   (even if they are disabled for pickup now, they still should be able to see historical orders)
      };

      /**
       * @method update
       * @param {Number} page
       * @param {Boolean} ignorePaginationHeaders
       */
      this.update = function (page, ignorePaginationHeaders) {
        var params;
        ignorePaginationHeaders = !!ignorePaginationHeaders;
        if (!this.period) {
          return;
        }

        params = this.getParams();
        params.page = page || 1;
        params.per_page = 10;
        this.loading = true;

        ordersQueue.getById(null, params).then(function (response) {
          var orders = response.data,
            headers = response.headers();

          self.setOrders(orders);
          if (!ignorePaginationHeaders) {
            self.scroller.success(headers);
          }
        }, function (error) {
          self.setOrders();
          if (!ignorePaginationHeaders) {
            self.scroller.failure(error);
          }
        }).finally(function () {
          $scope.$broadcast('scroll.infiniteScrollComplete');
        });
      };

      /**
       * Fetch order and update if it's already in the visible list
       *
       * @param {Object} eventName
       * @param {Object} data
       */
      this.updateOrder = function (eventName, data) {
        data = data || {};
        var orderId = data.order_id || 0;
        if (!orderId) {
          return;
        }

        ordersQueue.getById(orderId).then(function (response) {
          var order = response.data || {},
            index = -1,
            existingOrder;

          existingOrder = _.find(self.orders, function (o, i) {
            if (o.id === orderId) {
              index = i;
              return true;
            }
          });

          if (existingOrder && index > -1) {
            self.orders.splice(index, 1, order);
            self.filterOrders();
          }
        });
      };

      /**
       * Check for new orders and add to the current collection
       *
       * @param {Array} orders
       */
      this.setOrders = function (orders) {
        orders = orders || [];

        var ids = _.pluck(this.orders, 'id'),
          newOrders = _.filter(orders, function (order) {
            return ids.indexOf(order.id) === -1;
          });

        angular.forEach(newOrders, function (order) {
          order.outsideBusinessDay = Utilities.orders.outsideBusinessDay(order);
          order.isPickupOrder = order.status === 'do_not_deliver' || order.status === 'do_not_deliver_dismissed';
        });

        this.loading = false;
        if (!orders.length) {
          this.orders = [];
        } else {
          this.orders = (this.orders || []).concat(newOrders);
        }

        Utilities.orders.setNextActionTimes(self.orders);
        self.filterOrders();
      };

      /**
       * Iterate through all the Orders and compare each against the currently selected Rule from the constant
       *
       * @param {Object} order
       * @return {Boolean}
       */
      this.isOfFilterType = function (order) {
        var index = this.filterTypeIndex,
          prop,
          from,
          to,
          type;

        if (index === 'all') {
          return true;
        }

        index = Number(index);
        type = OrderFilterTypes[index];

        if (type.equals) {
          prop = order[type.prop];
          return (typeof type.equals === 'boolean') ? !!prop : prop === type.equals;
        }

        if (!type.from && type.greaterThan) {
          prop = order[type.prop];
          return prop > type.greaterThan;
        }

        if (!type.from && type.lessThan) {
          prop = order[type.prop];
          return prop < type.lessThan;
        }

        if (type.from) {
          prop = order[type.prop];
          if (!prop) {
            return false;
          }

          from = new Date(prop).getTime();
          to = new Date(order[type.from]).getTime();
          if (type.greaterThan) {
            return (from - to) > type.greaterThan;
          }

          if (type.lessThan) {
            return (from - to) < type.lessThan;
          }
        }
      };

      /**
       * Filter out the overall orders list, based on any valid text from the search-field
       */
      this.filterOrders = function () {
        var text = (this.filterText || '').toLowerCase();

        if (!text || text === '') {
          this.orders = _.map(this.orders, function (order) {
            order.visible = self.isOfFilterType(order);
            return order;
          });
          return;
        }
        this.orders = _.map(this.orders, function (order) {
          var address = order.address || {},
            address1 = (address.address_1 || '').toLowerCase(),
            address2 = (address.address_2 || '').toLowerCase(),
            driver = order.driver_assigned || {},
            name = (driver.name || '').toLowerCase();

          order.visible = self.isOfFilterType(order) && (
            ((order.id).toString()).indexOf(text) > -1 || (name.indexOf(text) > -1) || (address1.indexOf(text) > -1) || (address2.indexOf(text) > -1)
          );
          return order;
        });
      };


      pollingPromise = $scope.$on('$pusherPolling', function () {
        self.poll();
      });

      enterPromise = $scope.$on('$ionicView.enter', zDateRangeLauncher.bind($scope));

      onPromise = $rootScope.$on('$restaurantUpdated', function (e, eventName, data) {
        self.updateOrder(eventName, data);
      });

      rangePromise = $scope.$on('$zDateRangeUpdated', function (e, period) {
        self.period = period;
        self.reset();
        self.update();
        self.getOrderStatistics();
      });

      destroyPromise = $scope.$on('$destroy', function () {
        destroyPromise();
        onPromise();
        pollingPromise();
        rangePromise();
        enterPromise();
      });

    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('MenuCtrl', [
    '$scope', '$rootScope', '$state', '$interval', '$ionicLoading', '$ionicModal', 'zIonicPopup', 'Session', 'Config', 'Modals', 'InAppMessages', 'ExternalOrders', 'ordersQueue', 'confirmOrderRbtPopup', '$ionicHistory', 'externalOrdersModal', 'ThermalPrinter',
    function ($scope, $rootScope, $state, $interval, $ionicLoading, $ionicModal, zIonicPopup, Session, Config, Modals, InAppMessages, ExternalOrders, ordersQueue, confirmOrderRbtPopup, $ionicHistory, externalOrdersModal, ThermalPrinter) {
      var interval = null,
        delay = 60000,
        vm = this,
        confirmOrdersPromise,
        destroyPromise,
        invisibilityCountPromise,
        restaurantArrayPromise,
        firstRestaurantPromise,
        hasGhostKitchensPromise,
        pusherStatePromise;

      /**
       * @method logout
       */
      vm.logout = function () {
        $ionicLoading.show({ template: 'Logging out' });

        Session.logout(true).then(function () {
          $state.go(Config.ROOT_LOGGED_OUT_STATE);
          $ionicLoading.hide();
          ordersQueue.reset();
          $scope.stopPolling();
          InAppMessages.clear();
          ExternalOrders.reset();
        });
      };

      /**
       * @method confirmLogout
       */
      vm.confirmLogout = function () {
        zIonicPopup.confirm(Modals.CONFIRM_LOGOUT).then(function (confirm) {
          if (confirm) {
            vm.logout();
          }
        });
      };

      vm.nonESRestaurant = $rootScope.nonESRestaurant;

      $scope.isOrderReorder = false;
      $scope.inAppMessages = InAppMessages;
      $scope.restaurantArray = $rootScope.restaurantArray;
      $scope.firstRestaurant = $rootScope.firstRestaurant;
      $scope.hasGhostKitchens = $rootScope.hasGhostKitchens;

      /**
       * Start the $interval fallback
       */
      $scope.startPolling = function () {
        if (interval) {
          return;
        }

        interval = $interval(function () {
          $scope.$broadcast('$pusherPolling');
        }, delay);
        $scope.$broadcast('$pusherPolling');
      };

      /**
       * Stop the interval fallback
       */
      $scope.stopPolling = function () {
        if (!interval) {
          return;
        }

        $interval.cancel(interval);
        interval = null;
      };

      /**
       * https://pusher.com/docs/client_api_guide/client_connect#connection-states
       *
       * @param {Object} e
       * @param {Object} states
       */
      $scope.checkPusherState = function (e, states) {
        var current = states.current || '',
          validFailureStates = ['unavailable', 'failed', 'connecting'];

        if (_.contains(validFailureStates, current)) {
          return $scope.startPolling();
        }

        if (current === 'connected') {
          return $scope.stopPolling();
        }
      };

      /**
       * If any unconfirmed orders are found, display modal
       *
       * @param {Object} e
       * @param {Number} orderId
       */
      $scope.showOrderConfirm = function (e, orderId) {
        ordersQueue.getById(orderId).then(function (response) {
          var order = response.data;
          if (order.confirmed) {
            return;
          }

          return confirmOrderRbtPopup.show(order).then(function (answer) {
            if (!answer) {
              return $state.go('app.edit-specialorder', { orderId: order.id });
            }

            order.confirm();
          });
        });
      };

      $scope.goToSettings = function () {
        $ionicHistory.nextViewOptions({
          disableAnimate: true
        });
        $state.go('app.settings');
      };

      $scope.goToMenu = function (eatstreetId) {
        $ionicHistory.nextViewOptions({
          disableAnimate: true
        });
        $state.go('app.menu-list', { eatstreetId: eatstreetId});
      };

      $scope.goToOrders = function () {
        $ionicHistory.nextViewOptions({
          disableAnimate: true
        });
        $state.go('app.orders');
      };

      $scope.goToHours = function () {
        $ionicHistory.nextViewOptions({
          disableAnimate: true
        });
        var params = {
          scope: $scope
        };
        $ionicModal.fromTemplateUrl('app/components/hoursModal/hours.html', params).then(function (modal) {
          $scope.confirmModal = modal;
          $scope.confirmModal.show();
        });
      };

      $scope.shouldShowThermalPrinterSettings = function () {
        return ThermalPrinter.isInPrinterSupportedEnvironment();
      };

      invisibilityCountPromise = $rootScope.$watch('invisibilityCount', function (newVal) {
        $scope.invisibilityCount = newVal;
      });

      restaurantArrayPromise = $rootScope.$watch('restaurantArray', function (newVal) {
        $scope.restaurantArray = newVal;
      });

      firstRestaurantPromise = $rootScope.$watch('firstRestaurant', function (newVal) {
        $scope.firstRestaurant = newVal;
      });

      hasGhostKitchensPromise = $rootScope.$watch('hasGhostKitchens', function (newVal) {
        $scope.hasGhostKitchens = newVal;
      });

      pusherStatePromise = $rootScope.$on('$pusherStateChange', $scope.checkPusherState);

      confirmOrdersPromise = $rootScope.$on('$confirmSpecialOrders', $scope.showOrderConfirm);

      destroyPromise = $scope.$on('$destroy', function () {
        destroyPromise();
        pusherStatePromise();
        confirmOrdersPromise();
        invisibilityCountPromise();
      });

    }
  ]);
}());

(function () {
  'use strict';

  /** @ngInject */
  function MenuListCtrl($timeout, menuList, $stateParams, $rootScope, $scope, $ionicModal, $filter) {
    var self = this,
      params = $stateParams || {},
      eatstreetId = params.eatstreetId;

    var vm = this,
      DELAY_TIME = 100;
    vm.eatstreetId = params.eatstreetId;
    vm.restaurant = [];
    vm.menuList = [];
    vm.menu = [];
    vm.loading = true;
    vm.selectedcategory = 0;
    vm.filterSoldOut = false;
    vm.productSearch = "";
    vm.options = [];
    vm.allOptions = [];
    vm.allProducts = [];
    vm.viewChoice = 'products';
    vm.menuListOptions = [];
    vm.alphabet = [];
    vm.allItems = [];

    vm.$onInit = function () {
      $ionicModal.fromTemplateUrl('app/views/modals/loading-indicator.html', params).then(function (modal) {
        $scope.confirmModal = modal;
        $scope.confirmModal.show();
      });
    };

    vm.joinProductsWithCategories = function (categories, products) {
      if (!categories) {
        return [];
      }
      return categories.reduce(function (acc, cur) {
        return acc.concat(
          Object.assign({}, cur, {
            products: products.filter(function (product) {
              return product.categoryId === cur.id;
            })
          }));
      }, []);
    };

    vm.joinOptionsWithCategories = function (categories, products) {
      if (!categories) {
        return [];
      }
      return categories.reduce(function (acc, cur) {
        return acc.concat(
          Object.assign({}, cur, {
            products: products.filter(function (product) {
              return product.name.charAt(0).toUpperCase() === cur.name.charAt(0).toUpperCase() || (cur.name === "0 - 9" && (product.name.charAt(0).toUpperCase() < 'A' || product.name.charAt(0).toUpperCase() > 'Z'));
            })
          }));
      }, []);
    };

    vm.fetchDataES = function () {
      menuList
        .fetchMenuFromEs(params.eatstreetId)
        .then(function (response) {
          var data = response.data;
          vm.menuList = vm.joinProductsWithCategories(data.categories, data.products, 'all');
          vm.allProducts = data.products;
          vm.selectedcategory = data.categories[0];
          vm.menu = vm.menuList;
          vm.toggleMenuView('products');
        })
        .catch(function (error) {
          console.error(error);
          $scope.confirmModal.hide();
        });
    };

    vm.initAlphaArray = function () {
      var misc = {};
      misc.name = "0 - 9";
      vm.alphabet.push(misc);
      var i;
      for (i = 0; i < 26; i++) {
        var cat = {};
        cat.name = (i + 10).toString(36).toUpperCase();
        vm.alphabet.push(cat);
      }
    }

    vm.initAlphaArray();

    vm.fetchOptions = function () {
      menuList
        .fetchOptions(params.eatstreetId)
        .then(function (response) {
          var data = response.data;
          vm.options = data.sort(function (a, b) {
            return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0);
          });
          vm.allOptions = vm.options;
          vm.menuListOptions = vm.joinOptionsWithCategories(vm.alphabet, vm.options, 'all');
          $scope.confirmModal.hide();
        })
        .catch(function (error) {
          console.error(error);
          $scope.confirmModal.hide();
        });
    };

    vm.fetchDataES();

    vm.fetchOptions();

    vm.getRestName = function () {
      var i;
      if (($rootScope.restaurantArray)) {
        for (i = 0; i < $rootScope.restaurantArray.length; i++) {
          if ($rootScope.restaurantArray[i].eatstreetId === Number(params.eatstreetId)) {
            vm.restaurant = $rootScope.restaurantArray[i];
            return $rootScope.restaurantArray[i].restaurantName;
          }
        }
      }
    };

    vm.setActiveCategory = function (categoryId) {
      vm.selectedcategory = categoryId;
    };

    vm.setActiveCategory(vm.selectedcategory);

    vm.toggleMenuView = function (viewChoice) {
      vm.productSearch = "";
      vm.filterSoldOut = false;
      var catSelection = viewChoice === 'products' ? vm.menu : vm.menuListOptions;
      vm.setActiveCategory(catSelection[0]);
      vm.viewChoice = viewChoice;
      vm.allItems = viewChoice === 'products' ? vm.allProducts : vm.allOptions;
    };

    vm.countInvisible = function (items) {
      var total =  items.reduce(function (sum, item) {
        return sum + (item.invisible || item.temporarilyInvisible ? 1 : 0);
      }, 0);

      return total;
    };

    $scope.showLoadIndicator = function () {
      $ionicModal.fromTemplateUrl('app/views/modals/loading-indicator.html', params).then(function (modal) {
        $scope.confirmModal = modal;
        $scope.confirmModal.show();
      });
    };

    $scope.searchChange = function (productSearch) {
      vm.productSearch = productSearch;
    };

    $scope.soldOutChange = function (filterSoldOut) {
      vm.filterSoldOut = filterSoldOut;
    };

    /**
     * Used to update data without having to reload menu every time a menu item is changed
     */
    $scope.updateProduct = function (product) {
      var index;
      if (vm.viewChoice === 'products') {
        index = vm.allProducts.map(function(e) { return e.id; }).indexOf(product.id);
        vm.allProducts[index] = product;
        vm.joinProductsWithCategories(vm.menuList.categories, vm.allProducts, 'all');
        vm.restaurant.invisibilityCount = vm.countInvisible(vm.allProducts);
      } else {
        index = vm.allOptions.map(function(e) { return e.name; }).indexOf(product.name);
        vm.allOptions[index] = product; 
        vm.joinOptionsWithCategories(vm.menuListOptions.categories, vm.allOptions, 'all');
        vm.restaurant.invisibleOptsCount = vm.countInvisible(vm.allOptions);
      }
    };

    $scope.soldOutItems = function (product) {
      if (vm.filterSoldOut) {
          return product.invisible || product.temporarilyInvisible;
      } else {
        return true; 
      }
    };

    $scope.productSearchFilter = function (product) {
      if(vm.productSearch) {
        return product.name.toUpperCase().includes(vm.productSearch.toUpperCase());
      } else {
        return true;
      }
    };

    $scope.getCategory = function (categoryId) {
      var category = $filter('filter')(vm.menu, { 'id': categoryId });
      return category[0] ? category[0].name : "";
    };
  }

  angular.module('zoomerRestaurant')
    .controller('MenuListCtrl', MenuListCtrl, ['$timeout', 'menuList']);

}());


(function () {
  'use strict';
  angular.module('zoomerRestaurant').controller('PageCtrl', [
    'InfiniteScroller',
    function (InfiniteScroller) {

      this.scroller = InfiniteScroller.create();
      this.loading = false;

      /**
       * Poll callback to hard-refresh all requested pages
       */
      this.poll = function () {
        if (this.loading) {
          return;
        }

        var currentLastPage = this.scroller.getCurrentPage() || 1,
          i = 1,
          ignorePaginationHeaders;

        if (currentLastPage === 1) {
          return this.update();
        }

        for (i; i <= currentLastPage; i += 1) {
          ignorePaginationHeaders = i !== currentLastPage;
          this.update(i, ignorePaginationHeaders);
        }
      };

      /**
       * Check availability of a next paginated page and update() if so
       */
      this.nextPage = function () {
        var scroller = this.scroller;
        if (!scroller.hasNextPage()) {
          return;
        }

        scroller.setUpdating(true);
        this.update(scroller.getNextPage());
      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('ReceiptsCtrl', [
    '$rootScope', '$scope', '$controller', '$timeout', '$ionicModal', 'zIonicPopup', '$ionicScrollDelegate', 'Receipts', 'Utilities', 'zDateRangeLauncher', 'confirmBulkReceiptClosure', 'totalOpenReceipts', 'Toast',
    function ($rootScope, $scope, $controller, $timeout, $ionicModal, zIonicPopup, $ionicScrollDelegate, Receipts, Utilities, zDateRangeLauncher, confirmBulkReceiptClosure, totalOpenReceipts, Toast) {
      var self = this,
        modalPromise,
        disputePromise,
        pollingPromise,
        onPromise,
        enterPromise,
        destroyPromise;

      angular.extend(this, $controller('PageCtrl', { $scope: $scope }));

      $scope.selectedReceipt = null;

      /**
       * @method removeAndRefresh
       */
      $scope.removeAndRefresh = function () {
        var receipt = $scope.selectedReceipt || {},
          id = receipt.id;

        if (id) {
          self.removeReceipt(id);
        }

        self.update();
        totalOpenReceipts.refresh();
      };

      /**
       * Callback for shared controller
       */
      $scope.onToggle = function () {
        if ($scope.modal) {
          $scope.modal.hide();
        }
        $scope.removeAndRefresh();
      };

      /**
       * Close the modal and $destroy it and receipt data
       */
      $scope.closeModal = function () {
        $scope.modal.hide().then(function () {
          $scope.modal.remove();
          $scope.modal = null;
          $scope.selectedReceipt = null;
        });
      };

      this.type = 'credit_card';
      this.showOpen = true;
      this.receipts = [];
      this.selectAllReceipts = false;
      this.selectedReceipts = [];

      this.totalReceipts = 0;
      this.totalTips = 0;
      this.period = null;

      /**
       * Reset controller data
       */
      this.reset = function () {
        var handle = $ionicScrollDelegate.$getByHandle('pageContent');
        this.receipts = [];
        this.scroller.reset();

        if (handle) {
          $timeout(function () {
            handle.scrollTo(0, 0, true);
          }, 100);
        }
      };

      /**
       * @method resetSelectedReceipts
       */
      this.resetSelectedReceipts = function () {
        this.selectedReceipts = [];
        this.selectAllReceipts = false;
      };

      /**
       * Toggle receipt-type
       *
       * @param {String} type
       */
      this.show = function (type) {
        this.type = type || 'credit_card';
        this.reset();
        this.resetSelectedReceipts();
        this.update();
      };

      /**
       * Toggle open/closed _check status
       *
       * @param {Boolean} open
       */
      this.toggleOpen = function (open) {
        this.showOpen = !!open;
        this.reset();
        this.resetSelectedReceipts();
        this.update();
      };

      /**
       * Calculate the total tips for receipts
       */
      this.getTotalTips = function () {
        var total = 0;
        angular.forEach(this.receipts, function (receipt) {
          total += Number(receipt.tip);
        });
        this.totalTips = total;
      };

      /**
       * Parse current data to get param for API
       *
       * @param {Number} page
       * @return {Object}
       */
      this.getParams = function (page) {
        var period = this.period || {},
          status = (this.showOpen ? 'open' : 'closed') + '_check';

        return {
          before: period.before ? (new Date(period.before).getTime() / 1000) : null,
          after: period.after ? (new Date(period.after).getTime() / 1000) : null,
          page: page || 1,
          payment_method: this.type,
          per_page: 10,
          status: status
        };
      };

      /**
       * Update the currently relevant Receipt data from the server
       *
       * @param {Number} page
       * @param {Boolean} ignorePaginationHeaders
       */
      this.update = function (page, ignorePaginationHeaders) {
        ignorePaginationHeaders = !!ignorePaginationHeaders;

        this.loading = true;
        Receipts.getList(this.getParams(page)).then(function (response) {
          var headers = response.headers();

          if (!ignorePaginationHeaders) {
            self.scroller.success(headers);
          }
          self.receipts = Utilities.collections.merge(response.data, self.receipts);
          self.totalReceipts = Number(headers.total || 0);
          self.getTotalTips();
        }, function (error) {
          if (!ignorePaginationHeaders) {
            self.scroller.failure(error);
          }
        }).finally(function () {
          self.loading = false;
          $scope.$broadcast('scroll.infiniteScrollComplete');
        });
      };

      /**
       * @method refresh
       */
      this.refresh = function () {
        self.poll();
        totalOpenReceipts.refresh();
      };

      /**
       * @method updateReceiptDisputeStatus
       * @param {Object} e
       * @param {Object} data
       */
      this.updateReceiptDisputeStatus = function (e, data) {
        var receipt = self.receipts.find(function (r) { return r.id === data.receipt_id; });

        if (receipt && receipt.receipt_dispute && receipt.receipt_dispute.id === data.id) {
          $scope.$evalAsync(function () {
            receipt.receipt_dispute.status = data.status;
          });
        }
      };

      /**
       * Remove target receipt from local list
       *
       * @param {Number} id
       */
      this.removeReceipt = function (id) {
        var receipt = _.find(this.receipts, function (receipt) { return id === receipt.id; });
        if (receipt) {
          receipt.removed = true;
        }

        $timeout(function () {
          self.receipts = _.reject(self.receipts, function (receipt) { return id === receipt.id; });
        }, 1500);
      };

      /**
       * Display the selected receipt detials in a modal
       *
       * @param {Object} receipt
       */
      this.viewModal = function (receipt) {
        $scope.selectedReceipt = receipt;

        $ionicModal.fromTemplateUrl('app/views/modals/receipt-details.html', {
          backdropClickToClose: false,
          hardwareBackButtonClose: false,
          scope: $scope
        }).then(function (modal) {
          $scope.modal = modal;
          $scope.modal.show();
        });
      };

      /**
       * Confirm the desire to re-open a receipt
       *
       * @param {Object} receipt
       */
      this.reOpenReceipt = function (receipt) {
        zIonicPopup.confirm({
          okText: 'Re-open',
          okType: 'button-positive',
          template: 'Are you sure you wish to re-open this receipt?',
          title: 'Re-open receipt'
        }).then(function (answer) {
          if (answer) {
            receipt.toggle(false).then(function () {
              self.removeReceipt(receipt.id);
              self.update();
              totalOpenReceipts.refresh();
            });
          }
        });
      };

      /**
       * @method getSelectedReceipts
       */
      this.getSelectedReceipts = function () {
        this.selectedReceipts = this.receipts.filter(function (r) {
          return r.selected;
        }) || [];
      };

      /**
       * @method toggleAllSelectedReceipts
       */
      this.toggleAllSelectedReceipts = function () {
        var i = 0,
          length = this.receipts.length;

        if (!this.showOpen) {
          return;
        }

        for (i; i < length; i += 1) {
          this.receipts[i].selected = this.selectAllReceipts;
        }
        this.getSelectedReceipts();
      };

      /**
       * @method onReceiptToggled
       */
      this.onReceiptToggled = function () {
        this.getSelectedReceipts();
        this.selectAllReceipts = this.receipts.length === this.selectedReceipts.length;
      };

      /**
       * @method closeAllSelectedReceipts
       */
      this.closeAllSelectedReceipts = function () {
        var receiptIds,
          params;
        if (!this.showOpen || !this.selectedReceipts.length) {
          return;
        }

        receiptIds = this.selectedReceipts.map(function (receipt) { return receipt.id; });
        params = { receipt_ids: receiptIds };

        confirmBulkReceiptClosure.show(receiptIds.length).then(function(confirmed) {
          confirmed = !!confirmed;
          if (!confirmed) {
            return;
          }

          Receipts.one('bulk_close').customPUT(params).then(function () {
            Toast.show((self.selectedReceipts.length + ' receipts closed'));
            self.receipts = self.receipts.filter(function (receipt) {
              return receiptIds.indexOf(receipt.id) === -1;
            });
            self.resetSelectedReceipts();
            self.update();
            totalOpenReceipts.refresh();
          });
        });

      };

      modalPromise = $rootScope.$on('$closeReceiptDisputeModal', this.refresh);
      pollingPromise = $scope.$on('$pusherPolling', this.refresh);
      disputePromise = $rootScope.$on('$receiptDisputeUpdated', this.updateReceiptDisputeStatus);

      enterPromise = $scope.$on('$ionicView.enter', function () {
        zDateRangeLauncher.apply($scope);
        totalOpenReceipts.refresh();
      });

      onPromise = $scope.$on('$zDateRangeUpdated', function (e, period) {
        self.reset();
        self.period = period;
        self.update();
      });

      destroyPromise = $scope.$on('$destroy', function () {
        destroyPromise();
        modalPromise();
        pollingPromise();
        disputePromise();
        onPromise();
        enterPromise();
      });


    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('ReceiptModalCtrl', [
    '$ionicModal', '$rootScope', '$scope', '$ionicScrollDelegate', 'MixPanel', 'receiptDisputeTypes',
    function ($ionicModal, $rootScope, $scope, $ionicScrollDelegate, MixPanel, receiptDisputeTypes) {
      var self = this,
        angle = 0;

      /**
       * @method toggleScrollDelegate
       */
      function toggleScrollDelegate() {
        var delegateName = 'receiptDetailsModal',
          instances = $ionicScrollDelegate._instances || [],
          handle = instances.find(function (i) { return i.$$delegateHandle === delegateName; });

        if (handle) {
          handle.freezeScroll(self.view === 'image');
          handle.scrollTop();
        }
      }

      this.receiptDisputeTypes = receiptDisputeTypes;
      this.togglingCheck = false;
      this.rotationCls = '';
      this.view = ($scope.selectedReceipt && $scope.selectedReceipt.email_body_iframe) ? 'email' : 'image';
      this.disputeModal = null;
      toggleScrollDelegate();

      /**
       * Toggle the tab
       *
       * @param {String} view
       */
      this.toggleView = function (view) {
        this.view = view || 'image';
        toggleScrollDelegate();
      };

      /**
       * Rotate the image
       *
       * @param {Boolean} clockwise
       */
      this.rotateReceipt = function (clockwise) {
        angle += clockwise ? 90 : -90;

        if (angle > 270 || angle < -270) {
          angle = 0;
        }

        if (angle === 0) {
          self.rotationCls = '';
        } else {
          self.rotationCls = (angle > 0 ? 'clockwise' : 'anti-clockwise') + '-' + Math.abs(angle);
        }
      };

      /**
       * Toggle a receipt open / closed dependant on current status
       */
      this.toggleCheck = function () {
        var receipt = $scope.selectedReceipt || {},
          isOpen = receipt.status === 'open_check';

        if (this.togglingCheck) {
          return;
        }

        self.togglingCheck = true;
        receipt.toggle(isOpen).then(function () {
          MixPanel.track((isOpen ? 'close' : 'open') + '-receipt', receipt);
          $scope.onToggle();
        }).finally(function () {
          self.togglingCheck = false;
        });
      };

      /**
       * @method showDisputeModal
       */
      this.showDisputeModal = function () {
        var tpl = '<ion-modal-view class="z-modal-receipt-dispute"><receipt-dispute-modal receipt="selectedReceipt" on-re-open="removeAndRefresh()" modal="ReceiptModal.disputeModal"></receipt-dispute-modal></ion-modal-view>',
          options = {
            backdropClickToClose: false,
            scope: $scope
          };

        self.disputeModal = $ionicModal.fromTemplate(tpl, options);
        self.disputeModal.show();
      };

      /**
       * @method closeDisputeModal
       */
      this.closeDisputeModal = function () {
        if (self.disputeModal) {
          self.disputeModal.remove();
        }
      };

      $scope.$on('$destroy', this.closeDisputeModal.bind(this));
      $rootScope.$on('$closeReceiptDisputeModal', this.closeDisputeModal);

    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('ReorderCtrl', [
    '$log', '$scope', '$state', '$stateParams', '$ionicLoading', 'DeliveryZones', 'Order', 'Config', 'Restaurant', 'Utilities', 'pendingOrders',
    function ($log, $scope, $state, $stateParams, $ionicLoading, DeliveryZones, Order, Config, Restaurant, Utilities, pendingOrders) {
      var self = this,
        stateParams = $stateParams || {},
        orderId = stateParams.orderId;

      function goBack() {
        $state.go(Config.ROOT_LOGGED_IN_STATE);
        Order.reset();
      }

      $scope.isEdit = $state.current.name === 'app.edit-reorder';
      $scope.order = {};
      $scope.isOutsideBusinessDay = false;
      $scope.loading = true;
      $scope.config = Config;
      $scope.restaurant = Restaurant;
      $scope.deliveryZoneLoading = false;
      $scope.deliveryZoneStatus = {
        isWithinInner: true,
        isWithinOuter: false,
        isOutsideDeliveryZone: false
      };

      Order.init(orderId).then(function (order) {
        $scope.order = order;
        $scope.isOutsideBusinessDay = Utilities.orders.outsideBusinessDay(order);

        if (!$scope.isEdit) {
          if (order.isPickupOrder()) {
            $scope.order.status = 'do_not_deliver';        // re-ordering dismissed pickup order
            $scope.order.pickup_order_dismissed_at = null;
          } else {
            $scope.order.status = 'pending_assignment';    // reset the status since it's a fresh order
            self.getDeliveryZoneStatus();
          }

          $scope.order.delivery_notes = null;
          $scope.order.ready_by_time = null;
          $scope.order.oozo_pricing_accepted = false;

          if ($scope.order.address && $scope.order.address.id) {
            $scope.order.address.id = null;
          }
        }
      }).finally(function () {
        if (!$scope.deliveryZoneLoading) {  // don't show the form until we loaded delivery zones info, so they can't zoom OOZO re-order prematurely
          $scope.loading = false;
        }
      });

      /**
       * @method setDeliveryZoneStatus
       */
      this.getDeliveryZoneStatus = function () {
        var order = $scope.order,
          addressId = order.address_id;

        $scope.deliveryZoneLoading = true;             // We're not loading delivery zones for pickup orders
        DeliveryZones.check(addressId).then(function (deliveryZoneStatus) {
          $scope.deliveryZoneStatus = deliveryZoneStatus;
          $scope.deliveryZoneLoading = false;
          $scope.loading = false;
        });
      };

      /**
       * @method getLoadingMessage
       * @return {String}
       */
      this.showLoading = function () {
        var isEdit = $scope.isEdit,
          action = isEdit ? 'Updating' : 'Creating new';

        return $ionicLoading.show({
          template: '<i class="fa fa-refresh fa-spin"></i> ' + action + ' order'
        });
      };

      /**
       * Submit changes or new Order to the server; any External Order data should be removed
       */
      this.submit = function () {
        var params = Utilities.orders.getParams($scope.order);
        if (!params) {
          return;
        }
        params.order.source = 'Zoomer';
        params.order.receipt_provided_by_email_order = false;

        this.showLoading();
        if ($scope.isEdit) {
          return $scope.order.update().then(goBack, $log.error).finally($ionicLoading.hide);
        }

        params.order.reorder_of = Number(orderId);
        pendingOrders.create(params).then(goBack, $log.error).finally($ionicLoading.hide);

      };

      /**
       * Return to the Orders Queue state / page
       */
      this.goBack = function () {
        $ionicLoading.hide();
        $state.go(Config.ROOT_LOGGED_IN_STATE);
        Order.reset();
      };

    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('SettingsCtrl', [
    '$rootScope', '$scope', '$controller', '$timeout', '$ionicModal', 'zIonicPopup', '$ionicScrollDelegate', 'ThermalPrinter', 'Toast',
    function ($rootScope, $scope, $controller, $timeout, $ionicModal, zIonicPopup, $ionicScrollDelegate, ThermalPrinter, Toast) {
      $scope.availablePrinters = [];
      $scope.defaultPrinter = ThermalPrinter.getDefault();
      $scope.loading = false;
      $scope.printEnabled = ThermalPrinter.getOn();
      $scope.defaultNumberOfReceipts = ThermalPrinter.getDefaultNumberOfReceipts();

      this.isDefault = function(printer) {
        return $scope.defaultPrinter && printer.macAddress === $scope.defaultPrinter.macAddress;
      };

      this.testPrint = function() {
        ThermalPrinter.printTestReceipt()
          .then(function() {},
            function(error) {
              Toast.show(error || 'Could not test printer');
            });
      };

      this.setDefault = function(printer) {
        ThermalPrinter.setDefault(printer);
        $scope.defaultPrinter = ThermalPrinter.getDefault();
        ThermalPrinter.disconnect();
      };

      this.onPrintToggled = function() {
        $scope.printEnabled = !$scope.printEnabled;
        ThermalPrinter.setOn($scope.printEnabled);
      };

      this.subtractDefaultNumber = function() {
        $scope.defaultNumberOfReceipts--;
        ThermalPrinter.setDefaultNumberOfReceipts($scope.defaultNumberOfReceipts)
      };

      this.addDefaultNumber = function() {
        $scope.defaultNumberOfReceipts++;
        ThermalPrinter.setDefaultNumberOfReceipts($scope.defaultNumberOfReceipts)
      };

      this.shouldShowThermalPrinterSettings = function() {
        return ThermalPrinter.featureEnabled();
      };

      if (this.shouldShowThermalPrinterSettings()) {
        $scope.loading = true;

        $scope.$on('$ionicView.enter', function () {
          $scope.loading = true;
          ThermalPrinter.queryPrinters()
            .then(function (printers) {
              $scope.loading = false;
              $scope.availablePrinters = printers;
              $scope.$apply();
            }, function (error) {
              $scope.loading = false;
              $scope.$apply();
            });
        });
      }
    }
  ]);
}());

(function () {
  'use strict';

  /** @ngInject */
  function toggleFoodReadyNowCtrl($scope, confirmFoodReadyNow, foodReady) {
    var vm = this;

    /**
     * @method toggle
     * @param {Boolean} setFoodReadyNow
     */
    vm.toggle = function (setFoodReadyNow) {
      setFoodReadyNow = Boolean(setFoodReadyNow);
      var order = $scope.order || {},
        orderId = order.id;

      if (!orderId) {
        return;
      }

      if (!setFoodReadyNow) {
        return foodReady.toggle(orderId, false).then(function () {
          order.food_ready_now = null;
        });
      }

      confirmFoodReadyNow.show().then(function (confirmed) {
        if (confirmed) {
          foodReady.toggle(orderId, true).then(function () {
            order.food_ready_now = true;
          });
        }
      });
    };
  }

  angular.module('zoomerRestaurant')
    .controller('toggleFoodReadyNowCtrl', toggleFoodReadyNowCtrl);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('ViewOrderCtrl', [
    '$scope', '$stateParams', '$ionicModal', 'Receipts', 'Restaurant', 'Utilities', 'orderSourceModal', 'ordersQueue', 'ThermalPrinter',
    function ($scope, $stateParams, $ionicModal, Receipts, Restaurant, Utilities, orderSourceModal, ordersQueue, ThermalPrinter) {
      var self = this,
        params = $stateParams || {},
        orderId = params.orderId;

      this.restaurant = Restaurant;
      this.utilities = Utilities;
      this.orderId = orderId;
      this.loading = false;
      this.hasError = false;
      this.loadingReceipt = false;
      this.orderSourceModal = orderSourceModal;
      $scope.printStatus = null;

      this.getReceipt = function () {
        this.hasError = false;
        this.loadingReceipt = true;

        Receipts.one($scope.order.receipt_id).get().then(function (response) {
          self.loadingReceipt = false;
          $scope.selectedReceipt = response.data;
        }, function () {
          self.hasError = true;
          self.loadingReceipt = false;
        });
      };

      /**
       * Remove the IOU from this Order
       *
       * @param {Object} order
       */
      this.removeIou = function (order) {
        order = order || {};
        if (!order.driver_iou || !order.id) {
          return;
        }

        order.driver_iou = null;
        order.update().then(this.getOrder.bind(this, true));
      };

      /**
       * Fetch the Order from the server
       *
       * @param {Boolean} silent
       */
      this.getOrder = function (silent) {
        silent = !!silent;
        if (!this.orderId) {
          return;
        }

        if (!silent) {
          this.loading = true;
        }

        ordersQueue.getById(orderId, { timeline: true, include_items: true }).then(function (response) {
          var order = response.data;
          order.outsideBusinessDay = Utilities.orders.outsideBusinessDay(order);
          $scope.order = order;
          if ($scope.order.status === 'delivered' && $scope.order.receipt_id) {
            self.getReceipt();
          }
        }).finally(function () {
          self.loading = false;
        });
      };

      $scope.trustedBodyHTML = null;
      $scope.selectedReceipt = null;

      /**
       * View the receipt Image / External Order HTML
       */
      $scope.viewReceipt = function () {
        $ionicModal.fromTemplateUrl('app/views/modals/receipt-details.html', {
          scope: $scope
        }).then(function (modal) {
          $scope.modal = modal;
          $scope.modal.show();
        });
      };

      $scope.print = function() {
        var self = this;
        $ionicModal.fromTemplateUrl('app/views/modals/print-receipt-modal.html', {
          scope: $scope
        }).then(function (modal) {
          $scope.modal = modal;
          $scope.modal.show();
        });
        $scope.printStatus = 'Printing';
        ThermalPrinter.printOrder($scope.order, self.restaurant.info)
          .then(function() {
            $scope.closeModal();
          }, function(error) {
            $scope.printStatus = error || 'Error';
          });
      };

      $scope.shouldShowPrint = function() {
        return ThermalPrinter.shouldPrintOrder($scope.order);
      };

      /**
       * Close the modal and $destroy it and receipt data
       */
      $scope.closeModal = function () {
        $scope.modal.hide().then(function () {
          $scope.modal.remove();
          $scope.modal = null;
          $scope.selectedReceipt = null;
        });
      };

      /**
       * Callback for shared controller
       */
      $scope.onToggle = function () {
        var receipt = $scope.selectedReceipt || {},
          id = receipt.id;

        Receipts.one(id).get().then(function (response) {
          $scope.selectedReceipt = response.data || {};
          $scope.closeModal();
        });
      };

      /**
       * Close the modal
       */
      $scope.closeModal = function () {
        $scope.togglingCheck = false;
        if ($scope.modal) {
          $scope.modal.hide();
        }
      };

      this.getOrder();

    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('bindShiftKey', [
    '$rootScope',
    function ($rootScope) {
      return function (scope, element) {
        $rootScope.isShiftKey = false;

        element.on('keydown', function (e) {
          $rootScope.$evalAsync(function () {
            $rootScope.isShiftKey = !!e.shiftKey;
          });
        });

        element.on('keyup', function () {
          $rootScope.$evalAsync(function () {
            $rootScope.isShiftKey = false;
          });
        });
      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('dateRangeFilter', [
    '$parse', '$window',
    function ($parse, $window) {
      var moment = $window.moment;

      moment.locale('en', {
        calendar : {
          lastDay : '[Yesterday]',
          sameDay : '[Today]',
          nextDay : '[Tomorrow] LT',
          lastWeek : '[Last] dddd',
          nextWeek : 'dddd [at] LT',
          sameElse : 'L'
        }
      });

      function controller($scope) {
        $scope.useIsoWeek = false;

        $scope.period = {
          all: {
            value: 'All'
          },

          day: {
            increment: 0,
            after: null,
            before: null,
            value: ''
          },

          week: {
            increment: 0,
            after: null,
            before: null,
            value: ''
          },

          month: {
            increment: 0,
            after: null,
            before: null,
            value: ''
          }
        };

        /**
         * @method updateDayPeriod
         */
        $scope.updateDayPeriod = function () {
          var dayPeriod = $scope.period.day,
            start;

          start = moment().subtract(dayPeriod.increment, 'days');

          dayPeriod.value = start.calendar();
          dayPeriod.after = start.startOf('day').add(6, 'hours').format();
          dayPeriod.before = start.endOf('day').add(6, 'hours').format();

          $scope.notify();
        };

        /**
         * @method updateOtherPeriods
         */
        $scope.updateOtherPeriods = function () {
          var type = $scope.periodType,
            start,
            period;

          start = moment().subtract($scope.period[type].increment, type);
          period = $scope.period[type];

          type = (!!$scope.useIsoWeek && type === 'week') ? 'isoweek' : type;

          if (type === 'isoweek' || type === 'week') {
            period.value = start.startOf(type).format('ll') + ' - ' + start.endOf(type).format('ll');
          }

          if (type === 'month') {
            period.value = start.format('MMMM YYYY');
          }

          period.after = start.startOf(type).format();
          period.before = start.endOf(type).format();

          $scope.notify();
        };

        /**
         * @method updatePeriod
         */
        $scope.updatePeriod = function () {
          var type = $scope.periodType;

          if (type === 'all') {
            $scope.notify();
          } else if (type === 'day') {
            $scope.updateDayPeriod();
          } else {
            $scope.updateOtherPeriods();
          }

        };

        /**
         * @method setPeriodType
         * @param {String} period
         */
        $scope.setPeriodType = function (period) {
          $scope.periodType = period || 'day';
          if (period) {
            $scope.updatePeriod();
          }
        };

        /**
         * @method setIncrement
         * @param {Boolean} next
         */
        $scope.setIncrement = function (next) {
          next = !!next;

          var type = $scope.periodType,
            period = $scope.period[type],
            increment = next ? -1 : 1;

          if (next && period.increment === 0) {
            return;
          }

          period.increment += increment;
          $scope.updatePeriod();
        };

        /**
         * Emit event across scope of dateRange change
         */
        $scope.notify = function () {
          $scope.$emit('$zDateRangeUpdated', $scope.period[$scope.periodType]);
        };

        $scope.$on('$zDateRangeInit', function () {
          $scope.updatePeriod();
        });
      }

      function link(scope, element, attributes) {
        scope.showAll = !!attributes.showAll;
        scope.periodType = scope.showAll ? 'all' : 'day';
        scope.useIsoWeek = $parse(attributes.isoWeek)(scope);
      }

      return {
        controller: ['$scope', controller],
        link: link,
        replace: true,
        restrict: 'AE',
        templateUrl: 'app/views/date-range-filter.html'
      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('driverOrderStatus', [
    '$timeout',
    function ($timeout) {
      function link(scope) {
        var timeout,
          destroyPromise,
          watchPromise;

        function hasRbtElapsed() {
          var order = scope.order,
            orderStatus = order.driver_order_status,
            now = new Date().getTime(),
            rbtMs = new Date(order.ready_by_time).getTime();

          scope.isRbtElapsed = (rbtMs - now) < 0;

          if (scope.isRbtElapsed &&  !!orderStatus && !!order.not_ready_at) {
            scope.status = 'waiting';
            scope.cls = 'is-waiting';
            return;
          }

          if (orderStatus) {
            scope.status = orderStatus;
            scope.cls = 'is-' + orderStatus;
            return;
          }
          scope.status = null;
          scope.cls = '';
        }

        scope.cls = '';
        scope.isRbtElapsed = false;
        scope.status = null;

        timeout = $timeout(hasRbtElapsed, 30000);

        watchPromise = scope.$watchGroup([ 'order.not_ready_at', 'order.driver_order_status' ], function () {
          hasRbtElapsed();
        });

        destroyPromise = scope.$on('$destroy', function () {
          destroyPromise();
          watchPromise();
          $timeout.cancel(timeout);
          timeout = null;
        });
      }

      return {
        link: link,
        scope: true,
        template: '<span ng-show="status" ng-bind="status" class="{{cls}} badge badge-assertive"></span>'
      };
    }
  ]);
}());

(function () {
  'use strict';

  var EVENT_NAME = 'click',
    DELAY = 500;

  /** @ngInject */
  function ngClick($parse, $timeout, MixPanel) {
    function link(scope, element, attributes) {
      var mixPanelKey = attributes.mixPanel || '',
        destroyPromise,
        mixPanelData,
        timeout;

      if (!mixPanelKey || !mixPanelKey.length) {
        return;
      }

      function onClick() {
        if (timeout) {
          return;
        }

        mixPanelData = $parse(attributes.mixPanelData)(scope);
        $timeout(function () {
          MixPanel.track(mixPanelKey, mixPanelData);
          timeout = null;
        }, DELAY);
      }

      element.on(EVENT_NAME, onClick);

      destroyPromise = scope.$on('$destroy', function () {
        destroyPromise();
        element.off(EVENT_NAME, onClick);
      });
    }

    return {
      link: link,
      priority: 0
    };
  }

  angular.module('zoomerRestaurant')
    .directive('ngClick', ngClick);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('oozoPopoverOptions', [
    function () {
      return {
        restrict: 'AE',
        templateUrl: 'app/views/popovers/oozo-popover-options.html'
      };
    }
  ]);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').directive('openCloseRestaurant', [
    '$ionicModal', '$ionicSideMenuDelegate', 'Restaurant', 'MixPanel', '$rootScope',
    function ($ionicModal, $ionicSideMenuDelegate, Restaurant, MixPanel, $rootScope) {
      return {
        templateUrl: 'app/views/open-close-restaurant.html',
        replace: true,
        link: function (scope) {
          var params = {
              scope: scope
            };

          function complete() {
            scope.isTogglingRestaurant = false;
            $ionicSideMenuDelegate.toggleLeft(false);
          }

          scope.numOpen = 0;
          scope.numClosed = 0;
          scope.numPaused = 0;
          scope.tempPausedThreshold = 60;
          scope.restaurantArray = $rootScope.restaurantArray;
          scope.confirmModal = null;
          scope.isTogglingRestaurant = false;
          scope.disableOpenBtn = false;
          $rootScope.disableConfirmBtn = true;
          $rootScope.disableConfirmBtnFooter = true;
          scope.backupRestaurantArray = [];

          /**
           * Close the modal
           */
          scope.closeModal = function () {
            scope.confirmModal.hide();
          };

          /**
           * Toggle the restaurant open/closed
           */
          scope.toggleRestaurant = function () {
            var restaurant = Restaurant.info,
              isOpen = restaurant.status === 'active';
            scope.disableOpenBtn = true;

            scope.confirmModal.hide().then(function () {
              scope.isTogglingRestaurant = true;
              scope.disableOpenBtn = false;
              Restaurant.toggleOpening(!isOpen).then(complete, complete);
            });
          };

          /**
           * Access number of ghost kitchens marked open or paused
           */
          scope.getGkOpenClosed = function() {
            var i;
            scope.numOpen = scope.numClosed = scope.numPaused = 0;
            for (i = 0; i < $rootScope.restaurantArray.length; i++) {
              if ($rootScope.restaurantArray[i].openStatus === false) {
                if ($rootScope.restaurantArray[i].pauseLength <= scope.tempPausedThreshold && $rootScope.restaurantArray[i].reopenTime !== null) {
                  scope.numPaused++;
                } else {
                  scope.numClosed++;
                }
              }
              else scope.numOpen++;
            }
          };

          /**
           * Display full screen modal for managing open/closed status of ghost kitchens
           */
          scope.openManageStatusPage = function() {
            $rootScope.disableConfirmBtn = true;
            $rootScope.disableConfirmBtnFooter = true;
            scope.restaurantArray = $rootScope.restaurantArray;
            $ionicModal.fromTemplateUrl('app/views/modals/pause-unpause-ghost-kitchens.html', {scope: scope}).then(function (modal) {
              scope.confirmModal = modal;
              scope.confirmModal.show();
            });
          };

          /**
           * Toggle the closure of the restaurant
           */
          scope.toggleRestaurantOpening = function () {
            var restaurant = Restaurant.info,
              isOpen = restaurant.status === 'active';

            if (scope.isTogglingRestaurant) {
              return;
            }

            if (isOpen){
              $ionicModal.fromTemplateUrl('app/views/modals/confirm-close.html', params).then(function (modal) {
                scope.confirmModal = modal;
                scope.confirmModal.show();
              });
              MixPanel.track('pause-orders');
            } else {
              $ionicModal.fromTemplateUrl('app/views/modals/confirm-open.html', params).then(function (modal) {
                scope.confirmModal = modal;
                scope.confirmModal.show();
              });
              MixPanel.track('unpause-orders');
            }
          };
        }
      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('orderEta', [
    '$window',
    function ($window) {
      return {
        templateUrl: 'app/views/order-eta.html',
        replace: true,
        scope: {
          order: '='
        },

        link: function (scope, element) {
          var order = scope.order,
            activeTimeout = null,
            currentValue;

          scope.isAfter = false;
          scope.time = '';
          scope.isNow = false;

          /**
           * Cancel any timeout that may exist onDestroy
           */
          function cancelTimer() {
            if (activeTimeout) {
              $window.clearTimeout(activeTimeout);
              activeTimeout = null;
            }
          }

          /**
           * Update the time difference between now and the RBT
           */
          function updateTime() {
            var now = new Date(),
              orderRbt = scope.order.ready_by_time,
              diff = Date.parse(orderRbt) - now,
              minutesFromNow = Math.round(diff / 1000 / 60),
              howOld,
              secondsUntilUpdate;

            scope.$evalAsync(function () {
              scope.isNow = diff < 0 && diff > -60000;
              scope.minutesFromNow = minutesFromNow;
              scope.isAfter = minutesFromNow < 0;
            });

            howOld = Math.abs(minutesFromNow);

            secondsUntilUpdate = 3600;

            if (howOld <= 2) {
              secondsUntilUpdate = 1;
            } else if (howOld < 60) {
              secondsUntilUpdate = 30;
            } else if (howOld < 180) {
              secondsUntilUpdate = 300; // 5 minutes
            }

            activeTimeout = $window.setTimeout(function () {
              updateTime();
            }, secondsUntilUpdate * 1000);
          }

          function updateMoment() {
            cancelTimer();
            if (currentValue) {
              updateTime();
            }
          }

          scope.$watch('order.ready_by_time', function (value) {
            if ((typeof value === 'undefined') || (value === null) || (value === '')) {
              cancelTimer();
              if (currentValue) {
                element.text('');
                currentValue = null;
              }
              return;
            }
            currentValue = value;
            updateMoment();
          });

          scope.$on('$destroy', function () {
            cancelTimer();
          });

        }
      };

    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('orderHistoryRbt', [
    function () {
      var tpl = '<span>' +
        '<span ng-if="!isFinished">&nbsp;</span>' +
        '<span ng-if="isFinished"><span ng-if="!isNotReady">On time</span><span ng-if="isNotReady" ng-bind="minutesBeyondRbt + \' mins late\'"></span></span>' +
        '</span>';

      function link(scope) {
        var order = scope.order || {},
          status = order.status,
          isFinished = status === 'cancelled' || status === 'delivered' || status === 'undeliverable',
          notReady,
          rbt;

        scope.isFinished = !!isFinished;
        scope.isNotReady = !!order.not_ready_at;
        scope.minutesBeyondRbt = 0;

        if (scope.isFinished && scope.isNotReady) {
          notReady = Date.parse(order.not_ready_at);
          rbt = Date.parse(order.ready_by_time);
          scope.minutesBeyondRbt = Math.floor((notReady - rbt) / 60000);
        }
      }

      return {
        link: link,
        replace: true,
        restrict: 'AE',
        template: tpl
      };
    }
  ]);

}());
(function () {
  'use strict';

  /** @ngInject */
  function orderInternalId() {
    return {
      scope: {
        order: '=orderInternalId'
      },
      template: '<div ng-if="$root.features.checkEnabled(\'order_internal_id\') && order.internal_id" class="z-order-internal-id" ng-bind="order.internal_id"></div>'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('orderInternalId', orderInternalId);

}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').directive('orderLogo', [
    function () {
      function toLower(string) {
        string = string || '';
        return string.toLowerCase();
      }

      return {
        replace: true,
        scope: {
          order: '=orderLogo'
        },
        template: '<i class="order-logo" ng-class="orderLogoClass"></i>',
        link: function (scope) {
          var order = scope.order || {},
            thirdPartyId = order.third_party_id || toLower(order.source) === 'thirdparty',
            parser = order.parser_used,
            splitSource,
            name;

          scope.orderLogoClass = 'none';

          if (!order.id) {
            return;
          }

          if (thirdPartyId) {
            scope.orderLogoClass = 'third-party-logo';
          } else if (parser) {
            splitSource = parser.split(':');
            name = splitSource[splitSource.length - 1];
            scope.orderLogoClass = toLower(name) + '-logo';
          } else if (order.source) {
            scope.orderLogoClass = toLower(order.source) + '-logo';
          }
        }
      };
    }
  ]);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').directive('orderTimeline', [
    'Timeline',
    function (Timeline) {

      function link(scope) {
        Timeline.parse(scope.order);
        scope.orderTimeline = Timeline;
      }

      return {
        link: link,
        replace: true,
        restrict: 'AE',
        templateUrl: 'app/views/orders/timeline.html'
      };
    }
  ]);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').directive('ordersSubHeader', [
    function () {
      return {
        replace: true,
        restrict: 'AE',
        templateUrl: 'app/views/orders/sub-header.html'
      };
    }
  ]);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').directive('restaurantLogo', [
    function () {

      function link(scope, element) {
        var img = element.find('img');

        scope.alignWidth = false;

        scope.alignLogo = function () {
          var imgEl = img[0],
            imgWidth = imgEl.clientWidth,
            imgHeight = imgEl.clientHeight;

          scope.$evalAsync(function () {
            scope.alignWidth = imgWidth > imgHeight;
          });
        };

        img.bind('load', scope.alignLogo);
      }

      return {
        link: link,
        replace: true,
        restrict: 'AE',
        template: '<span><img ng-src="{{restaurant.info.logo.smallx3}}" ng-class="{ \'align-width\': alignWidth }" alt="Description" /></span>'
      };
    }
  ]);
}());
(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('stickyHeader', [
    function () {
      return {
        link: function (scope) {
          var destroyPromise,
            stickyPromise;

          scope.showStickyHeader = false;

          stickyPromise = scope.$on('$zToggleSticky', function (e, toggle) {
            scope.showStickyHeader = !!toggle;
          });

          destroyPromise = scope.$on('$destroy', function () {
            destroyPromise();
            stickyPromise();
          });
        }
      };
    }
  ]);


}());
(function () {
  'use strict';

  function toggleFoodReadyNow() {
    return {
      controller: 'toggleFoodReadyNowCtrl as vm',
      scope: {
        order: '='
      },
      templateUrl: 'app/views/toggle-food-ready-now.html'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('toggleFoodReadyNow', toggleFoodReadyNow);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('zAppUpdater', [
    '$rootScope', '$window', '$state', '$timeout', 'Config', 'Device', 'IonicDeploy',
    function ($rootScope, $window, $state, $timeout, Config, Device, IonicDeploy) {

      function controller($scope) {
        var raven = $window.Raven,
          statePromise,
          deploy;

        var MILLISECONDS_IN_MINUTE = 60 * 1000;
        var INITIAL_DELAY = 1 * 5 * 1000;
        var PROGRESS_RESET_DELAY = 1 * 5 * 1000;

        $scope.showUpdater = false;
        $scope.hasError = false;

        $scope.downloadProgress = 0;
        $scope.extractProgress = 0;

        $scope.isDownloading = false;
        $scope.isExtracting = false;

        /**
         * If there's an error anywhere in the process, reset values and ping Sentry
         *
         * @param {Object} error
         */
        $scope.onIonicDeployError = function (error) {
          raven.captureException(error, { extra: { appVersion: Device.version, zoomerAppVersion: Config.ZOOMER_APP_VERSION } });
          $scope.hasError = true;
          $scope.isDownloading = false;
          $scope.isExtracting = false;

          $timeout(function () {
            $scope.hasError = false;
            $scope.showUpdater = false;
            $scope.setDownloadProgress();
            $scope.setExtractProgress();
          }, PROGRESS_RESET_DELAY);
        };

        /**
         * Set the extract progress indicator
         *
         * @param {Number} progress
         */
        $scope.setExtractProgress = function (progress) {
          $scope.$evalAsync(function () {
            $scope.extractProgress = (progress || 0) / 100;
          });
        };

        /**
         * Set the download progress indicator
         *
         * @param {Number} progress
         */
        $scope.setDownloadProgress = function (progress) {
          $scope.$evalAsync(function () {
            $scope.downloadProgress = (progress || 0) / 100;
          });
        };

        /**
         * If the User is in any root (non-Order based) states, autodeploy the update.
         * Otherwise, listen for state changes and autodeploy when state changes to valid root state
         */
        $scope.autoExtractUpdate = function () {
          var validStates = [ 'login', 'app.orders', 'app.orders-queue', 'app.orders-inProgress', 'app.orders-delivered', 'app.orders-specialOrders', 'app.history', 'app.receipts'],
            current = $state.current || {},
            name = current.name || '';

          $scope.showUpdater = false;
          $scope.isExtracting = false;

          if (_.contains(validStates, name)) {
            deploy.redirect(angular.noop, $scope.onIonicDeployError);
            return;
          }

          if (statePromise) { // Already coerced to boolean - no need to '!!' see http://eslint.org/docs/2.0.0/rules/no-extra-boolean-cast
            statePromise();
          }

          statePromise = $rootScope.$on('$stateChangeSuccess', function (e, toState) {
            if (_.contains(validStates, toState.name)) {
              statePromise();
              deploy.redirect(angular.noop, $scope.onIonicDeployError);
            }
          });
        };

        /**
         * Extract the App update and prompt user to install now or later
         */
        $scope.extractUpdate = function () {
          if (!deploy) {
            return;
          }

          $scope.isDownloading = false;
          $scope.isExtracting = true;
          deploy.extract($scope.onIonicDeployExtractEvent, $scope.onIonicDeployError);
        };

        /**
         * Success callback function for Ionic Pro update extraction
         * @param {String or Number} extractEvent number representing percent of completion,
         *  or string 'done' if extraction has finished
         */
        $scope.onIonicDeployExtractEvent = function (extractEvent) {
          if(extractEvent === 'done') {
            $scope.autoExtractUpdate();
          } else {  //progress update event
            $scope.setExtractProgress(extractEvent);
          }
        };

        /**
         * Fetch the update package from Ionic Pro servers
         */
        $scope.downloadUpdate = function () {
          if (!deploy) {
            return;
          }
          $scope.isDownloading = true;
          deploy.download($scope.onIonicDeployDownloadEvent, $scope.onIonicDeployError);
        };

        /**
         * Success callback function for Ionic Pro update downloader
         * @param {String or Number} downloadEvent number representing percent of completion,
         *  or string 'true' if download has finished
         */
        $scope.onIonicDeployDownloadEvent = function (downloadEvent) {
          if(downloadEvent === 'true') {
            $scope.extractUpdate();
          } else {  //progress update event
            $scope.setDownloadProgress(downloadEvent);
          }
        };

        /**
         * When IonicDeploy is ready, check the server for any updates to the App
         */
        $scope.watchForUpdates = function () {
          if (!deploy) {
            return;
          }

          function checkForUpdates () {
            if (!deploy) {
              return;
            }

            deploy.check(function (hasUpdateAvailable) {

              $scope.showUpdater = hasUpdateAvailable === 'true';

              if ($scope.isDownloading) {
                return;
              }

              if (hasUpdateAvailable === 'true') {
                $scope.downloadUpdate();
              }
            }, $scope.onIonicDeployError);

            $timeout(checkForUpdates.bind($scope), Config.IONIC_DEPLOY_CHECK_INTERVAL * MILLISECONDS_IN_MINUTE);
          }

          $timeout(checkForUpdates.bind($scope), INITIAL_DELAY);
        };

        IonicDeploy.then(function (deployInstance) {
          if (deployInstance) {
            deploy = deployInstance;
            $scope.watchForUpdates();
          }
        });
      }

      return {
        controller: [ '$scope', controller ],
        replace: true,
        templateUrl: 'app/views/z-app-updater.html'
      };
    }
  ]);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').directive('zClick', [
    '$window', '$parse',
    function ($window, $parse) {
      var events = {
          start: [ 'touchstart', 'mousedown' ],
          end: [ 'touchend', 'mouseup' ]
        },
        ionic = $window.ionic,
        platform = ionic.Platform,
        isTouchdevice = platform.isIPad(),
        cls = 'z-activated',
        mappedEvents = {};

      angular.forEach(events, function (event, key) {
        mappedEvents[key] = (isTouchdevice ? event[0] : event[1]);
      });

      return function (scope, element, attr) {
        var destroyPromise;

        element.on(mappedEvents.start, function () {
          element.addClass(cls);
        });

        element.on(mappedEvents.end, function (e) {
          $parse(attr.zClick)(scope, { $event: e });
          element.removeClass(cls);
        });

        destroyPromise = scope.$on('$destroy', function () {
          var offEvents = mappedEvents.start + ' ' + mappedEvents.end;
          destroyPromise();
          element.off(offEvents);
        });
      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').directive('zoomerLogo', [
    function () {
      return {
        templateUrl: 'assets/images/es_logo_small.svg'
      };
    }
  ]);
}());
(function () {
  'use strict';

  /** @ngInject */
  function DriverFeedbackCtrl($ionicSideMenuDelegate, $rootScope, $scope, $state, $timeout, $window, Config, Features, LogEntries, Toast, driverFeedbacks, driverFeedbackReasons, unratedDrivers) {
    var vm = this,
      speed = 300,
      enterPromise,
      leavePromise,
      destroyPromise;

    vm.driverFeedbacks = driverFeedbacks;
    vm.driverFeedbackReasons = null;
    vm.slider = null;
    vm.submittedAll = false;
    vm.unratedDrivers = unratedDrivers;

    vm.options = {
      centeredSlides: true,
      longSwipesMs: 100,
      pagination: false,
      shortSwipes: false,
      slidesPerView: 3,
      slideToClickedSlide: true,
      spaceBetween: ($rootScope.isMobileDevice ? 500 : 0),
      touchAngle: 30,
      speed: speed
    };

    vm.rating = {
      negative: 0,
      neutral: 1,
      positive: 2
    };

    /**
     * @method selectRating
     * @param {Object} driver
     * @param {String} rating
     */
    vm.selectRating = function (driver, rating) {
      driver.rating = rating || null;
      if (rating === 'positive') {
        vm.submit(driver);
      } else if (!rating) {
        vm.setReason(driver);
      }
    };

    /**
     * @method setReason
     * @param {Object} driver
     * @param {Number} reasonId
     */
    vm.setReason = function (driver, reasonId) {
      if (!reasonId) {
        driver.driver_feedback_reason_ids = [];
        return;
      }

      if (driver.driver_feedback_reason_ids.indexOf(reasonId) > -1) {
        driver.driver_feedback_reason_ids = driver.driver_feedback_reason_ids.filter(function (id) {
          return id !== reasonId;
        });
      } else {
        driver.driver_feedback_reason_ids.push(reasonId);
      }
    };

    /**
     * @method sendWarningToast
     */
    vm.sendWarningToast = function () {
      Toast.warning('', 'Whoops! There was a problem submitting your Feedback; please try again', {
        iconClass: 'zoomer-toast-warning',
        tapToDismiss: true
      });
    };

    /**
     * @method submit
     * @param {Object} driver
     */
    vm.submit = function (driver) {
      var params = driver.getParams();

      driver.submitting = true;
      driver.submitted = false;
      driverFeedbacks.post(params).then(function () {
        driver.submitted = true;
      }, function (error) {
        LogEntries.log('Error submitting driver feedback for', driver.name, params, error);
        driver.submitting = false;
        vm.selectRating(driver);
        vm.sendWarningToast();
      });
    };

    /**
     * @method removeFromSlider
     * @param {Object} driver
     * @param {Number} index
     */
    vm.slideNextAndRemove = function (driver, index) {
      if (index === vm.unratedDrivers.all.length - 1) {
        vm.slider.slidePrev();
      } else {
        vm.slider.slideNext();
      }

      $timeout(function () {
        vm.slider.removeSlide(index);
        vm.unratedDrivers.reject(driver.id);
        vm.submittedAll = !vm.unratedDrivers.all.length;
      }, speed + 10);
    };

    enterPromise = $scope.$on('$ionicView.enter', function () {
      $ionicSideMenuDelegate.canDragContent(false);
      vm.driverFeedbackReasons = driverFeedbackReasons.getList();
      vm.submittedAll = false;
      unratedDrivers.getList();
    });

    leavePromise = $scope.$on('$ionicView.leave', function () {
      $ionicSideMenuDelegate.canDragContent(true);
      vm.submittedAll = false;
    });

    destroyPromise = $scope.$on('$destroy', function () {
      destroyPromise();
      enterPromise();
      leavePromise();
    });

    // Patch to fix Ionic issue: https://github.com/ionic-team/ionic-v1/issues/313
    // Remove 'special-keyboard-open' (see _slides.scss) from the DOM when keyboard is openned. 
    $window.addEventListener('native.keyboardhide', function() {
      $timeout(function() {
        document.body.classList.remove('special-keyboard-open');
      }, 400);  //set 400ms delay to match Ionic's 'keyboard-show' delay
    });
    
    // Add 'special-keyboard-open' (see _slides.scss) to the DOM when keyboard is openned. Can't trust 'keyboard-open' class.
    $window.addEventListener('native.keyboardshow', function() {
      $timeout(function() {
        document.body.classList.add('special-keyboard-open');
      }, 400);  //set 400ms delay to match Ionic's 'keyboard-show' delay
    });


  }

  angular.module('zoomerRestaurant.driverFeedback')
    .controller('DriverFeedbackCtrl', DriverFeedbackCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.drivers-feedback', {
      url: '/drivers-feedback',
      ownParams: { name: 'driversFeedback' },
      views: {
        'menu-content': {
          templateUrl: 'app/driverFeedback/driverFeedback.html',
          controller: 'DriverFeedbackCtrl as vm'
        }
      }
    });
  }

  angular.module('zoomerRestaurant.driverFeedback')
    .config(config);

}());

(function () {
  'use strict';

  /** @ngInject */
  function driverFeedbackReasons(Restangular) {
    return Restangular.service('driver_feedback_reasons');
  }

  angular.module('zoomerRestaurant.driverFeedback')
    .factory('driverFeedbackReasons', driverFeedbackReasons);

}());

(function () {
  'use strict';

  /** @ngInject */
  function driverFeedbacks(Restangular) {
    var serviceName = 'driver_feedbacks';
    return Restangular.service(serviceName);
  }

  angular.module('zoomerRestaurant.driverFeedback')
    .factory('driverFeedbacks', driverFeedbacks);

}());

(function () {
  'use strict';

  /** @ngInject */
  function ionSlidePage($animate, $parse) {
    function link(scope, element, attributes) {
      var destroyPromise,
        watchPromise;

      if (!scope.driver) {
        return;
      }

      watchPromise = scope.$watch('driver.submitted', function (submitted) {
        if (!submitted) {
          return;
        }

        $animate.addClass(element, 'slide-down').then(function () {
          $parse(attributes.onSubmitted)(scope);
        });
      });

      destroyPromise = scope.$on('$destroy', function () {
        destroyPromise();
        watchPromise();
      });
    }

    return {
      link: link,
      priority: 0
    };
  }

  angular.module('zoomerRestaurant')
    .directive('ionSlidePage', ionSlidePage);

}());

(function () {
  'use strict';

  /** @ngInject */
  function unratedDrivers($filter, Restangular, Restaurant) {
    var serviceName = 'restaurants',
      endPoint = 'unrated_drivers',
      resource = Restangular.service(serviceName);

    Restangular.extendModel(endPoint, function (unratedDriver) {

      /**
       * @method getParams
       * @return {Object}
       */
      unratedDriver.getParams = function () {
        return {
          driver_feedback: {
            driver_id: unratedDriver.id,
            rating: unratedDriver.rating,
            driver_feedback_reason_ids: unratedDriver.driver_feedback_reason_ids,
            description: unratedDriver.description
          }
        };
      };

      unratedDriver.abbreviatedName = $filter('getFirstName')(unratedDriver.name);
      unratedDriver.driver_feedback_reason_ids = [];

      unratedDriver.unrated_orders.sort(function (orderA, orderB) {
        var pickedUpAtA = new Date(orderA.pickup_completed_at).getTime(),
          pickedUpAtB = new Date(orderB.pickup_completed_at).getTime();
        return pickedUpAtB - pickedUpAtA;
      });
      return unratedDriver;
    });

    return angular.extend(resource, {
      all: [],

      /**
       * @method getList
       * @return {Object} $promise
       */
      getList: function () {
        return this.one((Restaurant.info || {}).id).getList(endPoint).then(function (response) {
          resource.all = response.data;
        });
      },

      /**
       * @method reject
       * @param {Number} driverId
       */
      reject: function (driverId) {
        resource.all = resource.all.filter(function (driver) {
          return driver.id !== driverId;
        });
      }
    });
  }

  angular.module('zoomerRestaurant.driverFeedback')
    .factory('unratedDrivers', unratedDrivers);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('deliverAt', {
      bindings: {
        order: '<'
      },
      bindToController: true,
      controller: 'DeliverAtCtrl',
      require: {
        parent: '^orderPickupSelector'
      },
      templateUrl: 'app/editOrder/deliverAt.html'
    });
}());

(function () {
  'use strict';

  var SIXTY_ONE_MINUTES = 3660000,
    DEFAULT_RBT_MINUTES = 30,
    MINUTES_TO_MS = 60000,
    FIVE_SECONDS = 5000;

    /** @ngInject */
  function DeliverAtCtrl($interval, $scope, Utilities, readyByTimes) {
    var vm = this,
      deliverAtPromise,
      interval;

    vm.isLessThanHour = false;
    vm.rbtFloorActive = false;
    vm.readyByTimes = readyByTimes;
    vm.showReadyByTimes = false;

    /**
     * @method getDeliverAtTime
     * @return {Number}
     */
    vm.getDeliverAtTime = function () {
      var order = vm.order || {};
      return new Date(order.deliver_at).getTime();
    };

    /**
     * @method setReadyByTime
     * @param {Date|Number} rbt
     */
    vm.setReadyByTime = function (rbt) {
      vm.order.ready_by_time = rbt || null;
    };

    /**
     * @method setDefaultReadyByTime
     */
    vm.setDefaultReadyByTime = function () {
      var deliverAt = vm.getDeliverAtTime(),
        readyBy = deliverAt - (DEFAULT_RBT_MINUTES * MINUTES_TO_MS);

      vm.setReadyByTime(new Date(readyBy).toISOString());
      vm.rbtFloorActive = false;
    };

    /**
     * @method setInitialDeliverAt
     */
    vm.setInitialDeliverAt = function () {
      var fromNow;
      if (vm.order.deliver_at) {
        return;
      }

      fromNow = new Date(new Date().getTime() + SIXTY_ONE_MINUTES);
      vm.order.deliver_at = fromNow.toISOString();
    };

    /**
     * @method setIsLessThanHour
     */
    vm.setIsLessThanHour = function () {
      var deliverAt = vm.getDeliverAtTime(),
        minutesDifference = Utilities.time.getMinutesDifference(deliverAt);

      vm.isLessThanHour = minutesDifference < 60;
    };

    /**
     * @method validateDeliverAt
     * @param {Boolean} updateDefaultRbt
     */
    vm.validateDeliverAt = function (updateDefaultRbt) {
      var deliverAt = vm.order.deliver_at;
      if (!deliverAt) {
        return vm.setReadyByTime(null);
      }

      vm.setIsLessThanHour();
      vm.showReadyByTimes = vm.order.large_order ? !vm.isLessThanHour : true;

      if (updateDefaultRbt) {
        vm.setDefaultReadyByTime();
      }
    };

    /**
     * @method startPolling
     */
    vm.startPolling = function () {
      if (interval) {
        return interval;
      }

      interval = $interval(function () {
        vm.validateDeliverAt(false);
        if (!vm.parent.form) {
          return;
        }

        if (vm.parent.form.deliverAt) {
          vm.parent.form.deliverAt.$validate();
        }

        if (vm.parent.form.readyByTime) {
          vm.parent.form.readyByTime.$validate();
        }
      }, FIVE_SECONDS);
    };

    /**
     * @method stopPolling
     */
    vm.stopPolling = function () {
      if (!interval) {
        return;
      }

      $interval.cancel(interval);
      interval = null;
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      vm.startPolling();
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      vm.stopPolling();
      deliverAtPromise();
    };

    deliverAtPromise = $scope.$watch('$ctrl.order.deliver_at', function () {
      vm.validateDeliverAt(true);
    });
  }

  angular.module('zoomerRestaurant')
    .controller('DeliverAtCtrl', DeliverAtCtrl);

}());

(function () {
  'use strict';

  var tpl = '<input type="hidden" ng-model="$ctrl.coordinates" name="deliveryCoordinates" disabled validate-address-coordinates>';

  angular.module('zoomerRestaurant')
    .component('deliveryCoordinates', {
      bindings: {
        address: '<'
      },
      controller: 'DeliveryCoordinatesCtrl',
      template: tpl
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function DeliveryCoordinatesCtrl() {
    var vm = this;

    vm.coordinates = null;

    /**
     * @method mergeCoordinates
     */
    vm.mergeCoordinates = function () {
      var address = vm.address || {},
        latitude = address.latitude || address.lat,
        longitude = address.longitude || address.long || address.lon || address.lng;

      if (latitude && longitude) {
        vm.coordinates = ([ latitude, longitude ]).join(',');
      } else {
        vm.coordinates = null;
      }

    };

    vm.$onChanges = vm.mergeCoordinates;
  }

  angular.module('zoomerRestaurant')
    .controller('DeliveryCoordinatesCtrl', DeliveryCoordinatesCtrl);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('orderPickupSelector', {
      bindings: {
        form: '<',
        order: '<'
      },
      bindToController: true,
      controller: 'OrderPickupSelectorCtrl',
      templateUrl: 'app/editOrder/orderPickupSelector.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function OrderPickupSelectorCtrl($scope, Features, Utilities) {
    var vm = this,
      deliverAtPromise,
      largeOrderPromise;

    vm.orderTypeSelected = false;
    vm.hasSpecificTime = null;

    largeOrderPromise = $scope.$watch('$ctrl.order.large_order', function (largeOrder) {
      vm.orderTypeSelected = largeOrder !== undefined;
      vm.hasSpecificTime = null;
    });

    deliverAtPromise = $scope.$watch('$ctrl.order.deliver_at', function (deliverAt) {
      if (deliverAt === undefined) {
        return;
      }

      vm.setSpecificTime(deliverAt !== null);
      deliverAtPromise();
    });

    /**
     * @method isFoodReadyNowToggleEnabled
     * @return {Boolean}
     */
    vm.isFoodReadyNowToggleEnabled = function () {
      return Utilities.orders.isRbtInFuture(vm.order) &&
          vm.order.id &&
          vm.isSpecificTimeSetTo(true);
    };

    /**
     * @method isSpecificTimeSetTo
     * @param {Boolean} to
     * @return {Boolean}
     */
    vm.isSpecificTimeSetTo = function (to) {
      return vm.hasSpecificTime !== null && vm.hasSpecificTime === to;
    };

    /**
     * @method setSpecificTimeAndReset
     * @param {Boolean} hasSpecificTime
     */
    vm.setSpecificTimeAndReset = function (hasSpecificTime) {
      if (Boolean(hasSpecificTime) !== vm.hasSpecificTime) {
        vm.resetDeliverAtAndRbt();
      }

      vm.setSpecificTime(hasSpecificTime);
    };

    /**
     * @method setSpecificDateTime
     * @param {Boolean} hasSpecificTime
     */
    vm.setSpecificTime = function (hasSpecificTime) {
      vm.hasSpecificTime = Boolean(hasSpecificTime);
    };

    /**
     * @method resetDeliverAtAndRbt
     */
    vm.resetDeliverAtAndRbt = function () {
      delete vm.order.deliver_at;
      delete vm.order.ready_by_time;
    };

    vm.$onDestroy = function () {
      largeOrderPromise();
      deliverAtPromise();
    };

  }

  angular.module('zoomerRestaurant')
    .controller('OrderPickupSelectorCtrl', OrderPickupSelectorCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function ValidateAddressCoordinatesCtrl($element, $q, $scope, Restaurant, deliveryExclusionZones, restaurantDeliveryZones) {
    var vm = this,
      watchPromise,
      ngModel;

    vm.restaurant = Restaurant;

    /**
     * @method isWithinExtendedDeliveryZone
     * @param {Object} deliveryZoneStatus
     * @return {Boolean}
     */
    vm.isWithinExtendedDeliveryZone = function (deliveryZoneStatus) {
      return !deliveryZoneStatus.hasInnerZone &&
        deliveryZoneStatus.hasOuterZone;
    };

    /**
     * @method isAddressOutsideValidZone
     * @param {Object} deliveryZoneStatus
     * @return {Boolean}
     */
    vm.isAddressOutsideValidZone = function (deliveryZoneStatus) {
      return deliveryZoneStatus.hasSnowZone ||
        (!deliveryZoneStatus.hasInnerZone && !deliveryZoneStatus.hasOuterZone);
    };

    /**
     * @method parseDeliveryZoneStatus
     */
    vm.parseDeliveryZoneStatus = function (response) {
      var deliveryZoneStatus = response.data || {};
      ngModel.$deliveryZoneStatus = deliveryZoneStatus;

      if (vm.isAddressOutsideValidZone(deliveryZoneStatus) || vm.isWithinExtendedDeliveryZone(deliveryZoneStatus)) {
        return $q.reject(deliveryZoneStatus);
      }

      return $q.resolve();
    };

    /**
     * @method parseExclusionZoneStatus
     * @param {Object} response
     * @return {Object} $promise
     */
    vm.parseExclusionZoneStatus = function (response) {
      var exclusionZones = response.data || {};
      if (exclusionZones.hasExclusionZone) {
        return $q.reject(exclusionZones);
      }

      return $q.resolve();
    };

    /**
     * @method getAddressCoordinates
     * @param {String} modelValue
     * @param {String} viewValue
     * @return {Object}
     */
    vm.getAddressCoordinates = function (modelValue, viewValue) {
      var string = modelValue || viewValue || '',
        split = string.split(',') || [],
        lat = split[0] || '',
        lon = split[1] || '';

      return {
        lat: Number(lat),
        lon: Number(lon)
      };
    };

    /**
     * @method isWithinDeliveryZone
     * @param {String} modelValue
     * @param {String} viewValue
     * @return {Object} $promise
     */
    vm.isWithinDeliveryZone = function (modelValue, viewValue) {
      var coordinates = vm.getAddressCoordinates(modelValue, viewValue);
      if (!coordinates.lat || !coordinates.lon) {
        return $q.resolve();
      }

      return restaurantDeliveryZones.getList(coordinates).then(vm.parseDeliveryZoneStatus);
    };

    /**
     * @method isWithinExclusionZone
     * @param {String} modelValue
     * @param {String} viewValue
     * @return {Object} $promise
     */
    vm.isWithinExclusionZone = function (modelValue, viewValue) {
      var coordinates = vm.getAddressCoordinates(modelValue, viewValue);
      if (!coordinates.lat || !coordinates.lon) {
        return $q.resolve();
      }

      return deliveryExclusionZones.getList(coordinates).then(vm.parseExclusionZoneStatus);
    };

    /**
     * @method hasNoValidCoordinates
     * @param {String} modelValue
     * @param {String} viewValue
     * @return {Boolean}
     */
    vm.hasNoValidCoordinates = function (modelValue, viewValue) {
      var coordinates = vm.getAddressCoordinates(modelValue, viewValue);
      return Boolean(coordinates.lat && coordinates.lon);
    };

    /**
     * @method toggleAsyncDeliveryZoneValidator
     * @param {Object} restaurant
     */
    vm.toggleAsyncDeliveryZoneValidator = function (restaurant) {
      restaurant = restaurant || {};
      var hasDeliveryZone = Boolean(restaurant.delivery_zone);

      if (hasDeliveryZone) {
        ngModel.$asyncValidators.isOutsideDeliveryZone = vm.isWithinDeliveryZone;
      } else {
        delete ngModel.$asyncValidators.isOutsideDeliveryZone;
      }
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      ngModel = $element.controller('ngModel');
      ngModel.$asyncValidators.isWithinExclusionZone = vm.isWithinExclusionZone;
      ngModel.$validators.hasNoValidCoordinates = vm.hasNoValidCoordinates;

      watchPromise = $scope.$watch('ValidateAddressCoordinatesCtrl.restaurant.info', vm.toggleAsyncDeliveryZoneValidator);
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      if (watchPromise) {
        watchPromise();
      }
    };
  }

  angular.module('zoomerRestaurant')
    .controller('ValidateAddressCoordinatesCtrl', ValidateAddressCoordinatesCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function validateAddressCoordinates() {
    return {
      controller: 'ValidateAddressCoordinatesCtrl as ValidateAddressCoordinatesCtrl',
      require: '^ngModel'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('validateAddressCoordinates', validateAddressCoordinates);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.externalOrders')
    .component('editExternalOrder', {
      bindings: {
        order: '<',
        onComplete: '&'
      },
      controller: 'EditExternalOrderCtrl',
      templateUrl: 'app/externalOrders/editExternalOrder.html'
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function EditExternalOrderCtrl($scope) {
    var vm = this,
      deliveryNotesPromise;

    vm.showComments = false;
    vm.orderBk = null;

    /**
     * @method save
     */
    vm.save = function () {
      vm.order.status = vm.isPickupOrder() ? vm.order.status : 'parsed'; // don't change status if correcting external pickup order (keep 'do_not_deliver')
      vm.order.diner_phone_number_invalid = false;
      vm.order.isEdited = true;
      vm.order.ready_by_time = null;
      vm.onComplete();
    };

    /**
     * @method cancel
     */
    vm.cancel = function () {
      angular.extend(vm.order, vm.orderBk);
      vm.onComplete();
    };

    /**
     * @method updateComments
     * @param {String} deliveryNotes
     */
    vm.updateComments = function (deliveryNotes) {
      vm.toggleComments(true);
      vm.order.comment += ' '  + (deliveryNotes || '');
      vm.order.comment = vm.order.comment.trim();
    };

    /**
     * @method toggleComments
     * @param {Boolean} force
     */
    vm.toggleComments = function (force) {
      vm.showComments = force !== undefined ? force : !vm.showComments;
    };

    vm.isPickupOrder = function () {
      return vm.order.status === 'do_not_deliver' || vm.order.status === 'do_not_deliver_dismissed';
    }

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      vm.orderBk = angular.copy(vm.order);
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      deliveryNotesPromise();
    };

    deliveryNotesPromise = $scope.$on('$setOrderDeliveryNotes', function (e, deliveryNotes) {
      vm.updateComments(deliveryNotes);
    });

  }

  angular.module('zoomerRestaurant.externalOrders')
    .controller('EditExternalOrderCtrl', EditExternalOrderCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function ExistingSimilarOrdersCtrl() {
    var vm = this;

    /**
     * @method hideExistingOrders
     */
    vm.hideExistingOrders = function () {
      vm.order.showExistingOrders = false;
    };
  }

  angular.module('zoomerRestaurant.externalOrders')
    .controller('ExistingSimilarOrdersCtrl', ExistingSimilarOrdersCtrl)
    .component('existingSimilarOrders', {
      bindings: {
        order: '<',
        confirmSkip: '&'
      },
      controller: 'ExistingSimilarOrdersCtrl',
      templateUrl: 'app/externalOrders/existingSimilarOrders.html'
    });

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.externalOrders')
    .component('externalOrder', {
      bindings: {
        order: '<',
        contentBounds: '<',
        scrollTop: '<'
      },
      controller: 'ExternalOrderCtrl',
      templateUrl: 'app/externalOrders/externalOrder.html'
    });
}());

(function () {
  'use strict';

  var ONE_SECOND_MS = 1000,
    loadingText = {
      template: '<i class="fa fa-refresh fa-spin"></i> Zooming order'
    };

  /** @ngInject */
  function ExternalOrderCtrl($element, $ionicLoading, $ionicScrollDelegate, $scope, $rootScope, $timeout, deviceNotifications, zIonicPopup, DeliveryZones, ExternalOrders, LogEntries, Modals, Restangular, Restaurant, Utilities, Features, ThermalPrinter, Toast) {
    var vm = this,
      rbtPromise,
      dinerSearchPromise,
      order = vm.order || {},
      address = order.serialized_address || {};

    /**
     * @method isOutsideInnerDeliveryZone
     * @return {Boolean}
     */
    function isOutsideInnerDeliveryZone() {
      var deliveryZoneStatus = $scope.deliveryZoneStatus;
      if (!deliveryZoneStatus || deliveryZoneStatus.isWithinExclusion || deliveryZoneStatus.isOutsideDeliveryZone) {
        return true;
      }

      return !deliveryZoneStatus.isWithinInner;
    }

    /**
     * @method isOrderSubmitDisabled
     * @return {Boolean}
     */
    function isOrderSubmitDisabled() {
      var externalOrder = vm.order;

      return !externalOrder.ready_by_time ||
        externalOrder.order_id ||
        externalOrder.status === 'converted_to_order' ||
        (!vm.isPickupOrder() && isOutsideInnerDeliveryZone() && !externalOrder.oozo_pricing_accepted);
    }

    $scope.deliveryZoneStatus = null;
    $scope.isDoNotDeliver = false;

    $scope.onlyDinerNumberError = false;
    $scope.parseError = false;
    $scope.loading = false;
    $scope.submitting = false;

    vm.isComponentVisible = false;

    /**
     * @method isOrderSizeSelected
     * @return {Boolean}
     */
    vm.isOrderSizeSelected = function () {
      var externalOrder = vm.order;
      if (!Restaurant.hasBicycleSupport()) {
        return true;
      }

      return Boolean(externalOrder.size);
    };

    /**
     * @method getAddressCoordinates
     * @return {Object}
     */
    vm.getAddressCoordinates = function () {
      var order = vm.order || {},
        address = order.serialized_address || {};

      return {
        lat: address.latitude || address.lat,
        lon: address.longitude || address.lon || address.long
      };
    };

    /**
     * @method showOozoOrderOptions
     * @return {Boolean}
     */
    vm.showOozoOrderOptions = function () {
      var order = vm.order,
        deliveryZoneStatus = $scope.deliveryZoneStatus,
        isEditing = vm.order.editing;

      if (isEditing) {
        return false;
      }

      return (order.ready_by_time && vm.isOrderSizeSelected() && deliveryZoneStatus) ||
        (deliveryZoneStatus && deliveryZoneStatus.isOutsideSnowZone);
    };

    /**
     * @method setDeliveryZoneStatus
     * @param {Object} status
     */
    vm.setDeliveryZoneStatus = function (status) {
      $scope.deliveryZoneStatus = status || null;
    };

    /**
     * @method isCardVisibleInViewport
     * @description NB: Once card is visible in viewport, STOP watching for scrolling
     */
    vm.isCardVisibleInViewport = function () {
      if (vm.isComponentVisible) {
        return;
      }

      var rect = $element[0].getBoundingClientRect(),
        contentBounds = vm.contentBounds || {};

      vm.isComponentVisible = rect.top <= (contentBounds.top + contentBounds.height);
      if (vm.isComponentVisible) {
        vm.$onChanges = null;
        vm.initAllResources();
        LogEntries.log("Order " + order.id + " became visible on the screen", address);
      }
    };

    /**
     * @method initAllResources
     */
    vm.initAllResources = function () {
      var order = vm.order,
        address = order.serialized_address || {};

      // Don't validate address for pickup orders
      if (!vm.isPickupOrder()) {
        vm.validateOrderAddress();
        $scope.getDeliveryZoneStatus();
        $scope.setEditing(!address.latitude || !address.longitude);
      }

      if (order.status === 'parse_error' || order.diner_phone_number_invalid || !order.payment_method) {
        $scope.setError();
      }
    };

    /**
     * @method isRbtSelectionEnabled
     * @return {Boolean}
     */
    vm.isRbtSelectionEnabled = function () {
      var deliveryZoneStatus = $scope.deliveryZoneStatus || {};

      return vm.isComponentVisible &&
        !$scope.isDoNotDeliver &&
        (!$rootScope.restaurant.isServiceHalted() || vm.isPickupOrder()) &&
        !deliveryZoneStatus.isOutsideSnowZone;
    };

    /**
     * @method validateOrderAddress
     */
    vm.validateOrderAddress = function () {
      var address = vm.order.serialized_address || {},
        isAddress1Valid = (address.address_1 && address.address_1.length),
        isCityValid = (address.city && address.city.length),
        isStateValid = (address.state_province_region && address.state_province_region.length);

      if (!isAddress1Valid || !isCityValid || !isStateValid) {
        vm.order.status = 'parse_error';
      }
    };

    /**
     * @method editOrder
     */
    vm.editOrder = function () {
      $scope.setEditing(true);
      $ionicScrollDelegate.resize();
    };

    /**
     * @method confirmSkip
     */
    vm.confirmSkip = function () {
      var order = vm.order;

      zIonicPopup.confirm(Modals.SKIP_EXTERNAL_ORDER).then(function (answer) {
        if (!answer) {
          return;
        }

        $ionicLoading.show({ template: 'Skipping order' });
        ExternalOrders.setSkipped(order).finally(function () {
          $ionicLoading.hide();
        });
      });
    };

    /**
     * @method canSkip determines if a restaurant can skip an external order
     * @return {boolean} true if the external order can be skipped
     */
    vm.canSkip = function () {
      if (Features.checkEnabled('enable_skipping_external_orders')) {
        return true;
      }

      return false;
    };

    /**
     * @method onComplete
     */
    vm.onComplete = function () {
      $scope.setEditing(false);
      $scope.getDeliveryZoneStatus();
      $ionicScrollDelegate.resize();
    };
    
    vm.$onChanges = vm.isCardVisibleInViewport;

    /**
     * @method $postLink
     */
    vm.$postLink = function () {
      $timeout(vm.isCardVisibleInViewport, ONE_SECOND_MS);
    };


    /**
     * @method $onDestroy
     **/
    vm.$onDestroy = function () {
      rbtPromise();
      dinerSearchPromise();
    };

    vm.isPickupOrder = function () {
      return vm.order.status === 'do_not_deliver' || vm.order.status === 'do_not_deliver_dismissed';
    };

    /**
     * Set 'error' state on the Email Order
     */
    $scope.setError = function () {
      var order = vm.order;

      $scope.parseError = true;
      $scope.onlyDinerNumberError = (order.status !== 'parse_error' && order.payment_method);
      $scope.setEditing(true);
      $ionicScrollDelegate.resize();
    };

    /**
     * Set the 'editing' state of the Order
     *
     * @param {Boolean} edit
     */
    $scope.setEditing = function (edit) {
      edit = Boolean(edit);
      vm.order.editing = edit;
    };

    /**
     * @method parseSubmitError
     * @param {Object} error
     */
    $scope.parseSubmitError = function (error) {
      error = error || {};
      var data = error.data || {},
        details = data.details || {},
        dinerErrors = details.diner;

      $scope.errors = !dinerErrors;
      if (!dinerErrors) {
        $scope.isDoNotDeliver = false;
        return;
      }

      $scope.isDoNotDeliver = !!(dinerErrors.filter(function (dinerError) {
        return !!dinerError.match(/do[\s|-|_]not[\s|-|_]deliver/gi);
      }) || []).length;
    };

    /**
     * @method searchForDinerNumber
     */
    $scope.searchForDinerNumber = function () {
      var order = vm.order || {},
        restaurant = Restaurant.info || {},
        territoryId = restaurant.territory_id;

      Restangular.one('addresses').customGET('search', {
        phone_number: Utilities.number.stripFormatting(order.diner_phone_number),
        territory: territoryId
      }).then($scope.setDoNotDeliver, $scope.parseDinerError);
    };

    /**
     * @method parseDinerError
     * @param {Object} error
     */
    $scope.parseDinerError = function (error) {
      error = error || {};
      var data = error.data || {};
      $scope.isDoNotDeliver = (data.error === 'diner_do_not_deliver');
    };

    /**
     * @method setDoNotDeliver
     * @param {Object} response
     */
    $scope.setDoNotDeliver = function (response) {
      var order = vm.order || {},
        address = order.serialized_address || {},
        dinerAddress;

      dinerAddress = _.find((response.data || []), function (a) {
          return a.address_1 === address.address_1 &&
            a.city === address.city &&
            a.state_province_region === address.state_province_region &&
            a.postal_code === address.postal_code;
        }) || {};

      $scope.isDoNotDeliver = !!dinerAddress.do_not_deliver;
    };

    /**
     * Pass the selected RBT time to the server and create the new Order
     */
    $scope.submit = function () {
      var externalOrder = vm.order;
      if (isOrderSubmitDisabled() || !vm.isOrderSizeSelected() || $scope.submitting) {
        return;
      }

      $scope.print();

      $ionicLoading.show(loadingText);
      $scope.submitting = true;

      ExternalOrders.createOrderAndRemove(externalOrder).then(function () {
        $rootScope.$emit('$emailOrderSubmitted', externalOrder);
      }, function (error) {
        $scope.parseSubmitError(error);
      }).finally(function () {
        $ionicLoading.hide();
        $scope.submitting = false;
      });
    };

    $scope.print = function() {
      try {
        // Progress and errors get reported on the order queue, so we don't need to wait for anything here
        ThermalPrinter.printMultipleOrders(vm.order, Restaurant.info);
      } catch (e) {
        // If there are any issues with printing, we want to proceed with the order creation call
      }
    };

    /**
     * Assign `oozo_pricing_accepted`
     */
    $scope.acceptChargeAndSubmit = function () {
      vm.order.oozo_pricing_accepted = true;
      $scope.submit();
    };

    /**
     * @method getDeliveryZoneStatus
     */
    $scope.getDeliveryZoneStatus = function () {
      var order = vm.order || {},
        coordinates = vm.getAddressCoordinates();

      if (!coordinates.lat || !coordinates.lon) {
        return vm.setDeliveryZoneStatus(null);
      }

      $scope.loading = true;

      DeliveryZones.check(coordinates).then(vm.setDeliveryZoneStatus, function (error) {
        $scope.deliveryZoneStatus = null;
        LogEntries.log('Error checking Order address against Delivery Zones', order.id, order.serialized_address, error);
      }).finally(function () {
        $scope.loading = false;
      });
    };

    /**
     * Dismiss errors
     */
    $scope.dismissSubmitErrors = function () {
      $scope.errors = false;
      vm.editOrder();
    };

    rbtPromise = $scope.$watch('$ctrl.order.ready_by_time', $scope.submit);
    dinerSearchPromise = $scope.$watchGroup([ '$ctrl.order.serialized_address', '$ctrl.order.diner_phone_number' ], $scope.searchForDinerNumber);
    LogEntries.log("Order " + order.id + " is loaded but not yet visible on the screen", address);
  }

  angular.module('zoomerRestaurant.externalOrders')
    .controller('ExternalOrderCtrl', ExternalOrderCtrl);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.externalOrders')
    .component('externalOrderLapsed', {
      bindings: {
        order: '<'
      },
      controller: 'ExternalOrderLapsedCtrl',
      templateUrl: 'app/externalOrders/externalOrderLapsed.html'
    });

}());

(function () {
  'use strict';

  var ONE_MINUTE = 60000,
    FIVE_MINUTES = ONE_MINUTE * 5;

  /** @ngInject */
  function ExternalOrderLapsedCtrl($interval) {
    var vm = this,
      interval;

    vm.isLapsed = false;

    /**
     * @method setIsLapsed
     */
    vm.setIsLapsed = function () {
      var now,
        difference;

      if (!vm.order) {
        return;
      }

      now = new Date().getTime();
      difference = now - Date.parse(vm.order.updated_at);

      vm.isLapsed = difference > FIVE_MINUTES;
      if (vm.isLapsed) {
        return vm.stopInterval();
      }

      if (!interval) {
        interval = $interval(vm.setIsLapsed, ONE_MINUTE);
      }
    };

    /**
     * @method stopInterval
     */
    vm.stopInterval = function () {
      if (interval) {
        $interval.cancel(interval);
        interval = undefined;
      }
    };

    vm.$onInit = vm.setIsLapsed;
    vm.$onChanges = vm.setIsLapsed;
    vm.$onDestroy = vm.stopInterval;
  }

  angular.module('zoomerRestaurant.externalOrders')
    .controller('ExternalOrderLapsedCtrl', ExternalOrderLapsedCtrl);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.externalOrders')
    .component('externalOrderRbts', {
      bindings: {
        order: '<',
        submit: '&'
      },
      templateUrl: 'app/externalOrders/externalOrderRbts.html'
    });

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').filter('formatPhoneNumber', [
    'Utilities',
    function (Utilities) {
      return Utilities.number.formatNumber;
    }
  ]);
}());
(function () {
  'use strict';

  angular.module('zoomerRestaurant').filter('formatSpecialOrderDate', [
    '$window',
    function ($window) {
      var moment = $window.moment;

      /**
       * Parse the date into a Relative 'friendly' format:
       * 'Today at 4:25PM'
       * 'Tomorrow at 3:00PM' etc.
       *
       * @param {String|Date} date
       * @return {String}
       */
      return function (date) {
        return moment(date).calendar();
      };
    }
  ]);

}());
(function () {
  'use strict';

  angular.module('zoomerRestaurant').filter('formatTipAmount', [
    function () {
      return function (tipAmount) {
        tipAmount = (tipAmount || 0);
        tipAmount = Number(tipAmount);
        return '$' + (tipAmount.toFixed(2));
      };
    }
  ]);

}());
(function () {
  'use strict';

  angular.module('zoomerRestaurant').filter('getExternalSources', [
    function () {
      return function (externalOrders) {
        var sources = _.uniq(_.pluck(externalOrders, 'source') || []);
        return _.map(sources, function (s) {
          return s.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1');
        }).join(',').trim();
      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').filter('getFirstName', [
    'Utilities',
    function (Utilities) {
      return Utilities.getFirstName;
    }
  ]);
}());
(function () {
  'use strict';

  angular.module('zoomerRestaurant').filter('sortOrders', function () {
    return function (orders, sortByProperty, descending) {
      descending = !!descending;
      sortByProperty = sortByProperty || 'ready_by_time';
      return _.sortBy(orders, function (order) {
        return Date.parse(order[sortByProperty]) * (descending ? -1 : 1);
      });
    };
  });

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').filter('toTrustedHtml', [
    '$sce',
    function ($sce) {
      return function (text) {
        return $sce.trustAsHtml(text);
      };
    }
  ]);
}());
(function () {
  'use strict';

  /** @ngInject */
  function announcements(Restangular) {
    var service = Restangular.service('restaurant_announcements');

    return angular.extend(service, {
      all: [],

      /**
       * @method getLatest
       * @return {Object} $promise
       */
      getLatest: function () {
        return service.getList().then(function (response) {
          service.all = response.data;
        });
      }
    });
  }

  angular.module('zoomerRestaurant')
    .factory('announcements', announcements);

}());

/**
 * Audio Alert Factory
 * Used to initialize web audio with a sound file and start/stop continuous audio alerts
 * 
 * Author: Ilya Vinogradov
 * © EatStreet, Restaurant Team, 2019
 */
(function () {
    'use strict';

    /** @ngInject */
    function audioAlert($interval) {
        //'const' is not available in 'strict mode'
        var AUDIO_DURATION_MILLISECONDS = 4000;  // 4 second audio
        var ALERT_INTERVAL_MILLISECONDS = 2000; // 2 second interval between alerts

        var _interval, webAudioElement;

        function playOnce() {
            if (webAudioElement) {
                webAudioElement.play();
            }
        }


        return {
            /**
             * Initialize web audio with a sound asset
             */
            init: function () {
                webAudioElement = document.createElement('audio');
                webAudioElement.src = 'assets/sounds/front-desk-bells-daniel-simon.wav';
            },
            play: function () {
                if (!_interval) {
                    playOnce();
                    _interval = $interval(playOnce, AUDIO_DURATION_MILLISECONDS + ALERT_INTERVAL_MILLISECONDS);
                }
            },
            stop: function () {
                if (_interval) {
                    $interval.cancel(_interval);
                    _interval = null;

                    if (webAudioElement) {
                        webAudioElement.pause();
                        webAudioElement.currentTime = 0;    // rewind
                    }
                }
            }
        };
    }

    angular.module('zoomerRestaurant')
        .factory('audioAlert', audioAlert);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').factory('authInterceptor', [
    '$window', '$rootScope', '$q', '$location', 'Storage', 'Config',
    function ($window, $rootScope, $q, $location, Storage, Config) {
      function getAppVersion() {
        if (!$window.cordova) {
          return 'web';
        }
        return $rootScope.device.version || 'native';
      }

      return {

        /**
         * Configure the $http headers to pass along the UserToken & Email
         *
         * @param {Object} config
         * @return {Object}
         */
        request: function (config) {
          config.headers = config.headers || {};
          config.headers['X-User-Token'] = Storage.get('X-User-Token');
          config.headers['X-User-Email'] = Storage.get('X-User-Email');
          config.headers['X-Restaurant-App-Version'] = getAppVersion();
          config.headers['X-Restaurant-Zoomer-App-Version'] = Config.ZOOMER_APP_VERSION;
          config.headers['X-Zoomer-App-Name'] = 'restaurants.eatstreet.com';
          return config;
        },

        /**
         * on Error, goTo login page if a bad request
         *
         * @param {Object} response
         */
        responseError: function (response) {
          if (response.status === 401 || response.status === 403) {
            $rootScope.session.destroy();
            $location.path('/login');
          }
          return $q.reject(response);
        }
      };
    }
  ]);

}());


(function () {
  'use strict';

  /** @ngInject */
  function autoCompleteModalBar($ionicModal) {
    var url = 'app/views/modals/auto-complete-modal-bar.html',
      modal;

    return {
      /**
       * @method show
       * @param {Object} params
       * @return {Object}
       */
      show: function (params) {
        params = angular.extend({
          backdropClickToClose: false,
          focusFirstInput: true
        }, (params || {}));
        if (modal) {  // Already coerced to boolean - no need to '!!' see http://eslint.org/docs/2.0.0/rules/no-extra-boolean-cast
          return modal.show();
        }

        return $ionicModal.fromTemplateUrl(url, params).then(function (ionicModal) {
          modal = ionicModal;
          modal.show();
        });
      },

      /**
       * @method remove
       */
      remove: function () {
        if (!modal) {
          return;
        }

        modal.remove().then(function () {
          modal = null;
        });
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('autoCompleteModalBar', autoCompleteModalBar);

}());

(function () {
  'use strict';

  /** @ngInject */
  function confirmBulkReceiptClosure(zIonicPopup) {
    return {
      show: function (openReceiptsTotal) {
        openReceiptsTotal = openReceiptsTotal || 0;
        var params = {
          cssClass: 'z-popup-confirm-bulk-receipt-closure text-center',
          okText: 'Yes close receipts',
          title: '<i class="fa fa-exclamation-triangle"></i>',
          template: 'You are about to close ' +
            openReceiptsTotal +
            ' open receipts. Please make sure you\'ve verified tip amounts!'
        };

        return zIonicPopup.confirm(params);
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('confirmBulkReceiptClosure', confirmBulkReceiptClosure);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').factory('confirmFoodReadyNow', [
    'zIonicPopup',
    function (zIonicPopup) {

      return {
        show: function () {
          var params = {
            okText: 'Food Ready Now',
            title: 'Food Ready Now',
            template: 'If your food is ready now, we’ll do our best to have a driver to you as quickly as possible. However, please be aware that your driver may not arrive before your original Ready By Time.'
          };

          return zIonicPopup.confirm(params);
        }
      };
    }
  ]);
}());

(function () {
  'use strict';

  /** @ngInject */
  function confirmStreetNumber($ionicModal) {
    var url = 'app/views/modals/confirm-street-number.html',
      modal;

    return {

      /**
       * @method show
       * @param {Object} params
       * @return {Object}
       */
      show: function (params) {
        params = params || {};
        if (modal) {  // Already coerced to boolean - no need to '!!' see http://eslint.org/docs/2.0.0/rules/no-extra-boolean-cast
          return modal.show();
        }

        return $ionicModal.fromTemplateUrl(url, params).then(function (ionicModal) {
          modal = ionicModal;
          modal.show();
        });
      },

      /**
       * @method hide
       */
      hide: function () {
        if (!modal) {
          return;
        }
        modal.remove().then(function () {
          modal = null;
        });
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('confirmStreetNumber', confirmStreetNumber);

}());

(function () {
  'use strict';

  /** @ngInject */
  function deliveryExclusionZones(Restangular) {
    var resource,
      serviceName = 'delivery_exclusion_zones';

    resource = Restangular.service(serviceName);

    Restangular.extendCollection(serviceName, function (data) {
      return angular.extend(data, {
        hasExclusionZone: Boolean(data.length)
      });
    });

    return resource;
  }

  angular.module('zoomerRestaurant')
    .factory('deliveryExclusionZones', deliveryExclusionZones);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').factory('DeliveryZones', [
    '$ionicPopup', '$q', '$rootScope', '$window', 'deliveryExclusionZones', 'restaurantDeliveryZones', 'Config', 'LogEntries', 'Modals', 'Restangular', 'Restaurant',
    function ($ionicPopup, $q, $rootScope, $window, deliveryExclusionZones, restaurantDeliveryZones, Config, LogEntries, Modals, Restangular, Restaurant) {

      function getZoneDefaults() {
        return {
          isWithinInner: true,
          isWithinOuter: false,
          isOutsideSnowZone: false,
          isOutsideDeliveryZone: false,
          isWithinExclusion: false
        };
      }

      /**
       * @method getParams
       * @param {Object|Number} params
       * @return {Object}
       */
      function getParams(params) {
        if (typeof params === 'number') {
          return { address_id: params };
        }

        return params;
      }

      /**
       * @param {String} prefix
       * @param {Object} data
       */
      function log(prefix, data) {
        var restaurant = Restaurant.info || {},
          restaurantId = restaurant.id;
        data = angular.extend({ restaurant_id: restaurantId }, data);
        LogEntries.log('[' + prefix + '] Restaurant-delivery / Exclusion zones', (data || {}));
      }

      /**
       * @method logSuccess
       * @param {Object} params
       * @param {Array} deliveryZones
       * @param {Array} exclusionZones
       * @param {Object} statuses
       */
      function logSuccess(params, deliveryZones, exclusionZones, statuses) {
        log('SUCCESS', {
          params: params, delivery_zones: deliveryZones, exclusion_zones: exclusionZones, statuses: statuses
        });
      }

      function warn(error) {
        $ionicPopup.alert(Modals.DELIVERY_ZONE_VALIDATION_WARNING);
        log('ERROR', error);
        return $q.reject(error);
      }

      return {

        _warn: warn,

        /**
         * @method validateZones
         * @param {Object} params
         * @return {Object} $promise
         */
        validateDeliveryZones: function (params) {
          var requests = [ restaurantDeliveryZones.getList(params), deliveryExclusionZones.getList(params) ],
            deferred = $q.defer(),
            deliveryZones,
            exclusionZones,
            statuses;

          $q.all(requests).then(function (response) {
            deliveryZones = response[0].data;
            exclusionZones = response[1].data;

            statuses = {
              isWithinInner: deliveryZones.hasInnerZone,
              isWithinOuter: deliveryZones.hasOuterZone,
              isOutsideSnowZone: Boolean(deliveryZones.hasSnowZone),
              isOutsideDeliveryZone: (!deliveryZones.hasInnerZone && !deliveryZones.hasOuterZone),
              isWithinExclusion: exclusionZones.hasExclusionZone,
              zones: {
                delivery: deliveryZones,
                exclusion: exclusionZones
              }
            };
            logSuccess(params, deliveryZones, exclusionZones, statuses);
            deferred.resolve(statuses);
          }, warn);

          return deferred.promise;
        },

        /**
         * @method validateWhenNoDeliveryZone
         * @param {Object} params
         * @param {Array} allDeliveryZones
         * @return {Object} $promise
         */
        validateWhenNoDeliveryZone: function (params, allDeliveryZones) {
          var deferred = $q.defer(),
            statuses = getZoneDefaults(),
            exclusionZones;

          deliveryExclusionZones.getList(params).then(function (response) {
            exclusionZones = response.data || [];
            statuses.isWithinExclusion = exclusionZones.hasExclusionZone;
            statuses.isOutsideSnowZone = Boolean(allDeliveryZones.hasSnowZone);
            statuses.zones = {
              delivery: allDeliveryZones,
              exclusion: exclusionZones
            };

            logSuccess(params, allDeliveryZones, exclusionZones, statuses);
            deferred.resolve(statuses);
          }, warn);

          return deferred.promise;
        },

        /**
         * @method getAllAvailableZonesForRestaurant
         * @return {Object} $promise
         */
        getAllAvailableZonesForRestaurant: function () {
          var deferred = $q.defer();

          restaurantDeliveryZones.getList().then(function (response) {
            deferred.resolve(response.data || []);
          }, deferred.reject);

          return deferred.promise;
        },

        /**
         * With a provided `address_id` or Lat/Long combo, search the Restaurant Delivery
         * zones & Territory exclusion zones to see if the Location is within any of these.
         *
         * @param {Object|Number} search
         */
        check: function (search) {
          var self = this,
            params = getParams(search);

          return this.getAllAvailableZonesForRestaurant().then(function (allDeliveryZones) {
            if (!allDeliveryZones.hasInnerZone) {
              return self.validateWhenNoDeliveryZone(params, allDeliveryZones);
            }

            return self.validateDeliveryZones(params);
          }, warn);
        }

      };
    }
  ]);
}());

(function () {
  'use strict';

  function desktopNotifications($q, $rootScope, $window, Utilities) {
    return {

      /**
       * @method requestPermission
       * @return {Object} $promise
       */
      requestPermission: function () {
        var Notification = $window.Notification,
          isMobileDevice = $rootScope.isMobileDevice,
          deferred = $q.defer();

        if (isMobileDevice || !Notification) {
          return deferred.reject({ message: 'No desktop notifications present' });
        }

        if (Notification.permission === 'granted') {
          deferred.resolve(true);
          return deferred.promise;
        }

        Notification.requestPermission(function (permission) {
          deferred.resolve(permission === 'granted');
        });

        return deferred.promise;
      },

      /**
       * @method isTabHidden
       * @return {Boolean}
       */
      isTabHidden: function () {
        var doc = $window.document;
        return doc.hidden;
      },

      /**
       * @method clearOrder
       * @param {Object} emailOrder
       */
      clearOrder: function (emailOrder) {
        emailOrder = emailOrder || {};
        var id = emailOrder.id;

        if (!id || !this[id]) {
          return;
        }

        this[id].close();
        delete this[id];
      },

      /**
       * @method notifyOrder
       * @param {Object} emailOrder
       */
      notifyOrder: function (emailOrder) {
        emailOrder = emailOrder || {};
        var self = this,
          Notification = $window.Notification,
          source = '',
          options;

        if (!this.isTabHidden()) {
          return;
        }

        this.requestPermission().then(function (permission) {
          if (!permission) {
            return;
          }

          if (!emailOrder.source || emailOrder.source.toLowerCase() === 'nullparser') {
            source = '';
          } else {
            source = ' from ' + Utilities.string.convertCamelToNatural(emailOrder.source);
          }

          options = {
            body: 'A new online order' + source + ' requires your attention',
            icon: '/assets/images/desktop-notification-icon.png'
          };

          self[emailOrder.id] = new Notification('An online order has arrived', options);
        });
      }
    };
  }

  desktopNotifications.$inject = ['$q', '$rootScope', '$window', 'Utilities'];

  angular.module('zoomerRestaurant')
    .factory('desktopNotifications', desktopNotifications);
}());

(function () {
  'use strict';

  /** @ngInject */
  function Device($cordovaAppVersion, $q, deviceNotifications, sentry) {
    return {
      build: null,
      version: null,

      /**
       * @method init
       */
      init: function () {
        this.getBuildNumber();
        this.getVersionNumber();
        deviceNotifications.init();
      },

      /**
       * @method getBuildNumber
       * @return {Object} $promise
       */
      getBuildNumber: function () {
        var self = this;
        return $cordovaAppVersion.getVersionCode().then(function (build) {
          self.build = build;
          sentry.setTags(self.version, self.build);
          return $q.resolve(build);
        });
      },

      /**
       * @method getVersionNumber
       * @return {Object} $promise
       */
      getVersionNumber: function () {
        var self = this;
        return $cordovaAppVersion.getVersionNumber().then(function (version) {
          self.version = version;
          sentry.setTags(self.version, self.build);
          return $q.resolve(version);
        });
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('Device', Device);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').service('deviceNotifications', [
    '$rootScope', '$window', 'Config', 'Utilities',
    function ($rootScope, $window, Config, Utilities) {
      var localTriggerPromise;

      return {

        /**
         * Get permission to send Notifications
         */
        init: function () {
          if (!this.isEnabled()) {
            return;
          }

          if (localTriggerPromise) {  // Already coerced to boolean - no need to '!!' see http://eslint.org/docs/2.0.0/rules/no-extra-boolean-cast
            localTriggerPromise();
          }

          localTriggerPromise = $window.cordova.plugins.notification.local.on('trigger', function() {
            $window.cordova.plugins.notification.local.on.cancelAll();
          }, $rootScope);
        },

        /**
         * Check that cordova plugins are present and installed
         *
         * @return {Boolean}
         */
        isEnabled: function () {

          return false;
        },

        /**
         * Ping a notification to the Device (if in background)
         *
         * @param {Object} emailOrder
         */
        notifyOrder: function (emailOrder) {
          emailOrder = emailOrder || {};
          var source = '',
            options;

          if (!emailOrder.id || !this.isEnabled()) {
            return;
          }

          if (!emailOrder.source || emailOrder.source.toLowerCase() === 'nullparser') {
            source = '';
          } else {
            source = ' from ' + Utilities.string.convertCamelToNatural(emailOrder.source);
          }

          options = {
            id: emailOrder.id,
            title: 'An online order has arrived',
            text: 'A new online order' + source + ' requires your attention',
            sound: null
          };

          $window.cordova.plugins.notification.local.schedule(options);
        },

        /**
         * Clear any existing Notification present on Device
         *
         * @param {Object} emailOrder
         */
        clearOrder: function (emailOrder) {
          emailOrder = emailOrder || {};

          if (!emailOrder.id || !this.isEnabled()) {
            return;
          }

          $window.cordova.plugins.notification.local.clear(emailOrder.id);
        }
      };
    }
  ]);
}());

/**
 * External Orders Polling Factory
 * Checks whether parsed external orders are present every 90 seconds. If so, initiates the retrieval external orders.
 * 
 * Author: Ilya Vinogradov
 * © EatStreet, Delivery Unit, 2018
 */
(function () {
    'use strict';

    /** @ngInject */
    angular.module('zoomerRestaurant').factory('externalOrderPoll', function ($interval, Restangular, ExternalOrders, Features) {
        /**
         * Polling interval
         */
        var POLLING_INTERVAL_MILLISECONDS = 90000,
            endPoint = 'external_orders/poll',
            _interval;

        /**
         * Sends GET request to the https://zoomer-api.eatstreet.com/api/v1/external_orders/poll endpoint.
         * If the response contains '{ "has_orders" : true }' - initiates the retrieval of external orders.
         */
        function checkForExternalOrders() {
            // Ideally we need to fetch flags before every poll; however this is a lot of overhead,
            // that we don't want every 90 seconds from ever app. Checking the flags locally every 90 seconds is fine.
            // As the users interact with the app, the flags will get eventually refreshed.
            if (!Features.checkEnabled('restaurant_app_enable_external_order_polling')) {
                stopPolling();
                return;
            }

            Restangular.one(endPoint).get().then(function (response) {
                if (response.data.has_orders) {
                    ExternalOrders.getAll();
                }
            });
        }

        function stopPolling() {
            if (!_interval) {
                return;
            }

            $interval.cancel(_interval);
            _interval = null;
        }

        return {
            /**
             * @method start
             * If restaurant_app_enable_external_order_polling flag is set
             *  checks for external orders immediately and every 90 seconds.
             * If restaurant_app_enable_external_order_polling is not set
             *  fetches external orders.
             */
            start: function () {
                Features.fetchAllFlags().then(function () {
                    if (!Features.checkEnabled('restaurant_app_enable_external_order_polling')) {
                        ExternalOrders.getAll();
                        return;
                    }
    
                    if (_interval) {
                        return;
                    }
    
                    _interval = $interval(checkForExternalOrders, POLLING_INTERVAL_MILLISECONDS);
                    checkForExternalOrders();
                });
            },

            /**
             * @method stop
             * Stops periodic polling for external orders
             */
            stop: function () {
                stopPolling();
            }
        };
    });
}());
(function () {
  'use strict';

  function foodReady(Restangular) {
    var resource = Restangular.service('orders');
    return angular.extend(resource, {

      /**
       * @method toggle
       * @param {Number} orderId
       * @param {Boolean} enable
       * @return {Object} $promise
       */
      toggle: function (orderId, enable) {
        enable = Boolean(enable);
        var promise = this.one(orderId),
          action = enable ? 'enable_food_ready_now' : 'disable_food_ready_now';

        return promise.one(action).put();
      }
    });
  }
  foodReady.$inject = [ 'Restangular' ];

  angular.module('zoomerRestaurant')
    .factory('foodReady', foodReady);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').factory('FullStory', [
    '$fullStory', '$location', '$window', 'Config',
    function ($fullStory, $location, $window, Config) {
      return {

        /**
         * Check if Angular app is in Production mode AND from a server
         *
         * @return {Boolean}
         */
        isProductionWeb: function () {
          return Config.ENV === 'production' && $location.protocol() !== 'file';
        },

        /**
         * Clear any existing User data in FullStory
         */
        clear: function () {
          if (!this.isProductionWeb()) {
            return;
          }

          $fullStory.clearUserCookie();
        },

        /**
         * Set user data in FullStory
         *
         * @param {Number|String} id
         * @param {Object} options
         */
        identify: function (id, options) {
          if (!this.isProductionWeb()) {
            return;
          }

          id = id || '';
          $fullStory.identify(id.toString(), options);
        }
      };
    }
  ]);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').factory('InfiniteScroller', [
    'Utilities',
    function (Utilities) {

      function InfiniteScroller() {
        this.reset();
        return this;
      }

      InfiniteScroller.prototype = {

        /**
         * Reset all data
         */
        reset: function () {
          this.updating = false;
          this.pagination = {
            current: 1
          };
        },

        /**
         * Toggle the `updating` property
         *
         * @param {Boolean} updating
         */
        setUpdating: function (updating) {
          this.updating = !!updating;
        },

        /**
         * Get next available pagination page
         *
         * @return {Number}
         */
        getNextPage: function () {
          var pagination = this.pagination || {},
            next = pagination.next || {};
          return next.page || 1;
        },

        /**
         * Get the pagination's current page
         *
         * @return {Number}
         */
        getCurrentPage: function () {
          var pagination = this.pagination || {};
          return pagination.current || 1;
        },

        /**
         * Check if another pagination page exists, and we're not already loading another page
         *
         * @return {Boolean}
         */
        hasNextPage: function () {
          var pagination = this.pagination || {},
            next = pagination.next;
          return !this.updating && !!next;
        },

        /**
         * Pass back the pagination data from the update() response
         *
         * @param {Object} headers
         */
        success: function (headers) {
          headers = headers || {};
          this.updating = false;

          this.pagination = Utilities.pagination.get(headers.link);
        },

        /**
         * Failure state
         */
        failure: function () {
          this.updating = false;
        }
      };

      return {
        _InfiniteScroller: InfiniteScroller, // for testing

        create: function () {
          return new InfiniteScroller();
        }
      };
    }
  ]);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').factory('IonicDeploy', [
    '$window', '$q', '$ionicPlatform', 'Config',
    function ($window, $q, $ionicPlatform, Config) {
      var deferred = $q.defer();

      $ionicPlatform.ready(function () {
        var ionic = $window.ionic,
          platform = ionic.Platform,
          isWebView = platform.isWebView(),
          IonicCordova = $window.IonicCordova,
          deployConfig;

        // Don't attempt Ionic Deploy if running in a browser
        if (!isWebView) {
          return deferred.resolve();
        }

        deployConfig = {
          appId: Config.IONIC_APP_ID,
          channel: Config.IONIC_DEPLOY_CHANNEL
        };

        IonicCordova.deploy.init(deployConfig, function(result) {
          console.log('Initialized IonicDeploy on ' + deployConfig.channel);
          deferred.resolve(IonicCordova.deploy);
        }, function(error) {
          console.log('Failed to initialize IonicDeploy on ' + deployConfig.channel);
          deferred.resolve(); // use 'resolve' instead of 'reject' since we need Appsee, Beacons, and Device info initialized
        });
        
      });
      return deferred.promise;
    }
  ]);
}());

(function () {
  angular.module('zoomerRestaurant').factory('LogEntries', [
    '$window', 'Config',
    function ($window, Config) {
      $window.LE.init({
        catchall: true,
        token: Config.LOGENTRIES_JS_API_KEY
      });
      return $window.LE;
    }
  ]);
}());

(function() {
  'use strict';

  angular.module('zoomerRestaurant').factory('makeIsAssigningSoon',
    /** @ngInject */
    function(deterministicRand) {
      function isAssigned(order) {
        return order.driver_assigned && order.driver_assigned.id;
      }

      return function makeIsAssigningSoon(order) {
        var rbt = new Date(order.ready_by_time);
        var randomDelay = deterministicRand(order.id) * 2;
        var assigningAt = moment(rbt).subtract(5, 'minutes').add(randomDelay, 'minutes').toDate();

        return function isAssigningSoon(now) {
          now = now || new Date();
          return !order.isPickupOrder() && !isAssigned(order) && (assigningAt <= now || !!order.food_ready_now);
        };
      };
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function menuList(Restangular) {

    return {
      fetchRestaurantArray: function () { 
        return Restangular
          .one('restaurants/my_restaurant/startup_array')
          .get();
      },
      fetchMenuFromEs: function (eatstreetId) { 
        return Restangular
          .one('restaurants/my_restaurant/get_menu_by_es_id/')
          .customGET('',{eatstreet_id: eatstreetId});
      }, 
      fetchOptions: function (eatstreetId) {
        return Restangular
        .one('restaurants/my_restaurant/options/')
        .customGET('',{eatstreet_id: eatstreetId});
      }, 
      setInvisibility: function (productId, eatstreetId, optionName, invisible, temporarilyInvisible) {
        if (productId) {
          return Restangular
          .one('restaurants/my_restaurant/set_product_invisibility/' + productId)
          .customPUT({invisible: invisible, temporarily_invisible: temporarilyInvisible});
        } else {
          return Restangular
          .one('restaurants/my_restaurant/set_option_invisibility/')
          .customPUT({eatstreet_id: eatstreetId, option_name: optionName, invisible: invisible, temporarily_invisible: temporarilyInvisible});
        }
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('menuList', menuList);

}());

(function () {
  'use strict';

  /** @ngInject */
  function offline($window, Config) {
    var o = $window.Offline,
      url = Config.API_BASEURL + '/connection_test';

    return angular.extend($window.Offline, {
      init: function () {
        o.options = {
          checkOnLoad: true,
          checks: {
            xhr: { url: url }
          },
          requests: false
        };
      }
    });
  }

  angular.module('zoomerRestaurant')
    .factory('offline', offline);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').factory('OozoActions', [
    '$ionicLoading', '$rootScope', '$state', 'zIonicPopup', 'ExternalOrders', 'Utilities', 'ordersForReview', 'oozoReviews',
    function ($ionicLoading, $rootScope, $state, zIonicPopup, ExternalOrders, Utilities, ordersForReview, oozoReviews) {
      return {

        /**
         * return to Orders Queue
         *
         * @param {Number} orderId
         */
        editOrder: function (orderId) {
          $state.go('app.edit-order', { orderId: orderId });
        },

        /**
         * Retrieve OOZO review info from the server
         *
         * @param {Number} id
         */
        get: function (id) {
          return oozoReviews.one(id.toString()).get();
        },

        /**
         * Send an Order up for Review (OOZO) and refresh Collection
         *
         * @param {Object} order
         * @return {Object} $promise
         */
        create: function (order) {
          var params = Utilities.orders.getParams(order);
          return oozoReviews.post(params).finally(ordersForReview.getAll.bind(ordersForReview));
        },

        /**
         * Create a new OOZO from a provided Email Order data
         *
         * @param {Object} externalOrder
         */
        createFromEmailOrder: function (externalOrder) {
          var params = Utilities.orders.getParams(externalOrder);

          params.external_order_id = externalOrder.id;
          $ionicLoading.show();

          oozoReviews.post(params).then(function () {
            ExternalOrders.remove(externalOrder);
            ExternalOrders.getAll();
            $rootScope.$emit('$emailOrderSubmitted', externalOrder);
          }).finally(function () {
            $ionicLoading.hide();
          });

        },

        /**
         * Confirm that an OOZO has been approved and whether to edit the order or continue
         *
         * @param {Number} oozoId
         */
        confirmApproved: function (oozoId) {
          var self = this;

          this.get(oozoId).then(function (response) {
            var oozo = response.data.plain(),
              scope = $rootScope.$new(),
              popupOptions;

            scope.oozo = oozo;
            popupOptions = {
              cssClass: 'z-popup-oozo-approved',
              okText: 'Confirm Order Details',
              scope: scope,
              title: '<i class="fa fa-check-circle"></i> Order Approved by Zoomer Support',
              templateUrl: 'app/views/popups/oozo-confirm-approved.html'
            };

            zIonicPopup.confirm(popupOptions).then(function (confirm) {
              if (confirm) {
                self.editOrder(oozo.order_id);
              }
            }).finally(scope.$destroy);
          });
        },

        /**
         * Confirm the OOZO rejection of an Order
         *
         * @param {Number} oozoId
         */
        confirmRejected: function (oozoId) {
          this.get(oozoId).then(function (response) {
            var oozo = response.data.plain(),
              orderId = oozo.order_id,
              scope = $rootScope.$new(),
              popupOptions;

            scope.oozo = oozo;
            popupOptions = {
              cssClass: 'z-popup-oozo-rejected',
              okText: 'View Order',
              scope: scope,
              title: '<i class="fa fa-times-circle"></i> Order Reviewed by Zoomer Support',
              templateUrl: 'app/views/popups/oozo-confirm-rejected.html'
            };

            zIonicPopup.alert(popupOptions).then(function () {
              $state.go('app.view-order', { orderId: orderId });
            }).finally(scope.$destroy);
          });
        },

        /**
         * On receipt of a OOZO pusher event, parse and process
         */
        onEvent: function (eventName, data) {
          data = data || {};
          var oozoStatus = data.status,
            oozoId = data.id;

          if (eventName === 'pusher:subscription_succeeded') {
            return;
          }

          ordersForReview.getAll();

          if (oozoStatus === 'approved') {
            return this.confirmApproved(oozoId);
          }

          if (oozoStatus === 'rejected') {
            return this.confirmRejected(oozoId);
          }
        }

      };
    }
  ]);
}());

(function () {
  'use strict';

  /** @ngInject */
  function oozoReviews(Restangular) {
    return Restangular.service('oozo_reviews');
  }

  angular.module('zoomerRestaurant')
    .factory('oozoReviews', oozoReviews);

}());

(function () {
  'use strict';
  var EDIT_ORDER_STATES = [
    'app.new-order', 'app.edit-order',
    'app.new-reorder', 'app.edit-reorder',
    'app.new-specialorder', 'app.edit-specialorder'
  ];

  angular.module('zoomerRestaurant').factory('Order', [
    '$filter', '$ionicLoading', '$q', '$rootScope', '$state', 'Config', 'Modals', 'ordersQueue', 'zIonicPopup',
    function ($filter, $ionicLoading, $q, $rootScope, $state, Config, Modals, ordersQueue, zIonicPopup) {
      var factory;
      function getDefaultParams() {
        return {
          driver_iou: null,
          diner: {}
        };
      }

      /**
       * @method isPickupOrder determines if the passed order is a pickup order. Handles blank objects.
       * @param {*} order
       * @returns true if the order has one of the pickup order statuses. False otherwise.
       */
      function isPickupOrder(order) {
        return order.status === 'do_not_deliver' || order.status === 'do_not_deliver_dismissed';
      }

      factory = {
        data: getDefaultParams(),

        /**
         * @method reset
         * @return {Object}
         */
        reset: function () {
          this.data = getDefaultParams();
          return this.data;
        },

        /**
         * @description $on: $ionicView.enter
         */
        viewPromise: $rootScope.$on('$ionicView.enter', function (e, ionicView) {
          if (EDIT_ORDER_STATES.indexOf(ionicView.stateName) === -1) {
            factory.reset();
          }
        }),

        /**
         * @method init
         * @param {Number} id
         * @retrun {Object} $promise
         */
        init: function (id) {
          var deferred = $q.defer(),
            self = this;

          if (!id) {
            deferred.resolve(this.reset());
            return deferred.promise;
          }

          ordersQueue.getById(id).then(function (response) {
            self.data = response.data || {};
            deferred.resolve(self.data);
          });

          return deferred.promise;
        },

        /**
         * @method get
         * @return {Object}
         */
        get: function () {
          return this.data;
        },

        /**
         * @method cancel
         */
        cancel: function () {
          var order = this.get(),
            id = order.id;

          if (!id) {
            return;
          }

          zIonicPopup.confirm(Modals.CONFIRM_CANCEL_ORDER).then(function (answer) {
            if (!answer) {
              return;
            }

            $ionicLoading.show({ template: 'Cancelling order' });
            order.cancel().then(function () {
              $state.go(Config.ROOT_LOGGED_IN_STATE);
            }).finally(function () {
              $ionicLoading.hide();
            });
          });
        },

        /**
         * (Re)set the Driver IOU value
         *
         * @param {Number} iou
         */
        setIou: function (iou) {
          if (!this.data) {
            return;
          }
          this.data.driver_iou = iou || null;
        },

        /**
         * @method updatePaymentMethod
         * @param {String} paymentMethod
         */
        updatePaymentMethod: function (paymentMethod) {
          if (!this.data) {
            return;
          }

          this.data.payment_method = paymentMethod;
          if (paymentMethod !== 'cash') {
            this.setIou();
          }
        },

        /**
         * @method updateIou
         */
        updateIou: function () {
          var self = this,
            order = this.get(),
            paymentMethod = order.payment_method,
            iou = order.driver_iou;

          if (paymentMethod !== 'cash') {
            return;
          }

          if (iou) {
            return this.confirmResetIou();
          }

          zIonicPopup.prompt(Modals.getSetOrderIouConfirm(order)).then(function (iouValue) {
            if (iouValue === undefined) {
              return;
            }

            self.setIou(iouValue);
            $rootScope.$broadcast('$updateOrderDriverIou', iouValue);
          });
        },

        /**
         * @method confirmResetIou
         */
        confirmResetIou: function () {
          var self = this,
            order = this.get(),
            id = order.id,
            driver = order.driver_assigned || {},
            driverName = driver.name || 'The driver',
            iou = $filter('currency')(order.driver_iou);

          zIonicPopup.confirm({
            okText: 'Remove IOU',
            okType: 'button-remove',
            template: driverName + ' has an IOU of: <h3>' + iou + '</h3>',
            title: 'IOU for Order ' + (id ? '#' + id : '')
          }).then(function (confirm) {
            if (confirm) {
              self.setIou();
              $rootScope.$broadcast('$updateOrderDriverIou');
            }
          });
        },

        /**
         * @method canOrderHaveIou
         * @return {Boolean}
         */
        canOrderHaveIou: function () {
          var order = this.get() || {};
          return order.payment_method === 'cash' && !isPickupOrder(order);
        },

        /**
         * @method canOrderBeCancelled
         * @return {Boolean}
         */
        canOrderBeCancelled: function () {
          var order = this.get() || {},
            nextActions = order.next_actions || [],
            currentState = $state.current;

          if (!order.id || currentState.name === 'app.new-reorder' || isPickupOrder(order)) {
            return false;
          }

          return !_.find(nextActions, function (action) {
            return action.action_type === 'pickup' && action.status === 'completed';
          });
        }

      };

      return factory;
    }
  ]);
}());

(function () {
  'use strict';

  /** @ngInject */
  function orderHistoryStatistics(Restangular) {
    return Restangular.service('orders').one('statistics');
  }

  angular.module('zoomerRestaurant')
    .factory('orderHistoryStatistics', orderHistoryStatistics);

}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').factory('PhoneUtils', [
    '$window',
    function ($window) {
      return $window.phoneUtils;
    }
  ]);
}());

(function () {
  'use strict';

  /** @ngInject */
  function readyByTimes($rootScope, Config, Restangular, Restaurant, Utilities) {
    var resource,
      serviceName = 'feasible_rbts';
    resource = Restangular.service(serviceName);

    Restangular.extendModel(serviceName, function (data) {
      data.rbt_options = Utilities.time.parseRbts(data.rbt_options);
      data.ready_by_time_floor = data.ready_by_time_floor || 0;
      return data;
    });

    return angular.extend(resource, {

      /**
       * @method isRbtFloorEnabled
       * @return {Boolean}
       */
      isFloorEnabledForRestaurant: function () {
        var rbtFloor = this.getFloor(),
          restaurant = Restaurant.info || {},
          tier = restaurant.tier;

        return tier > Config.LOWEST_PRIORITY_TIER && rbtFloor;
      },

      /**
       * @method getFloor
       * @return {Number}
       */
      getFloor: function () {
        return this.ready_by_time_floor;
      },

      /**
       * @method getMinRbt
       * @return {Number}
       */
      getMin: function () {
        var myRbts = this.rbt_options || [];

        return _.sortBy(myRbts || [])[0];
      },

      /**
       * @method refresh
       * @return {Object} $promise
       */
      refresh: function () {
        var self = this;

        return this.post().then(function (response) {
          angular.extend(self, response.data.plain());
        });
      },

      /**
       * @method onEvent
       * @param {String} eventName
       * @param {Object} data
       */
      onEvent: function (eventName, data) {
        if (eventName !== 'pusher:subscription_succeeded') {
          this.refresh();
          $rootScope.$broadcast('$floorSettingsUpdated', data);
        }
      }

    });
  }

  angular.module('zoomerRestaurant')
    .factory('readyByTimes', readyByTimes);

}());

(function () {
  'use strict';

  /** @ngInject */
  function restaurantDeliveryZones(Restangular, Restaurant) {
    var resource,
      serviceName = 'restaurant_delivery_zones';

    resource = Restangular.service(serviceName);

    Restangular.extendCollection(serviceName, function (data) {
      function getZoneByType(type) {
        return Boolean(data.find(function (zone) {
          return zone.delivery_zone_type === type;
        }));
      }

      var hasInnerZone = getZoneByType('inner'),
        hasOuterZone = getZoneByType('outer'),
        hasSnowZone = getZoneByType('snow');

      return angular.extend(data, {
        hasInnerZone: hasInnerZone,
        hasOuterZone: hasOuterZone && Restaurant.hasOozoPricing(),
        hasSnowZone: hasSnowZone
      });
    });

    return resource;
  }

  angular.module('zoomerRestaurant')
    .factory('restaurantDeliveryZones', restaurantDeliveryZones);

}());

/**
 * Sentry Factory
 * Used to initialize Raven with Sentry URL, AngularJS plugin, and Restaurant app-specific settings.
 * 
 * Note: this implementation is based on the one from the Driver app.
 *  There is another implementation that was prototyped by Zoomer, but never published (due to numerous unit-test failures).
 *  It's stored here: https://github.com/eatstreet/restaurants.zoomer.io/tree/update-sentry-logging
 *  I wish I have discovered it earlier and picked up where the previous developer left off. 
 *  If we have issues with this implementation in the future, we can always try Zoomer's prototype from that branch. 
 *
 * Author: Ilya Vinogradov
 * © EatStreet, Delivery Unit, 2017 - 2018
 */
(function() {
    'use strict';
  
    /** @ngInject */
    angular.module('zoomerRestaurant').factory('sentry', function(Config) {
      return  {
        init: init,
        setRestaurant: setRestaurant,
        setTags: setTags,
        test: test
      };

      /**
       * Initializes Raven and Raven-Angular plugin to log erros to Sentry
       */
      function init() {
        if(Config.ENV === 'dev') return;

        Raven.config(Config.RAVEN_DSN, {
          ignoreUrls: [ 'http://localhost:3000', 'http://localhost:3001' ],
          includePaths: [ /^file:\/\//, /restaurants-staging\.zoomer\.io/, /zoomer-restaurants\.eatstreet\.com/ ],
          release: Config.ZOOMER_APP_VERSION,
          whitelistUrls: [ /^file:\/\//, /restaurants-staging\.zoomer\.io/, /zoomer-restaurants\.eatstreet\.com/ ],
          ignoreErrors: [ '$rootScope:inprog' ] // Angular error is coming from ionic lib
        });
  
        if(Raven.Plugins) Raven.addPlugin(Raven.Plugins.Angular);
  
        Raven.install();
        this.setTags();
      }
  
      /**
       * Sets Sentry app version and environment context to differentiate where errors happen
       */
      function setTags(binaryVersion, binaryBuild) {
        Raven.setTagsContext({
          'environment': Config.ENV,
          'version': Config.ZOOMER_APP_VERSION,
          'binary.build': binaryBuild,
          'binary.version': binaryVersion
        });
      }
      
      /**
       * Sets Sentry to log errors agains the specified restaurant
       * @param {Object} restaurant
       */
      function setRestaurant(restaurant) {
        Raven.setUserContext(extractIdentifiers(restaurant));
      }

      /**
       * Parse and retrieve the sentry-relevant restaurant info (ID and name). 
       * @param {Object} restaurant - the object containing full restaurant info
       * @return {Object} containing name and ID of the restaurant, or 'No user' and '0' respectively if the object is null
       */
      function extractIdentifiers(restaurant) {
        var _restaurant = restaurant || '{}';
        return {
          name: _restaurant.name || 'No user',
          id: _restaurant.id || 0
        };
      }
  
      /**
       * Simulates exception to be logged to Sentry
       */
      function test() {
        Raven.captureException('Ilya: test error!');
      }
    });
  }());
(function () {
  'use strict';

  function getUrl(order) {
    var type = order.reorder_of ? 'reorder/' : '',
      parts = [
        '#/app/orders',
        order.id,
        (type + (order.status === 'delivered' ? 'view' : 'edit'))
      ];
    return parts.join('/');
  }

  /** @ngInject */
  function Toast(toastr) {

    return angular.extend(toastr, {

      /**
       * @method show
       * @param {String} content
       * @param {String} title
       * @param {Object} params
       */
      show: function (content, title, params) {
        content = content || '';
        title = title || '';
        params = params || {};
        return toastr.info(content, title, angular.extend({ iconClass: 'zoomer-toast' }, params));
      },

      /**
       * @method toastOrder
       * @param {String} content
       * @param {Object} order
       */
      toastOrder: function (content, order) {
        order = order || {};
        content = content || '';
        if (order.id) {
          content += ' <a class="right" href="' + getUrl(order) + '">View</a>';
        }

        return toastr.show(content);
      },

      /**
       * @method warnExtraLargeOrder
       */
      warnExtraLargeOrder: function () {
        var txt = '<i class="fa fa-exclamation-circle"></i> Because this order is X-Large, it must be sent as a Special Order';
        return toastr.info(txt, '', {
          iconClass: 'zoomer-toast zoomer-toast-long',
          tapToDismiss: true
        });

      }
    });
  }

  angular.module('zoomerRestaurant')
    .factory('Toast', Toast);

}());

(function () {
  'use strict';

  /** @ngInject */
  function totalOpenReceipts(Restangular) {
    var resource = Restangular.service('receipts'),
      params = {
        payment_method: 'credit_card,prepaid'
      };

    return angular.extend(resource, {
      $total: 0,

      /**
       * @method refresh
       * @return {Object} $promise
       */
      refresh: function () {
        return resource.getList(params).then(function (response) {
          resource.$total = Number(response.headers('total') || 0);
        });
      }
    });
  }

  angular.module('zoomerRestaurant')
    .factory('totalOpenReceipts', totalOpenReceipts);

}());

(function () {
  'use strict';

  /** @ngInject */
  function zDateRangeLauncher($ionicScrollDelegate, $timeout) {
    return function () {
      var scope = this;
      if (!scope || !scope.$broadcast) {
        return;
      }

      $timeout(function () {
        scope.$broadcast('$zDateRangeInit');
        $ionicScrollDelegate.scrollTop();
      }, 100);
    };
  }

  angular.module('zoomerRestaurant')
    .factory('zDateRangeLauncher', zDateRangeLauncher);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').factory('zIonicPopup', [
    '$ionicPopup', '$q',
    function ($ionicPopup, $q) {

      var firstDeferred = $q.defer(),
        lastPopupPromise,
        extended,
        execute;

      firstDeferred.resolve();
      lastPopupPromise = firstDeferred.promise;

      extended = angular.copy($ionicPopup);

      execute = function(options, method) {
        var deferred = $q.defer();
        lastPopupPromise.then(function () {
          $ionicPopup[method](options).then(function (response) {
            deferred.resolve(response);
          });
        });
        lastPopupPromise = deferred.promise;
        return deferred.promise;
      };

      /**
       * Extend show method
       *
       * @param {Object} options
       */
      extended.show = function(options) {
        return execute(options, 'show');
      };
      /**
       * Extend alert method
       *
       * @param {Object} options
       */
      extended.alert = function(options) {
        return execute(options, 'alert');
      };
      /**
       * Extend confirm method
       *
       * @param {Object} options
       */
      extended.confirm = function(options) {
        return execute(options, 'confirm');
      };

      return extended;
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('deliveryZoneStatus', {
      bindings: {
        deliveryZoneStatus: '<',
        onOozoPricingSelected: '&',
        order: '<'
      },
      bindToController: true,
      controller: 'DeliveryZoneStatusCtrl',
      templateUrl: 'app/ionView/deliveryZoneStatus.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function DeliveryZoneStatusCtrl($ionicModal, $scope, $state, Config, OozoActions) {
    var vm = this,
      modalParams = { scope: $scope };

    vm.mapModal = null;
    vm.reviewModal = null;

    vm.showOtherTextarea = false;
    vm.oozoOtherReason = '';

    vm.showOozoOrderOptions = false;
    vm.buttonDisabled = false;

    /**
     * @method isOutsideDeliveryZone
     * @return {Boolean}
     */
    vm.isOutsideDeliveryZone = function () {
      var deliveryZoneStatus = vm.deliveryZoneStatus;
      if (deliveryZoneStatus.isOutsideSnowZone) {
        return false;
      }

      return deliveryZoneStatus.isOutsideDeliveryZone || deliveryZoneStatus.isWithinExclusion;
    };

    /**
     * @method isWithinOuterZone
     * @return {Boolean}
     */
    vm.isWithinOuterZone = function () {
      var deliveryZoneStatus = vm.deliveryZoneStatus;
      if (deliveryZoneStatus.isOutsideSnowZone || vm.isOutsideDeliveryZone()) {
        return false;
      }

      return !deliveryZoneStatus.isWithinInner && deliveryZoneStatus.isWithinOuter;
    };

    /**
     * @method acceptOozoCharge
     */
    vm.acceptOozoCharge = function () {
      vm.order.oozo_pricing_accepted = true;
      if (vm.onOozoPricingSelected) {
        vm.onOozoPricingSelected();
      }
    };

    /**
     * Toggle the OOZO options
     *
     * @param {Boolean} force
     */
    vm.toggleOozoOptions = function (force) {
      vm.showOozoOrderOptions = force !== undefined ? !!force : !vm.showOozoOrderOptions;
    };

    /**
     * Assign OOZO review reason
     *
     * @param {String} reason
     */
    vm.setReviewReason = function (reason) {
      if (!reason) {
        return;
      }

      if (!vm.order.oozo_review) {
        vm.order.oozo_review = {};
      }

      vm.order.oozo_review.review_reason = reason;
    };

    /**
     * Set 'other' Reason to send OOZO for review
     */
    vm.setOtherReason = function () {
      if (!vm.order.oozo_review) {
        vm.order.oozo_review = {};
      }

      vm.order.oozo_review.review_reason = '';
      vm.showOtherTextarea = true;
    };

    /**
     * Show the OOZO map modal
     */
    vm.showOozoMapModal = function () {
      vm.toggleOozoOptions(false);

      $ionicModal.fromTemplateUrl('app/views/modals/oozo-order-map.html', modalParams).then(function (modal) {
        vm.mapModal = modal;
        vm.mapModal.show();
      });
    };

    /**
     * Confirm you'd like to send this scoped Order for review
     */
    vm.confirmSendForReview = function () {
      vm.toggleOozoOptions(false);

      $ionicModal.fromTemplateUrl('app/views/modals/oozo-send-for-review.html', modalParams).then(function (modal) {
        vm.reviewModal = modal;
        vm.reviewModal.show();
      });
    };

    /**
     * Close Review modal and reset data
     */
    vm.reset = function () {
      if (vm.reviewModal) {
        vm.reviewModal.remove();
      }

      vm.showOtherTextarea = false;
      vm.oozoOtherReason = '';
      vm.showOozoOrderOptions = false;

      if (vm.order.oozo_review) {
        vm.order.oozo_review.review_reason = null;
      }
    };

    /**
     * Submit an Order for review to the server and redirect back onSuccess
     */
    vm.sendForReview = function () {
      var isExternalOrder,
        order;

      if (vm.reviewModal) {
        vm.reviewModal.remove();
      }

      vm.buttonDisabled = true;

      $scope.$evalAsync(function () {
        order = vm.order;
        isExternalOrder = Boolean(order.source) && order.source !== 'Zoomer';
        if (isExternalOrder) {
          return OozoActions.createFromEmailOrder(order);
        }

        OozoActions.create(order).then(function () {
          $state.go(Config.ROOT_LOGGED_IN_STATE);
        });
      });

    };

  }

  angular.module('zoomerRestaurant')
    .controller('DeliveryZoneStatusCtrl', DeliveryZoneStatusCtrl);

}());

(function () {
  'use strict';

  var footerCls = '.menu-content [nav-view="active"] .z-footer';

  /** @ngInject */
  function ionContent($timeout) {
    function link(scope, element, attributes) {
      var delegateHandle = attributes.delegateHandle,
        marginTimeout,
        watchPromise,
        onPromise,
        destroyPromise;

      if (scope.$parent && attributes.delegateHandle) {
        scope.$parent.$hasHeader = true;
      }

      /**
       * @method setElementBottomMargin
       */
      scope.setElementBottomMargin = function (bottom) {
        bottom = bottom || 0;
        element.css({
          marginBottom: bottom ? (bottom + 2 + 'px') : 0
        });
      };


      /**
       * @method adjustContentHeight
       */
      scope.adjustContentHeight = function () {
        var footerEl;

        if (marginTimeout) {  // Already coerced to boolean - no need to '!!' see http://eslint.org/docs/2.0.0/rules/no-extra-boolean-cast
          $timeout.cancel(marginTimeout);
          marginTimeout = null;
        }

        marginTimeout = $timeout(function () {
          marginTimeout = null;
          footerEl = document.querySelector(footerCls) || {};

          scope.setElementBottomMargin(footerEl.clientHeight || 0);
        }, 500);
      };

      if (delegateHandle && delegateHandle === 'pageContent') {
        watchPromise = scope.$watch('state.current', scope.adjustContentHeight);
        onPromise = scope.$on('$adjustIonContentHeight', scope.adjustContentHeight);

        destroyPromise = scope.$on('$destroy', function () {
          destroyPromise();
          watchPromise();
          onPromise();
        });
      }

    }

    return {
      link: link,
      priority: 0
    };
  }

  angular.module('zoomerRestaurant')
    .directive('ionContent', ionContent);

}());

(function () {
  'use strict';

  var orderActionStates,
    fullScreenStates,
    otherStates;

  orderActionStates = [
    'app.new-order',
    'app.edit-order',
    'app.new-specialorder',
    'app.edit-specialorder',
    'app.new-reorder',
    'app.edit-reorder'
  ];

  fullScreenStates = [
    'login'
  ];

  otherStates = [
    'app.receipts'
  ];

  /** @ngInject */
  function ionView($state, $rootScope, $ionicModal, Restaurant, AutoComplete, GoogleMaps, InAppMessages, PaymentStatus, MixPanel) {
    function link(scope) {
      var watchPromise,
        deliveryZonePromise,
        destroyPromise;

      scope.autoComplete = AutoComplete;
      scope.googleMaps = GoogleMaps;
      scope.inAppMessages = InAppMessages;
      scope.isReceiptState = false;
      scope.isOrderState = false;
      scope.paymentStatus = PaymentStatus;
      scope.state = $state;
      scope.disableOpenBtn = false;
      scope.isRestaurantOpen = $rootScope.isRestaurantOpen;
      scope.backupRestaurantArray = [];
      scope.tempPausedThreshold = 60;
      $rootScope.disableConfirmBtn = true;
      $rootScope.disableConfirmBtnFooter = true;
      scope.restaurantArray = $rootScope.restaurantArray;
      scope.totalSoldOutItems = 0;
      scope.totalSoldOutOptions = 0;


      /**
       * @method isOozoPossible
       * @return {Boolean}
       */
      scope.isOozoPossible = function () {
        var order = scope.order || {},
          address = order.address || {},
          orderForm = scope.orderForm || {};

        return orderForm.$valid &&
            !address.do_not_deliver &&
            !order.oozo_pricing_accepted;
      };

      /**
       * @method isActionState
       * @return {Boolean}
       */
      scope.isActionState = function () {
        return scope.isOrderState ||
          (scope.isReceiptState && scope.showBulkReceiptClose());
      };

      /**
       * @method showBulkReceiptClose
       * @return {Boolean}
       */
      scope.showBulkReceiptClose = function () {
        var form = scope.receiptsForm || {};
        return form.$valid;
      };

      /**
       * @method showFooterBar
       * @return {Boolean}
       */
      scope.showFooterBar = function () {
        scope.restaurantArray = $rootScope.restaurantArray;
        return fullScreenStates.indexOf($state.current.name) === -1 ;
      };

      /**
       * Only show ghost kitchen status footer on main orders page
       * @method showGkFooter
       * @return {Boolean}
       */
      scope.showGkFooter = function() {
        return $state.current.name === 'app.orders' && $rootScope.hasGhostKitchens;
      }

      /**
       * Show new footer for invisible items/options only on main orders page
       * @method showNewFooter
       * @return {Boolean}
       */
      scope.showNewFooter = function (rest) {
        return $state.current.name === 'app.orders' && !$rootScope.hasGhostKitchens;
      }

      /**
       * @method showInAppMessage
       * @return {Boolean}
       */
      scope.showInAppMessage = function () {
        var rootStates = [ 'app.orders', 'app.history', 'app.receipts' ];
        return InAppMessages.message && rootStates.indexOf($state.current.name) > -1;
      };

      scope.toggleRestaurant = function () {
        var restaurant = Restaurant.info,
          isOpen = restaurant.status === 'active';
        scope.disableOpenBtn = true;

        scope.confirmModal.hide().then(function () {
          scope.isTogglingRestaurant = true;
          scope.disableOpenBtn = false;
          Restaurant.toggleOpening(!isOpen).then(complete, complete);
        });
      };

      scope.onOpenRestaurant = function () {
        $ionicModal.fromTemplateUrl('app/views/modals/confirm-open.html', {scope: scope}).then(function (modal) {
          scope.confirmModal = modal;
          scope.confirmModal.show();
        });
        MixPanel.track('unpause-orders');
      };

      /**
       * Toggle the (ghost) kitchen open/closed
       */
      scope.toggleKitchen = function () {
        $rootScope.disableConfirmBtn = false;
        $rootScope.disableConfirmBtnFooter = false;
        scope.getGkOpenClosed();
      };

      /**
       * Open open/close modal depending on current restaurant status
       */
      scope.onOpenCloseRestaurant = function () {
        var url = $rootScope.isRestaurantOpen ? 'app/views/modals/confirm-close.html' : 'app/views/modals/confirm-open.html';
        var mixpanel = $rootScope.isRestaurantOpen ? 'pause-orders' : 'unpause-orders';

        $ionicModal.fromTemplateUrl(url, {scope: scope}).then(function (modal) {
          scope.confirmModal = modal;
          scope.confirmModal.show();
        });
        MixPanel.track(mixpanel);
      };

      /**
       * Hide full screen manage status modal on cancel and revert
       * open/closed values
       */
      scope.closeModal = function () {
        scope.confirmModal.hide();
        if ($rootScope.hasGhostKitchens) {
          $rootScope.restaurantArray = scope.backupRestaurantArray;
        }
      };

      /**
       * Opens full screen manage status modal for opening/closing individual kitchens
       */
      scope.openManageStatusPage = function() {
        $rootScope.disableConfirmBtnFooter = true;
        $rootScope.disableConfirmBtn = true;
        scope.backupRestaurantArray = angular.copy($rootScope.restaurantArray);
        $ionicModal.fromTemplateUrl('app/views/modals/pause-unpause-ghost-kitchens.html', {scope: scope}).then(function (modal) {
          scope.confirmModal = modal;
          scope.confirmModal.show();
        });
      };

      scope.getGkOpenClosed = function() {
        var i;
        scope.numOpen = scope.numClosed = scope.numPaused = 0;
        for (i = 0; i < $rootScope.restaurantArray.length; i++) {
          if ($rootScope.restaurantArray[i].openStatus === false) {
            if ($rootScope.restaurantArray[i].pauseLength <= scope.tempPausedThreshold && $rootScope.restaurantArray[i].reopenTime !== null) {
              scope.numPaused++;
            } else {
              scope.numClosed++;
            }
          }
          else scope.numOpen++;
        }

        scope.totalSoldOutItems = 0;
        scope.totalSoldOutOptions = 0;
        $rootScope.restaurantArray.forEach(function(rest){
          scope.totalSoldOutItems += rest.invisibilityCount;
          scope.totalSoldOutOptions += rest.invisibleOptsCount;
        });
      };

      scope.openGKMenuModal = function () {
        $ionicModal.fromTemplateUrl('app/views/modals/gk-menus-select.html', {scope: scope}).then(function (modal) {
          scope.confirmModal = modal;
          scope.confirmModal.show();
        });
      };

      scope.closeGKMenuModal = function () {
        scope.confirmModal.hide();
      }

      scope.goToMenuGK = function (eatstreetId) {
        scope.confirmModal.hide();
        $state.go('app.menu-list', { eatstreetId: eatstreetId});
      };

      watchPromise = scope.$watch('state.current', function (state) {
        state = state || {};

        scope.isOrderState = orderActionStates.indexOf(state.name) > -1;
        scope.isReceiptState = otherStates.indexOf(state.name) > -1;

        if (scope.isReceiptState) {
          scope.showBulkReceiptClose();
        }
      });

      deliveryZonePromise = scope.$on('$orderDeliveryZoneStatusUpdated', function (e, deliveryZoneStatus) {
        scope.deliveryZoneStatus = deliveryZoneStatus;
        scope.order.oozo_pricing_accepted = false;
      });

      destroyPromise = scope.$on('$destroy', function () {
        watchPromise();
        deliveryZonePromise();
        destroyPromise();
      });

    }

    return {
      link: link,
      priority: 0,
      templateUrl: 'app/ionView/ionView.html',
      transclude: true
    };
  }

  angular.module('zoomerRestaurant')
    .directive('ionView', ionView);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('receiptCloseButton', {
      bindings: {
        form: '<'
      },
      bindToController: true,
      templateUrl: 'app/ionView/receiptCloseButton.html'
    });

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('submitOrderButton', {
      bindings: {
        deliveryZoneStatus: '<',
        form: '<',
        isEdit: '<',
        order: '<'
      },
      bindToController: true,
      controller: 'SubmitOrderButtonCtrl',
      templateUrl: 'app/ionView/submitOrderButton.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function SubmitOrderButtonCtrl(Restaurant) {
    var vm = this;
    vm.title = vm.isEdit ? 'Save changes' : 'Zoom it!';

    /**
     * @method is2xPricingUnselected
     * @return {Boolean}
     */
    vm.is2xPricingUnselected = function () {
      var order = vm.order,
        deliveryZoneStatus = vm.deliveryZoneStatus || {};

      if (deliveryZoneStatus.isWithinInner || !deliveryZoneStatus.isWithinOuter) {
        return false;
      }
      return deliveryZoneStatus.isWithinOuter && !order.oozo_pricing_accepted;
    };

    /**
     * @method isOutsideDeliveryZone
     * @return {Boolean}
     */
    vm.isOutsideDeliveryZone = function () {
      var deliveryZoneStatus = vm.deliveryZoneStatus || {};
      return deliveryZoneStatus.isOutsideDeliveryZone ||
        deliveryZoneStatus.isWithinExclusion ||
        deliveryZoneStatus.isOutsideSnowZone;
    };

    /**
     * @method isDisabled
     * @return {Boolean}
     */
    vm.isDisabled = function () {
      return Restaurant.isServiceHalted() ||
        vm.is2xPricingUnselected() ||
        vm.isOutsideDeliveryZone() ||
        vm.form.$pending ||
        vm.form.$pristine ||
        vm.form.$invalid;
    };
  }

  angular.module('zoomerRestaurant')
    .controller('SubmitOrderButtonCtrl', SubmitOrderButtonCtrl);

}());

(function () {
  'use strict';
  var timeout = null;

  /** @ngInject */
  function zFooterItem($rootScope, $timeout) {
    return function link(scope, element, attributes) {
      var watchPromise,
        destroyPromise,
        delay = 500;

      function broadcast() {
        if (timeout) {
          $timeout.cancel(timeout);
        }
        timeout = $timeout($rootScope.$broadcast.bind($rootScope, '$adjustIonContentHeight', attributes.zFooterItem), delay);
      }

      watchPromise = scope.$watch(attributes.zFooterItem, broadcast);

      destroyPromise = scope.$on('$destroy', function () {
        broadcast();
        watchPromise();
        destroyPromise();
      });
    };
  }

  angular.module('zoomerRestaurant')
    .directive('zFooterItem', zFooterItem);

}());

(function () {
  'use strict';

  var SCROLL_CONTENT_CLS = 'scroll-content',
    INFINITE_SCROLL_CUTOFF = 0.75,
    SCROLL_EVENT = 'scroll',
    DELAY = 100;

  /** @ngInject */
  function ZIonContentCtrl($attrs, $element, $parse, $rootScope, $scope, $timeout) {
    var vm = this,
      timeout;

    vm.delegate = null;
    vm.onScroll = null;
    vm.onInfiniteScroll = null;
    vm.desktopScrollContent = null;
    vm.stickyHeader = false;

    /**
     * @method emitStickyHeaderChange
     */
    vm.emitStickyHeaderChange = function () {
      if (timeout) {
        $timeout.cancel(timeout);
      }

      timeout = $timeout(function () {
        $scope.$emit('$zToggleSticky', vm.stickyHeader);
        timeout = null;
      }, DELAY);
    };

    /**
     * @method toggleStickyHeader
     * @param {Boolean} toggle
     */
    vm.toggleStickyHeader = function (toggle) {
      toggle = Boolean(toggle);
      if (vm.stickyHeader !== toggle) {
        vm.emitStickyHeaderChange();
      }

      vm.stickyHeader = toggle;
    };

    /**
     * @method getStickyScrollOffset
     * @return {Number}
     */
    vm.getStickyScrollOffset = function () {
      var offset = $attrs.zStickyScrollOffset || '';
      return Number(offset);
    };

    /**
     * @method getIonicScrollController
     */
    vm.getIonicScrollController = function () {
      var element = $element[0] || {},
        ionContent = angular.element(element.childNodes[0]);

      return ionContent.controller('$ionicScroll');
    };

    /**
     * @method getDelegateHandle
     * @return {Object}
     */
    vm.getDelegateHandle = function () {
      if (!vm.delegate) {
        vm.delegate = vm.getIonicScrollController();
      }

      return vm.delegate;
    };

    /**
     * @method getPercentageScroll
     * @param {Object} e
     * @return {Number}
     */
    vm.getPercentageScroll = function (e) {
      var target = e.target || {},
        scrollTop = target.scrollTop;

      return scrollTop / (target.scrollHeight - target.clientHeight);
    };

    /**
     * @method invokeInfiniteScrollCallback
     */
    vm.invokeInfiniteScrollCallback = function () {
      if (vm.onInfiniteScroll) {
        vm.onInfiniteScroll($scope);
      }
    };

    /**
     * @method invokeOnScrollCallback
     * @param {Number} scrollTop
     * @param {Object} scrollerBounds
     */
    vm.invokeOnScrollCallback = function (scrollTop, scrollerBounds) {
      if (vm.onScroll) {
        vm.onScroll($scope, { scrollTop: scrollTop, bounds: scrollerBounds });
      }
    };

    /**
     * @method onDesktopScroll
     * @param {Object} e
     */
    vm.onDesktopScroll = function (e) {
      var target = e.target || {},
        scrollTop = target.scrollTop,
        percentage = vm.getPercentageScroll(e),
        stickyScrollOffset = vm.getStickyScrollOffset();

      vm.invokeOnScrollCallback(scrollTop, target.getBoundingClientRect());

      if (stickyScrollOffset) {
        vm.toggleStickyHeader(scrollTop >= stickyScrollOffset);
      }

      if (percentage > INFINITE_SCROLL_CUTOFF) {
        vm.invokeInfiniteScrollCallback();
      }
    };

    /**
     * @method onMobileScroll
     */
    vm.onMobileScroll = function () {
      var handle = vm.getDelegateHandle(),
        scrollOffset = vm.getStickyScrollOffset(),
        scrollPosition = handle.getScrollPosition() || {},
        element = handle.element;

      vm.invokeOnScrollCallback(scrollPosition.top, element.getBoundingClientRect());

      if (scrollOffset) {
        vm.toggleStickyHeader(scrollPosition.top >= scrollOffset);
      }
    };

    /**
     * @method bindDesktopScroll
     */
    vm.bindDesktopScroll = function () {
      var el = $element[0];
      vm.desktopScrollContent = angular.element(el.getElementsByClassName(SCROLL_CONTENT_CLS));
      vm.desktopScrollContent.on(SCROLL_EVENT, vm.onDesktopScroll);
    };

    /**
     * @method bumpMobileScroller
     */
    vm.bumpMobileScroller =function () {
      var handle = vm.getDelegateHandle();
      if (handle) {
        handle.scrollTo(0, 1);
      }
    };

    /**
     * @method bumpDesktopScroller
     * @description if content is not scrollable, directly invoke callback
     */
    vm.bumpDesktopScroller = function () {
      var scrollContent = vm.desktopScrollContent[0],
        bounds = scrollContent.getBoundingClientRect() || {},
        scrollHeight = scrollContent.scrollHeight;

      if (scrollHeight > bounds.height) {
        scrollContent.scrollTop = 1;
      } else {
        vm.onDesktopScroll({ target: scrollContent });
      }
    };

    /**
     * @method bumpToTriggerOnScroll
     */
    vm.bumpToTriggerOnScroll = function () {
      var DELAY = 1000;

      $timeout(function () {
        if ($rootScope.isMobileDevice) {
          vm.bumpMobileScroller();
        } else {
          vm.bumpDesktopScroller();
        }
      }, DELAY);
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      if ($rootScope.isMobileDevice) {
        return;
      }

      $timeout(vm.bindDesktopScroll, DELAY);
    };

    /**
     * @method $postLink
     */
    vm.$postLink = function () {
      if ($attrs.onScroll) {
        vm.onScroll = $parse($attrs.onScroll);
        vm.bumpToTriggerOnScroll();
      }

      if ($attrs.zDesktopInfiniteScroll) {
        vm.onInfiniteScroll = $parse($attrs.zDesktopInfiniteScroll);
      }
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      if (vm.desktopScrollContent) {
        vm.desktopScrollContent.off(SCROLL_EVENT);
      }
    };
  }


  angular.module('zoomerRestaurant')
    .controller('ZIonContentCtrl', ZIonContentCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function zIonContent($rootScope) {
    var jqLite = angular.element,
      innerElement;

    /**
     * @method getIonContent
     * @param {Object} attributes
     * @return {String}
     */
    function getIonContent(attributes) {
      attributes = attributes || {};
      var htmlParts = [
        '<ion-content delegate-handle="pageContent" ',
        '</ion-content>'
      ];

      if (attributes.zHasSubHeader) {
        htmlParts[0] += ' class="has-subheader"';
      }

      if ($rootScope.isMobileDevice) {
        htmlParts[0] += ' on-scroll="zIonContentVm.onMobileScroll()"';
      } else {
        htmlParts[0] += ' scroll="false"';
      }

      return htmlParts.join('>');
    }

    /**
     * @method compile
     * @param {Object} element
     * @param {Object} attr
     */
    function compile(element, attr) {
      innerElement = jqLite(getIonContent(attr));
      innerElement.append(element.contents());
      element.addClass('z-ion-content');
      element.append(innerElement);

      return angular.noop;
    }

    return {
      controller: 'ZIonContentCtrl as zIonContentVm',
      compile: compile,
      priority: 800
    };
  }

  angular.module('zoomerRestaurant')
    .directive('zIonContent', zIonContent);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').controller('LoginCtrl', [
    '$state', '$timeout', 'zIonicPopup', 'Session', 'Storage', 'Config', 'externalOrderPoll', 'ordersQueue',
    function ($state, $timeout, zIonicPopup, Session, Storage, Config, externalOrderPoll, ordersQueue) {

      this.user = {
        email: '',
        password: ''
      };

      this.deployChannel = Config.IONIC_DEPLOY_CHANNEL;
      this.loading = false;
      this.storage = Storage;

      this.resetUser = function () {
        this.user = {
          email: '',
          password: ''
        };
      };

      /**
       * Continue launching the app
       */
      this.init = function () {
        this.resetUser();

        $state.go(Config.ROOT_LOGGED_IN_STATE);
        ordersQueue.getAll();
        externalOrderPoll.start();
      };

      /**
       * If enter key is pressed (and form is valid), blur the form
       *
       * @param {Object} e
       */
      this.blurOnEnter = function (e) {
        var key = e.keyCode,
          form = this.form;

        if (key !== 13 || !!form.$invalid) {
          return;
        }

        $timeout(function () {
          e.target.blur();
        }, 0, false);
      };

      /**
       * Display login errors in Ionic PopUp
       *
       * @param {Object} error
       */
      this.showLoginError = function (error) {
        error = error || {};
        zIonicPopup.alert({
          okText: 'Ok',
          title: 'Login failed',
          template: error.message || 'Please try again'
        });
      };

      /**
       * Submit to the server and login
       */
      this.submit = function () {
        var self = this,
          complete;

        complete = function () {
          self.loading = false;
        };

        if (!this.user.email || !this.user.password) {
          return;
        }

        this.loading = true;
        Session.login(this.user).then(this.init.bind(this), this.showLoginError.bind(this)).finally(complete);
      };

    }
  ]);
}());

(function () {
  'use strict';

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('login', {
      url: '/login',
      templateUrl: 'app/login/login.html',
      controller: 'LoginCtrl as Login'
    });
  }

  angular.module('zoomerRestaurant.login')
    .config(config);

}());

(function () {
  'use strict';


  angular.module('zoomerRestaurant')
    .component('editOrderNavBar', {
      controller: 'EditOrderNavBarCtrl as editOrderNavBarVm',
      templateUrl: 'app/navBar/editOrderNavBar.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function EditOrderNavBarCtrl($state, $stateParams, Config, Order, ZoomerState) {
    var vm = this;

    vm.order = Order;
    vm.state = $state;
    vm.title = null;
    vm.zoomerState = ZoomerState;

    /**
     * @method isBackStateInvalid
     * @return {Boolean}
     */
    vm.isBackStateInvalid = function () {
      var current = $state.current,
        name = current.name;

      return !ZoomerState.backTo ||
        (name === ZoomerState.backTo) ||  // We're in invalid state if we opened 2 editors sequentially (i.e. from accepting multiple pickup orders and viewing them immediately)
        (name === 'app.new-order' && ZoomerState.backTo === 'app.new-specialorder') ||
        (name === 'app.edit-order' && ZoomerState.backTo === 'app.edit-specialorder');
    };

    /**
     * @method back
     */
    vm.back = function () {
      var current = $state.current,
        name = current.name,
        params = angular.copy($stateParams);

      Order.reset();

      if (vm.isBackStateInvalid()) {
        return $state.go(Config.ROOT_LOGGED_IN_STATE);
      }

      if (name === 'app.new-reorder' && ZoomerState.backTo === 'app.view-order') {
        return $state.go('app.history');
      }
      $state.go((ZoomerState.backTo || 'app.orders'), params);
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      vm.title = $state.current.title || '';
    };

  }

  angular.module('zoomerRestaurant')
    .controller('EditOrderNavBarCtrl', EditOrderNavBarCtrl);

}());

(function () {
  'use strict';

  var params = {
    cssClass: 'popup-lg',
    title: 'Oops!',
    template: '<p>Looks like we haven\'t quite launched your restaurant and we\'re still getting things set up.</p>' +
    '<p>Please reach out to your Partnership Success Manager if you feel like this is an error.</p>'
  };

  /** @ngInject */
  function preLaunchWarningModal($ionicPopup) {
    return {
      show: function () {
        return $ionicPopup.alert(params);
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('preLaunchWarningModal', preLaunchWarningModal);

}());

(function () {
  'use strict';


  angular.module('zoomerRestaurant')
    .component('rootNavBar', {
      controller: 'RootNavBarCtrl as rootNavBarVm',
      templateUrl: 'app/navBar/rootNavBar.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function RootNavBarCtrl($state, $rootScope, ordersQueue, ExternalOrders, Features, PaymentStatus, Restaurant, Utilities, deviceNotifications, externalOrdersModal, preLaunchWarningModal, totalOpenReceipts, menuList) {
    var vm = this;

    vm.returnOrders = ordersQueue;
    vm.externalOrders = ExternalOrders;
    vm.externalOrdersModal = externalOrdersModal;
    vm.features = Features;
    vm.totalOpenReceipts = totalOpenReceipts;

    vm.returnCount = function() {
      return ordersQueue.returning.$all.length;
    };

    /**
     * @method hasPendingExternalOrders
     * @return {Boolean}
     */
    vm.hasPendingExternalOrders = function () {
      return ExternalOrders.dismissPage &&
        ExternalOrders.total &&
        Utilities.state.isAnyRootState();
    };

    vm.show = function () {
      externalOrdersModal.show();
    };

    vm.getStartupInfo = function () {
      menuList.fetchRestaurantArray().then(function (res) {
        $rootScope.restaurantArray = res.data;
        if($rootScope.restaurantArray[0]) {
          $rootScope.nonESRestaurant = false;
          $rootScope.invisibilityCount = $rootScope.restaurantArray[0].invisibilityCount;
          $rootScope.firstRestaurant = $rootScope.restaurantArray[0];
          $rootScope.hasGhostKitchens = $rootScope.restaurantArray[1] ? true : false;
        } else {
          $rootScope.nonESRestaurant = true;
        }
      });
    };

  }

  angular.module('zoomerRestaurant')
    .controller('RootNavBarCtrl', RootNavBarCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function deliveredOrders($interval, Restangular, Utilities, ordersCollection, paginatedRestangular) {
    var resource = Restangular.service('orders'),
      oneMinute = 60000,
      interval;

    return angular.extend(resource, ordersCollection, {
      /**
       * @method getAll
       * @return {Object} $promise
       */
      getAll: function () {
        var deliveredAfter = Utilities.time.getTimeFromNow(-30, true),
          params = {
            delivered_after: deliveredAfter,
            order_by: 'ready_by_time',
            queue: 'delivered',
            with_driver_order_status: true,
            include_items: true
          }; // FIXME: Ilya - Something sketchy going on here - delivered orders don't appear here right away (only in a minute or so)
            //  Probably a server bug - See Trello: https://trello.com/c/h8NiDeBq

        resource.loading = true;
        return paginatedRestangular(resource, params).then(function (orders) {
          resource.$all = orders;
          resource.periodicallyRemoveExpired();
        }).finally(function () {
          resource.loading = false;
        });
      },

      /**
       * @method periodicallyRemoveExpired runs removeExpired() once a minute
       */
      periodicallyRemoveExpired: function () {
        if (interval) {
          $interval.cancel(interval);
        }
        interval = $interval(resource.removeExpired.bind(resource), oneMinute);
      },

      /**
       * @method removeExpired filters out local collection of "Just Delivered" orders to only have the following:
       * 1) Delivery orders that have been dropped off less than [DEFAULT NUMBER = 30] minutes ago
       * 2) Pick-up orders that have been "picked up" less than [DEFAULT NUMBER = 30] minutes ago
       */
      removeExpired: function () {
        resource.$all = resource.$all.filter(function (order) {
          var timeDinerGotFood = order.isPickupOrder() ? order.pickup_order_dismissed_at : order.dropped_off_at;
          return Utilities.time.isLessThanMinutesAgo(timeDinerGotFood);
        });
      }

    });
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('deliveredOrders', deliveredOrders);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.ordersQueue')
    .component('noPendingOrdersDashboard', {
      controller: 'NoPendingOrdersDashboardCtrl',
      templateUrl: 'app/ordersQueue/noPendingOrdersDashboard.html'
    });

}());

(function () {
  'use strict';

  var ANNOUNCEMENTS_FEATURE_FLAG = 'restaurant_app_announcements';

  /** @ngInject */
  function NoPendingOrdersDashboardCtrl($scope, Features, Restaurant, announcements, announcementsModal, unratedDrivers) {
    var vm = this,
      featuresPromise;

    vm.announcements = announcements;
    vm.announcementsModal = announcementsModal;
    vm.features = Features;
    vm.restaurant = Restaurant;
    vm.unratedDrivers = unratedDrivers;

    /**
     * @method areAnnouncementsAvailable
     * @return {Boolean}
     */
    vm.areAnnouncementsAvailable = function () {
      return Features.checkEnabled(ANNOUNCEMENTS_FEATURE_FLAG) && announcements.all.length;
    };

    /**
     * @method areUnratedDriversAvailable
     * @return {Boolean}
     */
    vm.areUnratedDriversAvailable = function () {
      return !vm.areAnnouncementsAvailable() &&
        unratedDrivers.all.length;
    };

    /**
     * @method getUnratedDrivers
     */
    vm.getUnratedDrivers = function () {
      var restaurant = Restaurant.info || {};
      if (restaurant.id) {
        unratedDrivers.getList();
      }
    };

    /**
     * @method getLatestAnnouncements
     */
    vm.getLatestAnnouncements = function () {
      if (Features.checkEnabled(ANNOUNCEMENTS_FEATURE_FLAG)) {
        announcements.getLatest();
      }
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      vm.getUnratedDrivers();
      vm.getLatestAnnouncements();
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      featuresPromise();
    };

    featuresPromise = $scope.$watch('$ctrl.features.available', function () {
      if (Features.checkEnabled(ANNOUNCEMENTS_FEATURE_FLAG)) {
        vm.getLatestAnnouncements();
      }
    });
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .controller('NoPendingOrdersDashboardCtrl', NoPendingOrdersDashboardCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function orderModel(Utilities, makeIsAssigningSoon, pendingOrders, specialOrders, Toast) {
    var validEditableStatuses = ['pending_assignment', 'claimed', 'pending_oozo_review', 'do_not_deliver'];

    /**
     * Extracts a set of parameters from the supplied order object and save them to the server.
     * @param {*} order is a local object to be sync'ed.
     * @return {Object} $promise
     */
    function saveToServer(order) {
      var params = Utilities.orders.getParams(order);
      return order.customPUT(params);
    }

    return function orderModel(order) {
      order.isEditable = validEditableStatuses.indexOf(order.status) > -1;
      order.isDeliveryInProgress = order.status === 'delivery_in_progress';
      order.isEmailOrder = !!order.source && order.source !== 'Zoomer';
      order.isAssigningSoon = makeIsAssigningSoon(order);
      order.getParams = Utilities.orders.getParams;

      /**
       * @method update displays the "Order XX updated" toast after syncing the order model back to the server.
       * @return {Object} $promise
       */
      order.update = function () {
        return saveToServer(order).then(function () {
          Toast.toastOrder('Order ' + order.id + ' updated', order);
        });
      };

      order.confirmReturn = function () {
        if (order.isReturnedByDriver()) {
          order.status = 'return_completed';
          return saveToServer(order).then(function () {
            Toast.toastOrder('Order ' + order.id + ' confirmed as returned');
          });
        }
      };

      /**
       * @method dismiss Marks an pickup order dismissed (being picked up).
       * @returns {Object} $promise
       */
      order.dismiss = function () {
        if (order.isActivePickupOrder()) {
          order.status = 'do_not_deliver_dismissed';
          order.pickup_order_dismissed_at = new Date();
          return saveToServer(order).then(function () {
            Toast.toastOrder('Order ' + order.id + ' marked as picked up');
          });
        }
      };

      /**
       * @method confirm
       * @return {Object} $promise
       */
      order.confirm = function () {
        return order.one('confirm_special_order').put().then(function () {
          specialOrders.remove(order.id);
          pendingOrders.getAll();
        });
      };

      /**
       * @method getOozoReview
       * @return {Object} $promise
       */
      order.getOozoReview = function () {
        return order.one('oozo_review').get();
      };

      /**
       * @method cancel
       * @return {Object} $promise
       */
      order.cancel = function () {
        var orderId = order.id,
          text = 'Order ' + orderId + ' cancelled';

        return order.remove().then(function () {
          Toast.toastOrder(text);
        });
      };

      order.isActivePickupOrder = function () { return order.status === 'do_not_deliver'; }
      order.isDismissedPickupOrder = function () { return order.status === 'do_not_deliver_dismissed'; };
      order.isReturnedByDriver = function() { return order.status === 'merchant_confirming_return'; };
      order.isPickupOrder = function () { return order.isActivePickupOrder() || order.isDismissedPickupOrder(); };

      return order;
    };
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('orderModel', orderModel);

}());

(function () {
  'use strict';

  /** @ngInject */
  function ordersCollection(Utilities) {
    return {
      $all: [],
      loading: false,

      find: function (orderId) {
        return this.$all.find(function (order) {
          return order.id === orderId;
        });
      },

      /**
       * @method removeAt
       * @param {Number} orderId
       */
      remove: function (orderId) {
        this.$all = this.$all.filter(function (order) {
          return order.id !== orderId;
        });
      },

      /**
       * @method isMatchingStatus
       * @param {Object} order
       * @param {Array|String} status
       * @return {Boolean}
       */
      isMatchingStatus: function (order, status) {
        if (status instanceof Array) {
          return status.indexOf(order.status) > -1;
        }

        return order.status === status;
      },

      /**
       * @method findAndUpdate
       * @param {Object} freshOrder
       * @param {String} status
       */
      findAndUpdate: function (freshOrder, status) {
        freshOrder = freshOrder || {};
        var isMatchingOrderStatus,
          existingOrder;

        if (!freshOrder.confirmed) {
          return;
        }

        isMatchingOrderStatus = this.isMatchingStatus(freshOrder, status);
        existingOrder = this.find(freshOrder.id);

        if (existingOrder && !isMatchingOrderStatus) {
          this.remove(freshOrder.id);
        } else if (isMatchingOrderStatus) {
          this.$all = Utilities.collections.merge([ freshOrder ], this.$all);
        }
      }

    };
  }


  angular.module('zoomerRestaurant.ordersQueue')
    .factory('ordersCollection', ordersCollection);

}());

(function () {
  'use strict';

  /** @ngInject */
  function ordersForReview(Restangular, ordersCollection, paginatedRestangular) {
    var resource = Restangular.service('orders');

    return angular.extend(resource, ordersCollection, {

      /**
       * @method getAll
       * @return {Object} $promise
       */
      getAll: function () {
        var params = {
          order_by: 'ready_by_time',
          status: 'pending_oozo_review',
          with_driver_order_status: true,
          include_items: true
        };

        resource.loading = true;
        return paginatedRestangular(resource, params).then(function (orders) {
          resource.$all = orders;
        }).finally(function () {
          resource.loading = false;
        });
      }
    });
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('ordersForReview', ordersForReview);

}());

(function () {
  'use strict';

  /** @ngInject */
  function ordersInProgress(Restangular, ordersCollection, paginatedRestangular) {
    var resource = Restangular.service('orders');

    return angular.extend(resource, ordersCollection, {

      /**
       * @method getAll
       * @return {Object} $promise
       */
      getAll: function () {
        var params = {
          order_by: 'ready_by_time',
          queue: 'in_progress',
          with_driver_order_status: true,
          include_items: true
        };

        resource.loading = true;
        return paginatedRestangular(resource, params).then(function (orders) {
          resource.$all = orders;
        }).finally(function () {
          resource.loading = false;
        });
      }
    });
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('ordersInProgress', ordersInProgress);

}());

(function () {
  'use strict';

  /** @ngInject */
  function OrdersQueueCtrl($scope, $stateParams, $ionicModal, Features, ordersQueue, unratedDrivers, orderPopoverMenu, ThermalPrinter, Restaurant) {
    var vm = this,
      enterPromise,
      destroyPromise;

    vm.features = Features;
    vm.unratedDrivers = unratedDrivers;
    vm.ordersQueue = ordersQueue;
    vm.orderPopoverMenu = orderPopoverMenu;
    vm.ThermalPrinter = ThermalPrinter;
    vm.restaurant = Restaurant;

    /**
     * @method isCurrentState
     * @param {String} type
     * @return {String}
     */
    vm.isCurrentState = function (type) {
      return (type === vm.type) ? 'selected' : '';
    };

    /**
     * @method onEnter
     */
    vm.onEnter = function () {
      vm.type = $stateParams.ordersType || 'pending';
      var orders = vm.ordersQueue[vm.type];
      if (orders) {
        orders.getAll();
      }
    };

    /**
     * @method onDestroy
     */
    vm.onDestroy = function () {
      enterPromise();
      destroyPromise();
    };

    vm.openConfirmReturnModal = function (order) {
      $scope.order = order;
      var url = 'app/views/modals/confirm-return.html';
      $ionicModal.fromTemplateUrl(url, { scope: $scope }).then(function (modal) {
        $scope.confirmModal = modal;
        $scope.confirmModal.show();
      });
    };

    vm.confirmOrderReturn = function() {
      $scope.order.confirmReturn();
      $scope.confirmModal.hide().finally(function () {
        $scope.confirmModal.remove();
        $scope.confirmModal = null;
      });
    };

    enterPromise = $scope.$on('$ionicView.enter', vm.onEnter.bind(vm));
    destroyPromise = $scope.$on('$destroy', vm.onDestroy.bind(vm));
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .controller('OrdersQueueCtrl', OrdersQueueCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function ordersQueue(Restangular, deliveredOrders, ordersForReview, ordersInProgress, pendingOrders, specialOrders, returningOrders, orderModel, unratedDrivers) {
    Restangular.extendModel('orders', orderModel);
    Restangular.extendModel('special', orderModel);

    return {
      pending: pendingOrders,
      inProgress: ordersInProgress,
      delivered: deliveredOrders,
      specialOrders: specialOrders,
      ordersForReview: ordersForReview,
      returning: returningOrders,

      /**
       * @method getAll
       */
      getAll: function () {
        pendingOrders.getAll();
        ordersInProgress.getAll();
        deliveredOrders.getAll();
        specialOrders.getAll();
        ordersForReview.getAll();
        returningOrders.getAll();
      },

      /**
       * @method getById
       * @params {Object} params
       * @return {Object} $promise
       */
      getById: function (orderId, params) {
        params = params || {};
        params['include_items'] = true;
        return ordersInProgress.one(orderId).get(params);
      },

      /**
       * @method reset
       */
      reset: function () {
        pendingOrders.$all = [];
        ordersInProgress.$all = [];
        deliveredOrders.$all = [];
        specialOrders.$all = [];
        ordersForReview.$all = [];
        returningOrders.$all = [];
      },

      /**
       * Processing order updates sent through Pusher
       * @method onOrderUpdated
       */
      onOrderUpdated: function (orderId) {
        var order;

        return this.getById(orderId).then(function (response) {
          order = response.data;
          if (order.status === 'delivered') {
            unratedDrivers.getList();
          }
          // It's not necessary to feature-flag pick-up orders here - the server fliters pusher events and API responses based on feature flags
          pendingOrders.findAndUpdate(order, [ 'pending_assignment', 'claimed', 'do_not_deliver']);
          ordersInProgress.findAndUpdate(order, 'delivery_in_progress', 'return_in_progress');
          deliveredOrders.findAndUpdate(order, ['delivered', 'do_not_deliver_dismissed']);
          specialOrders.findAndUpdate(order, [ 'pending_assignment', 'claimed', 'do_not_deliver']);
          ordersForReview.findAndUpdate(order, 'pending_oozo_review');
          returningOrders.findAndUpdate(order, ['return_in_progress', 'merchant_confirming_return']);
        });
      },

      /**
       * @method onEvent
       * @param {String} eventName
       * @param {Object} data
       */
      onEvent: function (eventName, data) {
        data = data || {};
        if (eventName === 'pusher:subscription_succeeded' || !data.order_id) {
          return;
        }

        this.onOrderUpdated(data.order_id);
      }

    };
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('ordersQueue', ordersQueue);

}());

(function () {
  'use strict';

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.orders', {
      url: '/orders/queue/:ordersType',
      views: {
        'menu-content': {
          controller: 'OrdersQueueCtrl as vm',
          templateUrl: 'app/ordersQueue/ordersQueue.html'
        }
      }
    });
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .config(config);

}());

(function () {
  'use strict';

  /** @ngInject */
  function pendingOrders(Restangular, Utilities, $q, ordersCollection, paginatedRestangular, Toast) {
    var serviceName = 'orders',
      resource = Restangular.service(serviceName);

    return angular.extend(resource, ordersCollection, {
      /**
       * @method getAll
       * @return {Object} $promise
       */
      getAll: function () {
        var params = {
          order_by: 'ready_by_time',
          queue: 'pending',
          with_driver_order_status: true,
          include_items: true
        };

        resource.loading = true;
        return paginatedRestangular(resource, params).then(function (orders) {
          resource.$all = orders;
        }).finally(function () {
          resource.loading = false;
        });
      },

      /**
       * Creates an order on the server and displays a toast to the user
       * @method create
       * @param {Object} params
       * @return {Object} $promise
       */
      create: function (params) {
        var order;
        return resource.post(params).then(function (response) {
          order = response.data;
          resource.$all = Utilities.collections.merge([ order ], resource.$all);
          Toast.toastOrder(('Order ' + order.id + ' Zoomed'), order);
        });
      },

      /**
       * @method findByPhoneNumber
       * @param {String} phoneNumber
       * @return {Array}
       */
      findByPhoneNumber: function (phoneNumber) {
        var orders = resource.$all || [];

        return orders.filter(function (order) {
          var diner = order.diner || {},
            orderPhoneNumber = (diner.phone_number || '').toString();
          return Utilities.number.arePhoneNumbersEqual(phoneNumber, orderPhoneNumber);
        });
      }

    });
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('pendingOrders', pendingOrders);

}());

(function () {
  'use strict';

  /** @ngInject */
  function returningOrders(Restangular, ordersCollection, paginatedRestangular) {
    var serviceName = 'orders',
      resource = Restangular.service(serviceName);

    return angular.extend(resource, ordersCollection, {
      /**
       * @method getAll
       * @return {Object} $promise
       */
      getAll: function () {
        var params = {
          order_by: 'ready_by_time',
          queue: 'returning',
          with_driver_order_status: true,
          include_items: true
        };

        resource.loading = true;
        return paginatedRestangular(resource, params).then(function (orders) {
          resource.$all = orders;
        }).finally(function () {
          resource.loading = false;
        });
      }
    });
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('returningOrders', returningOrders);

}());

(function () {
  'use strict';

  /** @ngInject */
  function specialOrders($rootScope, Restangular, Utilities, ordersCollection, paginatedRestangular) {
    var resource = Restangular.service('special', Restangular.one('orders'));

    function getMinutesFromNow(order) {
      var now = new Date().getTime(),
        rbt = new Date(order.ready_by_time).getTime();
      return ((rbt - now) / 60000);
    }

    return angular.extend(resource, ordersCollection, {

      /**
       * @method getAll
       * @return {Object} $promise
       */
      getAll: function () {
        var params = {
            order_by: 'ready_by_time',
            queue: 'special',
            with_driver_order_status: true,
            include_items: true
          };

        resource.loading = true;
        return paginatedRestangular(resource, params).then(function (orders) {
          resource.$all = orders;
          resource.findUnconfirmed();
        }).finally(function () {
          resource.loading = false;
        });
      },

      /**
       * @method findUnconfirmed
       */
      findUnconfirmed: function () {
        var unconfirmed = _.filter(resource.$all, function (order) {
          return !order.confirmed && getMinutesFromNow(order) < 30;
        });

        if (!unconfirmed.length) {
          return;
        }

        angular.forEach(unconfirmed, function (order) {
          $rootScope.$emit('$confirmSpecialOrders', order.id);
        });
      },

      /**
       * @method findAndUpdate
       * @param {Object} freshOrder
       * @param {Array} status
       */
      findAndUpdate: function (freshOrder, status) {
        freshOrder = freshOrder || {};
        var isMatchingOrderStatus = this.isMatchingStatus(freshOrder, status),
          isUnconfirmedScheduledOrder = (!freshOrder.confirmed && freshOrder.deliver_at),
          existingOrder = this.find(freshOrder.id);

        if (existingOrder && (!isMatchingOrderStatus || !isUnconfirmedScheduledOrder)) {
          this.remove(freshOrder.id);
        } else if (isMatchingOrderStatus && isUnconfirmedScheduledOrder) {
          this.$all = Utilities.collections.merge([ freshOrder ], this.$all);
        }
      }

    });
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('specialOrders', specialOrders);

}());

(function () {
  'use strict';

  /** @ngInject */
  function arbitratorHelpModal($ionicModal, $rootScope) {
    var url = 'app/rbtArbitratorV1/arbitratorHelpModal.html',
      promise,
      params;

    params = {
      backdropClickToClose: false
    };

    return {

      /**
       * @method show
       * @return {Object} $promise
       */
      show: function () {
        function show() {
          return promise.then(function (m) {
            $rootScope._arbitratorHelpModal = m;
            m.show();
          });
        }

        if (promise) {
          return show();
        }

        promise = $ionicModal.fromTemplateUrl(url, params);
        return show();
      }
    };
  }

  angular.module('zoomerRestaurant.rbtArbitratorV1')
    .factory('arbitratorHelpModal', arbitratorHelpModal);

}());

(function () {
  'use strict';

  /** @ngInject */
  function getMinutesFromNow() {
    var MINUTE_TO_MS = 60000;

    return function (date) {
      date = new Date(date).getTime();
      var now = new Date().getTime();

      return Math.round((date - now) / MINUTE_TO_MS);
    };
  }

  angular.module('zoomerRestaurant.rbtArbitratorV1')
    .factory('getMinutesFromNow', getMinutesFromNow);

}());

(function () {
  'use strict';

  var THIRTY_SECONDS = 30000,
    DEFAULT_FLOOR = 0;

  /** @ngInject */
  function parseArbitratedData($q, $timeout, getMinutesFromNow) {
    function comparator(slotA, slotB) {
      var timeA = new Date(slotA).getTime(),
        timeB = new Date(slotB).getTime();
      return timeA - timeB;
    }

    function mapTimeSlots(data) {
      var slots = data.options || [];
      return (slots).sort(comparator).map(function (timeSlot) {
        return {
          datetime: timeSlot,
          minutesFromNow: getMinutesFromNow(timeSlot),
          isFromArbitrator: data.options_from_arbitrator
        };
      });
    }

    function ArbitratedData(data) {
      Object.assign(this, {
        available: mapTimeSlots(data),
        isArbitratorActive: Boolean(data.options_from_arbitrator),
        error: false,
        expired: false,
        rbtFloor: data.rbt_floor || DEFAULT_FLOOR
      });
      this.startExpiryTimeout();
    }

    ArbitratedData.prototype = {
      available: [],

      /**
       * @method setExpired
       */
      setExpired: function () {
        this.expired = true;
      },

      /**
       * @method stopExpiryTimeout
       */
      stopExpiryTimeout: function () {
        this.expired = false;
        if (this.timeout) {
          $timeout.cancel(this.timeout);
        }
      },

      /**
       * @method startExpiryTimeout
       */
      startExpiryTimeout: function () {
        this.stopExpiryTimeout();
        this.timeout = $timeout(this.setExpired.bind(this), THIRTY_SECONDS);
      }

    };


    return function (response) {
      var data = response.data.plain();
      return $q.resolve(new ArbitratedData(data));
    };
  }


  angular.module('zoomerRestaurant.rbtArbitratorV1')
    .factory('parseArbitratedData', parseArbitratedData);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.rbtArbitratorV1')
    .component('rbtArbitratorV1', {
      bindings: {
        order: '<',
        form: '<'
      },
      bindToController: true,
      controller: 'RbtArbitratorV1Ctrl',
      templateUrl: 'app/rbtArbitratorV1/rbtArbitratorV1.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function RbtArbitratorV1Ctrl($rootScope, $scope, Config, Restaurant, arbitratorHelpModal, getMinutesFromNow, rbtArbitratorV1) {
    var vm = this,
      settingsPromise,
      featuresPromise,
      orderIdPromise,
      addressPromise,
      expiryPromise,
      sizePromise;

    vm.arbitratedData = null;
    vm.arbitratorHelpModal = arbitratorHelpModal;
    vm.existingRbt = false;
    vm.loading = false;
    vm.rbtArbitratorV1 = rbtArbitratorV1;
    vm.restaurant = Restaurant;

    /**
     * @method onSettingsUpdated
     * @param {Object} e
     * @param {Object} data
     */
    vm.onFloorSettingsUpdated = function (e, data) {
      var arbitratedData = vm.arbitratedData || {},
        restaurant = Restaurant.info || {},
        rbtFloor = data['tier_' + restaurant.tier + '_ready_by_time_floor'];

      if (arbitratedData && !arbitratedData.isArbitratorActive) {
        arbitratedData.rbtFloor = rbtFloor || 0;

        if (getMinutesFromNow(vm.order.ready_by_time) < arbitratedData.rbtFloor) {
          vm.setReadyByTime(null);
        }
      }
    };

    /**
     * @method showFloorWarningMessage
     * @return {Boolean}
     */
    vm.showFloorWarningMessage = function () {
      var arbitratedData = vm.arbitratedData || {};
      return !arbitratedData.isArbitratorActive && arbitratedData.rbtFloor;
    };

    /**
     * @method getButtonClass
     * @param {Object} timeSlot
     * @return {String}
     */
    vm.getButtonClass = function (timeSlot) {
      timeSlot = timeSlot || {};
      var arbitratedData = vm.arbitratedData || {},
        isFloorActive = !arbitratedData.isArbitratorActive && timeSlot.minutesFromNow < arbitratedData.rbtFloor;
      if (arbitratedData.expired || isFloorActive) {
        return 'disabled';
      }

      if (timeSlot.datetime === vm.order.ready_by_time) {
        return 'selected';
      }
    };

    /**
     * @method isExistingRbtSelected
     * @return {Boolean}
     */
    vm.isExistingRbtSelected = function () {
      return vm.order.ready_by_time === vm.existingRbt;
    };

    /**
     * @method isAddressInvalid
     * @return {Boolean}
     */
    vm.isAddressInvalid = function () {
      var order = vm.order || {},
        address = order.address || order.serialized_address || {};

      return !address.latitude || !address.longitude;
    };

    /**
     * @method isOrderSizeUnselected
     * @return {Boolean}
     */
    vm.isOrderSizeUnselected = function () {
      if (!Restaurant.hasBicycleSupport()) {
        return false;
      }

      return !(vm.order || {}).size;
    };

    /**
     * @method getRequestParams
     * @return {Object|Boolean}
     */
    vm.getRequestParams = function () {
      var order = vm.order || {},
        address = order.address || order.serialized_address;

      if (vm.isAddressInvalid() || vm.isOrderSizeUnselected()) {
        return false;
      }

      return {
        do_not_deliver_by_bicycle: Boolean(order.do_not_deliver_by_bicycle),
        latitude: address.latitude,
        longitude: address.longitude,
        size: order.size || Config.DEFAULT_ORDER_SIZE
      };
    };

    /**
     * @method getAvailableTimeSlots
     */
    vm.getAvailableTimeSlots = function () {
      var params = vm.getRequestParams();
      if (!params || vm.loading) {
        return;
      }

      vm.loading = true;
      vm.setReadyByTime(null);
      rbtArbitratorV1.getAvailableTimeSlots(params).then(function (arbitratedData) {
        vm.arbitratedData = arbitratedData;
      }).finally(function () {
        vm.loading = false;
      });
    };

    /**
     * @method setReadyByTime
     * @param {Object} timeSlot
     */
    vm.setReadyByTime = function (timeSlot) {
      timeSlot = timeSlot || {};
      var newReadyByTime = timeSlot.datetime;
      vm.order.ready_by_time = newReadyByTime || vm.existingRbt || undefined;

      if (vm.arbitratedData && vm.order.ready_by_time && !vm.isExistingRbtSelected()) {
        vm.arbitratedData.startExpiryTimeout();
      }


      if (newReadyByTime && vm.$setDirty) {
        vm.$setDirty();
      }
    };

    /**
     * @method setExistingReadyByTime
     */
    vm.setExistingReadyByTime = function () {
      if (vm.order.id && vm.order.ready_by_time) {
        vm.existingRbt = angular.copy(vm.order.ready_by_time);
        orderIdPromise();
      }
    };

    /**
     * @method startOrderSizeWatcher
     */
    vm.startOrderSizeWatcher = function () {
      if (sizePromise) {
        return;
      }

      sizePromise = $scope.$watch('$ctrl.order.size', vm.getAvailableTimeSlots);
    };

    /**
     * @method stopOrderSizeWatcher
     */
    vm.stopOrderSizeWatcher = function () {
      if (sizePromise) {
        sizePromise();
        sizePromise = undefined;
      }
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      if (vm.arbitratedData) {
        vm.arbitratedData.stopExpiryTimeout();
      }
      vm.stopOrderSizeWatcher();
      settingsPromise();
      orderIdPromise();
      addressPromise();
      expiryPromise();
      featuresPromise();
    };

    settingsPromise = $rootScope.$on('$floorSettingsUpdated', vm.onFloorSettingsUpdated);
    orderIdPromise = $scope.$watch('$ctrl.order.id', vm.setExistingReadyByTime);
    addressPromise = $scope.$watch('$ctrl.order.address', vm.getAvailableTimeSlots);

    expiryPromise = $scope.$watch('$ctrl.arbitratedData.expired', function (expired) {
      if (expired) {
        vm.setReadyByTime(null);
      }
    });

    featuresPromise = $scope.$watch('$ctrl.restaurant.info', function () {
      if (Restaurant.hasBicycleSupport()) {
        vm.startOrderSizeWatcher();
      } else {
        vm.stopOrderSizeWatcher();
      }
    });
  }

  angular.module('zoomerRestaurant.rbtArbitratorV1')
    .controller('RbtArbitratorV1Ctrl', RbtArbitratorV1Ctrl);

}());

(function () {
  'use strict';

  var serviceName = 'restaurants',
    actionName = 'estimated_pickup_times';

  /** @ngInject */
  function rbtArbitratorV1($log, LogEntries, Restangular, parseArbitratedData) {
    var service = Restangular.service(serviceName);

    return angular.extend(service, {

      /**
       * @method log
       */
      log: function () {
        $log.info.apply($log, arguments);
        LogEntries.log.apply(LogEntries, arguments);
      },

      /**
       * @method catch
       * @param {Object} params
       * @param {Object} error
       */
      catch: function (params, error) {
        LogEntries.log('[Arbitrator V1] Failed retrieving times for', params, error);
      },

      /**
       * @method getAvailableTimeSlots
       * @param {Object} params
       * @return {Object}
       */
      getAvailableTimeSlots: function (params) {
        service.log('[Arbitrator V1] Getting pickup slots for', params);
        return service.one(actionName).get(params)
          .then(parseArbitratedData, function (error) {
            service.catch(params, error);
          });
      }
    });
  }

  angular.module('zoomerRestaurant.rbtArbitratorV1')
    .factory('rbtArbitratorV1', rbtArbitratorV1);

}());

(function () {
  'use strict';

  var STAGGER = 125,
    DURATION = 250;

  /** @ngInject */
  function timeSlotBounce($timeout) {
    function toMs(speed) {
      return (speed || 0) + 'ms';
    }

    return function (scope, element) {
      var index = (scope.$index || 0) + 1,
        delay = index * STAGGER,
        bounceCls = 'button-bounce';

      element.css({
        '-webkit-animation-duration': toMs(DURATION),
        'animation-duration': toMs(DURATION),
        'animation-delay': toMs(delay),
        '-webkit-animation-delay': toMs(delay)
      });
      element.addClass(bounceCls);

      $timeout(function () {
        element.removeClass(bounceCls);
      }, (DURATION + delay));
    };
  }

  angular.module('zoomerRestaurant.rbtArbitratorV1')
    .directive('timeSlotBounce', timeSlotBounce);

}());

(function () {
  'use strict';

  /** @ngInject */
  function receiptDetailsContent($rootScope) {
    var jqLite = angular.element,
      innerElement;

    /**
     * @method buildIonContent
     * @return {String}
     */
    function buildIonContent() {
      var isMobileDevice = $rootScope.isMobileDevice,
        htmlParts = [
          '<ion-content delegate-handle="receiptDetailsModal" ',
          '</ion-content>'
        ];

      htmlParts[0] += ' scroll="' + isMobileDevice + '"';
      if (!isMobileDevice) {
        htmlParts[0] += ' style="overflow: auto;"';
      }
      return htmlParts.join('>');
    }

    function compile(element) {
      innerElement = jqLite(buildIonContent());
      innerElement.append(element.contents());
      element.addClass('z-receipt-details-content');
      element.append(innerElement);
      return angular.noop;
    }

    return {
      compile: compile,
      priority: 800,
      restrict: 'AE'
    };
  }

  angular.module('zoomerRestaurant.receipts')
    .directive('receiptDetailsContent', receiptDetailsContent);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.receipts')
    .component('receiptDisputeModal', {
      bindings: {
        modal: '<',
        onReOpen: '&',
        receipt: '<'
      },
      bindToController: true,
      controller: 'ReceiptDisputeModalCtrl',
      templateUrl: 'app/receipts/receiptDisputeModal.html'
    });

}());

(function () {
  'use strict';

  var IN_DISPUTE_STATUS = 'in_dispute';

  /** @ngInject */
  function ReceiptDisputeModalCtrl(receiptDisputeTypes, zIonicPopup) {
    var vm = this;

    vm.receiptDisputeTypes = receiptDisputeTypes;
    vm.reOpenWithDispute = null;

    /**
     * @method toggleIsReOpening
     * @param {String} disputeKey
     */
    vm.setReOpenWithDispute = function (disputeKey) {
      vm.reOpenWithDispute = disputeKey;
    };

    /**
     * @method getClassBySelectedType
     * @param {String} type
     * @return {String}
     */
    vm.getClassBySelectedType = function (type) {
      var dispute = vm.receipt.receipt_dispute || {};

      return dispute.status === IN_DISPUTE_STATUS && dispute.dispute_type === type ? 'button-positive' : 'button-default';
    };

    /**
     * @method hasActiveDispute
     * @return {Boolean}
     */
    vm.hasActiveDispute = function () {
      var receipt = vm.receipt;
      return receipt.receipt_dispute && receipt.receipt_dispute.status === 'in_dispute';
    };

    /**
     * @method confirm
     * @param {String} disputeKey
     */
    vm.confirmDispute = function (disputeKey) {
      if (vm.receipt.status === 'closed_check') {
        return vm.setReOpenWithDispute(disputeKey);
      }

      if (vm.hasActiveDispute()) {
        return vm.receipt.closeOpenDispute(false).then(function () {
          vm.addDispute(disputeKey);
        }, vm.showError);
      }
      vm.addDispute(disputeKey);
    };

    /**
     * @method addDispute
     * @param {String} disputeKey
     */
    vm.addDispute = function (disputeKey) {
      var isReceiptReOpened = Boolean(vm.reOpenWithDispute);
      vm.receipt.receipt_dispute = {
        dispute_type: disputeKey,
        status: IN_DISPUTE_STATUS
      };

      vm.receipt.dispute(disputeKey, isReceiptReOpened).then(vm.updateReceipt, vm.showError);
    };

    /**
     * @method removeDispute
     */
    vm.removeDispute = function () {
      vm.receipt.closeOpenDispute().then(function (response) {
        vm.updateReceipt(response);
        vm.modal.remove();
      }, vm.showError);
    };

    /**
     * @method updateReceipt
     * @param {Object} response
     */
    vm.updateReceipt = function (response) {
      Object.assign(vm.receipt, response.data.plain());
      vm.reOpenWithDispute = null;
    };

    /**
     * @method reOpenReceipt
     */
    vm.reOpenReceipt = function () {
      vm.receipt.toggle(false).then(function () {
        Object.assign(vm.receipt, { status: 'open_check' });
        vm.confirmDispute(vm.reOpenWithDispute);
        if (vm.onReOpen) {
          vm.onReOpen();
        }
      });
    };

    /**
     * @method showError
     */
    vm.showError = function () {
      zIonicPopup.alert({
        title: 'Cannot report issue with receipt',
        template: 'Sorry, but there was a problem reporting an issue with this receipt. Please refresh and try again.'
      });
    };

  }

  angular.module('zoomerRestaurant.receipts')
    .controller('ReceiptDisputeModalCtrl', ReceiptDisputeModalCtrl);

}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').service('Buildings', [
    'Restangular', 'Restaurant', 'paginatedRestangular',
    function (Restangular, Restaurant, paginatedRestangular) {
      var serviceName = 'locations',
        resource = Restangular.service(serviceName);

      return angular.extend(resource, {
        all: [],
        loading: false,

        /**
         * @method getAll
         * @return {Object} $promise
         */
        getAll: function () {
          var restaurant = Restaurant.info || {},
            params = {
              territory_id: restaurant.territory_id
            };

          resource.loading = true;
          return paginatedRestangular(resource, params).then(function (buildings) {
            resource.all = buildings;
          }).finally(function () {
            resource.loading = false;
          });
        },

        /**
         * @method getAddress
         * @param {Number|String} addressId
         * @return {Object} $promise
         */
        getAddress: function (addressId) {
          addressId = addressId.toString();
          return Restangular.all('addresses').one(addressId).get();
        }
      });
    }
  ]);
}());

(function() {
  'use strict';

  angular.module('zoomerRestaurant').value('deterministicRand',
    function deterministicRand(seed) {
      var x = Math.sin(seed) * 10000;
      return x - Math.floor(x);
    }
  );
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').service('Diners', [
    '$q', 'Restangular', 'InfiniteScroller', 'Utilities',
    function ($q, Restangular, InfiniteScroller, Utilities) {
      var dinerParams = {};

      return {
        all: [],
        pagination: InfiniteScroller.create(),

        /**
         * Reset all data
         */
        reset: function () {
          this.all = [];
          this.pagination.reset();
        },

        /**
         * Reset and return initial page promise
         *
         * @param {Object} params;
         * @return {Object} $promise
         */
        init: function (params) {
          this.reset();
          dinerParams = params || {};
          return this.getByPage();
        },

        /**
         * Get next page if one present or not already loading
         *
         * @return {Object} $promise
         */
        getNextPage: function () {
          var pagination = this.pagination;
          if (!pagination.hasNextPage() || this.loading) {
            return $q.resolve(false);
          }

          pagination.setUpdating(true);
          return this.getByPage(pagination.getNextPage());
        },

        /**
         * Get specific page of Diner addresses
         *
         * @param {Number} page
         * @return {Object} $promise
         */
        getByPage: function (page) {
          var self = this,
            params = angular.extend({}, {
              page: page || 1
            }, dinerParams);

          this.loading = true;
          return Restangular.one('addresses').customGET('search', params).then(function (response) {
            var addresses = response.data,
              headers = response.headers();

            self.pagination.success(headers);
            self.all = Utilities.collections.merge(addresses, self.all);
          }).finally(function () {
            self.loading = false;
          });
        }

      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').service('ExternalOrders', [
    '$rootScope', 'InfiniteScroller', 'LogEntries', 'deviceNotifications', 'Restangular', 'Restaurant', 'Utilities', 'desktopNotifications', 'pendingOrders', 'paginatedRestangular', 'Features', '$q',
    function ($rootScope, InfiniteScroller, LogEntries, deviceNotifications, Restangular, Restaurant, Utilities, desktopNotifications, pendingOrders, paginatedRestangular, Features, $q) {
      var endPoint = 'external_orders',
        resource = Restangular.service(endPoint),
        defaultParams = {
          per_page: 10,
          requiring_attention: true,
          include_pickup_orders: true,
          include_items: true
        };

      function hasSameReferenceAndSource(pendingOrder, orderToRemove) {
        return (pendingOrder.remote_reference === orderToRemove.remote_reference) &&
          (pendingOrder.parser_used === orderToRemove.parser_used);
      }

      return {
        restaurantId: null,
        all: [],
        scroller: InfiniteScroller.create(),
        total: 0,
        totalSnoozed: 0,
        dismissPage: false,

        /**
         * Reset all values
         */
        reset: function () {
          this.restaurantId = null;
          this.all = [];
          this.scroller.reset();
          this.total = 0;
          this.totalSnoozed = 0;
        },

        /**
         * @method getTotalSnoozedOrders
         */
        getTotalSnoozedOrders: function () {
          var self = this,
            params = { include_items: true, snoozed: true, requiring_attention: true };

          Restangular.all(endPoint).getList(params).then(function (response) {
            self.totalSnoozed = Number(response.headers('total') || response.data.length);
          });
        },

        /**
         * Retrieve external orders by pagination page and merge into local Collection
         *
         * @param {Number} page
         * @param {Boolean} ignorePaginationHeaders
         * @return {Object} $promise
         */
        getAll: function (page, ignorePaginationHeaders) {
          ignorePaginationHeaders = !!ignorePaginationHeaders;
          var self = this,
            params = angular.extend({}, defaultParams, {
              page: page || this.scroller.getCurrentPage() || 1
            });

          this.getTotalSnoozedOrders();
          return Restangular.all(endPoint).getList(params).then(function (response) {
            var headers = response.headers();
            if (!ignorePaginationHeaders) {
              self.scroller.success(headers);
            }

            self.all = Utilities.collections.merge(response.data || [], self.all);
            self.total = Number(headers.total || self.all.length);
          }, function (error) {
            if (!ignorePaginationHeaders) {
              self.scroller.failure(error);
            }
          });
        },

        /**
         * Get details from specific external Order
         *
         * @param {Number} id
         * @param {Object} extra
         * @return {Object} $promise
         */
        get: function (id, extra) {
          return Restangular.all(endPoint).one(id.toString()).get(extra);
        },

        /**
         * @method findByPhoneNumber
         * @description Find any External Orders whose phonenumber match the one supplied
         * @param {Number|String} phoneNumber
         * @return {Object}
         */
        findByPhoneNumber: function (phoneNumber) {
          phoneNumber = (phoneNumber || '').toString();
          return _.filter(this.all, function (externalOrder) {
            var emailPhoneNum = (externalOrder.diner_phone_number || '').toString();
            return Utilities.number.arePhoneNumbersEqual(phoneNumber, emailPhoneNum);
          });
        },

        /**
         * Remove order from list
         *
         * @param {Object} order
         */
        remove: function (order) {
          this.all = _.reject(this.all, function (externalOrder) {
            if (hasSameReferenceAndSource(externalOrder, order)) {
              if (order.status === 'cancellation') {
                externalOrder.status = 'cancelled';
              }
              return true;
            }
            return false;
          });
          this.getAll();
        },

        /**
         * PUT update the supplied order on the server and remove
         *
         * @param {Object} externalOrder
         * @return {Object} $promise
         */
        put: function (externalOrder) {
          var self = this,
            id = externalOrder.id;

          return Restangular.service(endPoint).one(id.toString()).customPUT(externalOrder).then(function () {
            self.remove(externalOrder);
          }, function () {
            self.getAll();
          });
        },

        /**
         * @method skipAll Mark all exernal orders as skipped.
         * Doesn't skip EatStreet Delivery orders if disable_skipping_eatstreet_external_orders
         * feature flag is turned on for a restaurant.
         * @return {Object} $promise
         */
        skipAll: function () {
          var ids, skipableOrders;

          return paginatedRestangular(resource, defaultParams).then(function (orders) {
            skipableOrders = orders;

            if (Features.checkEnabled('disable_skipping_eatstreet_external_orders')) {
              skipableOrders =  _.filter(skipableOrders, function(externalOrder) {
                return externalOrder.source !== 'EatStreet';
              });
            }

            if (Features.checkEnabled('disable_skipping_grubhub_external_orders')) {
              skipableOrders =  _.filter(skipableOrders, function(externalOrder) {
                return externalOrder.source !== 'GrubHub';
              });
            }

            if (skipableOrders.length === 0) {
              return $q.reject('No orders to skip!');
            }
            ids = (skipableOrders || []).map(function (order) { return order.id; });
            return resource.one('bulk_skip').customPUT({ external_order_ids: ids });
          });
        },

        /**
         * Set this order as 'skipped'
         *
         * @param {Object} externalOrder
         * @return {Object} $promise
         */
        setSkipped: function (externalOrder) {
          externalOrder.status = 'skipped';
          return this.put(externalOrder);
        },

        /**
         * @method createOrderAndRemove
         * @param {Object} externalOrder
         * @return {Object} $promise
         */
        createOrderAndRemove: function (externalOrder) {
          var self = this,
            params;

          // Already converted to a real order
          if (externalOrder.order_id) {
            return;
          }

          externalOrder.order_id = 'TEMP';
          params = Utilities.orders.getParams(externalOrder);
          params.external_order_id = externalOrder.id;

          //we don't want to sync external order status (e.g 'parsed') to the real order - blank it! 'do_not_deliver' is the only one we want
          if (externalOrder.status !== 'do_not_deliver') {
            params.order.status = '';
          }

          return pendingOrders.create(params).then(function () {
            self.remove(externalOrder);
            self.getAll();
          }, function () {
            externalOrder.order_id = null;
          });
        },

        /**
         * @method clearNotification
         * @param {Object} externalOrder
         */
        clearNotification: function (externalOrder) {
          var isMobileDevice = $rootScope.isMobileDevice;
          if (isMobileDevice) {
            return deviceNotifications.clearOrder(externalOrder);
          }

          desktopNotifications.clearOrder(externalOrder);
        },

        /**
         * @method sendNotification
         * @param {Object} externalOrder
         */
        sendNotification: function (externalOrder) {
          var isMobileDevice = $rootScope.isMobileDevice;
          if (isMobileDevice) {
            return deviceNotifications.notifyOrder(externalOrder);
          }

          desktopNotifications.notifyOrder(externalOrder);
        },

        /**
         * Callback for pusher events
         *
         * @param {String} eventName
         * @param {Object} data
         */
        onEvent: function (eventName, data) {

          data = data || {};
          this.log(eventName, data);

          if (eventName === 'pusher:subscription_succeeded') {
            return;
          }


          if (eventName === 'converted_to_order' || eventName === 'skipped' || eventName === 'cancellation') {
            this.clearNotification(data);
            return this.remove(data);
          }
          this.getAll();
          this.sendNotification(data);
        },

        /**
         * @method log
         * @param {String} eventName
         * @param {Object} data
         */
        log: function (eventName, data) {
          var restaurant = Restaurant.info || {};
          LogEntries.log(('Pusher event fired: CHANNEL: private-email_orders_' + restaurant.id), eventName, {
            restaurant: { id: restaurant.id, name: restaurant.name }
          }, data);
        },

        /**
         * @method toggleDismiss
         * @param {Boolean} dismiss
         */
        toggleDismiss: function (dismiss) {
          dismiss = !!dismiss;
          this.dismissPage = dismiss;
        }

      };
    }
  ]);
}());

(function () {
  'use strict';

  /** @ngInject */
  function GoogleMaps($rootScope, $window, $q, Restaurant, Config) {
    var deferred = $q.defer(),
      baseUrl = 'https://maps.googleapis.com/maps/api/js',
      factory,
      scriptTag;

    factory = {
      baseUrl: baseUrl,
      loaded: false,
      error: false,

      params: {
        callback: 'initMap',
        libraries: 'geometry,places',
        v: '3'
      },

      /**
       * Remove any existing tag from DOM, and reset data
       */
      reset: function () {
        this.baseUrl = baseUrl;
        document.body.removeChild(scriptTag);
        deferred = $q.defer();
        $window.google = null;
        scriptTag = null;
      },

      /**
       * Convert a GeoCode set of geometry results into coordinates
       *
       * @param {Object} geometry
       * @return {Object}
       */
      getCoordinates: function (geometry) {
        geometry = geometry || {};
        var location = geometry.location || {},
          coords = location.toJSON ? geometry.location.toJSON() : {};

        return {
          lat: coords.lat,
          lon: coords.lng
        };
      },

      /**
       * Build Google Maps API URL string
       *
       * @return {String}
       */
      getSrc: function () {
        var result = this.baseUrl,
          settings = Restaurant.getClientSettings(),
          index = 0,
          params;

        params = angular.extend({}, this.params, {
          key: settings.google_maps_api_token || Config.GOOGLE_MAPS_TOKEN
        });

        angular.forEach(params, function (param, key) {
          result += (!index ? '?' : '&') + (key + '=' + param);
          index++;
        });
        return result;
      },

      /**
       * @method setLoaded
       * @param {Boolean} loaded
       */
      setLoaded: function (loaded) {
        factory.loaded = Boolean(loaded);
        factory.error = false;
      },

      /**
       * Attempt to get promise (eventually) containing ref. to GoogleMaps API
       *
       * @return {Object} $promise
       */
      get: function () {
        if (!!$window.google && !!$window.google.maps) {
          factory.setLoaded(true);
          deferred.resolve($window.google.maps);
          return deferred.promise;
        }

        function error() {
          deferred.reject({ message: 'Could not load Google Maps script' });
          factory.error = true;
          factory.loaded = false;
          factory.reset();
        }

        if (scriptTag) {  // Already coerced to boolean - no need to '!!' see http://eslint.org/docs/2.0.0/rules/no-extra-boolean-cast
          return deferred.promise;
        }

        scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = this.getSrc();
        scriptTag.onerror = error;
        document.body.appendChild(scriptTag);

        return deferred.promise;
      }
    };

    // Script loaded callback, send resolve
    $window.initMap = function () {
      $rootScope.$evalAsync(function () {
        factory.setLoaded(true);
        $rootScope.$emit('$initGoogleMaps', $window.google.maps);
      });
      deferred.resolve($window.google.maps);
    };

    return factory;
  }

  angular.module('zoomerRestaurant').service('GoogleMaps', GoogleMaps);
}());

(function () {
  'use strict';

  /** @ngInject */
  function InAppMessages(Restangular, $ionicPopup, $sanitize) {

    var getMessageContentFromResponse = function (data) {
      var messageContent = (data || []).map(function (d) {
        return d.message_content;
      });
      return $sanitize(messageContent.join('<br>'));
    };

    return {
      message: false,
      messageSha: null,

      /**
       * @method showAlertPopUp
       * @param {String} messageContent
       */
      showAlertPopUp: function (messageContent) {
        return $ionicPopup.alert({
          title: '<i class="fa fa fa-info-circle"></i>',
          template: messageContent
        });
      },

      /**
       * @method updateIfChanged
       */
      updateIfChanged: function (messageSha) {
        var self = this,
          messageContent;

        if (this.messageSha === messageSha) {
          return;
        }

        this.messageSha = messageSha;
        this.getAll().then(function (response) {
          messageContent = getMessageContentFromResponse(response.data);
          if (messageContent !== '') {
            self.showAlertPopUp(messageContent).then(function () {
              self.message = messageContent;
            });
          } else {
            self.message = false;
          }
        });
      },

      /**
       * @method getAll
       */
      getAll: function () {
        return Restangular.one('restaurant_in_app_messages').get();
      },

      /**
       * @method clear
       */
      clear: function () {
        this.messageSha = null;
        this.message = false;
      }
    };
  }

  angular.module('zoomerRestaurant')
    .service('InAppMessages', InAppMessages);
}());


(function () {
  'use strict';

  angular.module('zoomerRestaurant').service('MixPanel', [
    '$window', '$rootScope', 'Config', 'Device', 'MixPanelTranslations',
    function ($window, $rootScope, Config, Device, MixPanelTranslations) {

      var restaurantName, restaurantId, territoryId, districtId;

      return {

        /**
         * @method get
         * @return {Object}
         */
        get: function () {
          return $window.mixpanel;
        },

        /**
         * @method track
         * @param {String} key
         * @param {Object} properties
         */
        track: function (key, properties) {
          properties = properties || {};
          var mixpanel = this.get(),
            eventName,
            eventDataId,
            eventDataName;

          if (!mixpanel || !$rootScope.session.isLoggedIn()) {
            return;
          }

          if (key === 'order-update' && !properties.id) {
            key = 'order-create';
          }
          eventName = MixPanelTranslations[key] || 'Event';
          eventDataId = properties.id;
          eventDataName = properties.name;

          mixpanel.push([ 'track', eventName, angular.extend({ id: eventDataId, name: eventDataName }, this.getBuild(), this.getRestaurantInfo() ) ]);
        },

        /**
         * @method getBuild
         * @return {Object}
         */
        getBuild: function () {
          var cordova = $window.cordova;

          return {
            appBuild: Device.build,
            appVersion: Device.version,
            environment: cordova ? 'native' : 'web',
            userAgent: navigator.userAgent,
            vendor: navigator.vendor,
            zoomerAppVersion: Config.ZOOMER_APP_VERSION
          };
        },

        /**
         * @method getRestaurantInfo returns an object containing restaurant name, ID, territory, and district
         */
        getRestaurantInfo: function () {
          return {
            restaurant: restaurantName,
            restaurantId: restaurantId,
            territoryId: territoryId,
            districtId: districtId
          }
        },

        /**
         * @method identify
         * @param {Object} restaurant
         */
        identify: function (restaurant) {
          if (!$window.mixpanel) {
            return;
          }

          restaurantName = restaurant.name;
          restaurantId = restaurant.id;
          territoryId = restaurant.territory_id;
          districtId = restaurant.district_id;

          $window.mixpanel.init(Config.MIXPANEL_TOKEN, {
            loaded: function (mixpanel) {
              mixpanel.identify(restaurant.id);
              mixpanel.people.set({ '$name': restaurant.name });
            }
          });
        }
      };
    }
  ]);
}());

(function () {
  'use strict';

  var MAGIC_BLANK_STRING = "\x333";

  angular.module('zoomerRestaurant').factory('MonoSpaceRender', [
    'Utilities', '$window',
    function (Utilities, $window) {
      var moment = $window.moment;

      return {

        getTest: function(width) {
          this.width = width;
          this.paddingWidth = 0;
          this.padding = [];
          var lines = [];
          Array.prototype.push.apply(lines, this.rawHorizontalLine('-'));
          Array.prototype.push.apply(lines, this.rawCenteredText('This is a test receipt from EatStreet'));
          Array.prototype.push.apply(lines, this.rawCenteredText('If you are seeing this your thermal printer is working'));
          return lines.join('\n');
        },

        getOrder: function(order, restaurant, width, signature) {
          this.width = width;
          this.paddingWidth = 0;
          this.padding = [];
          var lines = this.restaurantHeader(order, restaurant);
          Array.prototype.push.apply(lines, this.customerHeader(order));
          Array.prototype.push.apply(lines, this.products(order));
          Array.prototype.push.apply(lines, this.footer(order));
          if (signature) {
            Array.prototype.push.apply(lines, this.signature());
          }
          return lines.join('\n');
        },

        restaurantHeader: function(order, restaurant) {
          var lines = [];
          lines.push('');
          var pickup = order.status === 'do_not_deliver' || order.status === 'do_not_deliver_dismissed';
          Array.prototype.push.apply(lines, this.rawCenteredText(pickup ? 'PICKUP' : 'DELIVERY'));
          lines.push('');
          Array.prototype.push.apply(lines, this.rawCenteredText(restaurant.name));
          Array.prototype.push.apply(lines, this.rawSplitLine('Order:', order.remote_reference, false));
          Array.prototype.push.apply(lines, this.rawHorizontalLine('-'));
          return lines
        },

        customerHeader: function(order) {
          var lines = [];
          var pickup = order.status === 'do_not_deliver' || order.status === 'do_not_deliver_dismissed';
          Array.prototype.push.apply(lines, this.rawCenteredText(order.payment_method));
          Array.prototype.push.apply(lines, this.rawSplitLine('Name:', order.diner_name || order.diner.name, false));
          Array.prototype.push.apply(lines, this.rawSplitLine('Phone:', Utilities.number.formatNumber(order.diner_phone_number || order.diner.phone_number, true), false));
          Array.prototype.push.apply(lines, this.rawSimpleLine('Delivery Address:'));
          this.rawPushLeft('  ');
          if (!pickup) {
            var addressObject = order.serialized_address || order.address;
            var addressLine = addressObject.address_1;
            if (addressObject.address_2) {
              addressLine += ', ' + addressObject.address_2;
            }
            Array.prototype.push.apply(lines, this.rawRightLine(addressLine));
            Array.prototype.push.apply(lines, this.rawRightLine(addressObject.city + ', ' + addressObject.state_province_region + ' ' + addressObject.postal_code));
          }
          this.rawPopLeft();
          lines.push('');
          var parsedDate = Number.isInteger(order.ready_by_time) ?
            moment().add(order.ready_by_time, 'minutes') :
            moment(order.ready_by_time);
          var displayDate = parsedDate.local().format('h:mm a M/D/YYYY');
          Array.prototype.push.apply(lines, this.rawSplitLine('Pickup at:', displayDate, false));
          Array.prototype.push.apply(lines, this.rawHorizontalLine('-'));
          return lines;
        },

        products: function(order) {
          var lines = [];
          var self = this;
          order.items.users.forEach(function(user) {
            user.items.forEach(function(item) {
              Array.prototype.push.apply(lines, self.renderProduct(item));
            });
          });
          return lines;
        },

        footer: function(order) {
          var lines = [];
          var self = this;
          if (order.comment && order.comment.length > 0) {
            lines.push('');
            Array.prototype.push.apply(lines, self.rawSimpleLine('Additional Comments:'));
            Array.prototype.push.apply(lines, self.rawSimpleLine(order.comment))
          }
          lines.push('');
          order.items.line_items.forEach(function(lineItem) {
            Array.prototype.push.apply(lines, self.rawRightLine(lineItem.name + ':' + Utilities.string.padStart(lineItem.price, 7, ' ')));
          });
          return lines;
        },

        signature: function() {
          var lines = [];
          var self = this;
          lines.push('');
          lines.push('');
          lines.push('');
          lines.push('');
          Array.prototype.push.apply(lines, self.rawSimpleLine('______________________________________'));
          Array.prototype.push.apply(lines, self.rawSimpleLine('Signature'));
          lines.push('');
          lines.push('');
          lines.push('');
          return lines;
        },

        rawHorizontalLine: function(text) {
          var string = '';
          for(var i = 0; i < this.width; i++) {
            string = string + text;
          }
          return [string];
        },

        /**
         * Intended for printing word wrapped left justified lines
         * @param text
         * @returns {Array} word wrapped lines of the input text
         */
        rawSimpleLine: function(text) {
          var lines = [];
          var paddingText = '';
          this.padding.forEach(function(pad) {
            paddingText = paddingText + pad;
          });
          Utilities.string.wordWrap(text, this.width - this.paddingWidth).split('\n').forEach(function(line) {
            lines.push(paddingText + line.replace(MAGIC_BLANK_STRING, " "));
          });
          return lines;
        },

        renderProduct: function(item) {
          var lines = [];
          Array.prototype.push.apply(lines, this.renderSubProduct(item, 0));
          return lines;
        },

        renderSubProduct: function(item, layer) {
          var lines = [];
          var self = this;
          if (item.price && item.price.length > 0) {
            Array.prototype.push.apply(lines, self.rawSplitLine("* " + item.name, item.price, true));
          } else {
            Array.prototype.push.apply(lines, self.rawSimpleLine("* " + item.name));
          }

          this.rawPushLeft('  ');
          if (item.items) {
            item.items.forEach(function (subitem) {
              Array.prototype.push.apply(lines, self.renderSubProduct(subitem, layer + 1));
            });
          }
          item.mods.forEach(function(mod) {
            Array.prototype.push.apply(lines, self.rawSplitLine('- ' + mod.name, mod.price ? mod.price : '', true));
          });
          this.rawPopLeft();
          return lines;
        },

        /**
         * For printing center justified, word wrapped lines of text
         * @param text
         * @returns {Array} the resulting word wrapped lines
         */
        rawCenteredText: function(text) {
          var lines = [];
          var self = this;
          Utilities.string.wordWrap(text, this.width).split('\n').forEach(function(string) {
            lines.push(Utilities.string.center(string, self.width));
          });
          return lines;
        },

        /**
         * For printing right justified, word wrapped lines of text
         * @param text
         * @returns {Array} the resulting word wrapped lines
         */
        rawRightLine: function(text) {
          return this.rawSplitLine(MAGIC_BLANK_STRING, text, true);
        },

        /**
         * For printing left justified text and right justified text on the same line, with whitespace separating
         * the left and right
         * @param left the text to be on the left of the line
         * @param right the text to be on the right of the line
         * @param biasRight boolean controlling if the line should ensure the right text is not wrapped
         * @returns {Array} resulting text lines
         */
        rawSplitLine: function(left, right, biasRight) {
          var lines = [];
          if (left.length + 4 + right.length < this.width - this.paddingWidth - 1) {
            return this.rawSimpleLine(left + Utilities.string.padStart(right, this.width - left.length - this.paddingWidth, ' '));
          } else if (biasRight) {
            var first = true;
            var self = this;
            Utilities.string.wordWrap(left, this.width - this.paddingWidth - right.length - 2).split("\n").forEach(function(line) {
              if (first) {
                Array.prototype.push.apply(lines, self.rawSimpleLine(line + Utilities.string.padStart(right, self.width - line.length - self.paddingWidth, ' ')));
                first = false;
              } else {
                Array.prototype.push.apply(lines, self.rawSimpleLine(line));
              }
            });
          } else {
            return this.rawSimpleLine(left + ' ' + right);
          }
          return lines;
        },

        /**
         * Begin indentation from the left
         * @param left the indentation characters
         */
        rawPushLeft: function(left) {
          this.padding.push(left);
          this.paddingWidth += left.length;
        },

        /**
         * End indentation from the left
         */
        rawPopLeft: function() {
          var popped = this.padding.pop();
          if (popped !== null) {
            this.paddingWidth -= popped.length;
          }
        }
      };
    }
  ]);
}());


(function () {
  'use strict';

  /** @ngInject */
  function PaymentStatus() {
    return {
      restrictRestaurant: false,
      warnRestaurant: false,
      daysUntilExpired: 0,

      /**
       * @method updateRestrictOrWarnRestaurant
       */
      updateRestrictOrWarnRestaurant: function(subscription) {
        subscription = subscription || '';
        if (subscription === 'invalid') {
          this.restrictRestaurant = true;
          this.warnRestaurant = false;
        } else if (subscription === 'valid') {
          this.restrictRestaurant = false;
          this.warnRestaurant = false;
        } else if (subscription.search('warning') === 0) {
          this.warnRestaurant = true;
          this.restrictRestaurant = false;
          this.daysUntilExpired = subscription.split(',')[1] || 7;
        }
      }
    };
  }

  angular.module('zoomerRestaurant')
    .service('PaymentStatus', PaymentStatus);

}());


(function () {
  'use strict';

  /** @ngInject */
  function receipts($q, $rootScope, Features, Restangular, Toast, receiptDisputeTypes) {
    var resource = Restangular.service('receipts');

    Restangular.extendModel('receipts', function (receipt) {
      receipt.loading = false;

      /**
       * @method closeOpenDispute
       * @return {Object} $promise
       */
      receipt.closeOpenDispute = function (showToast) {
        showToast = showToast !== undefined ? showToast : true;
        var restDisputes = Restangular.all('receipt_disputes'),
          dispute = receipt.receipt_dispute;

        if (!dispute || dispute.status !== 'in_dispute') {
          return $q.reject();
        }

        receipt.loading = true;
        return restDisputes.one(dispute.id.toString(), 'cancel').put().then(function (response) {
          if (showToast) {
            receipt.toastRemovedDispute();
          }
          return $q.resolve(response);
        }).finally(function () {
          receipt.loading = false;
        });
      };

      /**
       * @method dispute
       * @param {String} disputeType
       * @param {Boolean} isReceiptReOpened
       * @return {Object} $promise
       */
      receipt.dispute = function (disputeType, isReceiptReOpened) {
        receipt.loading = true;
        return receipt.customPOST({ dispute_type: disputeType }, 'receipt_disputes').then(function (response) {
          receipt.toastDispute(disputeType, isReceiptReOpened);
          $rootScope.$emit('$closeReceiptDisputeModal');
          return $q.resolve(response);
        }).finally(function () {
          receipt.loading = false;
        });
      };

      /**
       * @method toastDispute
       * @param {String} type
       * @param {Boolean} isReceiptReOpened
       */
      receipt.toastDispute = function (type, isReceiptReOpened) {
        isReceiptReOpened = isReceiptReOpened || false;
        var disputeType = (receiptDisputeTypes[type] || '').toLowerCase(),
          vowels = [ 'a', 'e', 'i', 'o', 'u' ],
          parts = [
            'The receipt for Order',
            ('#' + receipt.order_id),
            (isReceiptReOpened ? 'was reopened and'  : 'was') + ' reported for having',
            (vowels.indexOf(disputeType.charAt(0)) > -1 ? 'an' : ''),
            disputeType
          ];

        return Toast.show(parts.join(' '), '', {
          iconClass: 'zoomer-toast zoomer-toast-x-long'
        });
      };

      /**
       * @method toastRemovedDispute
       * @return {Boolean}
       */
      receipt.toastRemovedDispute = function () {
        var string = 'The reported issue for Order #' + receipt.order_id + '\'s receipt was removed.';
        return Toast.show(string, '', {
          iconClass: 'zoomer-toast zoomer-toast-x-long'
        });
      };

      /**
       * @method isDisputeEnabled
       * @return {Boolean}
       */
      receipt.isDisputeEnabled = function () {
        var  paymentMethod = receipt.order_payment_method || '';

        return Features.checkEnabled('receipt_disputes') && paymentMethod !== 'cash';
      };

      /**
       * @method toggle
       * @param {Boolean} markClosed
       * @return {Object} $promise
       */
      receipt.toggle = function (markClosed) {
        markClosed = Boolean(markClosed);
        var toastAction = markClosed ? 'closed' : 'opened',
          toastContent = [ 'Receipt', receipt.id, toastAction ],
          action = 'mark_' + (markClosed ? 'closed' : 'open');

        receipt.loading = true;
        return receipt.one(action).save().then(function () {
          Toast.show(toastContent.join(' '));
        }).finally(function () {
          receipt.loading = false;
        });

      };
      return receipt;
    });

    return angular.extend(resource, {

      /**
       * @method onEvent
       * @param {String} eventName
       * @param {Object} data
       */
      onEvent: function (eventName, data) {
        if (eventName === 'resolved') {
          $rootScope.$broadcast('$receiptDisputeUpdated', data);
        }
      }
    });
  }

  angular.module('zoomerRestaurant')
    .factory('Receipts', receipts);

}());

(function () {
  'use strict';

  var HALTED_STATUS = 'halted',
    NORMAL_STATUS = 'normal',
    ACTIVE_STATUS = 'active',
    INACTIVE_STATUS = 'inactive',
    serviceStatuses = [HALTED_STATUS, NORMAL_STATUS, ACTIVE_STATUS, INACTIVE_STATUS];

  angular.module('zoomerRestaurant').service('Restaurant', [
    '$rootScope', '$q', 'Restangular', 'LogEntries', 'serviceHaltedModal',
    function ($rootScope, $q, Restangular, LogEntries, serviceHaltedModal) {

      return {
        info: null,

        /**
         * Reset information
         */
        reset: function () {
          this.info = null;
        },

        /**
         * Get the restaurant information
         *
         * @return {Object} $promise
         */
        get: function () {
          var self = this,
            q = $q.defer();

          return Restangular.one('restaurants/my_restaurant').get().then(function (response) {
            var restaurant = response.data;
            self.info = restaurant;
            q.resolve(restaurant);
            return q.promise;
          }, function (error) {
            q.reject(error);
            return q.promise;
          });
        },

        /**
         * @method getClientSettings
         * @return {Object}
         */
        getClientSettings: function () {
          var restaurant = this.info || {};
          return restaurant.client_application_settings || {};
        },

        /**
         * @method hasBicycleSupport
         * @return {Boolean}
         */
        hasBicycleSupport: function () {
          var restaurant = this.info || {};
          return restaurant.supports_bicycle_delivery;
        },

        /**
         * Check if `contracted_for_oozo_pricing`
         *
         * @return {Boolean}
         */
        hasOozoPricing: function () {
          var restaurant = this.info || {};
          return !!restaurant.contracted_for_oozo_pricing;
        },

        /**
         * @method isPreLaunch
         * @return {Boolean}
         */
        isPreLaunch: function () {
          return (this.info || {}).launch_status === 'pre_launch';
        },

        /**
         * @method isServiceHalted
         * @return {Boolean}
         */
        isServiceHalted: function () {
          return (this.info || {}).service_status === HALTED_STATUS;
        },

        /**
         * @method setServiceStatus
         * @param {String} status
         */
        setServiceStatus: function (status) {
          status = status || NORMAL_STATUS;
          if (status === ACTIVE_STATUS || status === INACTIVE_STATUS) {
            return;
          }
          (this.info || {}).service_status = status;
          this.warnIfServiceHalted();
        },

        setGhostKitchenStatus: function (status, id) {
          console.log($rootScope.restaurantArray);
          for (var i = 0; i < $rootScope.restaurantArray.length; i++) {
            if ($rootScope.restaurantArray[i].eatstreetId === id) {
              $rootScope.restaurantArray[i].openStatus = status === 'active';
            }
          }
          console.log($rootScope.restaurantArray);
        },

        /**
         * @method warnIfServiceHalted
         */
        warnIfServiceHalted: function () {
          var status = (this.info || {}).service_status;
          if (status === HALTED_STATUS) {
            serviceHaltedModal.show();
          }
        },

        /**
         * Toggle the open / close status of the restaurant and update its details afterwards
         *
         * @param {Boolean} open
         * @return {Object} $promise
         */
        toggleOpening: function (open) {
          open = !!open;
          var self = this,
            q = $q.defer(),
            status = open ? 'activate' : 'inactivate';

          function onError(error) {
            q.reject(error);
            return q.promise;
          }

          return Restangular.all('restaurants').one(status).customPUT().then(function () {
            return Restangular.one('restaurants').one('my_restaurant').get().then(function (response) {
              var restaurant = response.data;
              self.info = restaurant;
              q.resolve(restaurant);
              return q.promise;
            }, onError);
          }, onError);
        },

        /**
         * Toggle the open / close status of the kitchen and update its details afterwards
         *
         * @param {Boolean} open
         * @return {Object} $promise
         */
        toggleOpeningKitchen: function (arr) {
          var i;
          var open_arr = [],
            closed_arr = [];
          var self = this,
            q = $q.defer();

          for (i = 0; i < arr.length; i++) {
            if(arr[i].openStatus) {
              open_arr.push(arr[i].eatstreetId);
            } else {
              closed_arr.push(arr[i].eatstreetId);
            }
          }

          $rootScope.restaurantArray = arr;

          return Restangular
            .one('restaurants/my_restaurant/update_es_open_status/')
            .customPOST({ open: open_arr, closed: closed_arr }).then(function (response) {
              var resp = response.data;
              q.resolve(resp);
              return q.promise;
            }, function (error) {
              q.reject(error);
              return q.promise;
            });
        },

        sendHoursRequest: function (hoursRequest) {
          var self = this,
          q = $q.defer();

          return Restangular
            .one('restaurants/my_restaurant/update_hours_request/')
            .customPOST({ email_contents: hoursRequest }).then(function (response) {
              var resp = response.data;
              q.resolve(resp);
              return q.promise;
            }, function (error) {
              q.reject(error);
              return q.promise;
            });
        },

        /**
         * Temporarily pause a restaurant/kitchen for 30 or 60 minutes
         * if user selects long (>=60 min) RBT
         *
         * @param {integer} minutes
         * @param {Array} eatstreetIds
         * @return {Object} promise
         */
        tempPause: function (minutes, eatstreetIds) {
          var self = this,
            q = $q.defer();

          function onError(error) {
            q.reject(error);
            return q.promise;
          }
          return Restangular
            .one('restaurants/my_restaurant/temporarily_inactivate/')
            .customPOST({minutes: minutes, eatstreet_restaurant_ids: eatstreetIds});
        },

        /**
         * Callback for pusher events
         *
         * @param {String} eventName
         * @param {Object} data
         */
        onEvent: function (eventName, data) {
          data = data || {};
          if (eventName === 'pusher:subscription_succeeded') {
            return;
          }

          this.logPusherEvent(eventName, data);
          if (serviceStatuses.indexOf(eventName) > -1 && !data.eatstreet_restaurant_id) {
            this.setServiceStatus(eventName);
            return this.get();
          } else if (serviceStatuses.indexOf(eventName) > -1 && data.eatstreet_restaurant_id) {
            this.setGhostKitchenStatus(eventName, data.eatstreet_restaurant_id);
          }

          if (eventName === 'pending_confirmation') {
            return $rootScope.$emit('$confirmSpecialOrders', data.order_id);
          }

          $rootScope.$emit('$restaurantUpdated', eventName, data);
        },

        /**
         * @method logPusherEvent
         * @param {String} eventName
         * @param {Object} data
         */
        logPusherEvent: function (eventName, data) {
          var restaurant = this.info || {},
            title = 'Pusher event fired: CHANNEL: private-restaurant_orders_channel_' + restaurant.id;

          LogEntries.log(title, eventName, {
            restaurant: { id: restaurant.id, name: restaurant.name }
          }, data);
        }
      };
    }
  ]);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').service('Session', [
    '$q', 'Restangular', 'Restaurant', 'MixPanel', 'Storage', 'ZoomerPusher', 'Features', 'GoogleMaps', 'readyByTimes','totalOpenReceipts', 'externalOrderPoll', 'menuList','$rootScope',
    function ($q, Restangular, Restaurant, MixPanel, Storage, ZoomerPusher, Features, GoogleMaps, readyByTimes, totalOpenReceipts, externalOrderPoll, menuList, $rootScope) {
      var userToken = Storage.get('X-User-Token'),
        email = Storage.get('X-User-Email');

      function setStorageAuthentication(user) {
        Storage.set('X-User-Email', user.email);
        Storage.set('X-User-Token', user.auth_token);
      }

      return {
        loggedIn: (!!userToken && !!email),
        user: null,

        /**
         * @method login
         * @param {Object} params
         * @return {Object} $promise
         */
        login: function (params) {
          params = {
            user: params,
            skip_activation: true
          };
          var self = this;

          return Restangular.all('users/login').post(params).then(function (response) {
            var user = response.data || {},
              isUserRestaurant = !!user.restaurant_id;

            setStorageAuthentication(user);
            self.loggedIn = isUserRestaurant;

            if (!isUserRestaurant) {
              self.logout(false);
              return $q.reject({ isUserRestaurant: isUserRestaurant, message: 'Sorry, but this user is not a restaurant', success: false });
            }

            MixPanel.track('login');
            return self.init(true);
          }, function (error) {
            error = error || {};
            self.loggedIn = false;
            return $q.reject(error.data || error);
          });
        },

        /**
         * Logout from the server, and return promise
         *
         * @return {Object} $promise
         */
        logout: function (track) {
          track = !!track;
          var self = this;

          return Restangular.one('users/logout').get({ skip_activation: true }).then(function () {
            if (track) {
              MixPanel.track('logout');
            }
            externalOrderPoll.stop();
            self.destroy();
          });
        },

        /**
         * @method init
         * @param {Boolean} checkServiceStatus
         * @return {Object} $promise
         */
        init: function (checkServiceStatus) {
          var self = this;
          return menuList.fetchRestaurantArray().then(function(res) {
            $rootScope.restaurantArray = res.data;
            if($rootScope.restaurantArray[0]) {
              $rootScope.nonESRestaurant = false;
              $rootScope.invisibilityCount = $rootScope.restaurantArray[0].invisibilityCount;
              $rootScope.firstRestaurant = $rootScope.restaurantArray[0];
              $rootScope.hasGhostKitchens = $rootScope.restaurantArray[1] ? true : false;
            } else {
              $rootScope.nonESRestaurant = true;
            }
            return Restaurant.get();
          }).catch(function() {
            return Restaurant.get();
          }).then(function (restaurant) {
            readyByTimes.refresh();
            totalOpenReceipts.refresh();
            GoogleMaps.get();
            MixPanel.identify(restaurant);
            ZoomerPusher.init(restaurant);
            self.save(restaurant.plain());
            if (checkServiceStatus) {
              Restaurant.warnIfServiceHalted();
            }
          });
        },

        /**
         * Set the user's data to localStorage for use later
         *
         * @param {Object} restaurant
         */
        save: function (restaurant) {
          if (restaurant.auth_token) {
            delete restaurant.auth_token;
          }

          Storage.set('user', restaurant);
          this.user = restaurant;
          return restaurant;
        },

        /**
         * Log-out / destroy the current session
         */
        destroy: function () {
          Storage.removeAll();
          ZoomerPusher.unsubscribeAll();
          Features.reset();
          this.loggedIn = false;
        },

        /**
         * Is the user logged-in?
         *
         * @return {Boolean}
         */
        isLoggedIn: function () {
          var token = !!Storage.get('X-User-Token'),
            email = !!Storage.get('X-User-Email');
          this.loggedIn = token && email;
          return this.loggedIn;
        }

      };
    }
  ]);

}());


(function () {
  'use strict';

  angular.module('zoomerRestaurant').service('Storage', [
    '$window',
    function ($window) {
      var ls = $window.localStorage,
        json = $window.JSON,
        isPrivateModeEnabled = false,
        testKey = 'test';

      try {
        ls.setItem(testKey, 123456);
        ls.removeItem(testKey);
      } catch (e) {
        isPrivateModeEnabled = true;
      }

      return {
        isPrivateModeEnabled: isPrivateModeEnabled,

        /**
         * Set data into LocalStorage
         *
         * @param {String} key
         * @param {String|Number|Object|Boolean} data
         */
        set: function (key, data) {
          if (!data) {
            return;
          }
          if (typeof data === 'object') {
            data = json.stringify(data);
          }
          ls.setItem(key, data);
        },

        /**
         * Retrieve data from LocalStorage based on key
         *
         * @param {String} key
         * @return {String|Number|Object|Boolean}
         */
        get: function (key) {
          return ls.getItem(key);
        },

        /**
         * Remove an item from LocalStorage
         *
         * @param {String} key
         */
        remove: function (key) {
          ls.removeItem(key);
        },

        /**
         * Clear all keys from LocalStorage
         */
        removeAll: function () {
          ls.clear();
        }
      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').service('ThermalPrinter', [
    'Storage', 'MonoSpaceRender', '$q', 'Features', '$window',
  function thermalPrinter(Storage, MonoSpaceRender, $q, Features, $window) {

    return {

      orderIdInProgress: 0,
      orderIdErrors: {},

      getOn: function() {
        return Storage.get('thermalPrintingOn') === 'enabled';
      },

      setOn: function(enabled) {
        Storage.set('thermalPrintingOn', enabled ? 'enabled' : 'disabled');
      },

      getDefaultNumberOfReceipts: function() {
        return Storage.get('defaultNumberOfReceipts') || 1;
      },

      setDefaultNumberOfReceipts: function(num) {
        Storage.set('defaultNumberOfReceipts', num);
      },

      featureEnabled: function() {
        return !Features.checkEnabled('hide_thermal_printers');
      },

      shouldPrint: function() {
        return this.getOn() && this.hasDefault() && this.featureEnabled();
      },

      shouldPrintOrder: function(order) {
        return this.shouldPrint() && order && order.items && !Array.isArray(order.items) && order.items.line_items;
      },

      setDefault: function(printer) {
        Storage.set('defaultThermalPrinter', printer);
      },

      clearDefault: function() {
        Storage.set('defaultThermalPrinter', {});
      },

      getDefault: function() {
        return JSON.parse(Storage.get('defaultThermalPrinter'));
      },

      hasDefault: function() {
        return !!this.getDefault() && this.getDefault().portName;
      },

      getPrintErrorMessage: function(orderId) {
        return this.orderIdErrors[orderId];
      },

      isInPrinterSupportedEnvironment: function() {
        return $window.cordova;
      },

      queryPrinters: function() {
        var deferred = $q.defer();
        if (this.isInPrinterSupportedEnvironment()) {
          starprnt.portDiscovery('All', function(result) {
              deferred.resolve(result);
            },
            function(error){
              deferred.reject(error);
            }
          );
        } else {
          deferred.resolve([]);
        }
        return deferred.promise;
      },

      attemptConnectToDefault: function() {
        var self = this;
        var deferred = $q.defer();
        var defaultPrinter = this.getDefault();
        if (defaultPrinter && defaultPrinter.portName && this.isInPrinterSupportedEnvironment()) {
          return self.connect(defaultPrinter.portName)
            .catch(function() {
              return self.queryPrinters()
                .then(function(printers) {
                  var printer = printers.find(function (printer) {
                    return printer.macAddress === defaultPrinter.macAddress;
                  });
                  if (printer && printer.portName) {
                    self.setDefault(printer);
                    return self.connect(printer.portName);
                  } else {
                    deferred.reject('Could not find default printer');
                    return deferred.promise;
                  }
                });
            });
        } else {
          deferred.resolve();
          return deferred.promise;
        }
      },

      connect: function(port) {
        var deferred = $q.defer();
        starprnt.connect(port,"StarGraphic", null, function(err,res) {
          if (err) {
            deferred.reject(err);
          } else {
            deferred.resolve(res);
          }
        });
        return deferred.promise;
      },

      disconnect: function() {
        var deferred = $q.defer();
        if (this.isInPrinterSupportedEnvironment()) {
          starprnt.disconnect(function() {
            deferred.resolve();
          }, function() {
            deferred.reject();
          });
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      },

      printESLogo: function() {
        var deferred = $q.defer();
        var imageObj = {
          uri: 'file://' + $window.cordova.file.applicationDirectory + 'www/assets/images/es-logo.jpg',
          width: 576, // options: 384 = 2", 576 = 3", 832 = 4"
          openCashDrawer: "false" // Defaults to true
        };
        starprnt.printImage(null, "StarGraphic", imageObj, function(result) {
            deferred.resolve(result);
          },
          function(error){
            deferred.reject(error);
          }
        );
        return deferred.promise;
      },

      printTestReceipt: function() {
        return this.attemptPrintLogoAndText(MonoSpaceRender.getTest(38));
      },

      attemptPrintLogoAndText: function(text) {
        var self = this;
        return self.printESLogo()
          .then(function() {
            return self.printText(text);
          }).catch(function(error) {
            return self.attemptConnectToDefault()
              .then(function() {
                return self.printESLogo();
              }).then(function() {
                return self.printText(text);
              });
          });
      },

      printText: function(text) {
        var deferred = $q.defer();
        var rasterObj = {
          text : text,
          fontSize: 25,       //Defaults to 25
          paperWidth: 576,    // options: 384 = 2", 576 = 3", 832 = 4"
          cutReceipt:"true", // Defaults to true
          openCashDrawer:"false" // Defaults to true
        };
        starprnt.printRasterReceipt(null,"StarGraphic", rasterObj, function(result){
            deferred.resolve(result);
          },
          function(error){
            deferred.reject(error);
          }
        );
        return deferred.promise;
      },

      attemptPrintTextDefaultTimes: function(text) {
        return this.attemptPrintTextXTimes(text, this.getDefaultNumberOfReceipts());
      },

      attemptPrintTextXTimes: function(text, number) {
        var self = this;
        if (number < 2) {
          return self.attemptPrintLogoAndText(text);
        } else {
          return self.attemptPrintLogoAndText(text)
            .then(function() {
              return self.attemptPrintTextXTimes(text, number - 1)
            });
        }
      },

      printMultipleOrders: function(order, restaurant) {
        return this.basePrintOrder(order, restaurant, true);
      },

      basePrintOrder: function(order, restaurant, printMultiple) {
        // If the items are null or the items are in the deprecated array format, then don't even try to print
        var deferred = $q.defer();
        if (!this.shouldPrintOrder(order)) {
          deferred.resolve();
          return deferred.promise;
        }

        this.orderIdInProgress = order.remote_reference;
        var self = this;
        var text = MonoSpaceRender.getOrder(order, restaurant, 38, false);

        var printPromise;
        if (printMultiple) {
          printPromise = self.attemptPrintTextDefaultTimes(text);
        } else {
          printPromise = self.attemptPrintLogoAndText(text);
        }

        if (order.hasAlcoholRestriction) {
          var textWithSignature = MonoSpaceRender.getOrder(order, restaurant, 38, true);
          printPromise = printPromise.then(function() {
            return self.attemptPrintLogoAndText(textWithSignature);
          });
        }

        return printPromise
          .then(function() {
            self.orderIdInProgress = 0;
            self.orderIdErrors[self.orderIdInProgress] = undefined;
            deferred.resolve();
            return deferred.promise;
          }).catch(function(error) {
            self.orderIdErrors[self.orderIdInProgress] = 'Errored';
            self.orderIdInProgress = 0;
            deferred.reject(error);
            return deferred.promise;
          });
      },

      printOrder: function(order, restaurant) {
        return this.basePrintOrder(order, restaurant, false);
      }
    }
  }])
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').service('Timeline', [
    function () {
      var translations = {
        address: 'Address',
        cancelled: 'Order cancelled',
        cash: 'cash',
        claimed: 'Order claimed',
        credit_card: 'credit card',
        delivered: 'Order delivered',
        delivery_attempt: 'Delivery attempt',
        delivery_in_progress: 'Picked up',
        driver_id: 'Driver',
        oozo_review_rejected: 'Order Rejected (OOZO)',
        payment_method: 'Payment method',
        pending_assignment: 'Pending assignment',
        pending_oozo_review: 'Order sent for review (OOZO)',
        phone_number: 'Phone number',
        prepaid: 'prepaid',
        ready_by_time: 'RBT',
        undeliverable: 'Undeliverable',
        not_ready_at: 'Food marked "Not Ready"',
        do_not_deliver: 'Takeout order created',
        do_not_deliver_dismissed: 'Takeout order picked up'
      };

      return {
        data: [],
        source: null,

        /**
         * Reset data
         */
        reset: function () {
          this.data = [];
          this.source = null;
        },

        /**
         * Parse the order's timeline object for rendering out to the UI
         *
         * @param {Object} order
         */
        parse: function (order) {
          var self = this,
            timeline = order.timeline,
            result = [],
            index,
            changeType;

          timeline = _.reject(timeline, function (item) {
            return (item.event === 'payment_method' && item.change_type === 'defined')
              || (item.event === 'phone_number' && item.change_type === 'defined')
              || (item.event === 'address' && item.change_type === 'defined')
              || (item.event === 'status' && item.change_type === 'updated' && item.value === 'claimed')
              || (item.event === 'status' && item.change_type === 'updated' && item.value === 'pending_assignment');
          });

          index = _.findIndex(timeline, function (item) { return item.event === 'ordered'; });
          if (index > 0) {
            timeline.splice(0, 0, timeline.splice(index, 1)[0]);
          }

          function getTimeDifference(now, rbt) {
            var nowTime = new Date(now).getTime(),
              rbtTime = new Date(rbt).getTime(),
              diff = rbtTime - nowTime;
            return Math.round(diff / 60000);
          }

          function getEventValue(event) {
            if (event.event === 'ready_by_time') {
              return getTimeDifference(event.timestamp, event.value) + 'mins';
            }

            if (event.event === 'food_ready_now') {
              return event.value === 'enabled' ? 'Food Ready Now activated' : 'Food Ready Now deactivated';
            }

            if (event.event === 'address' || event.event === 'driver_id' || event.event === 'phone_number' || event.event === 'delivery_attempt') {
              return event.value;
            }

            return translations[event.value];
          }

          angular.forEach(timeline, function (timelineEvent) {
            if (timelineEvent.event === 'email_order_detected') {
              self.source = timelineEvent.value;
              return;
            }

            changeType = timelineEvent.change_type === 'defined' ? 'set to' : 'updated to';

            timelineEvent.parsedType = translations[timelineEvent.event] + ' ' + changeType;
            timelineEvent.parsedValue = getEventValue(timelineEvent);

            if (timelineEvent.event === 'food_ready_now') {
              timelineEvent.parsedType = '';
            }

            if (timelineEvent.event === 'driver_id') {
              timelineEvent.parsedType = 'Order assigned to ';
            }

            if (timelineEvent.event === 'delivery_attempt' || timelineEvent.event === 'not_ready_at') {
              timelineEvent.parsedType = translations[timelineEvent.event];
            }
            if (timelineEvent.value === 'delivery_in_progress') {
              timelineEvent.parsedValue = 'Picked up (RBT ' + getTimeDifference(timelineEvent.timestamp, order.ready_by_time) + ')';
            }

            result.push(timelineEvent);
          });

          this.data = result;
        }

      };
    }
  ]);
}());

(function () {
  'use strict';

  var orderParamsKeys = [
    'payment_method', 'ready_by_time', 'internal_id', 'driver_iou',
    'oozo_pricing_accepted',
    'source', 'third_party_id', 'tip_amount',
    'size', 'do_not_deliver_by_bicycle',
    'deliver_at', 'large_order', 'status', 'pickup_order_dismissed_at'
  ];

  angular.module('zoomerRestaurant').factory('Utilities', [
    '$window', '$state', 'PhoneUtils',
    function ($window, $state, PhoneUtils) {
      var moment = $window.moment,
        orderStates = [ 'app.orders', 'app.orders-queue', 'app.orders-inProgress', 'app.orders-delivered', 'app.orders-specialOrders', 'app.orders-oozoForReview' ],
        minutesAgoDefault = 30,
        oneMinutesInMs = 60000;

      function stripFormatting(number) {
        if (!number) {
          return;
        }
        return (''+number).replace(/\(|\)|-|\+|\s/gi, '');
      }

      return {

        /**
         * Split string and return the first item in the array
         *
         * @param {String} name
         * @return {String}
         */
        getFirstName: function (name) {
          name = name || '';
          var split = name.split(' '),
            firstName = split[0] || '',
            lastNameChar = (split[1] || '').charAt(0);

          return ([firstName, lastNameChar]).join(' ').trim();
        },

        collections: {

          /**
           * @method merge
           * @param {Array} fresh
           * @param {Array} collection
           * @return {Array}
           */
          merge: function (fresh, collection) {
            fresh = fresh || [];

            if (!collection || !collection.length) {
              return fresh;
            } else if (!fresh.length) {
              return collection;
            }

            angular.forEach(collection, function (item) {
              if (!!item.isEdited || !!item.editing) {
                return;
              }

              var update = _.find(fresh, function (b) {
                return item.id === b.id;
              });

              if (update) {
                angular.merge(item, update);
              }
            });

            var ids = _.pluck(collection, 'id'),
              newItems = _.filter(fresh, function (item) {
                return ids.indexOf(item.id) === -1;
              }) || [];

            return collection.concat(newItems);
          }
        },

        orders: {

          getParams: function (order) {
            var result;
            if (!order) {
              return false;
            }

            result = {
              diner: {
                phone_number: order.diner_phone_number || order.diner.phone_number
              },
              order: _.pick(order, function (value, key) {
                return orderParamsKeys.indexOf(key) > -1 && !_.isUndefined(value);
              }),
              order_address: order.serialized_address || order.address
            };

            result.order.delivery_notes = order.comment || order.delivery_notes;
            result.order.source = order.source  || 'Zoomer';
            if (order.oozo_review) {  // Already coerced to boolean - no need to '!!' see http://eslint.org/docs/2.0.0/rules/no-extra-boolean-cast
              result.oozo_review = order.oozo_review;
            }

            if (order.provides_receipt) {
              result.order.receipt_provided_by_email_order = !!order.provides_receipt;
            }

            if (result.order.deliver_at) {
              result.order.deliver_at = moment(result.order.deliver_at).toISOString();
            }

            if (result.order.pickup_order_dismissed_at) {
              result.order.pickup_order_dismissed_at = moment(result.order.pickup_order_dismissed_at).toISOString();
            }

            return result;
          },

          /**
           * Validate Order is OOZO & feature is enabled
           *
           * @param {Object} order
           * @return {Boolean}
           */
          isOozo: function (order) {
            order = order || {};
            return order.status === 'oozo_review_rejected' || order.oozo_pricing_accepted;
          },

          /**
           * @method isReorderDisabled
           * @return {Boolean}
           */
          isReorderDisabled: function (order) {
            order = order || {};
            var isOutsideBusinessDay = order.outsideBusinessDay,
              isOozoRejected = order.status === 'oozo_review_rejected';

            return isOozoRejected || isOutsideBusinessDay || !!order.deliver_at || !!order.large_order;
          },

          /**
           * @method isRbtInFuture
           * @param {Object} order
           * @return {Boolean}
           */
          isRbtInFuture: function (order) {
            order = order || {};
            var rbt = new Date(order.ready_by_time).getTime(),
              now = new Date().getTime();

            return (rbt - now > 0);
          },

          /**
           * @method outsideBusinessDay
           * @param {Object} order
           * @return {Boolean}
           */
          outsideBusinessDay: function (order) {
            order = order || {};
            var now = new Date(),
              orderCreated = new Date(order.created_at),
              difference = now - orderCreated,
              hoursAgo = difference / 3600000;

            // If 'now' is a different day and after 6am, it's a new business day!
            return (hoursAgo > 24) || (now.getDate() !== orderCreated.getDate() && now.getHours() >= 6);
          },

          /**
           * Get the Picked-Up and Dropped-off times from the Next Actions array
           *
           * @param {Array} orders
           */
          setNextActionTimes: function (orders) {
            angular.forEach(orders, this.setNextActionTime.bind(this));
          },

          /**
           * Calculate the Picked-up and Dropped-off times for an order
           *
           * @param {Object} order
           */
          setNextActionTime: function (order) {
            var nextActions = order.next_actions || [],
              action;

            if (!nextActions.length) {
              return;
            }

            if (!order.picked_up_at) {
              action = _.find(nextActions, function (nextAction) {
                return nextAction.action_type === 'pickup' && nextAction.status === 'completed';
              });

              if (action) {
                order.picked_up_at = action.completed_at;
              }
            }

            if (!order.dropped_off_at) {
              action = _.find(nextActions, function (nextAction) {
                return nextAction.action_type === 'dropoff' && nextAction.status === 'completed';
              });
              if (action) {
                order.dropped_off_at = action.completed_at;
              }
            }
          }

        },

        string: {

          /**
           * Convert string to title-case, capitalising the first-letter
           *
           * @param {String} string
           * @return {String}
           */
          toTitleCase: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
          },

          /**
           * Convert SampleText to Sample Text
           *
           * @param {String} string
           * @return {String}
           */
          convertCamelToNatural: function (string) {
            string = string || '';
            var result = string.replace( /([A-Z])/g, ' $1');
            return (result.charAt(0).toUpperCase() + result.slice(1)).trim();
          },

          center: function(str, size) {
            if (str === null || size <= 0) {
              return str;
            }
            var strLen = str.length;
            var pads = size - strLen;
            str = this.padStart(str, strLen + pads / 2, ' ');
            str = this.padEnd(str, size, ' ');
            return str;
          },

          // Copied from polyfill here
          // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
          padStart: function padStart(str, targetLength, padString) {
            targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
            padString = String(typeof padString !== 'undefined' ? padString : ' ');
            if (str.length >= targetLength) {
              return str;
            } else {
              targetLength = targetLength - str.length;
              if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
              }
              return padString.slice(0, targetLength) + str;
            }
          },

          // Copied from polyfill here
          // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd
          padEnd: function padEnd(str, targetLength, padString) {
            targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
            padString = String((typeof padString !== 'undefined' ? padString : ' '));
            if (str.length > targetLength) {
              return str;
            } else {
              targetLength = targetLength - str.length;
              if (targetLength > padString.length) {
                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
              }
              return str + padString.slice(0,targetLength);
            }
          },

          wordWrap: function(str, cols) {
            var wordsArray = str.split(' ');
            var formattedString = wordsArray[0];
            var lines = [];

            for (var i = 1; i < wordsArray.length; i++) {
              if (formattedString.length + wordsArray[i].length + 1 <= cols) {
                formattedString += ' ' + wordsArray[i];
              } else if (formattedString.length + wordsArray[i].length <= cols && (wordsArray[i].charAt(0) === ' ' || wordsArray[i].charAt(0) === '\x333')) {
                formattedString += wordsArray[i];
              } else {
                lines.push(formattedString);
                formattedString = '  ' + wordsArray[i];
              }
            }
            lines.push(formattedString);
            return lines.join('\n');
          }
        },

        pagination: {

          /**
           * Parse the data returned in the header related to pagination and map it into a more usable JS object
           *
           * @param {String} data
           * @return {Object}
           */
          get: function (data) {
            data = data || '';
            var links = data.split(','),
              result = {};

            if (!data || data === '') {
              return {
                current: 1
              };
            }

            _.each(links, function (link) {
              var components = link.split(';'),
                url = components[0],
                rel = components[1].trim(),
                regex = /page=(\d+)/gi,
                type,
                page;

              type = rel.replace(/(rel=")(\w+)(")/gi, function (match, p1, p2) {
                return p2;
              });

              page = Number(regex.exec(url)[1] || '');

              if (type === 'next') {
                result.current = page - 1;
              }

              if (type === 'prev') {
                result.current = page + 1;
              }

              result[type] = {
                page: page,
                url: url
              };
            });
            return result;
          }
        },

        time: {
          /**
           * Sort all the available RBT options
           *
           * @param {Array} rbts
           * @return {Array}
           */
          parseRbts: function (rbts) {
            rbts = rbts || [];
            var result = _.map(rbts, Number);
            return _.sortBy(result);
          },

          /**
           * Caclulate the minutes difference between two points
           * of time: 'now' and time
           *
           * @param {Number} time (milliseconds)
           * @return {Number}
           */
          getMinutesDifference: function (time) {
            var now = new Date().getTime(),
              difference = time - now;
            return Math.round(difference / oneMinutesInMs);
          },

          /**
           * Get the Date n minutes from now in the future
           *
           * @param {Number} minutes
           * @param {Boolean} asDate
           */
          getTimeFromNow: function (minutes, asDate) {
            minutes = minutes || 0;
            var now = new Date().getTime(),
                milliseconds = now + (minutes * oneMinutesInMs);

            return asDate ? moment(milliseconds).format() : milliseconds;
          },

          /**
           * @method isLessThanMinutesAgo determines if the given date is withing the given number of minutes from the current time
           * @param {Date} date
           * @param {Number} minutes [default = 30 minutes]
           * @return Boolean
           */
          isLessThanMinutesAgo: function (date, minutes) {
            minutes = minutes || minutesAgoDefault;
            var now = new Date().getTime(),
              then = new Date(date).getTime(),
              difference = now - then,
              milliseconds = minutes * oneMinutesInMs;

            return difference < milliseconds;
          }

        },

        number: {

          /**
           * Remove the formatting added to the phone number
           *
           * @param {Number|String} number
           * @return String
           */
          stripFormatting: function (number) {
            return stripFormatting(number);
          },

          /**
           * Format the string telephone number into the standard (xxx) xxx-xxxx variation
           *
           * @param {Number|String} number
           * @return {string}
           */
          formatNumber: function (number, stripNationalCode) {
            var nationalCode,
              areaCode,
              exchangeCode,
              subscriberNumber;

            number = '' + (number || '');
            number = stripFormatting(number) || '';
            nationalCode = Number(number.charAt(0));

            if (nationalCode === 1) {
              number = number.substring(1);
              if (stripNationalCode) {
                nationalCode = '';
              }
            } else {
              nationalCode = '';
            }

            areaCode = number.substr(0, 3);
            exchangeCode = number.substr(3, 3);
            subscriberNumber = number.substr(6);

            if (number.length >= 3) {
              areaCode = '(' + areaCode + ') ';
            }

            if (number.length > 6) {
              exchangeCode = exchangeCode + '-';
            }

            return (nationalCode + ' ' + areaCode + exchangeCode + subscriberNumber).trim();
          },

          arePhoneNumbersEqual: function (phoneNum1, phoneNum2) {
            phoneNum1 = (phoneNum1 || '').toString();
            phoneNum2 = (phoneNum2 || '').toString();
            var phoneNum1National,
              phoneNum2National,
              phoneNum1Stripped,
              phoneNum2Stripped,
              valid;

            try {
              phoneNum1National = PhoneUtils.formatNational(phoneNum1, 'us');
              phoneNum2National = PhoneUtils.formatNational(phoneNum2, 'us');
              phoneNum1Stripped = stripFormatting(phoneNum1National);
              phoneNum2Stripped = stripFormatting(phoneNum2National);
              valid = phoneNum1Stripped === phoneNum2Stripped;
            } catch (e) {
              valid = false;
            }
            return valid;
          }

        },

        state: {

          /**
           * Root state include the orders' subPages in this case
           *
           * @param {String} target
           * @return {Boolean}
           */
          isAnyRootState: function (target) {
            var states = orderStates.concat([ 'app.history', 'app.receipts', 'app.drivers-feedback' ]),
              current = $state.current,
              name = target || current.name;
            return states.indexOf(name) > -1;
          },

          /**
           * Check if current $state matches against the target string
           *
           * @param {String} target
           * @return {Boolean}
           */
          isCurrentState: function (target) {
            var current = $state.current,
              name = current.name === 'app.orders' ? 'app.orders-queue' : current.name;
            return target === name;
          }
        }

      };
    }
  ]);
}());


(function () {
  'use strict';

  angular.module('zoomerRestaurant').service('ZoomerPusher', [
    '$window', '$rootScope', 'Config', 'Storage', 'ExternalOrders', 'OozoActions', 'Receipts', 'Restaurant', 'readyByTimes', 'ordersQueue',
    function ($window, $rootScope, Config, Storage, ExternalOrders, OozoActions, Receipts, Restaurant, readyByTimes, ordersQueue) {
      var pusher,
        prefixes = [
          { callback: ExternalOrders, key: 'private-email_orders_' },
          { callback: ordersQueue, key: 'private-restaurant_orders_channel_' },
          { callback: Restaurant, key: 'private-restaurant_orders_channel_' },
          { callback: Restaurant, key: 'restaurant_service_status_' },
          { callback: Receipts, key: 'receipt_disputes_', prop: 'territory_id' },
          { callback: readyByTimes, key: 'territory_settings_', prop: 'territory_id' },
          { callback: readyByTimes, key: 'district_settings_', prop: 'district_id' },
          { callback: OozoActions, key: 'private-restaurant_oozo_review_' }
        ];

      return {
        restaurant: null,

        /**
         * Init required Pusher channels
         *
         * @param {Number} restaurant
         */
        init: function (restaurant) {
          this.restaurant = restaurant;
          if (pusher) {
            return this.subscribeAll();
          }

          pusher = new $window.Pusher(Config.PUSHER_APP_KEY, {
            authEndpoint: Config.API_BASEURL + '/pusher/auth_restaurant',
            auth: this.getHeaders(),
            cluster: Config.PUSHER_CLUSTER
          });
          pusher.connection.bind('state_change', function (states) {
            $rootScope.$emit('$pusherStateChange', states);
          });
          this.subscribeAll();
        },

        /**
         * Disconnect and revert instance
         */
        disconnect: function () {
          if (!pusher) {
            return;
          }
          pusher = null;
        },

        /**
         * Return session headers
         *
         * @return {Object}
         */
        getHeaders: function () {
          return {
            headers: {
              'X-User-Token': Storage.get('X-User-Token'),
              'X-User-Email': Storage.get('X-User-Email')
            }
          };
        },

        /**
         * @method getChannel
         * @param {Object} pusherData
         * @return {Object|Boolean}
         */
        getChannel: function (pusherData) {
          var id = pusherData.prop ? this.restaurant[pusherData.prop] : this.restaurant.id,
            channelName;
          if (!id) {
            return false;
          }

          channelName = pusherData.key + id;
          return pusher.channel(channelName) || pusher.subscribe(channelName);
        },

        /**
         * Subscribe to available channel and bind to expected callbacks
         */
        subscribeAll: function () {
          var channel,
            callback;
          if (!pusher) {
            return;
          }

          angular.forEach(prefixes, function (prefix) {
            channel = this.getChannel(prefix);

            if (channel) {
              callback = prefix.callback['onEvent'];
              channel.bind_all(callback.bind(prefix.callback));
            }
          }, this);
        },

        /**
         * Unsubscribe from all channels
         */
        unsubscribeAll: function () {
          var channel;
          if (!pusher) {
            return false;
          }

          angular.forEach(prefixes, function (prefix) {
            channel = this.getChannel(prefix);
            if (channel) {
              channel.unsubscribe();
            }
          }, this);
          this.disconnect();
        }

      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant').service('ZoomerState', [
    'Utilities',
    function (Utilities) {

      var validBackStates = [ 'app.new-order', 'app.edit-order', 'app.new-reorder', 'app.edit-reorder', 'app.view-order', 'app.new-specialorder', 'app.edit-specialorder' ];
      return {
        showBack: false,
        showMenu: false,
        backTo: '',

        /**
         * Update custom / internal toggles for menu and back button, as well as the previous $state
         *
         * @param {Object} nextState
         * @param {Object} prevState
         */
        update: function (nextState, prevState) {
          nextState = nextState || {};
          prevState = prevState || {};
          var nextName = nextState.name || '',
            prevName = prevState.name || '';

          this.showBack = _.contains(validBackStates, nextName);
          this.backTo = prevName === '' ? 'app.orders' : prevName;
          this.showMenu = Utilities.state.isAnyRootState(nextName);
        }

      };
    }
  ]);

}());

(function(e,a){if(!a.__SV){var b=window;try{var c,l,i,j=b.location,g=j.hash;c=function(a,b){return(l=a.match(RegExp(b+"=([^&]*)")))?l[1]:null};g&&c(g,"state")&&(i=JSON.parse(decodeURIComponent(c(g,"state"))),"mpeditor"===i.action&&(b.sessionStorage.setItem("_mpcehash",g),history.replaceState(i.desiredHash||"",e.title,j.pathname+j.search)))}catch(m){}var k,h;window.mixpanel=a;a._i=[];a.init=function(b,c,f){function e(b,a){var c=a.split(".");2==c.length&&(b=b[c[0]],a=c[1]);b[a]=function(){b.push([a].concat(Array.prototype.slice.call(arguments,
  0)))}}var d=a;"undefined"!==typeof f?d=a[f]=[]:f="mixpanel";d.people=d.people||[];d.toString=function(b){var a="mixpanel";"mixpanel"!==f&&(a+="."+f);b||(a+=" (stub)");return a};d.people.toString=function(){return d.toString(1)+".people (stub)"};k="disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
  for(h=0;h<k.length;h++)e(d,k[h]);a._i.push([b,c,f])};a.__SV=1.2;b=e.createElement("script");b.type="text/javascript";b.async=!0;b.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===e.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";c=e.getElementsByTagName("script")[0];c.parentNode.insertBefore(b,c)}})(document,window.mixpanel||[]);

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('orderHelpModal', {
      bindToController: true,
      bindings: {
        order: '<',
        onHide: '=',
        text: '@'
      },
      controller: 'OrderHelpModalCtrl',
      template: '<a ng-click="$ctrl.openModal()"><i class="fa z-help-desk"></i><span ng-bind="$ctrl.text"></span></a>'
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function OrderHelpModalCtrl($ionicModal, $scope, orderHelpReasons, restaurantSupportRequests) {
    var orderHelpModalUrl = 'app/support/orderHelpModal.html',
      vm = this,
      modalPromise,
      shownPromise,
      hiddenPromise,
      modal;

    vm.reasons = orderHelpReasons;
    vm.details = '';
    vm.formDisabled = true;
    vm.formCompleted = false;
    vm.hasError = false;
    vm.text = vm.text || 'Help with this order';

    /**
     * @method setSupportRequestId
     * @param {Number} requestId
     */
    vm.setSupportRequestId = function (requestId) {
      if (!requestId) {
        return;
      }
      vm.order.restaurant_support_request_ids = vm.order.restaurant_support_request_ids || [];
      vm.order.restaurant_support_request_ids.push(requestId);
    };

    /**
     * @method sendFeedback
     */
    vm.sendFeedback = function () {
      var selected = findSelected(vm.reasons),
        orderId = vm.order.id,
        data = {
          order_id: orderId,
          details: vm.details,
          reason: selected.key
        };

      vm.formDisabled = true;
      restaurantSupportRequests.post({ restaurant_support_request: data }).then(function (response) {
        vm.formCompleted = true;
        vm.setSupportRequestId((response.data || {}).id);
      }, function () {
        vm.hasError = true;
      }).finally(function () {
        unselectAll(vm.reasons);
      });
    };

    /**
     * @method select
     * @param {Object} reason
     */
    vm.select = function (reason) {
      unselectAll(vm.reasons);
      reason.selected = !reason.selected;
      vm.formDisabled = false;
    };

    /**
     * @method open
     */
    vm.openModal = function () {
      modalPromise.then(function (modalInstance){
        modal = modalInstance;
        modal.show();
      });
    };

    /**
     * @method close
     */
    vm.close = function () {
      if (modal) {
        modal.hide();
      }
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      modalPromise = $ionicModal.fromTemplateUrl(orderHelpModalUrl, {
        backdropClickToClose: false,
        scope: $scope
      });

      shownPromise = $scope.$on('modal.shown', function (e) {
        var scope = e.targetScope || {};

        if (scope.externalOrders) {
          vm.close();
        }
      });

      hiddenPromise = $scope.$on('modal.hidden', function () {
        if (vm.onHide) {
          vm.onHide();
        }
        unselectAll(vm.reasons);
      });
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      shownPromise();
      hiddenPromise();
    };
  }

  // Private

  function findSelected(reasons) {
    return _.find(reasons, 'selected');
  }

  function unselectAll(reasons) {
    return _.each(reasons, function (reason) { reason.selected = false; });
  }

  angular.module('zoomerRestaurant')
    .controller('OrderHelpModalCtrl', OrderHelpModalCtrl);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .value('orderHelpReasons', [
      { value: 'Driver forgot something', id: 2, key: 'forgot_something' },
      { value: 'Driver picked up the wrong order', id: 1, key: 'picked_up_wrong_order' },
      { value: 'Address problem', id: 3, key: 'address_problem' },
      { value: 'Something else', id: 0, key: 'other' }
    ]);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.support')
    .component('orderRow', {
      bindings: {
        disabled: '<',
        order: '<',
        onClick: '&'
      },
      require: {
        supportDashboardCtrl: '^supportDashboard'
      },
      templateUrl: 'app/support/orderRow.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function restaurantSupportRequests(Restangular) {
    var serviceName = 'restaurant_support_requests';
    return Restangular.service(serviceName);
  }

  angular.module('zoomerRestaurant')
    .factory('restaurantSupportRequests', restaurantSupportRequests);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant.support')
    .component('supportDashboard', {
      controller: 'SupportDashboardCtrl',
      templateUrl: 'app/support/supportDashboard.html'
    });

}());

(function () {
  'use strict';

  function resetSupportRequestData() {
    return {
      form: {},
      details: null
    };
  }

  /** @ngInject */
  function SupportDashboardCtrl($animate, $cordovaInAppBrowser, $element, $ionicScrollDelegate, $rootScope, $scope, $state, $timeout, $window, Features, Restaurant, ordersQueue, restaurantSupportRequests, supportRouter) {
    var validStates = [ 'app.orders', 'app.history' ],
      handleName = 'restaurantSupportContent',
      explodeOutCls = 'explode-out-button',
      fadeOutCls = 'fade-out',
      delay = 100,
      vm = this;

    $rootScope.isSupportDashboardActive = false;

    vm.hasFooter = false;
    vm.supportRequestData = resetSupportRequestData();
    vm.issueResolved = false;
    vm.loading = false;
    vm.ordersQueue = ordersQueue;
    vm.supportRouter = supportRouter;

    /**
     * @method getScrollCls
     * @return {Array}
     */
    vm.getScrollCls = function () {
      var cls = [];
      if (vm.issueResolved) {
        cls.push('issue-resolved');
      }

      if (vm.hasFooter) {
        cls.push('has-footer');
      }

      return cls;
    };

    /**
     * @method getLauncherButtonEl
     * @return {Object}
     */
    vm.getLauncherButtonEl = function () {
      var element = $element[0],
        queryCls = '.support-launcher-button';
      return element.querySelector(queryCls);
    };

    /**
     * @method isLauncherEnabled
     * @return {Boolean}
     */
    vm.isLauncherEnabled = function () {
      return validStates.indexOf($state.current.name) > -1;
    };

    /**
     * @method launch
     */
    vm.launch = function () {
      $animate.addClass(vm.getLauncherButtonEl(), explodeOutCls).then(function () {
        $rootScope.isSupportDashboardActive = true;
      });
    };

    /**
     * @method close
     */
    vm.close = function () {
      return $animate.removeClass(vm.getLauncherButtonEl(), explodeOutCls).then(function () {
        $rootScope.isSupportDashboardActive = false;
      });
    };

    /**
     * @method closeAndReset
     * @TODO - add reset workflow
     */
    vm.closeAndReset = function () {
      return vm.close().then(function () {
        supportRouter.goTo();
        vm.refreshScrollDelegate();
        vm.supportRequestData = resetSupportRequestData();
      });
    };

    /**
     * @method refreshScrollDelegate
     */
    vm.refreshScrollDelegate = function () {
      var handle = $ionicScrollDelegate._instances.find(function (i) { return i.$$delegateHandle === handleName; });
      if (handle) {
        handle.scrollTop(true);
      }
    };

    /**
     * @method goToLastState
     */
    vm.goToLastState = function () {
      supportRouter.goToLastState();
      vm.supportRequestData = resetSupportRequestData();
    };

    /**
     * @method edit
     * @param {Number} order
     */
    vm.editOrder = function (order) {
      vm.closeAndReset().then(function () {
        $timeout(function () {
          $state.go('app.edit-order', { orderId: order.id });
        }, delay);
      });
    };

    /**
     * @method getCurrentHelpDocTpl
     */
    vm.getCurrentHelpDocTpl = function () {
      var currentState = supportRouter.current || {},
        helpDoc = currentState.helpDoc;

      if (!helpDoc) {
        return false;
      }

      return 'app/support/states/helpDocs/' + helpDoc + '.html';
    };

    /**
     * @method getRequestParams
     * @return {Object}
     */
    vm.getRequestParams = function () {
      var current = supportRouter.current || {},
        order = current.order || {},
        params = {
          details: vm.supportRequestData.details,
          order_id: order.id,
          phone_number: Restaurant.info.phone_number,
          preferred_contact_method: 'phone_call',
          reason: current.reason
        };

      return {
        restaurant_support_request: params
      };
    };

    /**
     * @method submitSupportRequest
     */
    vm.submitSupportRequest = function () {
      vm.loading = true;
      restaurantSupportRequests.post(vm.getRequestParams()).then(function () {
          vm.supportRequestData = resetSupportRequestData();
          supportRouter.goTo('supportRequestSent');
        }).finally(function () {
          vm.loading = false;
        });
    };

    /**
     * @method openWebAppInBrowser
     */
    vm.openWebAppInBrowser = function () {
      var url = 'https://zoomer-restaurants.eatstreet.com',
        cordova = $window.cordova || {};

      if (cordova.InAppBrowser) {
        $cordovaInAppBrowser.open(url, '_system');
      }
    };

    /**
     * @method setIssueResolved
     * @param {Boolean} resolved
     */
    vm.setIssueResolved = function (resolved) {
      var element = $element[0],
        ionFooterBar = element.querySelector('ion-footer-bar');
      vm.issueResolved = Boolean(resolved);

      if (resolved) {
        $animate.addClass(ionFooterBar, fadeOutCls).then(vm.refreshScrollDelegate);
      } else {
        vm.supportRouter.goTo('supportRequestForm', { reason: 'other' });
      }
    };

    $rootScope.$on('$restaurantSupportLaunch', vm.launch);
    $rootScope.$on('$includeContentLoaded', vm.refreshScrollDelegate);

    $scope.$watch('$ctrl.supportRouter.current', function () {
      vm.hasFooter = supportRouter.isCurrentFooterState();
      vm.issueResolved = false;

      if (vm.hasFooter) {
        $timeout(vm.refreshScrollDelegate, 500);
      }
    });
  }

  angular.module('zoomerRestaurant.support')
    .controller('SupportDashboardCtrl', SupportDashboardCtrl);

}());

(function () {
  'use strict';

  var tpl = '<img class="support-character" ng-src="assets/images/support/character{{$ctrl.number}}@2x.png"' +
    ' ng-srcset="assets/images/support/character{{$ctrl.number}}@3x.png 3x" alt="" />';

  /** @ngInject */
  function controller($animate, $element) {
    var vm = this,
      img = $element.find('img');

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      vm.number = (Math.floor(Math.random() * 3) + 1);
    };

    /**
     * @method $postLink
     */
    vm.$postLink = function () {
      $animate.addClass(img, 'scale-in');
    };
  }

  angular.module('zoomerRestaurant.support')
    .component('supportRequestCharacter', {
      controller: controller,
      template: tpl
    });
}());

(function () {
  'use strict';

  var HOME_STATE = 'home',
    HELP_DOC_STATE = 'helpDoc',
    REQUEST_SENT_STATE = 'supportRequestSent',
    STATES_WITH_FOOTER = [
      HELP_DOC_STATE,
      'supportRequestForm'
    ],
    STATES_WITH_NO_FOOTER = [
      'help',
      'drivers',
      'editOrder',
      'itemMissing',
      'editAddress',
      'priceAdjustment',
      REQUEST_SENT_STATE
    ],
    states = ([ HOME_STATE ]).concat(STATES_WITH_FOOTER, STATES_WITH_NO_FOOTER);

  function setState(key, params) {
    return Object.assign({}, { key: key || HOME_STATE }, params);
  }

  /** @ngInject */
  function supportRouter() {
    return {
      states: states,
      current: setState(HOME_STATE),
      cache: [],

      /**
       * @method is
       * @param {String} state
       * @return {Boolean}
       */
      is: function (state) {
        return this.current.key === state;
      },

      /**
       * @method isIssueResolvedState
       * @return {Boolean}
       */
      isIssueResolvedState: function () {
        var current = this.current || {};
        return [ HELP_DOC_STATE ].indexOf(current.key) > -1;
      },

      /**
       * @method isCurrentFooterState
       * @return {Boolean}
       */
      isCurrentFooterState: function () {
        var current = this.current || {};
        return STATES_WITH_FOOTER.indexOf(current.key) > -1;
      },

      /**
       * @method goToLastState
       */
      goToLastState: function () {
        var length = this.cache.length,
          newState;

        if (!length) {
          return;
        }

        newState = this.cache[length - 1];
        this.cache.pop();
        this.current = newState;
      },

      /**
       * @method goTo
       * @param {String} newState
       * @param {Object} params
       */
      goTo: function (newState, params) {
        newState = newState || HOME_STATE;

        if (states.indexOf(newState) === -1) {
          return;
        }

        if (newState === HOME_STATE || newState === REQUEST_SENT_STATE) {
          this.cache = [];
        } else {
          this.cache.push(this.current);
        }
        this.current = setState(newState, params);
      },

      /**
       * @method getCurrentTpl
       * @return {String}
       */
      getCurrentTpl: function () {
        return 'app/support/states/' + this.current.key + '.html';
      }
    };
  }

  angular.module('zoomerRestaurant.support')
    .factory('supportRouter', supportRouter);

}());

(function () {
  'use strict';

  /** @ngInject */
  function announcementsModal($ionicModal, $rootScope, announcements) {
    var url = 'app/components/announcementsModal/announcementsModal.html',
      promise;

    function show() {
      return promise.then(function (m) {
        m.show();
      });
    }

    return {
      isOpen: false,

      /**
       * @method getParams
       * @return {Object}
       */
      getParams: function () {
        var scope = $rootScope.$new();
        scope.announcements = announcements;
        scope.announcementsModal = this;

        return {
          backdropClickToClose: false,
          scope: scope
        };
      },

      /**
       * @method show
       */
      show: function () {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        if (promise) {
          return show();
        }

        promise = $ionicModal.fromTemplateUrl(url, this.getParams());
        return show();
      },

      /**
       * @method hide
       */
      hide: function () {
        this.isOpen = false;
        if (!promise) {
          return;
        }

        promise.then(function (m) {
          m.hide();
        });
      }
    };
  }

  angular.module('zoomerRestaurant.ordersQueue')
    .factory('announcementsModal', announcementsModal);

}());

(function () {
  'use strict';

  /** @ngInject */
  function confirmOrderRbtPopup($rootScope, $q, Modals, zIonicPopup) {
    var url = 'app/components/confirmOrderRbtPopup/confirmOrderRbtPopup.html';

    return {
      cache: [],

      /**
       * @method getParams
       * @param {Object} order
       * @return {Object}
       */
      getParams: function (order) {
        var params = angular.extend({ templateUrl: url }, Modals.CONFIRM_READY_BY_TIME),
          scope = $rootScope.$new(),
          now = new Date().getTime(),
          readyByTime = new Date(order.ready_by_time).getTime();

        scope.order = order;
        scope.minutesFromNow = Math.round((readyByTime - now) / 60000);
        params.scope = scope;
        return params;
      },

      /**
       * @method show
       * @param {Object} order
       * @return {Object} $promise
       */
      show: function (order) {
        var self = this,
          params;
        order = order || {};

        if (this.cache.indexOf(order.id) > -1) {
          return $q.reject();
        }

        params = this.getParams(order);
        this.cache.push(order.id);
        return zIonicPopup.confirm(params).finally(function () {
          self.cache = self.cache.filter(function (c) { return c !== order.id; });
          params.scope.$destroy();
        });
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('confirmOrderRbtPopup', confirmOrderRbtPopup);

}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').controller('CustomerInformationCtrl', [
    '$ionicScrollDelegate', '$scope', '$stateParams', 'Buildings', 'Diners', 'DeliveryZones',
    function ($ionicScrollDelegate, $scope, $stateParams, Buildings, Diners, DeliveryZones) {
      var self = this,
        nextPagePromise;

      Diners.reset();

      this.addressType = '';
      this.title = null;
      this.buildings = Buildings;
      this.diners = Diners;
      this.manual = false;
      this.selectedAddress = null;
      this.loadingBuilding = false;
      this.validating = false;

      /**
       * @method isLoading
       * @return {Boolean}
       */
      this.isLoading = function () {
        return this.validating || this.loadingBuilding;
      };

      /**
       */
      this.onComplete = function () {
        $ionicScrollDelegate.resize();
        $scope.$broadcast('scroll.infiniteScrollComplete');
      };

      /**
       * @method parseDinerError
       * @param {Object} error
       */
      this.parseDinerError = function (error) {
        error = error || {};
        var data = error.data || {};
        this.setDoNotDeliver(data.error === 'diner_do_not_deliver');
      };

      /**
       * Figure out what 'next page' to fetch
       */
      this.nextPage = function () {
        if (!this.manual) {
          Diners.getNextPage().then(angular.noop, this.parseDinerError.bind(this)).finally(this.onComplete);
        }
      };

      /**
       * @method setDoNotDeliver
       * @param {Boolean} doNotDeliver
       */
      this.setDoNotDeliver = function (doNotDeliver) {
        doNotDeliver = !!doNotDeliver;
        $scope.order.address = $scope.order.address || {};
        $scope.order.address.do_not_deliver = doNotDeliver;
      };

      /**
       * @method setDeliveryZoneStatus
       * @param {Object} deliveryZoneStatus
       */
      this.setDeliveryZoneStatus = function (deliveryZoneStatus) {
        if (deliveryZoneStatus) {
          $scope.deliveryZoneStatus = deliveryZoneStatus;
          $scope.$emit('$orderDeliveryZoneStatusUpdated', deliveryZoneStatus);
        }
      };

      /**
       * Set the selected Address to the following saved one
       *
       * @param {Object} address
       * @param {Boolean} manual
       */
      this.setAddress = function (address, manual) {
        if (!address || this.validating) {
          return;
        }

        this.manual = !!manual;
        this.selectedAddress = address;
        this.validating = true;

        DeliveryZones.check(address.id).then(this.setDeliveryZoneStatus).finally(function () {
          $scope.order.address = {
            address_1: address.address_1,
            address_2: address.address_2,
            city: address.city,
            do_not_deliver: !!address.do_not_deliver,
            state_province_region: address.state_province_region,
            latitude: address.latitude,
            longitude: address.longitude
          };
          self.validating = false;
        });
      };

      /**
       * Set selected building, removing any existing address selection
       *
       * @param {Object} building
       */
      this.setBuilding = function (building) {
        building = building || {};
        var addressId = building.address_id;
        if (!addressId || self.loadingBuilding || self.validating) {
          return;
        }

        if ($scope.order.address) {
          $scope.order.address = null;
        }

        this.loadingBuilding = true;
        building.loading = true;
        Buildings.getAddress(addressId).then(function (response) {
          self.setAddress(response.data, true);
        }).finally(function () {
          self.loadingBuilding = false;
          building.loading = false;
        });
      };

      /**
       * @method setDiner
       */
      this.setDiner = function () {
        var diners = Diners.all,
          length = diners.length;

        self.manual = !length;
        if (length === 1 && !$scope.isEdit) {
          return self.setAddress(diners[0]);
        }

        if (length === 0 && !Buildings.all.length) {
          this.setAddressType('address');
        }
        self.setDoNotDeliver(false);
      };

      /**
       * If no existing diner address found, revert to ByBuilding/ByAddress
       */
      this.setNewAddress = function () {
        this.manual = true;
        this.selectedAddress = null;
        this.addressType = Buildings.all.length ? '' : 'address';

        if ($scope.order.address) {
          $scope.order.address = {};
        }
        $ionicScrollDelegate.scrollTop();
      };

      /**
       * Set the address type user wishes to go by
       *
       * @param {String} type
       */
      this.setAddressType = function (type) {
        if (this.loadingBuilding || this.validating) {
          return;
        }

        this.addressType = type;

        if (type === 'building') {
          Buildings.getAll();
        }
      };

      /**
       * @method getDiners
       * @param {Object} params
       */
      this.getDiners = function (params) {
        this.manual = false;
        this.setAddressType('');

        Buildings.getAll();
        Diners.init(params).then(this.setDiner.bind(this), this.parseDinerError.bind(this)).finally(this.onComplete);
      };

      /**
       * @method $onInit
       */
      this.$onInit = function () {
        var isEdit = $scope.isEdit,
          isOrderDataPresent = isEdit || $stateParams.cached;

        if (!$scope.order.diner) {
          $scope.order.diner = {};
        }

        this.addressType = isOrderDataPresent ? 'address' : '';
        this.manual = isOrderDataPresent;
        this.title = (isEdit ? 'Edit' : 'Add') + ' Address';
        Buildings.getAll();
      };

      /**
       * @method $onDestroy
       */
      this.$onDestroy = function () {
        nextPagePromise();
      };

      nextPagePromise = $scope.$on('$editOrderNextPage', function () {
        self.nextPage();
      });

    }
  ]);
}());

(function () {
  'use strict';
  angular.module('zoomerRestaurant').directive('customerInformation', [
    function () {
      return {
        controller: 'CustomerInformationCtrl as $ctrl',
        replace: true,
        templateUrl: 'app/components/customerInformation/customerInformation.html'
      };
    }
  ]);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('dinerAddressItem', {
      bindings: {
        diner: '<',
        selectedAddress: '<'
      },
      bindToController: true,
      controller: 'DinerAddressItemCtrl',
      templateUrl: 'app/components/customerInformation/dinerAddressItem.html'
    });

}());

(function () {
  'use strict';

  var CUT_OFF_AT = 50,
    ELLIPSIS = ' ...';

  /** @ngInject */
  function DinerAddressItemCtrl() {
    var vm = this;

    vm.truncated = false;
    vm.isSelectedDiner = false;
    vm.fullAddress = '';

    /**
     * @method setFullAddress
     */
    vm.setFullAddress = function () {
      var diner = vm.diner || {},
        address1 = diner.address_1,
        address2 = diner.address_2;

      vm.fullAddress = address1 + (address2 ? (', ' + address2) : '');
    };

    /**
     * @method setTruncated
     */
    vm.setTruncated = function () {
      vm.truncated = !vm.isSelectedDiner && vm.fullAddress.length > (CUT_OFF_AT - ELLIPSIS.length);
      if (vm.truncated) {
        vm.fullAddress = vm.fullAddress.substr(0, CUT_OFF_AT) + ELLIPSIS;
      }
    };

    /**
     * @method setIsSelected
     */
    vm.setIsSelectedDiner = function () {
      var selectedAddress = vm.selectedAddress || {},
        diner = vm.diner || {};

      vm.isSelectedDiner = selectedAddress.id === diner.id;
    };

    /**
     * @method expand
     */
    vm.expand = function () {
      vm.truncated = false;
      vm.setFullAddress();
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      vm.setFullAddress();
      vm.setTruncated();
    };

    vm.$onChanges = function () {
      vm.setIsSelectedDiner();
      vm.setTruncated();
    };

  }

  angular.module('zoomerRestaurant')
    .controller('DinerAddressItemCtrl', DinerAddressItemCtrl);

}());

(function () {
  'use strict';
  var ORDER_MINUTES_MINIMUM = 60;

  /** @ngInject */
  function deliverAtInputValidator(Utilities) {

    /** @ngInject */
    function DeliverAtInputValidatorCtrl($scope) {
      var vm = this;

      function getDeliverAtDate(modelValue, viewValue) {
        var deliverAt = modelValue || viewValue;
        if (!deliverAt) {
          return;
        }

        return new Date(deliverAt);
      }

      /**
       * @method getOrder
       * @return {Object}
       */
      vm.getOrder = function () {
        var $ctrl = $scope.$ctrl || {};
        return $ctrl.order || {};
      };

      /**
       * @method
       * @param {String|Date} deliverAtDate
       * @return {Date}
       */
      vm.formatDeliverAtDate = function (deliverAtDate) {
        if (!deliverAtDate) {
          return null;
        }

        deliverAtDate = new Date(deliverAtDate);
        var year = deliverAtDate.getFullYear(),
          month = deliverAtDate.getMonth(),
          date = deliverAtDate.getDate(),
          hours = deliverAtDate.getHours(),
          minutes = deliverAtDate.getMinutes();

        return new Date(year, month, date, hours, minutes);
      };

      /**
       * @method invalidDate
       * @param {Date} modelValue
       * @param {Date} viewValue
       * @return {Boolean}
       */
      vm.invalidDate = function (modelValue, viewValue) {
        var deliverAt = getDeliverAtDate(modelValue, viewValue);

        if (!deliverAt) {
          return true;
        }

        return Utilities.time.getMinutesDifference(deliverAt) > 0;
      };

      /**
       * @method tooSoonToDeliver
       * @param {Date} modelValue
       * @param {Date} viewValue
       * @return {Boolean}
       */
      vm.tooSoonToDeliver = function (modelValue, viewValue) {
        var deliverAt = getDeliverAtDate(modelValue, viewValue);

        if (!deliverAt) {
          return true;
        }

        return Utilities.time.getMinutesDifference(deliverAt) > ORDER_MINUTES_MINIMUM;
      };
    }

    function link(scope, element, attributes, ngModel) {
      var controller = scope.DeliverAtInputValidatorCtrl;

      ngModel.$formatters.push(controller.formatDeliverAtDate);

      ngModel.$validators.invalidDate = controller.invalidDate;
      ngModel.$validators.tooSoonToDeliver = controller.tooSoonToDeliver;
    }

    return {
      controller: DeliverAtInputValidatorCtrl,
      controllerAs: 'DeliverAtInputValidatorCtrl',
      link: link,
      require: '^ngModel'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('deliverAtInputValidator', deliverAtInputValidator);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('assignedDriver', {
      bindings: {
        driver: '<'
      },
      templateUrl: 'app/components/assignedDriver/assignedDriver.html'
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function addressTwo() {
    function link(scope, element, attributes, ngModel) {
      var listeners = ngModel.$viewChangeListeners || [];
      listeners.push(scope.$ctrl.$setDirty);
    }

    return {
      link: link,
      require: '^ngModel'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('addressTwo', addressTwo);

}());

(function () {
  'use strict';

  /** @ngInject */
  function DinerAddressCtrl($scope) {
    var vm = this;

    vm.showAddressTwoWarning = true;
    vm.$dirty = false;

    /**
     * @method getAddressTwoLength
     * @return {String}
     */
    vm.getAddressTwoCls = function () {
      var address2 = ($scope.address || {}).address_2 || '',
        length = address2.replace(/\s+/g, '').length;

      return (vm.$dirty && vm.showAddressTwoWarning && length > 20) ? 'show-warning' : '';
    };

    /**
     * @method disableAddressTwoWarning
     */
    vm.disableAddressTwoWarning = function () {
      vm.showAddressTwoWarning = false;
    };

    /**
     * @method setAsSpecialNote
     */
    vm.setAsDeliveryNotes = function () {
      $scope.$emit('$setOrderDeliveryNotes', $scope.address.address_2);
      $scope.address.address_2 = '';
    };

    /**
     * @method $setDirty
     */
    vm.$setDirty = function () {
      vm.$dirty = true;
    };
  }

  angular.module('zoomerRestaurant')
    .controller('DinerAddressCtrl', DinerAddressCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function dinerAddress() {
    return {
      controller: 'DinerAddressCtrl as $ctrl',
      scope: {
        address: '=',
        onDeliveryZoneUpdate: '&'
      },
      templateUrl: 'app/components/dinerAddress/dinerAddress.html'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('dinerAddress', dinerAddress);

}());

(function () {
  'use strict';

  /** @ngInject */
  function DinerAddressLookupCtrl($rootScope, $scope, $timeout, DeliveryZones, AutoComplete, Restaurant, autoCompleteModalBar, confirmStreetNumber) {
    var vm = this,
      placeholder = 'Street address',
      destroyPromise,
      orderWatchPromise;

    vm.autoComplete = AutoComplete;
    vm.autoCompleteModalBar = autoCompleteModalBar;
    vm.isMobileDevice = $rootScope.isMobileDevice;
    vm.placeholder = placeholder;
    vm.isPlaceholder = true;
    vm.loading = true;
    vm.validating = false;
    vm.streetNumberConfirmed = true;
    vm.restaurant = Restaurant;
    vm.showConfirmStreetNumber = false;
    vm.street = null;
    vm.multipleLocations = [];
    vm.modelOptions = {
      updateOn: 'default blur',
      debounce: {
        default: 600,
        blur: 0
      }
    };

    /**
     * @method validatePlace
     * @param {Object} place
     */
    vm.validatePlace = function (place) {
      vm.validating = true;
      vm.multipleLocations = [];
      autoCompleteModalBar.remove();
      DeliveryZones.check(place.coordinates).then(function (deliveryZoneStatus) {
        vm.onDeliveryZoneUpdate({ deliveryZoneStatus: deliveryZoneStatus });
      }).finally(function () {
        vm.setOrderAddress(place);
        vm.validating = false;
      });
    };

    /**
     * @method onComplete
     * @param {Object} place
     * @param {Array} multipleLocations
     */
    vm.onComplete = function (place, multipleLocations) {
      vm.validatePlace(place);
      vm.multipleLocations = multipleLocations || [];
    };

    /**
     * @method setOrderAddress
     * @param {Object} selected
     */
    vm.setOrderAddress = function (selected) {
      var components = selected.address_components,
        streetNumber = components.street_number,
        route = components.route,
        coordinates = selected.coordinates;

      vm.address = {
        address_2: '',
        city: components.locality || components.sublocality_level_1,
        state_province_region: components.administrative_area_level_1,
        postal_code: components.postal_code,
        latitude: coordinates.lat,
        longitude: coordinates.lon
      };

      vm.streetNumberConfirmed = Boolean(streetNumber);

      if (streetNumber) {
        vm.showConfirmStreetNumber = false;
        streetNumber = streetNumber ? (streetNumber + ' ' + route) : route;
        vm.address.address_1 = streetNumber ? (streetNumber  + '.') : '';
      } else {
        vm.address.address_1 = selected.getRawStreetName();
        confirmStreetNumber.show({ scope: $scope });
      }

      vm.loading = true;
      $timeout(vm.setStreet, 200);
    };

    /**
     * @method setStreet
     */
    vm.setStreet = function () {
      var address = vm.address || {};

      vm.street = address.address_1 || '';
      vm.loading = false;
      vm.placeholder = address.address_1 || placeholder;
      vm.isPlaceholder = vm.placeholder === placeholder;

      vm.streetNumberConfirmed = Boolean(address.address_1);
    };

    /**
     * @method setConfirmNoStreetNumber
     */
    vm.setConfirmNoStreetNumber = function () {
      vm.showConfirmStreetNumber = true;
      vm.streetNumberConfirmed = false;

      confirmStreetNumber.hide();
    };

    orderWatchPromise = $scope.$watch('dinerAddressLookupVm.address', vm.setStreet);

    destroyPromise = $scope.$on('$destroy', function () {
      destroyPromise();
      orderWatchPromise();
      autoCompleteModalBar.remove();
    });
  }

  angular.module('zoomerRestaurant')
    .controller('DinerAddressLookupCtrl', DinerAddressLookupCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function dinerAddressLookup() {
    return {
      bindToController: true,
      controller: 'DinerAddressLookupCtrl as dinerAddressLookupVm',
      scope: {
        onDeliveryZoneUpdate: '&',
        isEmailOrder: '=',
        address: '='
      },
      templateUrl: 'app/components/dinerAddressLookup/dinerAddressLookup.html'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('dinerAddressLookup', dinerAddressLookup);

}());

(function () {
  'use strict';

  /** @ngInject */
  function DinerTelephoneCtrl($scope, $rootScope, $ionicClickBlock, Restaurant, Utilities, ExternalOrders, PhoneUtils, numberKeypad, externalOrdersModal, pendingOrders) {
    var vm = this,
      keypad,
      onPromise,
      destroyPromise;

    vm.isKeypadActive = false;
    vm.isPossibleNumber = false;
    vm.isValidNumber = false;

    /**
     * @method showKeypad
     * @param {Object} e
     */
    vm.showKeypad = function (e) {
      if (!$rootScope.isMobileDevice) {
        return;
      }
      vm.isKeypadActive = true;
      $scope.initiaKeypadValue = vm.phoneNumber;

      if (keypad) {
        return keypad.show(e);
      }

      numberKeypad.get({ scope: $scope }).then(function (popover) {
        keypad = popover;
        keypad.show(e);
      });
    };

    /**
     * @method hideKeypad
     */
    vm.hideKeypad = function () {
      vm.isKeypadActive = false;
      if (keypad) {
        keypad.hide();
      }
    };

    /**
     * @method getAddresses
     */
    vm.getAddresses = function () {
      var params,
        restaurant = Restaurant.info || {};

      vm.hideKeypad();
      if (!vm.isValidNumber || !vm.phoneNumber || !restaurant.territory_id) {
        return;
      }

      params = {
        phone_number: Utilities.number.stripFormatting(vm.phoneNumber),
        territory: restaurant.territory_id
      };

      if (vm.onValidNumber) { // Already coerced to boolean - no need to '!!' see http://eslint.org/docs/2.0.0/rules/no-extra-boolean-cast
        vm.onValidNumber({ params: params });
      }
    };

    /**
     * @method findExistingOrders
     */
    vm.findExistingOrders = function () {
      if (externalOrdersModal.isOpen) {
        return pendingOrders.findByPhoneNumber(vm.phoneNumber);
      }

      return ExternalOrders.findByPhoneNumber(vm.phoneNumber);
    };

    /**
     * @method updateKeypadValue
     * @param {String} phoneNumber
     */
    $scope.updateKeypadValue = function (phoneNumber) {
      var parent = $scope.$parent,
        form = parent.orderForm,
        externalOrders,
        valid;

      vm.phoneNumber = Utilities.number.stripFormatting(phoneNumber);
      if (!vm.phoneNumber || vm.phoneNumber.length < 10 || (vm.phoneNumber.length < 11 && vm.phoneNumber.charAt(0) === '1')) {
        return form.phoneNumber.$setValidity('phoneNumber', true);
      }

      try {
        valid = PhoneUtils.isValidNumber(phoneNumber || '');
      } catch (e) {
        valid = false;
      }

      form.phoneNumber.$setDirty();
      form.phoneNumber.$setValidity('phoneNumber', valid);
      vm.isValidNumber = valid;

      externalOrders = vm.findExistingOrders();
      $rootScope.$emit('$emailOrderAlreadyExists', externalOrders);

      if (!externalOrders.length && valid && !vm.isEdit) {
        vm.getAddresses();
      }
    };

    onPromise = $scope.$on('popover.hidden', function () {
      vm.isKeypadActive = false;
      $ionicClickBlock.show();
    });

    destroyPromise = $scope.$on('$destroy', function () {
      destroyPromise();
      onPromise();
      if (keypad) {
        keypad.hide();
      }
    });
  }

  angular.module('zoomerRestaurant')
    .controller('DinerTelephoneCtrl', DinerTelephoneCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function dinerTelephoneInput(PhoneUtils) {
    return {
      require: '^ngModel',
      link: function (scope, element, attr, ngModel) {
        ngModel.$validators.validPhoneNumber = function (modelValue, viewValue) {
          var value = modelValue || viewValue || '',
            isValidPhoneNumber;

          try {
            isValidPhoneNumber = PhoneUtils.isValidNumber(value || '');
          } catch (e) {
            isValidPhoneNumber = false;
          }

          return isValidPhoneNumber;
        };
      }
    };
  }

  angular.module('zoomerRestaurant')
    .directive('dinerTelephoneInput', dinerTelephoneInput);

  /** @ngInject */
  function dinerTelephone() {
    return {
      bindToController: true,
      controller: 'DinerTelephoneCtrl as dinerTelephoneVm',
      scope: {
        phoneNumber: '=',
        onValidNumber: '&',
        isEdit: '='
      },
      templateUrl: 'app/components/dinerTelephone/dinerTelephone.html'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('dinerTelephone', dinerTelephone);

}());

(function () {
  'use strict';

  /** @ngInject */
  function doNotDeliverInput() {
    return {
      require: '^ngModel',
      link: function (scope, element, attributes, ngModel) {
        ngModel.$validators.canDeliverToDiner = function (doNotDeliver) {
          return !doNotDeliver;
        };
      }
    };
  }

  angular.module('zoomerRestaurant')
    .directive('doNotDeliverInput', doNotDeliverInput);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('existingOrderFooter', {
      bindings: {
        order: '<'
      },
      bindToController: true,
      controller: 'ExistingOrderFooterCtrl',
      templateUrl: 'app/components/existingOrderFooter/existingOrderFooter.html'
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function ExistingOrderFooterCtrl($filter, $ionicModal, $rootScope, $scope, $state, $timeout, Config, ExternalOrders, Utilities) {
    var vm = this,
      externalOrdersPromise,
      externalOrderSubmittedPromise,
      existingExternalOrderPromise,
      timeout,
      modal;

    vm.existingExternalOrders = [];
    vm.externalOrders = ExternalOrders;
    vm.sources = [];
    vm.contentBounds = {};
    vm.scrollTop = 0;

    /**
     * @method onModalContentScroll
     * @param {Number} scrollTop
     * @param {Object} contentBounds
     */
    vm.onModalContentScroll = function (scrollTop, contentBounds) {
      if (timeout) {
        $timeout.cancel(timeout);
      }

      timeout = $timeout(function () {
        vm.scrollTop = Math.floor(scrollTop);
        vm.contentBounds = contentBounds;
        timeout = undefined;
      }, 20);
    };

    /**
     * Show the existing email-order modal
     */
    vm.showModal = function () {
      if (!vm.existingExternalOrders.length) {
        return;
      }

      if (modal) {
        return modal.show();
      }

      $ionicModal.fromTemplateUrl('app/views/modals/existing-order.html', {
        scope: $scope
      }).then(function (m) {
        modal = m;
        modal.show();
      });
    };

    /**
     * @method closeModal
     */
    vm.closeModal = function () {
      if (!modal) {
        return;
      }

      modal.hide().finally(function () {
        modal.remove();
        modal = null;
      });
    };

    /**
     * @method closeAndReturnToQueue
     */
    vm.closeAndReturnToQueue = function () {
      $state.go(Config.ROOT_LOGGED_IN_STATE);
      vm.closeModal();
    };

    /**
     * @method getOrderPhoneNumber
     * @return {String}
     */
    vm.getOrderPhoneNumber = function () {
      var order = vm.order || {},
        diner = order.diner || {};

      return diner.phone_number;
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      if(existingExternalOrderPromise) {
        existingExternalOrderPromise();
      }

      if(externalOrderSubmittedPromise) {
        externalOrderSubmittedPromise();
      }

      if(externalOrdersPromise) {
        externalOrdersPromise();
      }
    };

    existingExternalOrderPromise = $rootScope.$on('$emailOrderAlreadyExists', function (e, existingExternalOrders) {
      vm.existingExternalOrders = existingExternalOrders;
      vm.sources = $filter('getExternalSources')(existingExternalOrders);
    });

    externalOrderSubmittedPromise = $rootScope.$on('$emailOrderSubmitted', function (e, externalOrder) {
      var phoneNumber = vm.getOrderPhoneNumber();

      if (Utilities.number.arePhoneNumbersEqual(phoneNumber, externalOrder.diner_phone_number)) {
        vm.closeAndReturnToQueue();
      }
    });

    externalOrdersPromise = $rootScope.$watch('externalOrders.all', function () {
      var phoneNumber = vm.getOrderPhoneNumber();
      if (!phoneNumber) {
        return;
      }

      vm.existingExternalOrders = ExternalOrders.findByPhoneNumber(phoneNumber);
      vm.sources = $filter('getExternalSources')(vm.existingExternalOrders);
      if (!vm.existingExternalOrders.length) {
        vm.closeModal();
      }
    });
  }

  angular.module('zoomerRestaurant')
    .controller('ExistingOrderFooterCtrl', ExistingOrderFooterCtrl);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('externalOrderHtml', {
      bindings: {
        externalOrderId: '@'
      },
      bindToController: true,
      controller: 'ExternalOrderHtmlCtrl',
      templateUrl: 'app/components/externalOrderHtml/externalOrderHtml.html'
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function ExternalOrderHtmlCtrl(ExternalOrders) {
    var vm = this;

    vm.loading = false;
    vm.error = false;
    vm.emailOrder = null;

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      var id = vm.externalOrderId,
        extra = { ignore_iframe_in_html: true };

      vm.error = false;
      vm.loading = true;
      ExternalOrders.get(id, extra).then(function (response) {
        vm.emailOrder = response.data;
      }, function () {
        vm.error = true;
      }).finally(function () {
        vm.loading = false;
      });
    };

  }

  angular.module('zoomerRestaurant')
    .controller('ExternalOrderHtmlCtrl', ExternalOrderHtmlCtrl);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('externalOrderIframe', {
      bindings: {
        html: '<'
      },
      bindToController: true,
      controller: 'ExternalOrderIframeCtrl',
      templateUrl: 'app/components/externalOrderHtml/externalOrderIframe.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function ExternalOrderIframeCtrl($element, $ionicScrollDelegate, $rootScope, $sce, $scope, $timeout, $window) {
    var vm = this,
      acceleration = 10,
      timeout,
      scrollTarget,
      destroyPromise;

    function getFrameBody() {
      var frame = vm.iframe || {},
        win = frame.contentWindow || {},
        doc = win.document || {};
      return doc.body;
    }

    /**
     * @method refresh
     */
    function refresh() {
      vm.iframe = $element.find('iframe')[0];
      if(vm.iframe) {
        vm.iframe.style.height = '800px';
      }
      vm.setElementCss();
      vm.injectOrderDetailsToFrame();
    }


    vm.iframe = null;
    vm.iFrameWidth = 0;
    vm.iFrameHeight = 0;
    vm.offsetLeft = 0;
    vm.isIframeCssApplied = false;
    vm.$onInit = refresh;
    vm.$onChanges = refresh;

    /**
     * @method onDrag
     * @param {Object} e
     */
    vm.onDrag = function (e) {
      e = e || {};
      var containerWidth = $element[0].clientWidth,
        direction = e.type,
        gesture = e.gesture || {},
        velocityX = gesture.velocityX,
        iFrameWidth = Number(vm.iFrameWidth);

      if (!$rootScope.isMobileDevice || containerWidth >= iFrameWidth) {
        return false;
      }

      if (!scrollTarget) {
        scrollTarget = angular.element(e.target);
      }

      if (direction === 'dragleft' && (containerWidth + vm.offsetLeft) <= iFrameWidth) {
        vm.offsetLeft += (velocityX * acceleration);
      } else if (direction === 'dragright' && vm.offsetLeft >= 0) {
        vm.offsetLeft -= (velocityX * acceleration);
      }

      vm.updateScrollOffset();
    };

    /**
     * @method updateScrollOffset
     */
    vm.updateScrollOffset = function () {
      var translate = 'translate3d(-' + vm.offsetLeft + 'px, 0, 0)';
      $window.requestAnimationFrame(function () {
        scrollTarget.css({
          '-webkit-transform': translate
        });
      });
    };

    /**
     * @method injectToFrame
     */
    vm.injectOrderDetailsToFrame = function () {
      var doc,
        html;
      if (!vm.iframe || !vm.html) {
        return;
      }

      html = $sce.trustAsHtml(vm.html || '');
      doc = vm.iframe.contentWindow.document;
      doc.open('text/html', 'replace');
      doc.write(html.toString());
      doc.close();
    };

    /**
     * @method setElementCss
     */
    vm.setElementCss = function () {
      if (!$rootScope.isMobileDevice) {
        $element.addClass('is-desktop');
      }
      $element.addClass('external-order-iframe-wrapper');
      $element.css({ display: 'block' });
    };

    /**
     * @method setBodyCss
     */
    vm.overrideFrameBodyCss = function () {
      if (vm.isIframeCssApplied) {
        return;
      }

      var body = getFrameBody(),
        style = document.createElement('style'),
        css = '* { pointer-events: none; cursor: default; user-select: none; -ms-user-select: none; }';

      if (!body) {
        return;
      }
      vm.isIframeCssApplied = true;
      style.appendChild(document.createTextNode(css));
      body.appendChild(style);
    };

    /**
     * @method refreshAllScrollDelegates
     */
    vm.refreshAllScrollDelegates = function () {
      if (timeout) {
        $timeout.cancel(timeout);
      }

      timeout = $timeout(function () {
        var instances = $ionicScrollDelegate._instances || [];
        instances.forEach(function (delegateHandle) {
          delegateHandle.resize();
        });
      }, 500);
    };


    destroyPromise = $scope.$on('$destroy', function () {
      destroyPromise();
    });
  }

  angular.module('zoomerRestaurant')
    .controller('ExternalOrderIframeCtrl', ExternalOrderIframeCtrl);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('foodReadyNowButton', {
      bindings: {
        existingRbt: '<',
        order: '<',
        onComplete: '&'
      },
      controller: 'FoodReadyNowButtonCtrl',
      templateUrl: 'app/components/foodReadyNowButton/foodReadyNowButton.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function FoodReadyNowButtonCtrl($scope, Features, confirmFoodReadyNow, foodReady, readyByTimes) {
    var vm = this,
      readyByTimePromise;

    vm.features = Features;
    vm.isFoodReadyNowEnabled = true;

    /**
     * @method isFRNEnabled
     * @return {Boolean}
     */
    vm.isFRNEnabled = function () {
      var rbt,
        now;

      if (readyByTimes.isFloorEnabledForRestaurant() || !vm.existingRbt || !vm.isFoodReadyNowEnabled) {
        return;
      }

      rbt = new Date(vm.existingRbt).getTime();
      now = new Date().getTime();

      return rbt - now > 0;
    };


    /**
     * @method isSelected
     * @return {String}
     */
    vm.isFoodReadyNowSelected = function () {
      return vm.isFoodReadyNow() ? 'selected' : '';
    };

    /**
     * @method isFoodReadyNow
     * @return {Boolean}
     */
    vm.isFoodReadyNow = function () {
      var order = vm.order || {};
      return Boolean(order.food_ready_now);
    };

    /**
     * @method setFoodReadyNow
     */
    vm.setFoodReadyNow = function () {
      var order = vm.order,
        foodReadyNow = vm.isFoodReadyNow();

      if (foodReadyNow) {
        return;
      }

      confirmFoodReadyNow.show().then(function (confirmed) {
        if (confirmed) {
          foodReady.toggle(order.id, true).then(function () {
            order.food_ready_now = true;
            vm.onComplete();
          });
        }
      });
    };

    /**
     * @method unsetFoodReadyNow
     * @param {Date} readyByTime
     */
    vm.unsetFoodReadyNow = function (readyByTime) {
      var order = vm.order,
        isFoodReadyNow = vm.isFoodReadyNow();

      if (!isFoodReadyNow || !readyByTime || readyByTime === vm.existingRbt) {
        return false;
      }

      foodReady.toggle(order.id, false).then(function () {
        order.food_ready_now = null;
      });
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      readyByTimePromise();
    };

    readyByTimePromise = $scope.$watch('$ctrl.order.ready_by_time', vm.unsetFoodReadyNow);
  }

  angular.module('zoomerRestaurant')
    .controller('FoodReadyNowButtonCtrl', FoodReadyNowButtonCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function ExternalOrdersModalCtrl($ionicLoading, $rootScope, $scope, $timeout, ExternalOrders, Modals, deviceNotifications, externalOrdersModal, pendingOrders, zIonicPopup, Features) {
    var vm = this,
      ordersGroup = [ 'externalOrdersModalVm.pendingOrders.$all', 'externalOrdersModalVm.externalOrders.all'],
      watchPromise,
      watchGroupPromise,
      timeout,
      destroyPromise;

    vm.pendingOrders = pendingOrders;
    vm.externalOrders = ExternalOrders;
    vm.loading = false;
    vm.contentBounds = {};
    vm.scrollTop = 0;
    vm.tempPausedCount = 0; 
    vm.hasGhostKitchens = $rootScope.hasGhostKitchens;
    vm.restaurantArray = $rootScope.restaurantArray;

    /**
     * If applicable, get the next Paginated page
     */
    vm.nextPage = function () {
      var scroller = ExternalOrders.scroller;
      if (!scroller.hasNextPage()) {
        return;
      }

      scroller.setUpdating(true);
      vm.update(scroller.getNextPage());
    };

    /**
     * Pagination callback to update Collection from server
     *
     * @param {Number} page
     */
    vm.update = function (page) {
      vm.loading = true;
      ExternalOrders.getAll(page).finally(function () {
        $scope.$broadcast('scroll.infiniteScrollComplete');
      }).finally(function () {
        vm.loading = false;
      });
    };

    /**
     * Iterate across external orders and find any matching in Orders queue
     */
    vm.mapExistingOrders = function () {
      angular.forEach(ExternalOrders.all, function (externalOrder) {
        externalOrder.existingOrders = pendingOrders.findByPhoneNumber(externalOrder.diner_phone_number);
        if (externalOrder.showExistingOrders && externalOrder.editing) {
          externalOrder.showExistingOrders = true;
        } else {
          externalOrder.showExistingOrders = !externalOrder.editing;
        }
      });
    };

    /**
     * @method dismiss
     */
    vm.dismiss = function () {
      externalOrdersModal.hide();
      ExternalOrders.toggleDismiss(true);
    };

    /**
     * @method resetAndRefresh
     */
    vm.resetAndRefresh = function () {
      ExternalOrders.reset();
      ExternalOrders.getAll();
    };

    /**
     * @method refreshAllOrders
     */
    vm.refreshAllOrders = function () {
      ExternalOrders.getAll().finally(function () {
        $scope.$broadcast('scroll.refreshComplete');
      });
    };

    /**
     * @method skipAllOrders Mark all exernal orders as skipped.
     * Doesn't skip EatStreet Delivery orders if disable_skipping_eatstreet_external_orders
     * feature flag is turned on for a restaurant.
     */
    vm.skipAllOrders = function () {
      var popup;
      if (Features.checkEnabled('disable_skipping_eatstreet_external_orders') && Features.checkEnabled('disable_skipping_grubhub_external_orders')) {
        popup = Modals.SKIP_NON_EATSTREET_NON_GRUBHUB_EXTERNAL_ORDERS;
      } else if (Features.checkEnabled('disable_skipping_eatstreet_external_orders')) {
        popup = Modals.SKIP_NON_EATSTREET_EXTERNAL_ORDERS;
      } else if (Features.checkEnabled('disable_skipping_grubhub_external_orders')) {
        popup = Modals.SKIP_NON_GRUBHUB_EXTERNAL_ORDERS;
      } else {
        popup = Modals.SKIP_ALL_EXTERNAL_ORDERS;
      }
      zIonicPopup.confirm(popup).then(function (answer) {
        if (answer) {
          $ionicLoading.show();
          ExternalOrders.skipAll().then(vm.resetAndRefresh).finally($ionicLoading.hide);
        }
      });
    };

    /**
     * @method showSnoozedPopup
     */
    vm.showSnoozedOrdersHelp = function () {
      zIonicPopup.alert(Modals.SNOOZED_ORDERS_HELP);
    };

    /**
     * @method onContentScroll
     * @param {Number} scrollTop
     * @param {Object} contentBounds
     */
    vm.onContentScroll = function (scrollTop, contentBounds) {
      if (timeout) {
        $timeout.cancel(timeout);
      }

      timeout = $timeout(function () {
        vm.scrollTop = Math.floor(scrollTop);
        vm.contentBounds = contentBounds;
        timeout = undefined;
      }, 20);
    };

    /**
     * Determine if paused restaurant is short-term pause based on long RBT select
     * or if paused until next day
     */
    vm.isTempPaused = function (rest) {
      if (!rest) return; 
      if (rest.pauseLength) {
        return rest.pauseLength <= 60;
      } else {
        return false;
      }
    };

    vm.countPausedKitchens = function () {
      var count = 0;
      if ($rootScope.hasGhostKitchens) {
        $rootScope.restaurantArray.forEach(function (rest) {
          if (!rest.openStatus && rest.reopenTime) {
            count++;
          }
        });
        vm.tempPausedCount = count;
      } else {
        if ($rootScope.restaurantArray) {
          count = vm.isTempPaused($rootScope.restaurantArray[0]) ? 1 : 0;
        }
      }
      return count;
    };

    watchPromise = $rootScope.$on('$emailOrderAlreadyExists', function () {
      vm.mapExistingOrders();
    });

    watchGroupPromise = $scope.$watchGroup(ordersGroup, function (data) {

      var orders = data[0],
        externalOrders = data[1];

      if (!orders || !orders.length || !externalOrders || !externalOrders.length) {
        return;
      }

      vm.mapExistingOrders();
    });

    destroyPromise = $scope.$on('$destroy', function () {
      watchPromise();
      watchGroupPromise();
      destroyPromise();
    });

  }

  angular.module('zoomerRestaurant')
    .controller('ExternalOrdersModalCtrl', ExternalOrdersModalCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function externalOrdersModal($ionicModal) {
    var url = 'app/components/externalOrdersModal/externalOrdersModal.html',
      params = { backdropClickToClose: false },
      promise;

    function show() {
      return promise.then(function (m) {
        m.show();
      });
    }

    return {
      isOpen: false,
      newOrders: false,

      /**
       * @method show
       */
      show: function () {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        if (promise) {
          return show();
        }

        promise = $ionicModal.fromTemplateUrl(url, params);
        return show();
      },

      /**
       * @method hide
       */
      hide: function () {
        this.isOpen = false;
        if (!promise) {
          return;
        }

        promise.then(function (m) {
          m.hide();
        });
      },

      showNotificationScreen: function () {
        this.newOrders = true;
        this.hide();
      },

      removeNotificationScreen: function () {
        this.newOrders = false;
      }
    };
  }
  angular.module('zoomerRestaurant')
    .factory('externalOrdersModal', externalOrdersModal);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('ghostKitchenToggleOpen', {
      bindings: {
        restaurantArray: '<',
        confirmModal: '<'
      },
      controller: [
        '$scope',
        '$rootScope',
        'Restaurant',
        'menuList',
        GhostKitchenToggleOpenController
      ],
      templateUrl: 'app/components/ghostKitchenToggleOpen/ghost-kitchen-toggle-open.html'
    });
  /** @ngInject */
  function GhostKitchenToggleOpenController($scope, $rootScope, Restaurant, menuList) {
    var vm = this;
    $scope.restaurantArray = angular.copy(vm.restaurantArray);
    $scope.confirmModal = vm.confirmModal;
    $scope.tempPausedThreshold = 60;
    $scope.disableConfirmBtn = true;
    $scope.numOpen = 0;
    $scope.numClosed = 0;
    $scope.numPaused = 0;
    $scope.loading = false;

    vm.$onChanges = function () {
      $scope.restaurantArray = angular.copy(vm.restaurantArray);
      $scope.confirmModal = vm.confirmModal;
      $scope.getGkOpenClosed();
    };

    /**
     * Toggle the (ghost) kitchen open/closed
     */
    $scope.toggleKitchen = function () {
      $scope.disableConfirmBtn = false;
      $scope.disableConfirmBtnFooter = false;
      $scope.getGkOpenClosed();
    };

    /**
     * Access number of ghost kitchens marked open or paused
     */
    $scope.getGkOpenClosed = function () {
      var i;
      $scope.numOpen = $scope.numClosed = $scope.numPaused = 0;
      for (i = 0; i < $scope.restaurantArray.length; i++) {
        if ($scope.restaurantArray[i].openStatus === false) {
          if (($scope.restaurantArray[i].pauseLength <= $scope.tempPausedThreshold) && $scope.restaurantArray[i].reopenTime !== null) {
            $scope.numPaused++;
          } else {
            $scope.numClosed++;
          }
        }
        else $scope.numOpen++;
      }
    };

    /**
     * Determine if paused restaurant is short-term pause based on long RBT select
     * or if paused until next day
     * @method isTempPaused
     * @param {object} rest
     * @return {Boolean}
     */
    $scope.isTempPaused = function (rest) {
      if (!rest) return;
      if (rest.pauseLength) {
        return rest.pauseLength <= $scope.tempPausedThreshold;
      } else {
        return false;
      }
    };

    $scope.confirmKitchenModal = function () {
      $scope.loading = true;
      if (!$scope.disableConfirmBtnFooter) {
        Restaurant.toggleOpeningKitchen($scope.restaurantArray).then(function (data) {
          vm.submitted = true;
          $scope.loading = false;
          // Reload restaurant array
          menuList.fetchRestaurantArray().then(function (res) {
            $rootScope.restaurantArray = res.data;
          });
          $scope.closeModal();
          return;
        }, function (reason) {
          vm.submitted = false;
          vm.error = true;
          return;
        });
      }
    };

    $scope.closeModal = function () {
      $scope.confirmModal.hide().then(function () {
        $scope.confirmModal.remove();
        $scope.confirmModal = null;
      });
    };

  }
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('hours', {
      bindToController: true,
      controller: 'HoursCtrl as hoursVm',
      templateUrl: 'app/components/hoursModal/hours.html'
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function HoursCtrl($rootScope, $scope, readyByTimes, Restaurant) {
    var vm = this;

    vm.loading = false; 
    vm.submitted = false; 
    vm.error = false; 
    vm.request = "";
    vm.hasGhostKitchens = $rootScope.hasGhostKitchens;

    vm.closeModal = function () {
      $scope.confirmModal.hide().then(function () {
        $scope.confirmModal.remove();
        $scope.confirmModal = null;
      });
    };

   vm.checkInput = function () {
      return !vm.request || vm.loading;
   };

    vm.submit = function () {
      vm.loading = true; 
      Restaurant.sendHoursRequest(vm.request).then(function(data) {
        vm.submitted = true;
        return;
      }, function(reason) {
        vm.submitted = false; 
        vm.error = true; 
        return;
      })
    };

  }


  angular.module('zoomerRestaurant')
    .controller('HoursCtrl', HoursCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function inputChangeValidator() {
    return {
      require: '^ngModel',
      link: function (scope, element, attr, ngModel) {
        var previousValue = null;

        ngModel.$validators.validAddressField = function (modelValue, viewValue) {
          var value = modelValue || viewValue || '';
          if (previousValue && value && value !== previousValue) {
            ngModel.$setDirty();
          }

          previousValue = value;
          return true;
        };
      }
    };
  }

  angular.module('zoomerRestaurant')
    .directive('inputChangeValidator', inputChangeValidator);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('largeOrderToggle', {
      bindings: {
        onSelect: '&',
        order: '<'
      },
      bindToController: true,
      controller: 'LargeOrderToggleCtrl',
      templateUrl: 'app/components/largeOrderToggle/largeOrderToggle.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function LargeOrderToggleCtrl($scope) {
    var vm = this;

    /**
     * @method setLargeOrder
     * @param {Boolean} largeOrder
     */
    vm.setLargeOrder = function (largeOrder) {
      vm.order.large_order = largeOrder;
      if (vm.onSelect) {
        vm.onSelect({ largeOrder: largeOrder });
      }
    };

    $scope.$watch('$ctrl.order.size', function (orderSize) {
      if (orderSize === undefined) {
        return;
      }
      vm.setLargeOrder(orderSize === 'extra_large');
    });
  }

  angular.module('zoomerRestaurant')
    .controller('LargeOrderToggleCtrl', LargeOrderToggleCtrl);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('menuFooter', {
      bindings: {
        filterSoldOut: '=',
        restaurant: '<',
        viewChoice: '<',
        onChange: '&'
      },
      controller: [
        '$scope',
        menuFooterController
      ],
      templateUrl: 'app/components/menuFooter/menu-footer.html'
    });
  /** @ngInject */
  function menuFooterController($scope) {
    var vm = this;

    vm.$onChanges = function () {
      $scope.filterSoldOut = vm.filterSoldOut;
      $scope.restaurant = vm.restaurant;
      $scope.viewChoice = vm.viewChoice;
    };

    this.change = function () {
      this.onChange({ filterSoldOut: this.filterSoldOut });
    };
  }
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('menuItems', {
      bindings: {
        product: '=',
        productSearch: '<',
        eatstreetId: '<',
        categoryName: '<',
        isProduct: '<',
        updateProduct: '&'
      },
      controller: [
        '$scope',
        'menuList',
        '$ionicModal',
        MenuItemsController
      ],
      templateUrl: 'app/components/menuItemsList/menu-items.html'
    });
  /** @ngInject */
  function MenuItemsController($scope, menuList, $ionicModal, $filter) {
    var vm = this;

    $scope.productSearch = vm.productSearch;
    $scope.optionLoading = false;
    $scope.err = false;
    $scope.activeItemCopy = [];
    $scope.eatstreetId = 0;
    $scope.product = vm.product;
    $scope.categoryName = vm.categoryName;
    $scope.isProduct = vm.isProduct;

    $scope.activeOption = [];

    vm.$onChanges = function () {
      $scope.product = vm.product;
      $scope.productSearch = vm.productSearch;
      $scope.eatstreetId = vm.eatstreetId;
      $scope.categoryName = vm.categoryName;
      $scope.isProduct = vm.isProduct;
    };

    $scope.submit = function () {
      $scope.optionLoading = true;
      $scope.err = false;
      var product = $scope.isProduct ? $scope.product.id : null;
      menuList.setInvisibility(product, $scope.eatstreetId, $scope.activeItemCopy.name, $scope.activeItemCopy.invisible, $scope.activeItemCopy.temporarilyInvisible)
        .then(function () {
          $scope.err = false;
          $scope.optionLoading = false;
          $scope.activeOption.invisible = $scope.activeItemCopy.invisible;
          $scope.activeOption.temporarilyInvisible = $scope.activeItemCopy.temporarilyInvisible || false;
          vm.updateProduct($scope.activeOption);
          $scope.closeModal();
        })
        .catch(function (err) {
          console.error(err);
          $scope.err = true;
          $scope.optionLoading = false;
        });
    };

    $scope.closeModal = function () {
      $scope.confirmModal.hide().then(function () {
        $scope.confirmModal.remove();
        $scope.confirmModal = null;
      });
    };

    $scope.openOptionsAvailability = function (activeOption) {
      vm.activeOption = activeOption;
      var params = {
        scope: $scope
      };
      $scope.activeOption = activeOption;
      $scope.activeItemCopy = angular.copy(activeOption);
      $ionicModal.fromTemplateUrl('app/views/menu-list/optionsAvailabilityPopup.html', params).then(function (modal) {
        $scope.checkChanges();
        $scope.confirmModal = modal;
        $scope.confirmModal.show();
      });
    };

    $scope.checkChanges = function () {
      $scope.err = false;
      $scope.itemAvailabilityChanged = $scope.activeItemCopy.invisible !== $scope.activeOption.invisible
        || $scope.activeItemCopy.temporarilyInvisible !== $scope.activeOption.temporarilyInvisible;
    };

  }
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('menuSearch', {
      bindings: {
        productSearch: '=',
        viewChoice: '<',
        onChange: '&'
      },
      controller: [
        '$scope',
        MenuSearchController
      ],
      templateUrl: 'app/components/menuSearchTool/menu-search.html'
    });
  /** @ngInject */
  function MenuSearchController($scope) {
    var vm = this;

    vm.$onChanges = function () {
      $scope.productSearch = vm.productSearch;
      $scope.viewChoice = vm.viewChoice;
    };

    this.change = function () {
      this.onChange({ productSearch: this.productSearch });
    };
  }
}());

(function () {
  'use strict';

  /** @ngInject */
  function NumberKeypadCtrl($scope, $timeout, Utilities) {
    var vm = this,
      initialValue,
      cache = [],
      onPromise,
      destroyPromise;

    initialValue = Utilities.number.stripFormatting(($scope.initiaKeypadValue || '').toString());
    if (initialValue) {
      cache = initialValue.split('');
    }

    /**
     * @method invokeCallback
     * @param {String} value
     */
    vm.invokeCallback = function (value) {
      if ($scope.updateKeypadValue) {
        $scope.updateKeypadValue(value);
      }
    };

    /**
     * @method addDigit
     * @param {Number} digit
     */
    vm.addDigit = function (digit) {
      cache.push(digit);
      $scope.$evalAsync(function () {
        vm.invokeCallback(cache.join(''));
      });
    };

    /**
     * @method removeDigit
     */
    vm.removeDigit = function () {
      if (cache.length > 0) {
        cache.pop();
      }

      $scope.$evalAsync(function () {
        vm.invokeCallback(cache.join(''));
      });
    };

    /**
     * @method clear
     */
    vm.clear = function () {
      cache = [];
      $scope.$evalAsync(function () {
        vm.invokeCallback('');
      });
    };

    /**
     * @method togglePopoverClass
     * @description Fix popover Cls not removed if modals still open in ionic modal stack
     */
    vm.togglePopoverClass = function () {
      var selector = '.popover-backdrop.active',
        activePopovers;

      $timeout(function () {
        activePopovers = document.querySelectorAll(selector).length;
        document.body.classList.toggle('popover-open', Boolean(activePopovers));
      }, 400);
    };

    onPromise = $scope.$on('popover.hidden', vm.togglePopoverClass);

    destroyPromise = $scope.$on('$destroy', function () {
      onPromise();
      destroyPromise();
    });

  }

  angular.module('zoomerRestaurant')
    .controller('NumberKeypadCtrl', NumberKeypadCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function numberKeypad($ionicPopover) {
    var url = 'app/components/numberKeypad/numberKeypad.html';

    return {
      /**
       * @method get
       * @param {Object} params
       * @return {Object}
       */
      get: function (params) {
        params = params || {};
        return $ionicPopover.fromTemplateUrl(url, params);
      }
    };

  }

  angular.module('zoomerRestaurant')
    .factory('numberKeypad', numberKeypad);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('orderVisualNotification', {
      bindings: {
        category: '<'
      },
      controller: [
        'ExternalOrders',
        '$scope',
        '$interval',
        'externalOrdersModal',
        orderNotificationController
      ],
      templateUrl: 'app/components/order-visual-notification/order-visual-notification.html'
    });


  function orderNotificationController(ExternalOrders, $scope, $interval, externalOrdersModal) {
    var ordersModalPromise,
      ordersTotalPromise;

    $scope.newOrders = false;
    $scope.total = 0;

    $scope.removeNotificationScreen = function () {
      externalOrdersModal.removeNotificationScreen();
      externalOrdersModal.show();
    };

    ordersTotalPromise = $scope.$watch(function () {
      return ExternalOrders.total;
    }, function (newTotal) {
      $scope.total = newTotal;
    });

    ordersModalPromise = $scope
      .$watch(function () {
        return externalOrdersModal.newOrders;
      }, function (newVal) {
        $scope.newOrders = newVal;
      });

    $scope.$on('$destroy', function () {
      ordersModalPromise();
      ordersTotalPromise();
    });
  }
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('orderDriverIou', {
      bindings: {
        order: '<'
      },
      bindToController: true,
      controller: 'OrderDriverIouCtrl',
      templateUrl: 'app/components/orderDriverIou/orderDriverIou.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function OrderDriverIouCtrl($rootScope) {
    var vm = this,
      onPromise;

    /**
     * @method updateIou
     * @param {Object} e
     * @param {Number} driverIou
     */
    vm.updateIou = function (e, driverIou) {
      vm.order.driver_iou = driverIou || null;
      if (vm.$setDirty) {
        vm.$setDirty();
      }
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      if (onPromise) {
        onPromise();
      }
    };

    onPromise = $rootScope.$on('$updateOrderDriverIou', vm.updateIou.bind(vm));
  }

  angular.module('zoomerRestaurant')
    .controller('OrderDriverIouCtrl', OrderDriverIouCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function orderDriverIou() {
    return {
      restrict: 'A',
      require: '^ngModel',
      link: function (scope, element, attr, ngModel) {
        scope.$ctrl.$setDirty = ngModel.$setDirty;
      }
    };
  }

  angular.module('zoomerRestaurant')
    .directive('orderDriverIou', orderDriverIou);

}());

(function () {
  'use strict';

  function OrderInternalIdInputCtrl($scope, numberKeypad) {
    var vm = this;

    $scope.initiaKeypadValue = (vm.order || {}).internal_id;

    vm.keypad = null;

    /**
     * @method showKeypad
     * @param {Object} e
     */
    vm.showKeypad = function (e) {
      if (vm.order.isDeliveryInProgress) {
        return;
      }

      if (vm.keypad) {
        return vm.keypad.show(e);
      }

      numberKeypad.get({ scope: $scope }).then(function (keypad) {
        vm.keypad = keypad;
        vm.keypad.show(e);
      });
    };

    /**
     * @method updateKeypadValue
     * @param {String} value
     */
    $scope.updateKeypadValue = function (value) {
      vm.order.internal_id = value;
    };

  }

  angular.module('zoomerRestaurant')
    .controller('OrderInternalIdInputCtrl', OrderInternalIdInputCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function orderInternalIdInput() {
    return {
      bindToController: true,
      controller: 'OrderInternalIdInputCtrl as orderInternalIdInputVm',
      scope: {
        order: '=orderInternalIdInput'
      },
      templateUrl: 'app/components/orderInternalIdInput/orderInternalIdInput.html'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('orderInternalIdInput', orderInternalIdInput);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('orderLeafletMap', {
      bindings: {
        order: '<',
        zones: '='
      },
      bindToController: true,
      controller: 'OrderLeafletMapCtrl',
      templateUrl: 'app/components/orderLeafletMap/orderLeafletMap.html'
    });

}());

(function () {
  'use strict';

  function getZoneStyle(colour) {
    return {
      style: {
        color: colour,
        weight: 1,
        fillColor: colour,
        fillOpacity: 0.4
      }
    };
  }

  var BLUE = '#05cbaa',
    ORANGE = '#f5a523',
    RED = '#d24d57';

  /** @ngInject */
  function OrderLeafletMapCtrl($element, $timeout, $window, Config, Features, Restaurant) {
    var vm = this,
      Leaflet = $window.L,
      iconSize = [ 31, 36 ],
      iconAnchor = [ 15, 36 ],
      tileAttributes,
      tileLayer,
      tilesUrl,
      mapOptions,
      timeout;

    tilesUrl = 'https://{s}.tile.thunderforest.com/neighbourhood/{z}/{x}/{y}.png?apikey=' + Config.THUNDERFOREST_API_KEY;
    tileAttributes = {
      detectRetina: true,
      attributionControl: false
    };
    mapOptions = {
      zoomControl: false
    };

    tileLayer = Leaflet.tileLayer(tilesUrl, tileAttributes);

    vm.features = Features;
    vm.map = null;
    vm.isDinerMissingCoordinates = false;
    vm.isRestaurantMissingCoordinates = false;

    /**
     * @method drawSnowDeliveryZone
     * @param {Object} zone
     */
    vm.drawSnowDeliveryZone = function (zone) {
      var geoCircle;
      if (!zone || !zone.geo_circle) {
        return;
      }

      geoCircle = zone.geo_circle;
      Leaflet.circle(
        [geoCircle.center.latitude, geoCircle.center.longitude],
        (geoCircle.radius * Config.MILES_TO_METRES),
        getZoneStyle(BLUE)
      ).addTo(vm.map);
    };

    /**
     * @method drawDeliveryZone
     * @param {Object} zone
     */
    vm.drawDeliveryZone = function (zone) {
      var deliveryColour;
      if (!zone) {
        return;
      }

      if (zone.type && zone.type === 'DeliveryExclusionZone') {
        deliveryColour = RED;
      } else {
        deliveryColour = (zone.delivery_zone_type === 'inner' ? BLUE : ORANGE);
      }

      Leaflet.geoJson({
        type: 'Feature',
        geometry: zone.geo_json
      }, getZoneStyle(deliveryColour)).addTo(vm.map);
    };

    /**
     * @method onDinerMarkerError
     */
    vm.onDinerMarkerError = function () {
      vm.isDinerMissingCoordinates = true;
    };

    /**
     * @method onDinerMarkerError
     */
    vm.onRestaurantMarkerError = function () {
      vm.isRestaurantMissingCoordinates = true;
    };

    /**
     * @method drawDeliveryZones
     */
    vm.drawDeliveryZones = function () {
      var zones = vm.zones || {},
        restaurant = Restaurant.info || {},
        deliveryZones = zones.delivery || [],
        snowZone = deliveryZones.find(function (z) { return z.delivery_zone_type === 'snow'; });

      angular.forEach(zones.exclusion, vm.drawDeliveryZone);
      if (snowZone) {
        return vm.drawSnowDeliveryZone(snowZone);
      }

      vm.drawDeliveryZone(restaurant.delivery_zone);
      if (Restaurant.hasOozoPricing()) {
        vm.drawDeliveryZone(restaurant.extended_delivery_zone);
      }

    };

    /**
     * @method drawMarker
     * @param {Object} target
     * @param {String} iconUrl
     * @param {Function} onError
     */
    vm.drawMarker = function (target, iconUrl, onError) {
      target = target || {};
      if (!target.latitude || !target.longitude) {
        return onError();
      }

      Leaflet.marker([target.latitude, target.longitude], {
        icon: Leaflet.icon({ iconUrl: iconUrl, iconSize: iconSize, iconAnchor: iconAnchor})
      }).addTo(vm.map);
    };

    /**
     * @method fitBounds
     * @param {Object} diner
     * @param {Object} restaurant
     */
    vm.fitBounds = function (diner, restaurant) {
      if (!diner.latitude || !diner.longitude || !restaurant.latitude || !restaurant.longitude) {
        return;
      }

      vm.map.fitBounds([
        [restaurant.latitude, restaurant.longitude],
        [ diner.latitude, diner.longitude ]
      ]).zoomOut();
    };

    /**
     * @method drawMap
     */
    vm.drawMap = function () {
      var order = vm.order || {},
        diner = order.serialized_address || order.address || {},
        restaurant = Restaurant.info || {};

      if (vm.map) {
        return;
      }

      vm.map = Leaflet.map($element[0].children[0], mapOptions);
      vm.map.setView([ 39.8282, -98.5795 ], 0);
      tileLayer.addTo(vm.map);

      vm.drawMarker(restaurant, 'assets/images/restaurant-icon.svg', vm.onRestaurantMarkerError);
      vm.drawMarker(diner, 'assets/images/customer-icon.svg', vm.onDinerMarkerError);
      vm.drawDeliveryZones();
      vm.fitBounds(diner, restaurant);

    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      timeout = $timeout(vm.drawMap, 500);
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      if (timeout) {
        $timeout.cancel(timeout);
      }

      if (vm.map) {
        vm.map.remove();
      }
    };
  }

  angular.module('zoomerRestaurant')
    .controller('OrderLeafletMapCtrl', OrderLeafletMapCtrl);

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('orderPaymentMethod', {
      bindings: {
        order: '<'
      },
      templateUrl: 'app/components/orderPaymentMethod/orderPaymentMethod.html'
    });

}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('orderPopoverMenu', {
      controller: 'OrderPopoverMenuCtrl',
      templateUrl: 'app/components/orderPopoverMenu/orderPopoverMenu.html'
    });
}());

(function () {
  'use strict';

  /**
   * @method scrollContentByOffset
   */
  function scrollContentByOffset(target, offsetY, callback) {
    var startingScrollTop = target.scrollTop,
      scrollInterval,
      intervalMs = 5;

    scrollInterval = setInterval(function () {
      if (target.scrollTop < (startingScrollTop + offsetY)) {
        target.scrollTop += 1;

        return target.scrollTop;
      }

      clearInterval(scrollInterval);
      callback();
    }, intervalMs);
  }

  /** @ngInject */
  function OrderPopoverMenuCtrl($ionicModal, $ionicPosition, $ionicScrollDelegate, $rootScope, $scope, $timeout, $window, Features, confirmFoodReadyNow, orderSourceModal, foodReady, orderPopoverMenu, ThermalPrinter, Restaurant) {
    var vm = this,
      locationModalUrl = 'app/views/modals/customer-location.html',
      popoverId = 'order-popover';

    vm.modalPromise = null;
    vm.menuWrapper = null;
    vm.order = null;
    vm.features = Features;

    /**
     * @method getTopOffset
     */
    vm.getTopOffset = function (offset) {
      var halfHeight = offset.height * 0.5;
      return offset.top + halfHeight;
    };

    /**
     * @method setMenuOptions
     */
    vm.getScrollPosition = function (data) {
      if (!data.order) {
        return;
      }

      var rect = data.event.target.getBoundingClientRect(),
        viewportHeight = $window.innerHeight;

      if (viewportHeight - rect.top < rect.height) {
        vm.scrollBy(rect.height, function () {
          vm.show(data);
        });
      } else {
        vm.show(data);
      }
    };

    /**
     * @method scrollBy
     * @param {Number} offsetY
     * @param {Function} callback
     */
    vm.scrollBy = function (offsetY, callback) {
      var ionicContent;

      if ($rootScope.isMobileDevice) {
        $ionicScrollDelegate.scrollBy(0, offsetY, true);
        return $timeout(callback, 300);
      }

      ionicContent = $window.document.querySelector('ion-view[nav-view="active"] ion-content');
      scrollContentByOffset(ionicContent, offsetY, callback);
    };

    /**
     * @method show
     * @param {Object} data
     */
    vm.show = function (data) {
      var el = data.event.target,
        element = angular.element(el),
        offset = $ionicPosition.offset(element);

      vm.invisible = false;
      vm.order = data.order;
      vm.menuWrapper.css('top', vm.getTopOffset(offset) + 'px');
    };

    /**
     * @method hide
     */
    vm.hide = function () {
      vm.order = null;
      orderPopoverMenu.reset();
    };

    vm.hideWithoutRemoving = function(){
      vm.invisible = true;
    };

    /**
     * @method confirmFoodReadyNow
     */
    vm.confirmFoodReadyNow = function () {
      var order = vm.order,
        orderId = order.id;

      vm.hide();
      confirmFoodReadyNow.show().then(function (confirmed) {
        if (confirmed) {
          foodReady.toggle(orderId, true).then(function () {
            order.food_ready_now = true;
          });
        }
      });
    };

    /**
     * @method openEmailDetailsModal
     * @param {Number} emailOrderId
     */
    vm.openEmailDetailsModal = function (emailOrderId) {
      if (!emailOrderId) {
        return;
      }

      orderSourceModal.show(emailOrderId).then(vm.hide);
    };

    /**
     * @method openLocationModal
     */
    vm.openLocationModal = function () {
      vm.modalPromise.then(function (modal) {
        modal.scope.order = vm.order;
        modal.show();
        vm.hide();
      });
    };

    /**
     * @method closeLocationModal
     */
    vm.closeLocationModal = function () {
      vm.modalPromise.then(function (modal) {
        modal.scope.order = null;
        modal.hide();
      });
    };

    /**
     * @method launchSupportV2
     */
    vm.launchSupportDashboardV2 = function () {
      $rootScope.$emit('$restaurantSupportLaunch');
      vm.hide();
    };

    /**
     * @method $postLink
     */
    vm.$postLink = function () {
      var wrapperEl = $window.document.getElementById(popoverId);
      vm.menuWrapper = angular.element(wrapperEl);
    };

    /**
     * @method $onInit
     */
    vm.$onInit = function () {
      vm.modalPromise = $ionicModal.fromTemplateUrl(locationModalUrl, { scope: $scope, backdropClickToClose: false });
      orderPopoverMenu.notify().then(angular.noop, angular.noop, vm.getScrollPosition);
    };

    /**
     * @method dismissPickupOrder removes the order from the pending queue.
     */
    vm.dismissPickupOrder = function () {
      vm.order.dismiss();
      vm.hide();
    };

    vm.shouldShowPrint = function () {
      return ThermalPrinter.shouldPrintOrder(vm.order);
    };

    vm.print = function () {
      ThermalPrinter.printOrder(vm.order, Restaurant.info);
    };

  }

  angular.module('zoomerRestaurant')
    .controller('OrderPopoverMenuCtrl', OrderPopoverMenuCtrl);
}());

(function () {
  'use strict';

  /** @ngInject */
  function orderPopoverMenu($q, Features, Utilities) {
    var deferred = $q.defer();

    function reset() {
      return {
        order: null,
        event: null
      };
    }

    return {
      data: reset(),

      notify: function () {
        return deferred.promise;
      },

      /**
       * @method show
       * @param {Object} e
       * @param {Object} order
       */
      show: function (e, order) {
        var orderFinishedStatuses = ['delivered', 'cancelled', 'undeliverable', 'oozo_review_rejected', 'do_not_deliver_dismissed' ];
        this.data.order = angular.extend({}, order, {
          isDelivered: order.status === 'delivered',
          isFinished: orderFinishedStatuses.indexOf(order.status) > -1,
          isReOrder: !!order.reorder_of,
          isReOrderDisabled: Utilities.orders.isReorderDisabled(order),
          isSpecialOrder: order.deliver_at || order.large_order,
          isUndeliveredEmailOrder: order.isEmailOrder && order.status !== 'delivered'
        });
        this.data.event = e;
        deferred.notify(this.data);
      },

      reset: function () {
        this.data = reset();
        deferred.notify(this.data);
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('orderPopoverMenu', orderPopoverMenu);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('orderSize', {
      bindings: {
        order: '<',
        onSelect: '&',
        onSelectExtraLarge: '&',
        disableXLarge: '<'
      },
      controller: 'OrderSizeCtrl',
      templateUrl: 'app/components/orderSize/orderSize.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function OrderSizeCtrl(sizeHelpModal) {
    var vm = this;

    vm.sizeHelpModal = sizeHelpModal;

    /**
     * @method getCls
     * @param {String} size
     * @return {Array}
     */
    vm.getCls = function (size) {
      var cls = [],
        order = vm.order;

      if (order.size === size || '') {
        cls.push('selected');
      }

      if (order.isDeliveryInProgress) {
        cls.push('disabled');
      }
      return cls;
    };

    /**
     * @method setOrderSize
     * @param {String} size
     */
    vm.setOrderSize = function (size) {
      var isExtraLarge = size === 'extra_large';
      vm.order.size = size || null;

      if (isExtraLarge) {
        vm.setDoNotDeliverByBike(true);
        vm.invokeExtraLargeCallback();
      }

      if (vm.onSelect) {
        vm.onSelect({ size: size });
      }
    };

    /**
     * @method invokeExtraLargeCallback
     */
    vm.invokeExtraLargeCallback = function () {
      if (vm.onSelectExtraLarge) {
        vm.onSelectExtraLarge();
      }
    };

    /**
     * @method setDoNotDeliverByBike
     * @param {Boolean} doNotDeliver
     */
    vm.setDoNotDeliverByBike = function (doNotDeliver) {
      vm.order.do_not_deliver_by_bicycle = Boolean(doNotDeliver);
    };

  }

  angular.module('zoomerRestaurant')
    .controller('OrderSizeCtrl', OrderSizeCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function orderSourceModal($ionicModal, $q, ExternalOrders) {
    var url = 'app/components/orderSourceModal/orderSourceModal.html',
      promise;

    return {

      /**
       * @method show
       * @param {Number} emailOrderId
       * @return {Object} $promise
       */
      show: function (emailOrderId) {
        if (!emailOrderId) {
          return $q.reject({ message: 'No email order ID provided' });
        }

        if (!promise) {
          promise = $ionicModal.fromTemplateUrl(url);
        }

        return ExternalOrders.get(emailOrderId, { ignore_iframe_in_html: true }).then(function (response) {
          promise.then(function (modal) {
            modal.scope.emailOrder = response.data;
            modal.show();
          });
        });
      }

    };
  }

  angular.module('zoomerRestaurant')
    .factory('orderSourceModal', orderSourceModal);

}());

(function () {
  'use strict';

  /** @ngInject */
  function orderSubmitErrorModal($rootScope, zIonicPopup) {
    var url = 'app/components/orderSubmitErrorModal/orderSubmitErrorModal.html',
      okButton = {
      text: 'OK',
      type: 'button-positive'
    };

    return {

      /**
       * @method show
       * @param {Object} error
       * @return {Object} $promise
       */
      show: function (error) {
        var scope = $rootScope.$new();
        scope.error = error || {};

        return zIonicPopup.show({
          buttons: [ okButton ],
          scope: scope,
          title: 'Cannot save order',
          templateUrl: url
        }).finally(function () {
          scope.$destroy();
          scope = null;
        });
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('orderSubmitErrorModal', orderSubmitErrorModal);

}());

(function () {
  'use strict';


  angular.module('zoomerRestaurant')
    .component('ordersQueueInfoIcons', {
      bindings: {
        order: '<'
      },
      controller: 'OrdersQueueInfoIconsCtrl',
      templateUrl: 'app/components/ordersQueueInfoIcons/ordersQueueInfoIcons.html'
    });
}());

(function () {
  'use strict';

  /** @ngInject */
  function OrdersQueueInfoIconsCtrl($filter, $ionicPopover, $ionicModal, $scope, Features, Utilities, orderPopoverMenu, zIonicPopup) {
    var vm = this,
      options = { scope: $scope },
      destroyPromise;

    vm.orderPopoverMenu = orderPopoverMenu;
    vm.features = Features;
    vm.utilities = Utilities;
    vm.orderTooltip = '';
    vm.isReturning = false;
    vm.promises = {
      tooltip: $ionicPopover.fromTemplateUrl('app/views/popovers/order-tooltip.html', options),
      oozoTooltip: $ionicPopover.fromTemplateUrl('app/views/popovers/oozo-tooltip.html', options),
      oozoModal: $ionicModal.fromTemplateUrl('app/views/modals/oozo-details.html', options)
    };

    vm.$onInit = function () {
      vm.isReturning = vm.order.status === 'return_in_progress' || vm.order.status === 'merchant_confirming_return';
    };

      /**
       * @method hasOpenSupportRequests
       * @return {Boolean}
       */

      vm.hasOpenSupportRequests = function () {
        return vm.order.restaurant_support_request_ids.length;
      };

      /**
      * @method openDeliveryNote
      */
    vm.openDeliveryNote = function () {
      var order = vm.order || {};
      if (!order.delivery_notes) {
        return;
      }

      zIonicPopup.alert({
        title: 'Special Notes',
        template: order.delivery_notes
      });
    };

    /**
     * @method showIouTooltip
     * @param {Object} e
     */
    vm.showIouTooltip = function (e) {
      var order = vm.order || {},
        driverIou = order.driver_iou;
      vm.showTooltip(e, 'tooltip', $filter('currency')(driverIou));
    };

    /**
     * @method showTooltip
     * @param {Object} e
     * @param {String} type
     * @param {String} text
     */
    vm.showTooltip = function (e, type, text) {
      if (!type) {
        return;
      }

      vm.tooltipText = text || '';
      vm.promises[type].then(function (popover) {
        popover.show(e);
      });
    };

    /**
     * @method closeTooltip
     * @param {String} type
     */
    vm.closeTooltip = function (type) {
      if (!type) {
        return;
      }

      vm.promises[type].then(function (popover) {
        popover.hide();
        vm.tooltipText = '';
      });
    };

    /**
     * @method openModal
     */
    vm.openModal = function () {
      vm.closeTooltip('oozoTooltip');
      vm.promises.oozoModal.then(function (modal) {
        modal.show();
      });
    };

    /**
     * @method closeModal
     */
    vm.closeModal = function () {
      vm.promises.oozoModal.then(function (modal) {
        modal.hide();
      });
    };

    destroyPromise = $scope.$on('$destroy', function () {
      destroyPromise();

      angular.forEach(vm.promises, function (promise) {
        promise.then(function (ionicItem) {
          ionicItem.remove();
        });
      });
    });
  }

  angular.module('zoomerRestaurant')
    .controller('OrdersQueueInfoIconsCtrl', OrdersQueueInfoIconsCtrl);
}());

(function () {
  'use strict';

  angular.module('zoomerRestaurant')
    .component('rbtButtons', {
      bindToController: true,
      bindings: {
        order: '<',
        onSelect: '&'
      },
      controller: 'RbtButtonsCtrl as rbtButtonsVm',
      templateUrl: 'app/components/rbtButtons/rbtButtons.html'
    });

}());

(function () {
  'use strict';

  /** @ngInject */
  function RbtButtonsCtrl($ionicModal, $scope, readyByTimes, $rootScope, Restaurant, Features) {
    var vm = this,
      floorPromise,
      rbtPromise;

    vm.existingRbt = null;
    vm.isFoodReadyNowEnabled = false;
    vm.readyByTimes = readyByTimes;

    vm.loading = true;
    readyByTimes.refresh().finally(function () {
      vm.loading = false;
    });

    vm.rbt = 0;
    vm.pause30 = [];
    vm.pause60 = [];
    $scope.restaurantArray = $rootScope.restaurantArray;
    vm.activeKitchen = {};
    $scope.viewGhostKitchens = false;
    $scope.openRestaurantArray = [];

    /**
     * @method isRespectingRbtFloor
     * @returns {Boolean} true for delivery orders, false for pickup orders
     */
    vm.isRespectingRbtFloor = function () {
      if (!vm.order) {
        return true; 
      }
      return vm.order.status !== 'do_not_deliver' && vm.order.status !== 'do_not_deliver_dismissed';
    }

    /**
     * @method existingSelected
     * @return {Boolean}
     */
    vm.existingSelected = function () {
      return vm.order.ready_by_time === vm.existingRbt;
    };

    /**
     * @method isSelected
     * @param {String|Date} rbt
     * @return {Boolean}
     */
    vm.isSelected = function (rbt) {
      return rbt === vm.order.ready_by_time;
    };

    /**
     * @method setExistingRbt
     * @param {String} readyByTime
     */
    vm.setExistingRbt = function (readyByTime) {
      var isValidDateString = moment(readyByTime, moment.ISO_8601, true).isValid();
      if (isValidDateString) {
        vm.existingRbt = readyByTime;
      }
    };

    /**
     * @method getButtonCls
     * @param {Number} rbt
     * @return {Array}
     */
    vm.getButtonCls = function (rbt) {
      var cls = [];
      if (vm.isSelected(rbt)) {
        cls.push('selected');
      }

      if (vm.order.isDeliveryInProgress || (rbt < readyByTimes.ready_by_time_floor && vm.isRespectingRbtFloor())) {
        cls.push('disabled');
      }

      return cls;
    };

    /**
     * Retrieve array of open (not temporarily paused) restaurants 
     */
    vm.setOpenRestaurants = function () {
      var i;
      if (!$scope.restaurantArray) {
        $scope.openRestaurantArray = []; 
        return;
      }
      $scope.restaurantArray.forEach(function (rest) {
        if (rest.openStatus) {
          $scope.openRestaurantArray.push(rest);
        }
      });
    };

    vm.setOpenRestaurants();

    /**
     * @method setRbt
     * @param {Number} rbt
     */
    vm.setRbt = function (rbt) {
      vm.setActiveKitchen();
      vm.setOpenRestaurants();
      vm.rbt = rbt;
      $scope.rbt = rbt;
      if (rbt >= 60 && !vm.activeKitchen.reopenTime && $scope.openRestaurantArray.length > 0 && !Features.checkEnabled('disable_rbt_pause_prompt')) {
        var url = $rootScope.hasGhostKitchens ? 'app/views/modals/prompt-temp-pause-gk.html' : 'app/views/modals/prompt-temp-pause.html';
        $ionicModal.fromTemplateUrl(url, { scope: $scope }).then(function (modal) {
          $scope.confirmModal = modal;
          $scope.confirmModal.show();
        });
      }
      else {
        vm.setRbtFromModal();
      }
    };

    vm.setRbtFromModal = function () {
      vm.order.ready_by_time = $scope.rbt || vm.existingRbt;
      if (vm.onSelect) {
        vm.onSelect();
      }

      if (vm.$setDirty) {
        vm.$setDirty();
      }
    };

    vm.setLocalPauseTime = function (restaurant, length) {
      $scope.restaurantArray.forEach(function (rest) {
        if (rest.eatstreetId === restaurant) {
          var index = $rootScope.restaurantArray.indexOf(rest);
          $rootScope.restaurantArray[index].openStatus = false;
          var date = new Date();
          date.setMinutes(date.getMinutes() + length);
          $rootScope.restaurantArray[index].reopenTime = date;
        }
      });
    }

    vm.setPauseTime = function (length) {
      $rootScope.restaurantArray[0].pauseLength = length;
      if (length === 30) {
        vm.pause30.push($rootScope.restaurantArray[0].eatstreetId);
        Restaurant.tempPause(length, vm.pause30);
      } else {
        vm.pause60.push($rootScope.restaurantArray[0].eatstreetId);
        Restaurant.tempPause(length, vm.pause60);
      }
      var date = new Date();
      date.setMinutes(date.getMinutes() + length);
      $rootScope.restaurantArray[0].reopenTime = date;
      vm.closeModalVM();
    };

    vm.setPauseTimeGk = function () {
      if (vm.pause30.length > 0) {
        Restaurant.tempPause(30, vm.pause30);
        vm.pause30.forEach(function (rest) {
          vm.setLocalPauseTime(rest, 30);
        });
      }
      if (vm.pause60.length > 0) {
        Restaurant.tempPause(60, vm.pause60);
        vm.pause60.forEach(function (rest) {
          vm.setLocalPauseTime(rest, 60);
        });
      }
      vm.closeModalVM();
    }

    vm.closeModalVM = function () {
      vm.setRbtFromModal();

      $scope.confirmModal.hide().then(function () {
        $scope.confirmModal.remove();
        $scope.confirmModal = null;
      });
    };


    vm.pauseCount = function () {
      return vm.pause30.length + vm.pause60.length;
    };

    vm.addPause30 = function (eatstreetId) {
      vm.pause30.push(eatstreetId);
      // check that eatstreetid isn't in 60 min array
      var index = vm.pause60.indexOf(eatstreetId);
      if (index >= 0) {
        vm.pause60.splice(index, 1);
      }
    };

    vm.unpause30 = function (eatstreetId) {
      var index = vm.pause30.indexOf(eatstreetId);
      if (index >= 0) {
        vm.pause30.splice(index, 1);
      }
    };

    vm.addPause60 = function (eatstreetId) {
      vm.pause60.push(eatstreetId);
      // check that eatstreetid isn't in 30 min array
      var index = vm.pause30.indexOf(eatstreetId);
      if (index >= 0) {
        vm.pause30.splice(index, 1);
      }
    };

    vm.unpause60 = function (eatstreetId) {
      var index = vm.pause60.indexOf(eatstreetId);
      if (index >= 0) {
        vm.pause60.splice(index, 1);
      }
    };

    vm.setActiveKitchen = function () {
      if (!$scope.restaurantArray) {
        vm.activeKitchen = {}; 
        return; 
      }
      $scope.restaurantArray.forEach(function (rest) {
        if (rest.eatstreetId === vm.order.items.restaurant_id) {
          vm.activeKitchen = rest;
        }
      });
    };

    /**
     * @method isRbtValidWithActiveFloor
     */
    vm.isRbtValidWithActiveFloor = function () {
      if (!vm.isRespectingRbtFloor()) {
        return true;
      }

      var floor = readyByTimes.getFloor();
      if (floor && vm.order.ready_by_time < floor) {
        vm.setRbt(null);
      }
    };

    /**
     * @method showFloorWarningMessage
     * @return {Boolean}
     */
    vm.showFloorWarningMessage = function () {
      return vm.isRespectingRbtFloor() &&
        readyByTimes.ready_by_time_floor &&
        readyByTimes.rbt_options[0] < readyByTimes.ready_by_time_floor;
    };

    /**
     * @method $onDestroy
     */
    vm.$onDestroy = function () {
      rbtPromise();
      floorPromise();
    };

    rbtPromise = $scope.$watch('rbtButtonsVm.order.ready_by_time', vm.setExistingRbt);
    floorPromise = $scope.$watch('rbtButtonsVm.readyByTimes.ready_by_time_floor', vm.isRbtValidWithActiveFloor);
  }


  angular.module('zoomerRestaurant')
    .controller('RbtButtonsCtrl', RbtButtonsCtrl);

}());

(function () {
  'use strict';

  /** @ngInject */
  function readyByTimeInput() {
    return {
      restrict: 'A',
      require: '^ngModel',
      link: function (scope, element, attr, ngModel) {
        var ctrl = (scope.rbtButtonsVm || scope.$ctrl || {});
        ctrl.$setDirty = ngModel.$setDirty;
      }
    };
  }

  angular.module('zoomerRestaurant')
    .directive('readyByTimeInput', readyByTimeInput);

}());

(function () {
  'use strict';

  /** @ngInject */
  function serviceHaltedModal($ionicModal, $rootScope, externalOrdersModal) {
    var url = 'app/components/serviceHaltedModal/serviceHaltedModal.html',
      params = { backdropClickToClose: false },
      promise;

    function show() {
      return promise.then(function (m) {
        $rootScope._serviceHaltedModal = m;
        m.show();
      });
    }

    return {
      isOpen: false,

      /**
       * @method getParams
       * @return {Object}
       */
      getParams: function () {
        params.scope = $rootScope.$new();
        params.scope.hide = this.hide.bind(this);
        return params;
      },

      /**
       * @method show
       * @return {Object} $promise
       */
      show: function () {
        if (this.isOpen || externalOrdersModal.isOpen) {
          return;
        }

        this.isOpen = true;
        promise = $ionicModal.fromTemplateUrl(url, this.getParams());
        return show();
      },

      /**
       * @method hide
       */
      hide: function () {
        this.isOpen = false;
        promise.then(function (m) {
          m.hide();
        });
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('serviceHaltedModal', serviceHaltedModal);

}());

(function () {
  'use strict';

  /** @ngInject */
  function sizeHelpModal($ionicModal, $rootScope) {
    var url = 'app/components/sizeHelpModal/sizeHelpModal.html',
      promise,
      params;

    params = {
      backdropClickToClose: false
    };

    return {

      /**
       * @method show
       * @return {Object} $promise
       */
      show: function () {
        function show() {
          return promise.then(function (m) {
            $rootScope._sizeHelpModal = m;
            m.show();
          });
        }

        if (promise) {
          return show();
        }

        promise = $ionicModal.fromTemplateUrl(url, params);
        return show();
      }
    };
  }

  angular.module('zoomerRestaurant')
    .factory('sizeHelpModal', sizeHelpModal);

}());

(function () {
  'use strict';
  var oneMinuteMs = 60000,
    ORDER_DELIVER_AT_MINUTES_CUTOFF = 20,
    LARGE_ORDER_DELIVER_AT_MINUTES_CUTOFF = 30,
    RBT_TO_DELIVER_AT_MINUTES_CUTOFF = 60;

  /** @ngInject */
  function specialOrderRbtValidator(Utilities, readyByTimes) {

    /** @ngInject */
    function SpecialOrderRbtValidatorCtrl($scope) {
      var vm = this;

      function getRbtTime(modelValue, viewValue) {
        return new Date(modelValue || viewValue).getTime();
      }

      function getMinutesBetweenRbtAndDeliverAt(modelValue, viewValue) {
        var rbt = getRbtTime(modelValue, viewValue),
          deliverAt = vm.getOrder().deliver_at,
          difference;

        if (!deliverAt) {
          return;
        }

        difference = new Date(deliverAt).getTime() - rbt;
        return Math.floor(difference / oneMinuteMs);
      }

      /**
       * @method formatReadyByTime
       * @param {Date|String} rbtDate
       * @return {Date}
       */
      vm.formatReadyByTime = function (rbtDate) {
        if (!rbtDate) {
          return null;
        }

        rbtDate = new Date(rbtDate);
        return new Date(rbtDate.getFullYear(), rbtDate.getMonth(), rbtDate.getDate(), rbtDate.getHours(), rbtDate.getMinutes());
      };

      /**
       * @method getOrder
       * @return {Object}
       */
      vm.getOrder = function () {
        var $ctrl = $scope.$ctrl || {};
        return $ctrl.order || {};
      };

      /**
       * @method rbtTooShort
       * @param {Date} modelValue
       * @param {Date} viewValue
       * @return {Boolean}
       */
      vm.rbtTooShort = function (modelValue, viewValue) {
        var rbt = modelValue || viewValue,
          difference;

        if (!rbt || !vm.getOrder().deliver_at) {
          return true;
        }

        rbt = new Date(rbt).getTime();
        difference = Utilities.time.getMinutesDifference(rbt);
        return difference >= (readyByTimes.getMin() || 1);
      };

      /**
       * @method rbtTooLong
       * @param {Date} modelValue
       * @param {Date} viewValue
       * @return {Boolean}
       */
      vm.rbtTooLong = function (modelValue, viewValue) {
        var rbtMinutes = getMinutesBetweenRbtAndDeliverAt(modelValue, viewValue);
        if (!rbtMinutes) {
          return true;
        }

        return rbtMinutes <= RBT_TO_DELIVER_AT_MINUTES_CUTOFF;
      };

      /**
       * @method rbtIsAfterDeliverAt
       * @param {Date} modelValue
       * @param {Date} viewValue
       * @return {Boolean}
       */
      vm.rbtIsAfterDeliverAt = function (modelValue, viewValue) {
        var rbtMinutes = getMinutesBetweenRbtAndDeliverAt(modelValue, viewValue);
        if (!rbtMinutes) {
          return true;
        }

        return rbtMinutes > 0;
      };

      /**
       * @method tooCloseToDeliverBy
       * @param {Date} modelValue
       * @param {Date} viewValue
       * @return {Boolean}
       */
      vm.tooCloseToDeliverBy = function (modelValue, viewValue) {
        var rbtMinutes = getMinutesBetweenRbtAndDeliverAt(modelValue, viewValue),
          order = vm.getOrder(),
          deliverAt = new Date(order.deliver_at),
          largeOrder = order.large_order,
          closeToLimit = largeOrder ? LARGE_ORDER_DELIVER_AT_MINUTES_CUTOFF : ORDER_DELIVER_AT_MINUTES_CUTOFF,
          isRbtFarEnoughAway;

        if (!rbtMinutes || rbtMinutes < 0) {
          return true;
        }

        isRbtFarEnoughAway = rbtMinutes >= closeToLimit;
        $scope.minValidRbtDate = !isRbtFarEnoughAway ? new Date(deliverAt.getTime() - (closeToLimit * oneMinuteMs)) : null;

        return isRbtFarEnoughAway;
      };
    }

    function link(scope, element, attributes, ngModel) {
      var controller = scope.SpecialOrderRbtValidatorCtrl;

      ngModel.$formatters.push(controller.formatReadyByTime);

      ngModel.$validators.rbtTooShort = controller.rbtTooShort;
      ngModel.$validators.rbtTooLong = controller.rbtTooLong;
      ngModel.$validators.rbtIsAfterDeliverAt = controller.rbtIsAfterDeliverAt;
      ngModel.$validators.tooCloseToDeliverBy = controller.tooCloseToDeliverBy;
    }

    return {
      controller: SpecialOrderRbtValidatorCtrl,
      controllerAs: 'SpecialOrderRbtValidatorCtrl',
      link: link,
      require: '^ngModel'
    };
  }

  angular.module('zoomerRestaurant')
    .directive('specialOrderRbtValidator', specialOrderRbtValidator);
}());

angular.module('zoomerRestaurant').run(['$templateCache', function($templateCache) {$templateCache.put('app/autoComplete/autoCompleteDrawer.html','<div class="pac-container" ng-if="autoCompleteVm.isVisible()" ng-style="autoCompleteVm.getPositionStyles()" ng-class="{ \'is-mapquest\': autoCompleteVm.predictions[0].scope === \'MAPQUEST\' }"><div class="pac-item" ng-repeat="prediction in autoCompleteVm.predictions track by $index" ng-class="{\'pac-item-selected\': $index === autoCompleteVm.index }" ng-click="autoCompleteVm.getPlace(prediction)" id="{{prediction.id}}"><span class="pac-icon pac-icon-marker"></span> <span ng-if="prediction.scope === \'MAPQUEST\'" ng-bind="prediction.formatted_address"></span> <span ng-if="prediction.scope !== \'MAPQUEST\'" ng-bind="prediction.description"></span></div></div>');
$templateCache.put('app/autoComplete/autoCompleteWarnings.html','<div class="auto-complete-warnings" ng-if="[\'UNKNOWN_ERROR\', \'REQUEST_DENIED\', \'INVALID_REQUEST\'].indexOf($ctrl.error) > -1"><i class="fa fa-exclamation-triangle"></i> <strong>There are problems with our address finder</strong></div>');
$templateCache.put('app/driverFeedback/driverFeedback.html','<ion-view view-title="Drivers" can-swipe-back="false" class="view-feedback"><root-nav-bar></root-nav-bar><ion-content scroll="false"><div class="no-items no-drivers" ng-if="!vm.unratedDrivers.all.length"><span class="no-items-icon"></span><p ng-if="!vm.submittedAll">No recent drivers</p><p ng-if="vm.submittedAll">You\'ve submitted feedback on all recent drivers. Check back again after a few deliveries.</p></div><ion-slides ng-if="vm.unratedDrivers.all.length" options="vm.options" slider="vm.slider"><ion-slide-page ng-repeat="driver in vm.unratedDrivers.all track by driver.id" ng-class="driver.rating" on-submitted="vm.slideNextAndRemove(driver, $index)"><div class="box-wrapper"><div class="box"><div class="choose-rating" ng-if="!driver.rating || driver.rating === \'positive\'"><h2>Tell us about your experience with</h2><h3 ng-bind="driver.abbreviatedName"></h3><div class="driver-feedback-rating"><a ng-click="vm.selectRating(driver, \'negative\')" class="face face-negative"></a> <a ng-click="vm.selectRating(driver, \'neutral\')" class="face face-neutral"></a> <a ng-click="driver.submitting || vm.selectRating(driver, \'positive\')" class="face face-positive"></a></div><h4><span ng-bind="driver.abbreviatedName"></span>\'s latest deliveries</h4><div class="unrated-orders" ng-class="{ \'fade-edge\': driver.unrated_orders.length >= 4 }"><div class="row header"><div class="col col-75">Address</div><div class="col col-25">Picked up</div></div><ion-scroll direction="y"><ion-list><ion-item ng-repeat="order in driver.unrated_orders track by order.id"><div class="row"><div class="col col-75" ng-bind="order.address.address_1"></div><div class="col col-25" ng-bind="order.pickup_completed_at | date:\'h:mm a\'"></div></div></ion-item></ion-list></ion-scroll></div></div><form name="form" novalidate ng-if="driver.rating === \'neutral\' || driver.rating === \'negative\'" ng-submit="vm.submit(driver)"><h4 ng-switch="driver.rating"><span ng-switch-when="neutral">What could\'ve been better?</span> <span ng-switch-default>What went wrong?</span></h4><a ng-click="vm.selectRating(driver)"><i class="fa fa-chevron-left"></i> Back</a><div class="reasons"><a class="reason" ng-repeat="reason in vm.driverFeedbackReasons.$object track by reason.id" ng-class="{ \'selected\': driver.driver_feedback_reason_ids.indexOf(reason.id) > -1  }" ng-click="vm.setReason(driver, reason.id)" ng-bind="reason.name"></a></div><textarea ng-model="driver.description" placeholder="Tell us more about your experience..."></textarea> <button class="button button-positive" type="submit" ng-disabled="driver.submitting"><i class="fa fa-check" ng-if="driver.submitting"></i> <span ng-if="!driver.submitting">Submit Feedback</span></button></form></div></div></ion-slide-page></ion-slides></ion-content></ion-view>');
$templateCache.put('app/editOrder/deliverAt.html','<h4>When is this order to be delivered?</h4><label class="z-date-picker" for="deliverAt" ng-click="$ctrl.setInitialDeliverAt()"><i class="fa fa-calendar"></i> <input type="datetime-local" id="deliverAt" name="deliverAt" ng-model="$ctrl.order.deliver_at" deliver-at-input-validator> <em ng-if="$ctrl.parent.form.deliverAt.$pristine && !$ctrl.order.deliver_at">Select a day & time</em></label><div ng-messages="$ctrl.parent.form.deliverAt.$error" class="z-error"><strong ng-message="invalidDate">Invalid delivery date selected</strong> <strong ng-message="tooSoonToDeliver">Delivery date is too soon</strong></div><div class="special-order-rbt-wrapper" ng-if="$ctrl.showReadyByTimes"><div class="rbt-floor-active" ng-if="$ctrl.rbtFloorActive"><h6>Whoah! Things are busy!</h6><p>To provide the best customer experience, we need to temporarily push back our pick-up times just a bit. All \'Ready By Time\' options will return shortly.</p></div><div class="special-order-rbt" ng-cloak ng-show="$ctrl.order.deliver_at"><h4 ng-if="!$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')">When will the order be ready?</h4><h4 ng-if="$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')">Select desired pickup time</h4><h6>We have estimated the ready by time, please adjust if necessary</h6><label class="z-date-picker z-time-picker" for="readyByTime"><i class="fa fa-calendar"></i> <input type="time" id="readyByTime" name="readyByTime" ng-model="$ctrl.order.ready_by_time" special-order-rbt-validator required></label><div ng-messages="$ctrl.parent.form.readyByTime.$error" class="z-error" role="alert"><strong ng-message="rbtIsAfterDeliverAt">Ready by time is after the delivery time!</strong> <strong ng-message="tooCloseToDeliverBy">Please select a ready by time no later than <span ng-bind="minValidRbtDate | date:\'h:mm a\'"></span> </strong><strong ng-message="rbtTooLong">Ready by time cannot be more than 1 hour before delivery time!</strong> <strong ng-message="rbtTooShort">Ready by time cannot be sooner than <span ng-bind="$ctrl.readyByTimes.rbt_options[0]"></span>mins away!</strong></div></div></div>');
$templateCache.put('app/editOrder/orderPickupSelector.html','<div ng-if="$ctrl.orderTypeSelected"><h4>Should this order be delivered at a specific day or time?</h4><div class="z-button-group"><a ng-href="" ng-class="{ selected: $ctrl.isSpecificTimeSetTo(true) }" ng-click="$ctrl.setSpecificTimeAndReset(true)">Yes </a><a ng-href="" ng-class="{ selected: $ctrl.isSpecificTimeSetTo(false) }" ng-click="$ctrl.setSpecificTimeAndReset(false)">No</a></div><deliver-at class="special-order-deliver-at" ng-if="$ctrl.isSpecificTimeSetTo(true)" order="$ctrl.order"></deliver-at><rbt-buttons class="edit-orders-rbts" ng-if="$ctrl.isSpecificTimeSetTo(false) && !$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')" order="$ctrl.order"></rbt-buttons><rbt-arbitrator-v1 ng-if="$ctrl.isSpecificTimeSetTo(false) && $root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')" order="$ctrl.order" form="$ctrl.form"></rbt-arbitrator-v1><!--  <div ng-if="$ctrl.isFoodReadyNowToggleEnabled()"--><!--       toggle-food-ready-now--><!--       order="$ctrl.order"></div>--></div>');
$templateCache.put('app/externalOrders/editExternalOrder.html','<form class="edit-order-form" name="orderForm"><div class="edit-email-order-wrapper"><div class="edit-email-number"><h4>Phone Number</h4><diner-telephone phone-number="$ctrl.order.diner_phone_number" is-edit="true"></diner-telephone><span class="form-error" ng-class="{ \'is-invalid\': orderForm.phoneNumber.$invalid }">Please enter a valid phone number.</span></div><div class="contact-message" style="text-align:left;font-size: 15px;width: 290px;"><p>Please contact EatStreet support if a customer\u2019s address needs to be updated</p></div><div class="edit-email-comments"><a ng-href="" ng-click="$ctrl.toggleComments()" ng-if="!$ctrl.showComments">View Delivery Notes</a><div ng-if="$ctrl.showComments"><label>Delivery Notes</label> <textarea ng-model="$ctrl.order.comment" rows="4" name="comment" placeholder="Extension number, delivery instruction etc." class="form-control special-comments">\n        </textarea></div></div></div><div class="form-group submit-row text-right"><button class="button button-default" ng-href="" ng-click="$ctrl.cancel()" ng-if="$ctrl.order.status !== \'parse_error\'">Cancel</button> <button class="button button-positive" ng-click="$ctrl.save()" ng-disabled="orderForm.$invalid">Save</button></div></form>');
$templateCache.put('app/externalOrders/existingSimilarOrders.html','<div class="email-order-exists"><p><i class="fa fa-exclamation-circle"></i> <span ng-if="$ctrl.order.existingOrders.length > 1">Orders</span> <span ng-if="$ctrl.order.existingOrders.length === 1">An order</span> with this phone number is already in the queue:</p><table ng-repeat="existingOrder in $ctrl.order.existingOrders track by existingOrder.id"><tr><th>Ordered</th><th>Address</th><th>Ready by time</th></tr><tr><td ng-bind="existingOrder.created_at | date:\'h:mma\'"></td><td ng-if="!existingOrder.isPickupOrder()" ng-bind="existingOrder.address.address_1"></td><td ng-if="existingOrder.isPickupOrder()">Takeout</td><td><span order-eta order="existingOrder"></span></td></tr><tr ng-if="existingOrder.delivery_notes"><th>Special Notes</th></tr><tr ng-if="existingOrder.delivery_notes"><td colspan="3" ng-bind="existingOrder.delivery_notes"></td></tr></table><p><span ng-if="$ctrl.order.existingOrders.length > 1">Are the orders</span> <span ng-if="$ctrl.order.existingOrders.length === 1">Is the order</span> in the queue the same order as this online order?</p><div class="existing-order-options"><a ng-href="" ng-click="$ctrl.hideExistingOrders()" class="button button-default">No, it\'s different </a><a ng-href="" ng-click="$ctrl.confirmSkip()" class="button button-positive">Yes, skip this order</a></div></div>');
$templateCache.put('app/externalOrders/externalOrder.html','<div class="email-order-container"><div class="container-fluid"><div class="row"><div class="col col-logo"><span order-logo="$ctrl.order"></span></div><div class="col col-details"><external-order-lapsed order="$ctrl.order"></external-order-lapsed><div class="email-orders-details-wrapper"><header class="row row-center"><div class="col col-75"><h3 ng-bind="::$ctrl.order.remote_reference"></h3><h3 ng-if="$ctrl.order.internal_id" order-internal-id="$ctrl.order"></h3></div><div class="col" ng-if="$ctrl.isComponentVisible && !loading"><a ng-href="" ng-click="$ctrl.editOrder()" ng-if="!$ctrl.order.editing">Edit</a> <a ng-if="$ctrl.canSkip()" ng-href="" ng-click="$ctrl.confirmSkip()">Skip</a></div></header><delivery-zone-status ng-if="$ctrl.showOozoOrderOptions()" on-oozo-pricing-selected="acceptChargeAndSubmit()" delivery-zone-status="deliveryZoneStatus" order="$ctrl.order"></delivery-zone-status><div class="email-order-do-not-deliver" ng-if="isDoNotDeliver"><i class="fa fa-times-circle"></i> Order #<span ng-bind="$ctrl.order.remote_reference"></span> for delivery to:<div ng-bind="$ctrl.order.serialized_address.address_1"></div>has been marked as <strong>Do Not Deliver.</strong><br>Contact EatStreet Support for more information</div><existing-similar-orders ng-if="$ctrl.order.existingOrders.length && $ctrl.order.showExistingOrders && !isDoNotDeliver" confirm-skip="$ctrl.confirmSkip()" order="$ctrl.order"></existing-similar-orders><div class="parse-error" ng-if="!$ctrl.isPickupOrder() && (!$ctrl.order.serialized_address.latitude || !$ctrl.order.serialized_address.longitude)"><i class="fa fa-warning"></i> Warning - We can\'t find the exact location of this address</div><div class="parse-error service-halted" ng-if="$root.restaurant.isServiceHalted() && !$ctrl.isPickupOrder()"><i class="fa fa-info-circle"></i> Unfortunately, EatStreet is temporarily halting the delivery service for new orders. We are working to resume service as soon as possible.</div><div class="parse-not-visible" ng-if="!$ctrl.isComponentVisible || loading"><i class="fa fa-refresh fa-spin"></i> Loading ...</div><div ng-show="!$ctrl.order.editing"><div class="order-details"><span class="payment-method" ng-class="$ctrl.order.payment_method" ng-switch on="$ctrl.order.payment_method"><i ng-switch-when="cash" class="fa fa-usd"></i> <i ng-switch-when="credit_card" class="fa fa-credit-card"></i> <i ng-switch-when="prepaid" class="fa fa-check-circle-o"></i></span><h3><i class="fa fa-phone"></i> <span ng-bind="$ctrl.order.diner_phone_number | formatPhoneNumber"></span></h3><h4 ng-if="!$ctrl.isPickupOrder()"><i class="fa fa-map-marker"></i> <span ng-bind="$ctrl.order.serialized_address.address_1"></span></h4><h4 ng-if="$ctrl.isPickupOrder()"><i class="fa fa-shopping-basket"></i> <span>Takeout order</span></h4></div><div ng-if="$ctrl.isRbtSelectionEnabled()"><div class="email-order-internal-id"><div class="edit-order-form" ng-if="$root.features.checkEnabled(\'order_internal_id\')" order-internal-id-input="$ctrl.order"></div></div><external-order-rbts ng-if="!loading" order="$ctrl.order" submit="submit()"></external-order-rbts></div></div><div class="parse-error" ng-show="$ctrl.order.editing && parseError"><p ng-if="onlyDinerNumberError"><i class="fa fa-exclamation-triangle"></i> The number that the diner provided is invalid. Please contact <strong ng-bind="$ctrl.order.source"></strong> customer support to resolve the problem.</p><p ng-if="!onlyDinerNumberError"><i class="fa fa-exclamation-triangle"></i> There was a problem processing this order. Please check the order details from <strong ng-bind="$ctrl.order.source"></strong> and enter them here.</p></div><edit-external-order ng-if="$ctrl.order.editing" on-complete="$ctrl.onComplete()" order="$ctrl.order"></edit-external-order><div class="order-overlay" ng-if="errors"><p>There was an error scheduling pickup,<br>please update order details and try again.</p><button ng-click="dismissSubmitErrors()" class="button button-positive">Update Order Details</button></div><div class="order-overlay" ng-if="cancelled"><h2>Order Was Cancelled</h2></div></div><external-order-html ng-if="$ctrl.isComponentVisible" external-order-id="{{::$ctrl.order.id}}"></external-order-html></div></div></div></div>');
$templateCache.put('app/externalOrders/externalOrderLapsed.html','<h4 class="time-ago"><i ng-if="$ctrl.isLapsed" class="fa fa-exclamation-triangle warning-sign"></i> <strong am-time-ago="$ctrl.order.updated_at"></strong></h4>');
$templateCache.put('app/externalOrders/externalOrderRbts.html','<order-size ng-if="$root.restaurant.hasBicycleSupport()" on-select="$ctrl.submit()" disable-x-large="true" order="$ctrl.order"></order-size><div class="order-ready-by"><rbt-buttons ng-if="!$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')" order="$ctrl.order"></rbt-buttons><rbt-arbitrator-v1 ng-if="$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')" order="$ctrl.order"></rbt-arbitrator-v1></div>');
$templateCache.put('app/ionView/deliveryZoneStatus.html','<div class="oozo-options"><div ng-if="$ctrl.isWithinOuterZone()" class="oozo-options-oozo-pricing"><p>The address associated with this order is <strong>outside the Standard Delivery Zone</strong>.</p><a class="accept" ng-href="" ng-click="$ctrl.acceptOozoCharge()"><i class="fa fa-check"></i> Accept</a><oozo-popover-options order="$ctrl.order"></oozo-popover-options></div><div class="oozo-options-outside-zones" ng-if="$ctrl.deliveryZoneStatus.isOutsideSnowZone"><p>Deliveries to the address associated with this order are currently unavailable due to events outside of EatStreet\'s control.</p><a ng-href="" ng-click="$ctrl.showOozoMapModal()">View on Map</a></div><div class="oozo-options-outside-zones" ng-if="$ctrl.isOutsideDeliveryZone()"><p ng-show="$ctrl.deliveryZoneStatus.isOutsideDeliveryZone">The address associated with this order is outside the <strong>Outer Delivery Radius</strong>.</p><p ng-show="$ctrl.deliveryZoneStatus.isWithinExclusion">The address associated with this order is within a <strong>No Delivery Zone</strong></p><a ng-href="" ng-click="$ctrl.showOozoMapModal()">View on Map </a><a ng-href="" ng-if="!$root.restaurant.isServiceHalted() && !$ctrl.buttonDisabled" ng-click="$ctrl.confirmSendForReview()">Send for Review</a></div></div>');
$templateCache.put('app/ionView/ionView.html','<div ng-transclude></div><ion-footer-bar class="z-footer" ng-if="showFooterBar()"><div class="payment-service-alert" z-footer-item="paymentStatus.restrictRestaurant || paymentStatus.warnRestaurant" ng-if="paymentStatus.restrictRestaurant || paymentStatus.warnRestaurant"><div ng-show="paymentStatus.restrictRestaurant">Please enable your payment service to continue placing orders.<br>Contact your EatStreet representative for details.</div><div ng-show="paymentStatus.warnRestaurant">Your payment service is disabled. Please enable it within <span ng-bind="paymentStatus.daysUntilExpired"></span> days or you will not be able to place orders.<br>Contact your EatStreet representative for details.</div></div><div class="in-app-message" ng-if="showInAppMessage()" z-footer-item="inAppMessages.message" ng-bind-html="inAppMessages.message"></div><div class="in-app-message" ng-if="$root.restaurant.isServiceHalted()" z-footer-item="$root.restaurant.isServiceHalted() && !hasGhostKitchens">Unfortunately, EatStreet is temporarily halting the delivery service for new orders. We are working to resume service as soon as possible.</div><div class="in-app-message in-app-action" ng-if="isTempPaused(restaurantArray[0]) && $root.features.checkEnabled(\'disable_pausing_orders\') && !hasGhostKitchens" z-footer-item="isRestaurantOpen"><strong>Paused accepting new orders for {{restaurantArray[0].pauseLength}} minutes.</strong><br>You are set to automatically start accepting new orders at {{restaurantArray[0].reopenTime | date : "shortTime"}}.</div><div class="in-app-message-new in-app-action-new" ng-if="showNewFooter(restaurantArray[0])"><div class="rest-status"><div class="action-block-new"><span class="dot" ng-class="{\'paused\': !$root.isRestaurantOpen, \'open\': $root.isRestaurantOpen}"></span> <span ng-if="!$root.isRestaurantOpen">Not accepting orders</span> <span ng-if="$root.isRestaurantOpen">Accepting orders</span></div><div class="manage-status-button" ng-click="onOpenCloseRestaurant()"><span>Manage Status</span> <i class="fa fa-chevron-right"></i></div></div><div class="border"></div><div class="menu-status"><div class="action-block-new"><span class="invis-count"><i class="fa fa-eye-slash"></i>{{restaurantArray[0].invisibilityCount}} Unavailable Items</span> <span class="invis-count"><i class="fa fa-eye-slash"></i>{{restaurantArray[0].invisibleOptsCount}} Unavailable Options</span></div><div class="manage-status-button" ng-click="goToMenu(firstRestaurant.eatstreetId)"><span>Menu Availability</span> <i class="fa fa-chevron-right"></i></div></div></div><div class="in-app-message-new in-app-action-new gk" ng-if="showGkFooter()"><div class="rest-status gk" ng-click="openManageStatusPage()"><div class="action-block-new gk"><div><i class="fa fa-circle green"></i> <span>{{numOpen}} Open</span></div><div><i class="fa fa-circle"></i> <span>{{numClosed}} Paused</span></div><div><span><i class="fa fa-clock-o"></i>{{numPaused}} Paused temporarily</span></div></div><div class="manage-status gk"><div class="manage-status-button gk" ng-click="openManageStatusPage()"><span>Manage Status</span> <i class="fa fa-chevron-right"></i></div><span>{{getGkOpenClosed()}}</span> <span>{{numOpen + numClosed + numPaused}} Kitchens</span></div></div><div class="border gk"></div><div class="rest-status gk"><div class="action-block-new gk start"><div class="sold-out-text"><i class="fa fa-eye-slash"></i>Sold Out:</div><div><span ng-pluralize count="totalSoldOutItems" when="{\'1\': \'1 Menu Item\', \'other\': \'{} Menu Items\'}"></span></div><i class="fa fa-circle small"></i><div><span ng-pluralize count="totalSoldOutOptions" when="{\'1\': \'1 Option\', \'other\': \'{} Options\'}"></span></div></div><div class="manage-status gk"><div class="manage-status-button gk" ng-click="openGKMenuModal()"><span>Menus Availability</span> <i class="fa fa-chevron-right"></i></div></div></div></div><delivery-zone-status ng-if="isOozoPossible()" delivery-zone-status="deliveryZoneStatus" order="order"></delivery-zone-status><existing-order-footer ng-if="isOrderState" order="order"></existing-order-footer><div ng-cloak class="has-oozo-review" ng-class="oozoReview.status" ng-if="EditCtrl.hasOozoReview()"><p ng-show="!!order.oozo_pricing_accepted">The address associated with this Order is within the <strong>Outer Delivery Radius</strong></p><p ng-show="oozoReview.status === \'approved\'">This order was <strong>approved</strong> after <em>Out of Zone Order (OOZO)</em> review</p><p ng-show="oozoReview.status === \'rejected\'">This order was <strong>rejected</strong> after <em>Out of Zone Order (OOZO)</em> review</p></div><div class="has-google-maps-error" z-footer-item="isOrderState && googleMaps.error" ng-if="isOrderState && googleMaps.error" ng-click="googleMaps.get()"><i class="fa fa-exclamation-triangle"></i> Whoops! Our address finder failed to load. <em>Click here to retry</em></div><submit-order-button z-footer-item="isOrderState" ng-if="isOrderState" form="orderForm" is-edit="isEdit" delivery-zone-status="deliveryZoneStatus" order="order"></submit-order-button><receipt-close-button z-footer-item="isReceiptState && receiptsForm.selectedReceipts.$modelValue.length" ng-if="isReceiptState && receiptsForm.selectedReceipts.$modelValue.length" form="receiptsForm"></receipt-close-button></ion-footer-bar>');
$templateCache.put('app/ionView/receiptCloseButton.html','<div class="action-button-wrapper"><button type="submit" ng-disabled="$ctrl.form.$invalid">Close <span ng-bind="$ctrl.form.selectedReceipts.$modelValue.length"></span> Receipts</button></div>');
$templateCache.put('app/ionView/submitOrderButton.html','<div class="do-not-deliver-warning" ng-if="$ctrl.form.doNotDeliver.$invalid">This address has been marked <strong>Do Not Deliver.</strong><br>Contact EatStreet Support for more information.</div><div class="action-button-wrapper" ng-cloak ng-if="$ctrl.form.doNotDeliver.$valid"><button type="submit" mix-panel-data="$ctrl.order" ng-class="{ \'is-edit\': $ctrl.isEdit }" ng-disabled="$ctrl.isDisabled()"><span ng-if="!$ctrl.form.$pending"><i class="fa fa-check"></i> <span ng-bind="$ctrl.title"></span> </span><span ng-if="$ctrl.form.$pending"><i class="fa fa-refresh fa-spin ng-animate-disabled"></i> <span>Validating address...</span></span></button></div>');
$templateCache.put('app/login/login.html','<ion-view view-title="Login" class="view-login"><ion-content><div class="form-content"><div class="zoomer-logo" zoomer-logo></div><form name="Login.form" ng-submit="Login.submit()" autocomplete="off"><ion-list ng-class="{ loading: Login.loading }"><div class="private-mode-warning" ng-if="Login.storage.isPrivateModeEnabled"><i class="fa fa-exclamation-triangle"></i> The EatStreet web app cannot be run in Safari\'s Private Browsing Mode. In order to work properly, try reloading the page in a normal tab.</div><ion-item><ion-input class="item item-input"><ion-label>Email Address</ion-label><input ng-keyup="Login.blurOnEnter($event)" ng-model="Login.user.email" ng-disabled="Login.storage.isPrivateModeEnabled" id="input-email" type="email"></ion-input></ion-item><ion-item><ion-input class="item item-input"><ion-label>Password</ion-label><input ng-keyup="Login.blurOnEnter($event)" ng-model="Login.user.password" ng-disabled="Login.storage.isPrivateModeEnabled" type="password" id="input-password" class="form-control"></ion-input></ion-item><em>Logging in</em></ion-list><button ladda="Login.loading" type="submit" class="button button-block button-positive" ng-disabled="Login.loading || Login.storage.isPrivateModeEnabled">Log in</button><ul class="debug-info" ng-if="deployChannel === \'Master\'"><li>Deploy Channel: <span ng-bind="Login.deployChannel"></span></li><li>Device version: <span ng-bind="$root.device.version"></span></li><li>Zoomer App version: <span ng-bind="$root.zoomerAppVersion"></span></li></ul></form></div></ion-content></ion-view>');
$templateCache.put('app/navBar/editOrderNavBar.html','<ion-header-bar class="bar-stable z-nav-bar"><a class="button button-back button-clear" ng-if="editOrderNavBarVm.zoomerState.showBack" ng-href="" ng-click="editOrderNavBarVm.back()"><i class="fa fa-chevron-left"></i> Back</a><h1 class="title" ng-bind="editOrderNavBarVm.title"></h1><div class="order-options"><a class="button button-clear button-iou" ng-href="" ng-if="editOrderNavBarVm.order.canOrderHaveIou()" ng-click="editOrderNavBarVm.order.updateIou()">IOU <span ng-show="!!editOrderNavBarVm.order.data.driver_iou" ng-bind="editOrderNavBarVm.order.data.driver_iou | currency:\'$\':2"></span> </a><a class="button button-clear button-special-order" mix-panel="new-special-order" ng-href="#/app/orders/special/new" ng-if="editOrderNavBarVm.state.current.name === \'app.new-order\'">Special Order </a><a class="button button-assertive" ng-href="" ng-if="editOrderNavBarVm.order.canOrderBeCancelled()" ng-click="editOrderNavBarVm.order.cancel()">Cancel Order</a></div></ion-header-bar>');
$templateCache.put('app/navBar/rootNavBar.html','<ion-header-bar class="bar-stable z-nav-bar"><a class="button button-menu button-icon ion-navicon" menu-toggle="left" ng-click="rootNavBarVm.getStartupInfo()" ng-href=""></a><div class="z-root-buttons" ng-class="rootNavBarVm.state.current.name"><a ng-href="#/app/orders" class="orders" menu-close><i class="z-icon z-orders"></i> Orders </a><a ng-href="#/app/dropoffs" class="dropoffs" ng-if="$root.features.checkEnabled(\'show_returns_tab\')" menu-close><i class="fa fa-undo"></i> Returns <sup class="total-returns" ng-if="rootNavBarVm.returnCount() <= 99" ng-bind="rootNavBarVm.returnCount()"></sup> <sup class="total-returns" ng-if="rootNavBarVm.returnCount() > 99">99+</sup> </a><a ng-href="#/app/history" class="history" menu-close><i class="fa fa-calendar"></i> History </a><a ng-href="#/app/receipts" class="receipts" menu-close><i class="fa fa-file-text-o"></i> Receipts <sup class="total-open-receipts" ng-if="rootNavBarVm.totalOpenReceipts.$total <= 99" ng-bind="rootNavBarVm.totalOpenReceipts.$total"></sup> <sup class="total-open-receipts" ng-if="rootNavBarVm.totalOpenReceipts.$total > 99">99+</sup> </a><a class="drivers" menu-close ng-href="#/app/drivers-feedback"><i class="fa fa-car"></i> Drivers</a></div><a class="button-email-orders-count ng-hide" ng-show="rootNavBarVm.hasPendingExternalOrders()" ng-click="rootNavBarVm.show()" menu-close><i class="fa fa-envelope"></i> <span ng-bind="rootNavBarVm.externalOrders.total"></span><ng-pluralize count="rootNavBarVm.externalOrders.total" when="{ \'1\': \' order waiting\', \'other\': \' orders waiting\' }"></ng-pluralize></a></ion-header-bar>');
$templateCache.put('app/ordersQueue/noPendingOrdersDashboard.html','<div class="no-items no-orders"><span class="no-items-icon"></span><p>No orders in the queue</p><div class="no-items-info announcements-info" ng-if="$ctrl.areAnnouncementsAvailable()"><h3 ng-bind="$ctrl.announcements.all[0].subject"></h3><p ng-bind="$ctrl.announcements.all[0].description"></p><a class="button button-positive" mix-panel="open-announcements-modal" mix-panel-data="$ctrl.announcements.all[0]" ng-href="" ng-click="$ctrl.announcementsModal.show()">Read more</a></div><div class="no-items-info unrated-drivers-info" ng-if="$ctrl.areUnratedDriversAvailable()"><img src="assets/images/faces.svg"><p>How about submitting feedback on some drivers?</p><a ng-href="#/app/drivers-feedback" class="button button-positive">View recent drivers</a></div></div>');
$templateCache.put('app/ordersQueue/ordersQueue.html','<ion-view view-title="Orders" class="view-orders-queue"><root-nav-bar></root-nav-bar><orders-sub-header></orders-sub-header><z-ion-content z-desktop-infinite-scroll="vm.getAll()" z-sticky-scroll-offset="134" z-has-sub-header="true"><div ng-if="vm.type === \'pending\'" ng-include="\'app/views/orders/list/queue.html\'"></div><div ng-if="vm.type === \'inProgress\'" ng-include="\'app/views/orders/list/inProgress.html\'"></div><div ng-if="vm.type === \'delivered\'" ng-include="\'app/views/orders/list/delivered.html\'"></div><div ng-if="vm.type === \'specialOrders\'" ng-include="\'app/views/orders/list/specialOrders.html\'"></div><div ng-if="vm.type === \'ordersForReview\'" ng-include="\'app/views/orders/list/oozoForReview.html\'"></div></z-ion-content></ion-view>');
$templateCache.put('app/rbtArbitratorV1/arbitratorHelpModal.html','<ion-modal-view class="z-modal-arbitrator-help"><ion-header-bar><h1><i class="fa fa-refresh"></i> Estimated Pickup Times</h1></ion-header-bar><ion-content scroll="false"><p>We want to provide our restaurant partners with the most accurate Estimated Pickup Times (EPT) possible. EatStreet continually provides new EPT values based on the current status of several factors including:</p><div class="row"><div class="col"><i class="fa fa-signal"></i> <span>Current Demand</span></div><div class="col"><i class="fa fa-compass"></i> <span>Restaurant Location</span></div><div class="col"><i class="fa fa-map-marker"></i> <span>Delivery Address</span></div></div></ion-content><ion-footer-bar><button class="button button-positive" ng-click="$root._arbitratorHelpModal.hide()">Close</button></ion-footer-bar></ion-modal-view>');
$templateCache.put('app/rbtArbitratorV1/rbtArbitratorV1.html','<h4>Select Estimated Pickup Time <span class="z-icon-help-circle" ng-click="$ctrl.arbitratorHelpModal.show()">?</span></h4><div class="rbt-times-expired row row-center" ng-if="$ctrl.arbitratedData.expired" ng-click="$ctrl.getAvailableTimeSlots()"><span class="col col-60">Time estimates have expired </span><span class="col text-right"><i class="fa fa-refresh ng-animate-disabled" ng-class="{ \'fa-spin\': $ctrl.loading }"></i> <em ng-if="!$ctrl.loading">Refresh</em> <em ng-if="$ctrl.loading">Refreshing...</em></span></div><div class="rbt-buttons rbt-buttons-arbitrator"><div ng-if="$ctrl.existingRbt"><h5>Leave Pickup Time Unchanged</h5><a class="edit-order-existing-rbt" ng-href="" ng-class="{ selected: $ctrl.isExistingRbtSelected() }" ng-click="$ctrl.setReadyByTime()" ng-bind="$ctrl.existingRbt | date:\'h:mm a\'"></a></div><p ng-if="!$ctrl.loading && !$ctrl.arbitratedData.available.length && !$ctrl.arbitratedData.expired">To view available times please input address <span ng-if="$ctrl.restaurant.hasBicycleSupport()">and order size</span></p><p ng-if="$ctrl.loading">Fetching Times...</p><p ng-if="!$ctrl.loading && $ctrl.arbitratedData.available.length && !$ctrl.arbitratedData.expired"><span ng-if="!$ctrl.existingRbt">Available Times</span> <span ng-if="$ctrl.existingRbt">Select Alernative Time</span></p><food-ready-now-button order="$ctrl.order" existing-rbt="$ctrl.existingRbt" on-complete="$ctrl.setReadyByTime()"></food-ready-now-button><a class="button disabled" ng-if="!$ctrl.arbitratedData.available.length" ng-repeat="button in [0, 1, 2, 3]" ng-href="">&hellip; </a><a ng-href="" class="button" ng-if="$ctrl.arbitratedData.available.length" ng-repeat="timeSlot in $ctrl.arbitratedData.available" ng-class="$ctrl.getButtonClass(timeSlot)" ng-click="$ctrl.setReadyByTime(timeSlot)" time-slot-bounce><strong ng-bind="timeSlot.minutesFromNow"></strong> min</a><div ng-if="$ctrl.showFloorWarningMessage()" ng-include="\'app/components/rbtButtons/rbtFloorActiveWarning.html\'"></div><p class="small-note">Estimated Pickup Times are updated to ensure accuracy and help you to better prepare for your deliveries</p></div><input type="hidden" ng-model="$ctrl.order.ready_by_time" name="readyByTime" disabled="disabled" required ready-by-time-input>');
$templateCache.put('app/receipts/receiptDisputeModal.html','<ion-header-bar><h5>Report Issue with Receipt</h5></ion-header-bar><ion-content scroll="false"><div ng-if="!$ctrl.reOpenWithDispute"><h5>What was the issue with the receipt?</h5><button class="button button-block" ng-repeat="(key, value) in $ctrl.receiptDisputeTypes" ng-class="$ctrl.getClassBySelectedType(key)" ng-click="$ctrl.confirmDispute(key)" ng-disabled="$ctrl.receipt.loading" ng-bind="value"></button></div><div ng-if="$ctrl.reOpenWithDispute"><p>In order to change the reported issue, you need to re-open the check first.</p><p>Do you want to re-open this check?</p></div></ion-content><ion-footer-bar><button class="button button-default" ng-if="$ctrl.receipt.receipt_dispute && $ctrl.receipt.receipt_dispute.status === \'in_dispute\' && !$ctrl.reOpenWithDispute" ng-disabled="$ctrl.receipt.loading" ng-click="$ctrl.removeDispute()">Remove issue</button> <button class="button button-default" ng-disabled="$ctrl.receipt.loading" ng-click="$ctrl.modal.remove()">Cancel</button> <button class="button button-positive" ng-if="$ctrl.reOpenWithDispute" ng-disabled="$ctrl.receipt.loading" ng-click="$ctrl.reOpenReceipt()">Re-open check</button></ion-footer-bar>');
$templateCache.put('app/support/orderHelpModal.html','<ion-modal-view class="z-modal-order-help"><div id="page-form" ng-if="!$ctrl.formCompleted"><ion-content scroll="false"><h1>What do you need help with?</h1><h5 ng-if="$ctrl.hasError">There was a problem sending the request - please try again</h5><button class="button button-block button-fat" ng-click="$ctrl.select(button)" ng-class="{ selected : button.selected }" ng-bind="button.value" ng-repeat="button in $ctrl.reasons track by button.id"></button> <textarea ng-model="$ctrl.details" placeholder="Include optional details..."></textarea></ion-content><ion-footer-bar><button class="button button-full" ng-disabled="$ctrl.formDisabled" ng-click="$ctrl.sendFeedback()">REQUEST SUPPORT</button></ion-footer-bar></div><div id="page-thanks" ng-if="$ctrl.formCompleted"><ion-content scroll="false" class="thanks"><div><img src="assets/images/dispatch-guy.png"><p>We\'ve received your support request and an agent is working on that for you now! We\'ll contact you if we need anything else!</p><a href="" ng-click="$ctrl.close()">CLOSE</a></div></ion-content></div></ion-modal-view><a ng-href="" ng-click="$ctrl.close()" class="close-receipt-modal icon ion-ios-close-empty"></a>');
$templateCache.put('app/support/orderRow.html','<div class="row" ng-class="{ disabled: $ctrl.disabled }" ng-click="$ctrl.onClick()"><div class="col col-60" ng-bind="$ctrl.order.address.address_1" ng-if="!$ctrl.order.isPickupOrder()"></div><assigned-driver class="col col-40" driver="$ctrl.order.driver_assigned" ng-if="!$ctrl.order.isPickupOrder()"></assigned-driver><div class="col col-60" ng-bind="$ctrl.order.diner.phone_number" ng-if="$ctrl.order.isPickupOrder()"></div><div class="col col-40" ng-if="$ctrl.order.isPickupOrder()"><i class="fa fa-shopping-basket"></i> <span>Takeout</span></div></div>');
$templateCache.put('app/support/supportDashboard.html','<div class="support-dashboard-wrapper"><div class="support-dashboard-backdrop" ng-click="$ctrl.closeAndReset()" ng-show="$root.isSupportDashboardActive"></div><div class="support-dashboard-content" ng-show="$root.isSupportDashboardActive"><ion-header-bar><a ng-if="$ctrl.supportRouter.cache.length" ng-click="$ctrl.goToLastState()"><i class="fa fa-chevron-left"></i> Back</a><h1>Support</h1><i class="fa fa-times" ng-click="$ctrl.closeAndReset()"></i></ion-header-bar><ion-scroll ng-class="$ctrl.getScrollCls()" delegate-handle="restaurantSupportContent"><div ng-include="$ctrl.supportRouter.getCurrentTpl()"></div></ion-scroll><ion-footer-bar ng-if="$ctrl.hasFooter"><div class="row row-center" ng-if="$ctrl.supportRouter.isIssueResolvedState() && !$ctrl.issueResolved"><div class="col col-60">Was your issue resolved?</div><div class="col"><button class="button button-clear" ng-click="$ctrl.setIssueResolved(true)">Yes</button> <button class="button button-clear" ng-click="$ctrl.setIssueResolved(false)">No</button></div></div><div class="row row-center" ng-if="$ctrl.issueResolved"><div class="col">Glad we could help!</div></div><button type="submit" ng-if="$ctrl.supportRouter.is(\'supportRequestForm\')" ng-click="$ctrl.submitSupportRequest()" ng-disabled="$ctrl.supportRequestData.form.$invalid || $ctrl.loading"><span ng-if="!$ctrl.loading">Submit</span> <span ng-if="$ctrl.loading">Submitting...</span></button></ion-footer-bar></div></div><button class="support-launcher-button" ng-if="$ctrl.isLauncherEnabled()" ng-click="$ctrl.launch()">Support</button>');
$templateCache.put('app/views/date-range-filter.html','<div><a class="button-period-all" ng-if="showAll" ng-href="" ng-click="setPeriodType(\'all\')" ng-class="{ selected: periodType === \'all\' }">All</a><div class="buttons-filter-period"><a ng-href="" ng-click="setPeriodType(\'day\')" ng-class="{ selected: periodType === \'day\' }">Day </a><a ng-href="" ng-click="setPeriodType(\'week\')" ng-class="{ selected: periodType === \'week\' }">Week </a><a ng-href="" ng-click="setPeriodType(\'month\')" ng-class="{ selected: periodType === \'month\' }">Month</a></div><div class="buttons-date-range" ng-class="{ \'disabled\': periodType === \'all\' }"><a ng-href="" class="prev" ng-click="setIncrement()"><i class="fa fa-chevron-left"></i> </a><a ng-href="" class="range-selected" ng-bind="period[periodType].value"></a><a ng-href="" class="next" ng-click="setIncrement(true)"> <i class="fa fa-chevron-right"></i></a></div></div>');
$templateCache.put('app/views/menu.html','<ion-side-menus enable-menu-with-back-views="false"><ion-side-menu-content ng-class="$root.pageClass"><order-visual-notification></order-visual-notification><ion-nav-view name="menu-content"></ion-nav-view></ion-side-menu-content><ion-side-menu side="left" width="300" class="z-side-menu"><ion-content><header ng-if="restaurant.info"><restaurant-logo></restaurant-logo><h3 ng-bind="restaurant.info.name"></h3><span open-close-restaurant ng-hide="$root.features.checkEnabled(\'disable_pausing_orders\')"></span></header><div class="menu-list"><div class="menu-item" ng-click="goToOrders()" mix-panel="orders-queue-accessed" menu-close><i class="fa fa-list"></i> <a>Orders</a></div></div><ul><li class="is-clickable" ng-click="expanded = !expanded;"><div class="menu-list" ng-click="expanded = !expanded;" ng-if="$root.features.checkEnabled(\'menu_viewing\') && hasGhostKitchens"><div class="menu-item"><i class="fa fa-cutlery"></i> <a>Menu Availability </a><i ng-class="{\'fa fa-chevron-down\' : !expanded}" style="font-size: smaller;"></i> <i ng-class="{\'fa fa-chevron-up\' : expanded}" style="font-size: smaller;"></i></div></div></li></ul><div ng-class="{\'expanded\' : expanded}" class="li--wrapper"><div class="dropdown-elem" ng-repeat="rest in restaurantArray" ng-init="show = false" ng-click="show = !show"><div ng-click="goToMenu(rest.eatstreetId)" mix-panel="menu-accessed" menu-close><div ng-if="rest.restaurantName">{{rest.restaurantName}}<div class="right-chevron"><i class="fa fa-chevron-right"></i></div></div></div></div></div><div class="menu-list" ng-if="!hasGhostKitchens && $root.features.checkEnabled(\'menu_viewing\') && !nonESRestaurant"><div class="menu-item" ng-click="goToMenu(firstRestaurant.eatstreetId)" mix-panel="menu-accessed" menu-close><i class="fa fa-cutlery"></i> <a>Menu</a></div></div><div class="menu-list"><div class="menu-item" ng-click="goToHours()" mix-panel="hours-accessed" menu-close><i class="fa fa-clock-o"></i> <a>Update Hours</a></div></div><div class="menu-list"><div class="menu-item" ng-click="goToSettings()" mix-panel="settings-accessed" ng-if="shouldShowThermalPrinterSettings()" menu-close><i class="fa fa-cog"></i> <a>Settings</a></div></div></ion-content><ion-footer-bar><div class="version">Version <span ng-bind="$root.zoomerAppVersion"></span></div><a ng-href="" menu-close ng-click="MenuCtrl.confirmLogout()"><i class="fa fa-sign-in"></i> Logout <span class="zoomer-logo" zoomer-logo></span></a></ion-footer-bar></ion-side-menu></ion-side-menus>');
$templateCache.put('app/views/open-close-restaurant.html','<div><a ng-show="!hasGhostKitchens" ng-href="" class="button" ng-click="toggleRestaurantOpening()" ng-class="{ \'is-toggling\': isTogglingRestaurant, \'button-open\': isRestaurantOpen, \'button-closed\': !isRestaurantOpen }"><span ng-if="isRestaurantOpen" class="toggle-icon"><i ng-class="{ \'fa-check-circle\': !isTogglingRestaurant, \'fa-refresh fa-spin\': isTogglingRestaurant }" class="fa fa-check-circle"></i> </span><span ng-if="!isRestaurantOpen" class="toggle-icon inactive"><i ng-class="{ \'fa-times\': !isTogglingRestaurant, \'fa-refresh fa-spin\': isTogglingRestaurant }" class="fa fa-times"></i> </span><span>{{isRestaurantOpen ? \'\' : \'Not\'}} Accepting orders</span> </a><a ng-if="hasGhostKitchens" ng-href="" class="gkPauseUnpauseModal"><div class="gkKitchenCt"><span>{{getGkOpenClosed()}}</span> <span>{{numOpen + numClosed + numPaused}} Kitchens</span></div><div class="gkOpenClosed"><span class="dot open"></span> <span>{{numOpen}} Open</span> <span class="dot closed"></span> <span>{{numClosed + numPaused}} Paused</span></div><div ng-href="" class="gkManageStatus" ng-click="openManageStatusPage()" menu-close><span>Manage Status</span> <i class="fa fa-chevron-right"></i></div></a></div>');
$templateCache.put('app/views/order-eta.html','<span><span ng-if="isAfter || isNow">Ready</span> <span ng-if="!isAfter && !isNow">{{minutesFromNow}} Mins</span> ({{order.ready_by_time|date:\'h:mm a\'}})</span>');
$templateCache.put('app/views/order-rbt-progress.html','<span class="order-rbt-progress-wrapper"><i style="width: {{transformX}}%"></i></span>');
$templateCache.put('app/views/toggle-food-ready-now.html','<div><h4>Is the Food Ready Now?</h4><div class="z-button-group"><a ng-href="" ng-class="{ selected: !!order.food_ready_now }" ng-click="vm.toggle(true)">Yes </a><a ng-href="" ng-class="{ selected: !order.food_ready_now }" ng-click="vm.toggle(false)">No</a></div></div>');
$templateCache.put('app/views/z-app-updater.html','<div ng-show="showUpdater" class="z-app-updater-wrapper"><div ng-hide="hasError" class="z-app-updater"><p>An update is available; <span ng-show="isDownloading">downloading</span><span ng-show="isExtracting">extracting</span></p><div ng-show="isDownloading" class="z-app-updater-progressbar"><progress max="1.0" ng-value="downloadProgress"></progress></div><div ng-show="isExtracting" class="z-app-updater-progressbar"><progress max="1.0" ng-value="extractProgress"></progress></div></div><div ng-show="hasError" class="z-app-updater-error">There was a problem downloading an update for the app; an error has been logged</div></div>');
$templateCache.put('app/components/announcementsModal/announcementsModal.html','<ion-modal-view class="z-modal z-modal-announcements"><ion-header-bar><h1 ng-bind="announcements.all[0].subject"></h1></ion-header-bar><ion-content><p ng-bind="announcements.all[0].body"></p></ion-content></ion-modal-view><a class="close-receipt-modal icon ion-ios-close-empty" ng-href="" ng-click="announcementsModal.hide()" mix-panel="close-announcements-modal" mix-panel-data="announcements.all[0]"></a>');
$templateCache.put('app/components/assignedDriver/assignedDriver.html','<span class="driver-name" ng-bind="$ctrl.driver.name | getFirstName"></span> <i class="fa fa-bicycle driver-vehicle-bicycle" ng-if="$ctrl.driver.current_vehicle_type === \'bicycle\'"></i>');
$templateCache.put('app/components/confirmOrderRbtPopup/confirmOrderRbtPopup.html','<div class="confirm-special-order"><p>You have a special order going to:</p><div class="address"><div ng-bind="order.address.address_1"></div><div ng-if="order.address.address_2" ng-bind="order.address.address_2"></div><span ng-bind="order.address.city"></span><span ng-if="order.address.state_province_region">, {{order.address.state_province_region}}</span><div>Delivered by <strong ng-bind="order.deliver_at | date:\'h:mm a\' "></strong></div></div><p>The order is set to be ready in <strong>{{minutesFromNow}} minutes.</strong></p><p>Is this time still correct?</p></div>');
$templateCache.put('app/components/customerInformation/customerInformation.html','<div class="col-50"><input ng-if="!order.isPickupOrder()" ng-model="order.address.address_1" name="address_1" type="hidden" required input-change-validator> <input ng-if="!order.isPickupOrder()" ng-model="order.address.city" name="city" type="hidden" required input-change-validator> <input ng-if="!order.isPickupOrder()" ng-model="order.address.state_province_region" name="state_province_region" type="hidden" required input-change-validator><h4>Customer Information</h4><diner-telephone on-valid-number="$ctrl.getDiners(params)" phone-number="order.diner.phone_number" is-edit="false"></diner-telephone><div class="contact-message"><p>Please contact EatStreet support if a customer\u2019s address needs to be updated</p></div><ion-infinite-scroll class="infinite-scroll-spinner" ng-if="::isMobileDevice" distance="15%" immediate-check="false" on-infinite="$ctrl.nextPage()"></ion-infinite-scroll></div>');
$templateCache.put('app/components/customerInformation/dinerAddressItem.html','<div class="truncated-diner-address" ng-click="$ctrl.expand()"><span ng-bind="$ctrl.fullAddress"></span> <span class="expand-diner-address" ng-if="$ctrl.truncated">Expand</span></div>');
$templateCache.put('app/components/dinerAddress/dinerAddress.html','<div class="zoomer-order-address-fields"><ion-input class="zoomer-field"><input type="hidden" ng-model="address.address_1" name="address_1" required><diner-address-lookup address="address" on-delivery-zone-update="onDeliveryZoneUpdate({ deliveryZoneStatus: deliveryZoneStatus })"></diner-address-lookup></ion-input><ion-input class="zoomer-field zoomer-order-address-two" ng-class="$ctrl.getAddressTwoCls()"><p>This address looks long. Should this go in the Special Notes?</p><input type="text" ng-model="address.address_2" name="address_2" placeholder="Apt / suite / floor" address-two> <a ng-click="$ctrl.disableAddressTwoWarning()">No, this is an address</a> <a class="confirm" ng-click="$ctrl.setAsDeliveryNotes()">Yes, these are instructions</a></ion-input><div class="row" ng-if="!$root.features.checkEnabled(\'restaurant_multiple_locations\')"><ion-input class="zoomer-field"><input type="text" ng-model="address.city" name="city" placeholder="City"></ion-input><ion-input class="zoomer-field"><input type="text" ng-model="address.state_province_region" name="state_province_region" placeholder="State"></ion-input></div><div ng-if="$root.features.checkEnabled(\'restaurant_multiple_locations\')"><ion-input class="zoomer-field"><input type="text" ng-model="address.city" name="city" placeholder="City"></ion-input><div class="row"><ion-input class="zoomer-field"><input type="text" ng-model="address.state_province_region" name="state_province_region" placeholder="State"></ion-input><ion-input class="zoomer-field"><input type="text" ng-model="address.postal_code" name="postal_code" placeholder="ZIP Code"></ion-input></div></div></div>');
$templateCache.put('app/components/dinerAddressLookup/dinerAddressLookup.html','<div class="auto-complete-wrapper"><div class="auto-complete-loading" ng-if="dinerAddressLookupVm.loading || dinerAddressLookupVm.validating"><i class="fa fa-refresh fa-spin ng-animate-disabled" ng-show="dinerAddressLookupVm.loading"></i> <i class="fa fa-refresh fa-spin ng-animate-disabled" ng-show="dinerAddressLookupVm.validating"></i></div><auto-complete-warnings error="dinerAddressLookupVm.autoComplete.error"></auto-complete-warnings><input type="text" autocomplete="off" ng-if="!dinerAddressLookupVm.isMobileDevice && !dinerAddressLookupVm.loading" ng-model="dinerAddressLookupVm.street" ng-model-options="dinerAddressLookupVm.modelOptions" on-complete="dinerAddressLookupVm.onComplete(place, multipleLocations)" auto-complete> <input readonly="readonly" class="z-dummy-input-field" ng-if="dinerAddressLookupVm.isMobileDevice && !dinerAddressLookupVm.loading" ng-class="{ \'is-placeholder\': dinerAddressLookupVm.isPlaceholder }" ng-click="dinerAddressLookupVm.autoCompleteModalBar.show({ scope: this })" ng-model="dinerAddressLookupVm.placeholder"><div class="auto-complete-multiple-locations" ng-if="dinerAddressLookupVm.multipleLocations.length > 1"><h4>This address has multiple locations. Do you mean:</h4><a ng-href="" ng-repeat="location in dinerAddressLookupVm.multipleLocations" ng-bind="location.formatted_address" ng-click="dinerAddressLookupVm.validatePlace(location)"></a></div><label class="label-confirm-street" ng-show="dinerAddressLookupVm.showConfirmStreetNumber"><input type="checkbox" name="streetNumberConfirmed" required ng-model="dinerAddressLookupVm.streetNumberConfirmed"><div><i class="fa fa-check"></i></div>Yes, this is the correct address.</label></div>');
$templateCache.put('app/components/dinerTelephone/dinerTelephone.html','<div class="diner-telephone-wrapper ng-animate-disabled" ng-class="{ active: dinerTelephoneVm.isKeypadActive, \'is-mobile\': $root.isMobileDevice, \'is-desktop\': !$root.isMobileDevice }" ng-click="dinerTelephoneVm.showKeypad($event)"><input name="phoneNumber" placeholder="Phone number" diner-telephone-input ng-change="updateKeypadValue(dinerTelephoneVm.phoneNumber)" ng-model="dinerTelephoneVm.phoneNumber"> <span class="phone-number" ng-bind="dinerTelephoneVm.phoneNumber | formatPhoneNumber"></span> <em ng-show="!dinerTelephoneVm.phoneNumber">Phone number</em> <span class="invalid-number" ng-if="$parent.orderForm.$error.phoneNumber">Not a valid US phone-number</span></div>');
$templateCache.put('app/components/existingOrderFooter/existingOrderFooter.html','<div class="has-existing-order" ng-cloak z-footer-item="$ctrl.existingExternalOrders.length" ng-if="$ctrl.existingExternalOrders.length"><p>Is this order from <span ng-bind="$ctrl.sources"></span>? There\'s an online order waiting which looks similar</p><a ng-href="" ng-click="$ctrl.showModal()">View order</a></div>');
$templateCache.put('app/components/externalOrdersModal/externalOrdersModal.html','<ion-modal-view class="z-modal-email-orders" hide-nav-bar="true" ng-controller="ExternalOrdersModalCtrl as externalOrdersModalVm"><ion-header-bar><h1>You have <span ng-bind="externalOrdersModalVm.externalOrders.total"></span> new <em ng-if="externalOrdersModalVm.externalOrders.all.length === 1">order!</em> <em ng-if="externalOrdersModalVm.externalOrders.all.length > 1">orders!</em> <a ng-href="" ng-if="$root.features.checkEnabled(\'restaurant_app_enable_bulk_skip_of_external_orders\')" ng-click="externalOrdersModalVm.skipAllOrders()">Skip all?</a></h1><div class="snoozed-orders-count" ng-if="externalOrdersModalVm.externalOrders.totalSnoozed" ng-click="externalOrdersModalVm.showSnoozedOrdersHelp()"><span ng-pluralize count="externalOrdersModalVm.externalOrders.totalSnoozed" when="{\'0\': \'No orders snoozed\', \'1\': \'1 snoozed order\', \'other\': \'{} snoozed orders\'}"></span> <span class="z-icon-help-circle">?</span></div><a class="button button-close" ng-href="" ng-click="externalOrdersModalVm.dismiss()">Close</a></ion-header-bar><z-ion-content on-scroll="externalOrdersModalVm.onContentScroll(scrollTop, bounds)" z-desktop-infinite-scroll="externalOrdersModalVm.nextPage()"><ion-refresher ng-if="$root.isMobileDevice" pulling-text="Pull to refresh..." on-refresh="externalOrdersModalVm.refreshAllOrders()"></ion-refresher><div class="email-order-container" ng-if="externalOrdersModalVm.countPausedKitchens() > 0"><div class="container-fluid"><div class="row"><div class="col col-logo"><span order-logo="$ctrl.order"></span></div><div class="col col-details"><div class="email-orders-details-wrapper gk"><div class="col"><div class="paused-notification" ng-if="externalOrdersModalVm.hasGhostKitchens">You have temporarily paused accepting new orders for {{externalOrdersModalVm.tempPausedCount}} kitchen{{externalOrdersModalVm.tempPausedCount > 1 ? \'s\' : \'\'}}.<br><strong>Please select "Ready By Time" for the {{externalOrdersModalVm.externalOrders.total}} order{{externalOrdersModalVm.externalOrders.total > 1 ? \'s\' : \'\'}} below:</strong></div><div class="paused-notification" ng-if="!externalOrdersModalVm.hasGhostKitchens">You have temporarily paused accepting new orders for {{externalOrdersModalVm.restaurantArray[0].pauseLength}} minutes.<br><strong>Please select "Ready By Time" for the {{externalOrdersModalVm.externalOrders.total}} order{{externalOrdersModalVm.externalOrders.total > 1 ? \'s\' : \'\'}} below:</strong></div></div></div></div></div></div></div><external-order ng-repeat="order in externalOrdersModalVm.externalOrders.all track by order.id" content-bounds="externalOrdersModalVm.contentBounds" scroll-top="externalOrdersModalVm.scrollTop" order="order"></external-order><div class="row loading" ng-if="externalOrdersModalVm.loading" ng-class="{ \'no-items\': !externalOrdersModalVm.externalOrders.all.length }"><div class="col text-center"><i class="fa fa-refresh fa-spin"></i></div></div><ion-infinite-scroll class="email-orders-spinner infinite-scroll-spinner" ng-if="$root.isMobileDevice" distance="15%" immediate-check="false" on-infinite="externalOrdersModalVm.nextPage()"></ion-infinite-scroll></z-ion-content></ion-modal-view>');
$templateCache.put('app/components/externalOrderHtml/externalOrderHtml.html','<div class="order-email-html" ng-class="{ open: $ctrl.showBodyHtml }"><em ng-show="$ctrl.loading"><i class="fa fa-refresh fa-spin ng-animate-disabled"></i> Loading details...</em><div ng-cloak ng-show="!$ctrl.loading"><a class="has-error" ng-href="" ng-if="$ctrl.error" ng-click="$ctrl.$onInit()">There was a problem fetching the order details.<br>Click to try again</a><div class="html-wrapper"><external-order-iframe html="$ctrl.emailOrder.body_html" ng-if="!$ctrl.error"></external-order-iframe></div></div></div>');
$templateCache.put('app/components/externalOrderHtml/externalOrderIframe.html','<div class="external-order-iframe-content" on-drag-right="$ctrl.onDrag($event)" on-drag-left="$ctrl.onDrag($event)"><iframe onload="this.style.height = this.contentWindow.document.body.scrollHeight + \'px\'"></iframe></div>');
$templateCache.put('app/components/foodReadyNowButton/foodReadyNowButton.html','<a ng-href="" class="button" ng-if="$ctrl.isFRNEnabled()" ng-class="$ctrl.isFoodReadyNowSelected()" ng-click="$ctrl.setFoodReadyNow()"><strong>Now</strong></a>');
$templateCache.put('app/components/ghostKitchenToggleOpen/ghost-kitchen-toggle-open.html','<ion-modal-view class="z-modal-gk-pause-unpause"><div class="z-modal-gk-pause-unpause__header"><h1>Restaurant Status</h1><div class="gkPauseUnpauseModal"><span>{{numOpen + numClosed + numPaused}} Kitchens </span><a class="gkOpenClosed"><div><i class="fa fa-circle green"></i> <span>{{numOpen}} Open</span></div><div><i class="fa fa-circle grey"></i> <span>{{numClosed}} Paused</span></div><div><i class="fa fa-clock-o blue"></i> <span>{{numPaused}} Paused temporarily</span></div></a></div></div><div class="rest-list-table"><div ng-repeat="rest in restaurantArray" class="gk-restaurant-list" ng-class-odd="\'gk-restaurant-list--odd\'"><span>{{rest.restaurantName}}</span><div ng-class="{\'reopen-switch-container\' : (isTempPaused(rest))}"><span ng-if="isTempPaused(rest)" class="reopen-time"><i class="fa fa-clock-o"></i> Paused temporarily until {{rest.reopenTime | date : "shortTime"}}</span><div class="pause-switch-wrapper"><input type="checkbox" id="{{rest.eatstreetId}}" class="checkbox" ng-model="rest.openStatus" ng-change="toggleKitchen()"> <label for="{{rest.eatstreetId}}" class="switch"></label></div></div></div></div><div class="bottom-container"><div class="buttons-flex"><div class="paused-notice">All paused kitchens will automatically reopen tomorrow</div><a class="cancel-button" ng-click="closeModal()">Cancel</a> <a ng-class="{\'confirm-button\': !disableConfirmBtn, \'confirm-button confirm-button--disabled\': disableConfirmBtn}" ng-click="confirmKitchenModal()">Confirm{{loading ? \'ing\' : \'\'}} Changes<div ng-if="loading"><ion-spinner icon="ios"></ion-spinner></div></a></div></div></ion-modal-view>');
$templateCache.put('app/components/hoursModal/hours.html','<ion-modal-view class="z-modal z-modal-hours submit" ng-controller="HoursCtrl as hoursVm"><div><div class="header submit"><div><i class="fa fa-check-circle"></i><h1>Request Submitted</h1></div></div><div class="hours-input submit"><div>Your change has been sent to our Support team.</div><div>You\u2019ll receive an email confirmation once complete.</div></div></div><div class="hours-buttons"><div class="button cancel bold" ng-click="hoursVm.closeModal();">Close</div></div></ion-modal-view><ion-modal-view class="z-modal z-modal-hours" ng-controller="HoursCtrl as hoursVm" ng-hide="hoursVm.submitted"><div class="header"><h1>Update Hours Request</h1></div><div class="hours-input">Please specify your updated hours below.<div ng-show="hoursVm.hasGhostKitchens">Be sure to include which kitchens are being updated.</div><textarea id="hoursRequest" placeholder="Write here" ng-model="hoursVm.request"></textarea><div ng-hide="hoursVm.error">It can take up to 48 hours to process your request. For immediate changes, please contact Support.</div><div class="error" ng-show="hoursVm.error">Your request did not send successfully. Please try again. If you continue to experience issues, please contact EatStreet Support.</div></div><div class="hours-buttons"><div class="button cancel" ng-click="hoursVm.closeModal();">Cancel</div><div class="button submit" id="submit-button" ng-click="hoursVm.submit()" ng-disabled="hoursVm.checkInput()">Submit Request</div></div></ion-modal-view>');
$templateCache.put('app/components/largeOrderToggle/largeOrderToggle.html','<div ng-if="!$root.restaurant.hasBicycleSupport()"><h4>Will this order require multiple trips to the car?</h4><div class="z-button-group"><a ng-href="" ng-class="{ selected: $ctrl.order.large_order !== null && $ctrl.order.large_order === true }" ng-click="$ctrl.setLargeOrder(true)">Yes </a><a ng-href="" ng-class="{ selected: $ctrl.order.large_order !== null && $ctrl.order.large_order === false }" ng-click="$ctrl.setLargeOrder(false)">No</a></div></div>');
$templateCache.put('app/components/menuFooter/menu-footer.html','<div class="menu-footer"><div class="visibilities"><span class="invis-count"><i class="fa fa-eye-slash"></i> <span ng-pluralize count="restaurant.invisibilityCount" when="{\'1\': \'1 Unavailable Item\', \'other\': \'{} Unavailable Items\'}"></span> </span><span class="invis-count"><i class="fa fa-eye-slash"></i> <span ng-pluralize count="restaurant.invisibleOptsCount" when="{\'1\': \'1 Unavailable Option\', \'other\': \'{} Unavailable Options\'}"></span></span></div><div class="sold-out" ng-class="{\'sold-out-active\': $ctrl.filterSoldOut}"><div class="custom-checkbox"><label class="container"><input type="checkbox" id="filter-soldout-items" class="checkbox" name="filter-soldout-items" ng-model="$ctrl.filterSoldOut" ng-change="$ctrl.change()"> <span class="checkmark"></span></label></div><div ng-click="$ctrl.filterSoldOut = !$ctrl.filterSoldOut; $ctrl.change()">Sold Out {{viewChoice === \'products\' ? \'Items\' : \'Options\'}}</div></div></div>');
$templateCache.put('app/components/menuItemsList/menu-items.html','<div class="li li--menu" ng-click="openOptionsAvailability(product)"><div class="menu-item__container" ng-class="::{\'menu-item__container--disabled\': (product.pickupOnly) || (product.deliveryOnly)}"><div class="product__info-container"><div><div class="menu-item__header category" ng-if="productSearch">{{ categoryName }}</div><div class="menu-item__header">{{product.name}}</div></div></div><div class="product-price-container"><button class="available-btn" ng-show="!product.invisible && !product.temporarilyInvisible"><i class="fa fa-check"></i> <span>Available</span></button> <button class="available-btn err" ng-show="product.temporarilyInvisible"><i class="fa fa-eye-slash"></i> <span>Sold out today</span></button> <button class="available-btn err" ng-show="product.invisible && !product.temporarilyInvisible"><i class="fa fa-eye-slash"></i> <span>Sold out indefinitely</span></button></div><i class="z-icon-kebab"></i></div></div>');
$templateCache.put('app/components/menuSearchTool/menu-search.html','<div class="search-bar-items"><div class="search"><i class="fa fa-search" ng-class="{blue: focus === true}"></i> <input type="text" ng-model="$ctrl.productSearch" ng-change="$ctrl.change()" ng-focus="focus = true" ng-blur="focus = false" placeholder="Search for {{viewChoice === \'products\' ? \'menu items\' : \'options\'}}"></div></div>');
$templateCache.put('app/components/numberKeypad/numberKeypad.html','<ion-popover-view class="z-popover z-popover-phone-keypad"><div scroll="false" ng-controller="NumberKeypadCtrl as numberKeypadVm"><div class="row"><a ng-href="" class="col" z-click="numberKeypadVm.addDigit(1)">1</a> <a ng-href="" class="col" z-click="numberKeypadVm.addDigit(2)">2</a> <a ng-href="" class="col" z-click="numberKeypadVm.addDigit(3)">3</a></div><div class="row"><a ng-href="" class="col" z-click="numberKeypadVm.addDigit(4)">4</a> <a ng-href="" class="col" z-click="numberKeypadVm.addDigit(5)">5</a> <a ng-href="" class="col" z-click="numberKeypadVm.addDigit(6)">6</a></div><div class="row"><a ng-href="" class="col" z-click="numberKeypadVm.addDigit(7)">7</a> <a ng-href="" class="col" z-click="numberKeypadVm.addDigit(8)">8</a> <a ng-href="" class="col" z-click="numberKeypadVm.addDigit(9)">9</a></div><div class="row"><a ng-href="" class="col delete" z-click="numberKeypadVm.removeDigit()">&nbsp;</a> <a ng-href="" class="col" z-click="numberKeypadVm.addDigit(0)">0</a> <a ng-href="" class="col" z-click="numberKeypadVm.clear()">Clear</a></div></div></ion-popover-view>');
$templateCache.put('app/components/order-visual-notification/order-visual-notification.html','<div class="visual-notification-bg" ng-if="newOrders" ng-click="removeNotificationScreen()"><span class="zoomer-logo" zoomer-logo></span><div class="notification-wrapper"><div class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" id="Comp-1" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 400 400" white-space="pre"><g id="Shape-Layer-4" transform="matrix(.3 0 0 .3 200 200)" style="animation:3.467s linear infinite both Shape-Layer-4_t"><g id="Ellipse-1" transform="translate(.479 .174) scale(1.19263)" style="animation:3.467s linear infinite both Ellipse-1_o"><ellipse id="Ellipse-Path-1" fill="#fff" rx="230.987" ry="230.987" stroke="#fff" stroke-width="2"/></g></g><g id="Shape-Layer-3" transform="matrix(.3 0 0 .3 200 200)" style="animation:3.467s linear infinite both Shape-Layer-3_t"><g id="Ellipse-1-2" transform="translate(.479 .174) scale(1.19263)" style="animation:3.467s linear infinite both Ellipse-1-2_o"><ellipse id="Ellipse-Path-1-2" fill="#fff" rx="165.987" ry="165.987" stroke="#fff" stroke-width="2"/></g></g><g id="Shape-Layer-2" transform="matrix(.3 0 0 .3 200 200)" style="animation:3.467s linear infinite both Shape-Layer-2_t"><g id="Ellipse-1-3" transform="translate(.479 .174) scale(1.19263)" style="animation:3.467s linear infinite both Ellipse-1-3_o"><ellipse id="Ellipse-Path-1-3" fill="#fff" rx="165.987" ry="165.987" stroke="#fff" stroke-width="2"/></g></g></svg> <span>{{total}}</span></div><h1>New {{total !== 1 ? \'Orders\' : \'Order\'}}</h1></div><p>Tap anywhere to view orders</p></div>');
$templateCache.put('app/components/orderDriverIou/orderDriverIou.html','<input ng-model="$ctrl.order.driver_iou" name="driverIou" type="hidden" readonly="readonly" placeholder="Driver IOU" order-driver-iou>');
$templateCache.put('app/components/orderInternalIdInput/orderInternalIdInput.html','<h4>Internal ID <sup>* Optional</sup></h4><div class="internal-id-wrapper"><input name="internalId" ng-show="!$root.isMobileDevice" ng-disabled="orderInternalIdInputVm.order.isDeliveryInProgress" ng-model="orderInternalIdInputVm.order.internal_id"><div class="input" ng-if="$root.isMobileDevice" ng-class="{ disabled: orderInternalIdInputVm.order.isDeliveryInProgress }" ng-bind="orderInternalIdInputVm.order.internal_id" ng-click="orderInternalIdInputVm.showKeypad($event)"></div></div>');
$templateCache.put('app/components/orderLeafletMap/orderLeafletMap.html','<div class="order-map-wrapper"></div><div class="order-map-warnings" ng-if="$ctrl.isDinerMissingCoordinates || $ctrl.isRestaurantMissingCoordinates"><div ng-if="$ctrl.isDinerMissingCoordinates"><span><i class="fa fa-exclamation-triangle"></i> We\'re having trouble geo-locating this customer - contact EatStreet support to resolve this.</span><order-help-modal text="GET IN TOUCH" order="$ctrl.order"></order-help-modal></div><div ng-if="$ctrl.isRestaurantMissingCoordinates"><span><i class="fa fa-exclamation-triangle"></i> No Restaurant coordinates found for this order</span></div></div>');
$templateCache.put('app/components/orderPaymentMethod/orderPaymentMethod.html','<div class="z-button-group payment-methods"><ion-radio ng-model="$ctrl.order.payment_method" ng-value="\'credit_card\'" ng-disabled="$ctrl.order.isDeliveryInProgress">Credit Card</ion-radio><ion-radio ng-model="$ctrl.order.payment_method" ng-value="\'cash\'" ng-disabled="$ctrl.order.isDeliveryInProgress">Cash</ion-radio><ion-radio ng-model="$ctrl.order.payment_method" ng-value="\'prepaid\'" ng-disabled="$ctrl.order.isDeliveryInProgress">Online Prepaid</ion-radio></div><input ng-disabled="$ctrl.order.isDeliveryInProgress" ng-model="$ctrl.order.payment_method" type="hidden" name="paymentMethod" readonly="readonly" required>');
$templateCache.put('app/components/orderPopoverMenu/orderPopoverMenu.html','<div class="order-popover-menu" ng-show="$ctrl.order" ng-class="{invisible: $ctrl.invisible}"><div class="order-popover-backdrop" ng-click="$ctrl.hide()"></div><div id="order-popover" ng-class="{ \'show\': $ctrl.order }"><div class="order-popover-content" ng-if="$ctrl.order"><div ng-if="$ctrl.order.isFinished"><a mix-panel="view-order" mix-panel-data="$ctrl.order" ng-click="$ctrl.hide()" ng-href="#/app/orders/{{$ctrl.order.id}}/view"><i class="fa fa-external-link"></i> View in detail </a><a mix-panel="reorder" mix-panel-data="$ctrl.order" ng-if="!$ctrl.order.isReOrderDisabled" ng-click="$ctrl.hide()" ng-href="#/app/orders/{{$ctrl.order.id}}/reorder/new"><i class="fa fa-refresh"></i>Re-order </a><a class="disabled" ng-href="" ng-if="$ctrl.order.isReOrderDisabled"><i class="fa fa-refresh"></i> <span ng-if="$ctrl.order.isSpecialOrder">Re-order unavailable on special orders</span> <span ng-if="!$ctrl.order.isSpecialOrder">Re-order</span></a></div><div ng-if="!$ctrl.order.isFinished"><a mix-panel="edit-order" mix-panel-data="$ctrl.order" ng-if="!$ctrl.order.isSpecialOrder && !$ctrl.order.isReOrder && $ctrl.order.isEditable" ng-click="$ctrl.hide()" ng-href="#/app/orders/{{$ctrl.order.id}}/edit"><i class="fa fa-pencil-square-o"></i>Edit order </a><a mix-panel="edit-special-order" mix-panel-data="$ctrl.order" ng-if="$ctrl.order.isSpecialOrder && !$ctrl.order.isReOrder && $ctrl.order.isEditable" ng-click="$ctrl.hide()" ng-href="#/app/orders/special/{{$ctrl.order.id}}/edit"><i class="fa fa-pencil-square-o"></i>Edit special order </a><a mix-panel="edit-reorder" mix-panel-data="$ctrl.order" ng-if="!!$ctrl.order.isReOrder && $ctrl.order.isEditable" ng-click="$ctrl.hide()" ng-href="#/app/orders/{{$ctrl.order.id}}/reorder/edit"><i class="fa fa-pencil-square-o"></i>Edit re-order </a><a mix-panel="view-order-html" mix-panel-data="$ctrl.order" ng-click="$ctrl.openEmailDetailsModal($ctrl.order.email_order_id)" ng-if="$ctrl.order.isUndeliveredEmailOrder"><i class="ng-animate-disabled fa fa-list"></i> Order details </a><a mix-panel="order-reorder" mix-panel-data="$ctrl.order" ng-show="$ctrl.order.status === \'delivery_in_progress\' && !$ctrl.order.isSpecialOrder" ng-click="$ctrl.hide()" ng-href="#/app/orders/{{$ctrl.order.id}}/reorder/new"><i class="fa fa-refresh"></i>Re-order </a><a mix-panel="view-order-loc" mix-panel-data="$ctrl.order" ng-if="!$ctrl.order.isPickupOrder()" ng-click="$ctrl.openLocationModal()" ng-href=""><i class="fa fa-map-marker"></i>Location </a><a mix-panel="dismiss-pickup-order" mix-panel-data="$ctrl.order" ng-if="$ctrl.order.isActivePickupOrder()" ng-click="$ctrl.dismissPickupOrder()" ng-href=""><i class="fa fa-times"></i>Mark as picked up </a><a mix-panel="print" mix-panel-data="$ctrl.order" ng-if="$ctrl.shouldShowPrint()" ng-click="$ctrl.print()" ng-href=""><i class="fa fa-print"></i>Print</a></div><a ng-click="$ctrl.launchSupportDashboardV2()" ng-href="#/app/orders"><i class="fa fa-comments"></i> Support</a></div></div></div>');
$templateCache.put('app/components/orderSize/orderSize.html','<div class="order-size"><h4>Size of Order <span class="z-icon-help-circle" ng-click="$ctrl.sizeHelpModal.show()">?</span></h4><div class="rbt-buttons"><a class="button" ng-class="$ctrl.getCls(\'small\')" ng-click="$ctrl.setOrderSize(\'small\')">Small </a><a class="button" ng-class="$ctrl.getCls(\'medium\')" ng-click="$ctrl.setOrderSize(\'medium\')">Medium </a><a class="button" ng-class="$ctrl.getCls(\'large\')" ng-click="$ctrl.setOrderSize(\'large\')">Large </a><a class="button" ng-if="!$ctrl.disableXLarge" ng-class="$ctrl.getCls(\'extra_large\')" ng-click="$ctrl.setOrderSize(\'extra_large\')">X-Large</a></div><p class="small-note" ng-if="$ctrl.order.size" ng-switch="$ctrl.order.size"><span ng-switch-when="small">Comfortably fits in one grocery bag. </span><span ng-switch-when="medium">Comfortably fits in two grocery bags. </span><span ng-switch-when="large">Comfortably fits in four grocery bags. Can be carried in <strong>one trip to the vehicle</strong>, and will be charged as a standard delivery. </span><span ng-switch-when="extra_large">Requires multiple trips to the vehicle.</span></p><ion-checkbox ng-model="$ctrl.order.do_not_deliver_by_bicycle" ng-disabled="$ctrl.order.size === \'extra_large\' || $ctrl.order.isDeliveryInProgress">This should not be delivered on a bicycle</ion-checkbox><input type="hidden" ng-model="$ctrl.order.size" ng-disabled="$ctrl.order.isDeliveryInProgress" required input-change-validator></div>');
$templateCache.put('app/components/orderSourceModal/orderSourceModal.html','<ion-modal-view class="z-modal-html-source"><ion-content delegate-handle="emailSource" direction="xy"><external-order-iframe ng-if="emailOrder.body_html" html="emailOrder.body_html"></external-order-iframe></ion-content></ion-modal-view><a ng-href="" ng-click="modal.hide()" class="close-receipt-modal icon ion-ios-close-empty"></a>');
$templateCache.put('app/components/orderSubmitErrorModal/orderSubmitErrorModal.html','<div class="order-submit-error"><p ng-bind="error.data.error_description"></p><ul ng-show="error.data.details"><li ng-show="key !== \'restaurant\'" ng-repeat="(key, details) in error.data.details track by key"><strong ng-bind="key"></strong> <span ng-repeat="detail in details track by $index" ng-bind="detail"></span></li></ul></div>');
$templateCache.put('app/components/ordersQueueInfoIcons/ordersQueueInfoIcons.html','<span class="z-order-status z-iou" ng-click="$ctrl.showIouTooltip($event, $ctrl.order)" ng-if="!!$ctrl.order.driver_iou && !$ctrl.isReturning">IOU</span> <span class="z-order-status z-oozo" ng-click="$ctrl.showTooltip($event, \'oozoTooltip\')" ng-if="$ctrl.utilities.orders.isOozo($ctrl.order) && !$ctrl.isReturning">OOZO</span> <i class="fa fa-star" ng-click="$ctrl.showTooltip($event, \'tooltip\', \'Special Order\')" ng-if="(!!$ctrl.order.deliver_at || !!$ctrl.order.large_order) && !$ctrl.isReturning"></i> <i class="fa fa-refresh" ng-if="!!$ctrl.order.reorder_of && !$ctrl.isReturning"></i> <span order-logo="$ctrl.order" ng-if="!!$ctrl.order.source && $ctrl.order.source !== \'Zoomer\'  && !$ctrl.isReturning"></span> <span class="z-order-support" ng-if="$ctrl.hasOpenSupportRequests() && !$ctrl.isReturning"></span> <span class="z-icon z-icon-note" ng-if="!!$ctrl.order.delivery_notes && !$ctrl.isReturning" ng-click="$ctrl.openDeliveryNote()"></span> <span class="z-icon z-icon-kebab" ng-click="$ctrl.orderPopoverMenu.show($event, $ctrl.order)"></span>');
$templateCache.put('app/components/rbtButtons/rbtButtons.html','<div class="rbt-buttons"><h4>Ready By Time <i ng-show="vm.loading" class="fa fa-spin fa-refresh ng-animate-disabled"></i></h4><div ng-if="rbtButtonsVm.existingRbt"><h5>Leave Pickup Time Unchanged</h5><a class="button edit-order-existing-rbt" ng-href="" ng-class="{ selected: rbtButtonsVm.existingSelected(), disabled: rbtButtonsVm.order.isDeliveryInProgress }" ng-click="rbtButtonsVm.setRbt()" ng-bind="rbtButtonsVm.existingRbt | date:\'h:mm a\'"></a><h5>Change Ready By Time</h5></div><food-ready-now-button order="rbtButtonsVm.order" existing-rbt="rbtButtonsVm.existingRbt" on-complete="rbtButtonsVm.setRbt()"></food-ready-now-button><a ng-href="" class="button" ng-repeat="rbt in rbtButtonsVm.readyByTimes.rbt_options" ng-class="rbtButtonsVm.getButtonCls(rbt)" ng-click="rbtButtonsVm.setRbt(rbt)"><strong ng-bind="rbt"></strong> min</a><div ng-if="rbtButtonsVm.showFloorWarningMessage()" ng-include="\'app/components/rbtButtons/rbtFloorActiveWarning.html\'"></div><input type="hidden" ng-disabled="rbtButtonsVm.order.isDeliveryInProgress" ng-model="rbtButtonsVm.order.ready_by_time" name="readyByTime" disabled="disabled" required ready-by-time-input></div>');
$templateCache.put('app/components/rbtButtons/rbtFloorActiveWarning.html','<div class="rbt-floor-active"><h6>Woah! Things are busy!</h6><p>To provide the best customer experience, we need to temporarily push back our pick-up times just a bit. All \'Ready By Time\' options will return shortly.</p></div>');
$templateCache.put('app/components/serviceHaltedModal/serviceHaltedModal.html','<ion-modal-view class="z-modal-service-halted"><ion-header-bar><h1>Delivery service temporarily halted</h1></ion-header-bar><ion-content scroll="false"><p>Unfortunately, EatStreet has temporarily halted the delivery service for new orders. We\'ll handle any existing orders.</p><p>Temporary pauses are based on several factors, including:</p><div class="row"><div class="col col-33"><img src="assets/images/modals/orderVolumeIcon@2x.png" srcset="assets/images/modals/orderVolumeIcon@3x.png 3x"> Order Volume</div><div class="col col-33"><img src="assets/images/modals/trafficCongestionIcon@2x.png" srcset="assets/images/modals/trafficCongestionIcon@3x.png 3x"> Traffic Congestion</div><div class="col col-33"><img src="assets/images/modals/weatherIcon@2x.png" srcset="assets/images/modals/weatherIcon@3x.png 3x"> Weather</div></div></ion-content><ion-footer-bar><button class="button button-positive" ng-click="hide()">Close</button></ion-footer-bar></ion-modal-view>');
$templateCache.put('app/components/sizeHelpModal/sizeHelpModal.html','<ion-modal-view class="z-modal-order-size-help"><ion-header-bar><h1>What\'s the size of my order?</h1></ion-header-bar><ion-content scroll="false"><div class="row"><div class="col col-25"><img src="assets/images/modals/smallBagIcon@3x.png" alt="Small"><h3>Small</h3><ul><li>Comfortably fits in one grocery bag</li></ul></div><div class="col col-25"><img src="assets/images/modals/mediumBagIcon@3x.png" alt="Medium"><h3>Medium</h3><ul><li>Comfortably fits in two grocery bags</li></ul></div><div class="col col-25"><img src="assets/images/modals/largeBagIcon@3x.png" alt="Large"><h3>Large</h3><ul><li>Comfortably fits in four grocery bags</li><li>Can be carried in one trip to the vehicle</li></ul></div><div class="col col-25"><img src="assets/images/modals/xlargeBagIcon@3x.png" alt="Extra large"><h3>X-Large</h3><ul><li>Requries multiple trips to the vehicle</li><li>Group catering orders</li></ul></div></div></ion-content></ion-modal-view><a ng-href="" ng-click="$root._sizeHelpModal.hide()" class="close-receipt-modal icon ion-ios-close-empty"></a>');
$templateCache.put('app/support/states/editAddress.html','<div class="support-content"><h2>Which address needs to be updated?</h2></div><div class="orders-list"><div class="row row-header"><div class="col col-60">Customer</div><div class="col col-40">Driver</div></div><order-row ng-repeat="order in $ctrl.ordersQueue.pending.$all track by order.id" order="order" on-click="$ctrl.supportRouter.goTo(\'supportRequestForm\', { order: order, reason: \'new_address\' })"></order-row><order-row ng-repeat="order in $ctrl.ordersQueue.inProgress.$all track by order.id" order="order" on-click="$ctrl.supportRouter.goTo(\'supportRequestForm\', { order: order, reason: \'new_address\' })"></order-row></div>');
$templateCache.put('app/support/states/editOrder.html','<div class="orders-list"><div class="row row-header"><div class="col col-60">Customer</div><div class="col col-40">Driver</div></div><order-row ng-repeat="order in $ctrl.ordersQueue.pending.$all track by order.id" order="order" on-click="$ctrl.editOrder(order)"></order-row><order-row ng-repeat="order in $ctrl.ordersQueue.inProgress.$all track by order.id" order="order" on-click="$ctrl.editOrder(order)"></order-row></div>');
$templateCache.put('app/support/states/help.html','<div><button class="button button-block" ng-click="$ctrl.supportRouter.goTo(\'helpDoc\', { helpDoc: \'charging\' })">My iPad isn\'t charging properly</button> <button class="button button-block" ng-click="$ctrl.supportRouter.goTo(\'helpDoc\', { helpDoc: \'password\' })">I\'m being asked to sign in with an Apple ID or enter a password</button> <button class="button button-block" ng-click="$ctrl.setIssueResolved(false)">My issue isn\'t listed here</button></div>');
$templateCache.put('app/support/states/helpDoc.html','<div class="support-content" ng-include="$ctrl.getCurrentHelpDocTpl()"></div>');
$templateCache.put('app/support/states/home.html','<div><button class="button button-block" ng-click="$ctrl.supportRouter.goTo(\'help\')">I\'m having iPad issues</button> <button class="button button-block" ng-click="$ctrl.supportRouter.goTo(\'priceAdjustment\')">Send price adjustment for an order</button> <button class="button button-block" ng-click="$ctrl.supportRouter.goTo(\'itemMissing\')">An item is missing from an order</button> <button class="button button-block" ng-click="$ctrl.supportRouter.goTo(\'editOrder\')">An order\'s phone number needs to be updated</button> <button class="button button-block" ng-click="$ctrl.supportRouter.goTo(\'editAddress\')">An order\'s address needs to be updated</button> <button class="button button-block" ng-click="$ctrl.setIssueResolved(false)">My issue isn\'t listed here</button></div>');
$templateCache.put('app/support/states/itemMissing.html','<div class="support-content"><h2>Which order is missing an item?</h2></div><div class="orders-list"><div class="row row-header"><div class="col col-60">Customer</div><div class="col col-40">Driver</div></div><order-row ng-repeat="order in $ctrl.ordersQueue.pending.$all track by order.id" order="order" on-click="$ctrl.supportRouter.goTo(\'supportRequestForm\', { order: order, reason: \'order_is_missing_item\' })"></order-row><order-row ng-repeat="order in $ctrl.ordersQueue.inProgress.$all track by order.id" order="order" on-click="$ctrl.supportRouter.goTo(\'supportRequestForm\', { order: order, reason: \'order_is_missing_item\' })"></order-row></div>');
$templateCache.put('app/support/states/priceAdjustment.html','<div class="support-content"><h2>Which order needs a price adjustment?</h2></div><div class="orders-list"><div class="row row-header"><div class="col col-60">Customer</div><div class="col col-40">Driver</div></div><order-row ng-repeat="order in $ctrl.ordersQueue.pending.$all track by order.id" order="order" on-click="$ctrl.supportRouter.goTo(\'supportRequestForm\', { order: order, reason: \'price_adjustment\' })"></order-row><order-row ng-repeat="order in $ctrl.ordersQueue.inProgress.$all track by order.id" order="order" on-click="$ctrl.supportRouter.goTo(\'supportRequestForm\', { order: order, reason: \'price_adjustment\' })"></order-row><div class="footer"><button class="button button-block" class="button" ng-click="$ctrl.supportRouter.goTo(\'supportRequestForm\', { reason: \'price_adjustment\' })">Has this order already been delivered?</button></div></div>');
$templateCache.put('app/support/states/supportRequestForm.html','<form class="orders-list support-content" name="$ctrl.supportRequestData.form" ng-submit="$ctrl.submitSupportRequest()"><order-row ng-if="$ctrl.supportRouter.current.order" disabled="true" order="$ctrl.supportRouter.current.order"></order-row><p ng-if="$ctrl.supportRouter.current.reason === \'order_is_missing_item\'">Please provide some details about the missing item</p><p ng-if="$ctrl.supportRouter.current.reason === \'new_address\'">Please submit the updated address</p><p ng-if="$ctrl.supportRouter.current.reason === \'price_adjustment\' && $ctrl.supportRouter.current.order">Please list the price adjustment</p><p ng-if="$ctrl.supportRouter.current.reason === \'price_adjustment\' && !$ctrl.supportRouter.current.order">Please list the price adjustment and order number</p><p ng-if="!$ctrl.supportRouter.current.order && $ctrl.supportRouter.current.reason !== \'price_adjustment\'">How can we help you?</p><textarea ng-if="$ctrl.supportRouter.current.reason === \'order_is_missing_item\'" placeholder="Describe the missing items..." ng-model="$ctrl.supportRequestData.details" name="details" required></textarea> <textarea ng-if="$ctrl.supportRouter.current.reason === \'price_adjustment\'" placeholder="Describe the price adjustment..." ng-model="$ctrl.supportRequestData.details" name="details" required></textarea> <textarea ng-if="$ctrl.supportRouter.current.reason === \'new_address\'" placeholder="Update address to..." ng-model="$ctrl.supportRequestData.details" name="details" required></textarea> <textarea ng-if="!$ctrl.supportRouter.current.order  && $ctrl.supportRouter.current.reason !== \'price_adjustment\'" placeholder="Describe your issue..." ng-model="$ctrl.supportRequestData.details" name="details" required></textarea> <input ng-model="$ctrl.supportRouter.current.order.id" type="hidden"></form>');
$templateCache.put('app/support/states/supportRequestSent.html','<div class="support-content support-content-thanks"><div class="text-center"><img src="assets/images/dispatch-guy.png" style="width: 180px; height: auto; margin-bottom: 40px;"></div><p>We\'ve received your support request and an agent is working on that for you now! We\'ll contact you if we need anything else!</p><p class="text-center"><a ng-href="" ng-click="$ctrl.closeAndReset()"><strong>CLOSE</strong></a></p></div>');
$templateCache.put('app/views/history/index.html','<ion-view view-title="Order History" class="view-history"><root-nav-bar></root-nav-bar><div class="bar bar-subheader bar-history"><form name="historyForm" ng-submit="HistoryCtrl.filterOrders()"><label for="order-history-search" class="item-input-wrapper" ng-class="{ \'has-input\': HistoryCtrl.filterText !== \'\' }"><i class="icon ion-ios-search placeholder-icon"></i> <input id="order-history-search" ng-keyup="HistoryCtrl.filterOrders()" ng-model="HistoryCtrl.filterText" type="search" placeholder="Find any order on this page - by address, order number or driver"></label><div class="row row-center other-options"><div class="col col-filter-type"><label for="order-history-filter-type" class="button-filter-type"><select id="order-history-filter-type" ng-change="HistoryCtrl.filterOrders()" ng-model="HistoryCtrl.filterTypeIndex"><option value="all">All orders</option><option ng-repeat="type in HistoryCtrl.filterTypes" ng-if="!type.hidden" ng-bind="type.key" value="{{$index}}"></option></select> <span ng-if="HistoryCtrl.filterTypeIndex !== \'all\'" ng-bind="HistoryCtrl.filterTypes[HistoryCtrl.filterTypeIndex].key"></span> <span ng-if="HistoryCtrl.filterTypeIndex === \'all\'">All orders</span> <i class="fa fa-caret-down"></i></label></div><date-range-filter class="col col-history-period text-right"></date-range-filter></div></form></div><div class="bar bar-subheader bar-sticky-header" sticky-header ng-show="showStickyHeader"><div class="row"><div class="col col-id">ID</div><div class="col col-date">Date</div><div class="col col-driver">Driver</div><div class="col col-address">Customer</div><div class="col col-ordered">Ordered</div><div class="col col-food-ready">Food ready?</div><div class="col col-timeline">Timeline</div><div class="col col-c2c">C2C</div><div class="col col-tdt">TDT</div><div class="col col-options">&nbsp</div></div></div><z-ion-content z-desktop-infinite-scroll="HistoryCtrl.nextPage()" z-sticky-scroll-offset="134" z-has-sub-header="true"><div class="order-history-cards row" ng-show="!HistoryCtrl.loadingStats && HistoryCtrl.orders.length"><div class="col col-25"><div class="summary-card"><h4>Total Deliveries/Takeouts</h4><em>--</em> <strong ng-bind="HistoryCtrl.statistics.total_deliveries"></strong></div></div><div class="col col-25"><div class="summary-card"><h4>Average Counter to Customer</h4><em>--</em> <strong ng-cloak ng-bind="HistoryCtrl.statistics.average_c2c"></strong> mins</div></div><div class="col col-25"><div class="summary-card"><h4>Average Total Delivery Time</h4><em>--</em> <strong ng-bind="HistoryCtrl.statistics.average_dropoff_minutes"></strong> mins</div></div><div class="col col-25"><div class="summary-card"><h4>Counter to Customer Less Than 25 mins</h4><em>--</em> <strong ng-bind="HistoryCtrl.statistics.orders_percent_c2c_under_25m"></strong>%</div></div></div><ion-list class="order-history-table" ng-show="HistoryCtrl.orders.length"><div class="row row-center header"><div class="col col-id">ID</div><div class="col col-date">Date</div><div class="col col-driver">Driver</div><div class="col col-address">Customer</div><div class="col col-ordered">Ordered</div><div class="col col-food-ready">Food ready?</div><div class="col col-timeline">Timeline</div><div class="col col-c2c">C2C</div><div class="col col-tdt">TDT</div><div class="col col-options">&nbsp</div></div><ion-item class="row" ng-repeat="order in HistoryCtrl.orders track by order.id" ng-show="order.visible" ng-class="{ \'is-rejected\': order.status === \'oozo_review_rejected\' }" }><div class="col col-id"><div class="z-order-id">Z-{{order.id}}</div><span order-internal-id="order"></span> <i class="fa fa-star" ng-if="!!order.deliver_at || !!order.large_order"></i> <i class="fa fa-refresh" ng-if="!!order.reorder_of"></i> <span class="z-order-support" ng-if="order.restaurant_support_request_ids.length"></span></div><div class="col col-date"><span ng-bind="order.created_at | date:\'M/d/yy\'"></span></div><div class="col col-driver" ng-if="!order.isPickupOrder"><assigned-driver driver="order.driver_assigned"></assigned-driver><span class="z-order-status z-iou" ng-if="!!order.driver_iou">IOU</span></div><div class="col col-driver" ng-if="order.isPickupOrder"><span>Takeout</span></div><div class="col col-address" ng-if="!order.isPickupOrder"><span ng-bind="order.address.address_1"></span> <span ng-if="order.address.address_2">,</span><span ng-bind="order.address.address_2"></span><div><span class="z-order-status z-oozo" ng-if="HistoryCtrl.utilities.orders.isOozo(order)">OOZO</span> <i class="fa fa-exclamation-circle" ng-if="!!order.not_ready_at || !!order.delivery_attempts.length"></i></div></div><div class="col col-address" ng-if="order.isPickupOrder"><span ng-bind="order.diner.phone_number"></span><div><i class="fa fa-shopping-basket"></i></div></div><div class="col col-ordered"><span ng-bind="order.created_at | date:\'h:mma\'"></span></div><div class="col col-rejected">Rejected by EatStreet Support</div><div class="col col-food-ready"><span ng-show="!!order.not_ready_at">{{order.pickup_performance}} mins late</span> <span ng-show="!order.not_ready_at">On time</span></div><div class="col col-timeline"><div ng-if="order.picked_up_at"><i class="fa fa-arrow-up"></i><span ng-bind="order.picked_up_at | date:\'h:mma\'"></span></div><div ng-if="order.dropped_off_at"><i class="fa fa-arrow-down"></i><span ng-bind="order.dropped_off_at | date:\'h:mma\'"></span></div></div><div class="col col-c2c"><span ng-show="order.counter_to_customer">{{order.counter_to_customer}} mins</span></div><div class="col col-tdt"><span ng-show="order.dropoff_minutes">{{order.dropoff_minutes}} mins</span></div><div class="col col-options"><i class="z-icon-kebab" ng-click="HistoryCtrl.orderPopoverMenu.show($event, order)"></i></div></ion-item></ion-list><div class="no-items no-orders" ng-if="!HistoryCtrl.loading && !HistoryCtrl.orders.length"><span class="no-items-icon"></span><p>No orders found</p></div><div class="row loading" ng-if="HistoryCtrl.loading" ng-class="{ \'no-items\': !HistoryCtrl.orders.length }"><div class="col text-center"><i class="fa fa-refresh fa-spin"></i></div></div><ion-infinite-scroll class="infinite-scroll-spinner" ng-if="isMobileDevice" distance="15%" immediate-check="false" on-infinite="HistoryCtrl.nextPage()"></ion-infinite-scroll></z-ion-content></ion-view>');
$templateCache.put('app/views/dropoffs/index.html','<ion-view view-title="Orders" class="view-orders-queue"><root-nav-bar></root-nav-bar><orders-sub-header></orders-sub-header><z-ion-content z-desktop-infinite-scroll="vm.getAll()" z-sticky-scroll-offset="134" z-has-sub-header="false"><div ng-include="\'app/views/orders/list/returning.html\'"></div></z-ion-content></ion-view>');
$templateCache.put('app/views/menu-list/index.html','<div class="menu-items-page" ng-init="MenuListCtrl.viewChoice = \'products\'; focus = false; showLoadIndicator()"><div class="menu-items-page menu-header"><ion-header-bar class="bar-stable z-nav-bar menu-nav" style="display:flex; width:100%"><a class="button button-menu button-icon ion-navicon show" menu-toggle="left"></a><div class="menu-header-flex"><div class="menu-heading"><span class="header-menu-avail"><i class="fa fa-cutlery"></i> Menu Availability</span> <span ng-if="MenuListCtrl.getRestName()" class="header-rest-name">{{MenuListCtrl.getRestName()}}</span></div><div class="menu-tabs"><div ng-class="{\'active\': MenuListCtrl.viewChoice === \'products\'}" ng-click="MenuListCtrl.viewChoice = \'products\'; MenuListCtrl.toggleMenuView(\'products\')">Items</div><div ng-class="{\'active\': MenuListCtrl.viewChoice === \'options\'}" ng-click="MenuListCtrl.viewChoice = \'options\'; MenuListCtrl.toggleMenuView(\'options\')">Options</div></div></div></ion-header-bar></div><div class="menu-editor-page"><div style="width:100%"><menu-search product-search="MenuListCtrl.productSearch" view-choice="MenuListCtrl.viewChoice" on-change="searchChange(productSearch)"></menu-search></div><div ng-if="MenuListCtrl.productSearch" class="search-results"><div class="search-name">Search results for "{{MenuListCtrl.productSearch}}"</div><div class="reset-search" ng-click="MenuListCtrl.productSearch = \'\'">Clear Search</div></div><div class="menu-items" ng-class="{\'search-view\': MenuListCtrl.productSearch}"><div class="category-scroll" ng-hide="MenuListCtrl.productSearch"><ul ng-if="!MenuListCtrl.productSearch" ng-repeat="category in {true: MenuListCtrl.menu, false: MenuListCtrl.menuListOptions}[MenuListCtrl.viewChoice === \'products\']" ng-click="MenuListCtrl.setActiveCategory(category)"><div ng-if="category.products.length !== 0"><div class="category-name" ng-class="{\'selected\': MenuListCtrl.selectedcategory.name === category.name}">{{ category.name }}</div><div class="spacer"></div></div></ul></div><div class="item-scroll" ng-class="{\'search-view\': MenuListCtrl.productSearch}"><div class="li--wrapper expanded"><menu-items ng-repeat="product in (MenuListCtrl.productSearch ? MenuListCtrl.allItems : MenuListCtrl.selectedcategory.products) | filter : productSearchFilter | filter : soldOutItems" product="product" product-search="MenuListCtrl.productSearch" eatstreet-id="MenuListCtrl.eatstreetId" category-name="MenuListCtrl.viewChoice === \'products\' ? getCategory(product.categoryId) : null" is-product="MenuListCtrl.viewChoice === \'products\'" update-product="updateProduct(product)"></menu-items></div><div class="no-items" ng-show="((MenuListCtrl.productSearch ? MenuListCtrl.allItems : MenuListCtrl.selectedcategory.products) | filter : productSearchFilter | filter : soldOutItems).length == 0"><div ng-if="!MenuListCtrl.productSearch && MenuListCtrl.filterSoldOut">There are no sold out {{MenuListCtrl.viewChoice === \'products\' ? \'items\' : \'options\'}} under "{{MenuListCtrl.selectedcategory.name}}"</div><div ng-if="MenuListCtrl.productSearch">There are no {{MenuListCtrl.filterSoldOut ? \'sold out\' : \'\'}} {{MenuListCtrl.viewChoice === \'products\' ? \'items\' : \'options\'}} under this search term "{{MenuListCtrl.productSearch}}"</div></div></div></div><div style="width: 100%"><menu-footer filter-sold-out="MenuListCtrl.filterSoldOut" restaurant="MenuListCtrl.restaurant" view-choice="MenuListCtrl.viewChoice" on-change="soldOutChange(filterSoldOut)"></menu-footer></div></div></div>');
$templateCache.put('app/views/menu-list/optionsAvailabilityPopup.html','<ion-modal-view class="z-modal z-modal-options" ng-class="{expanded: itemAvailabilityChanged && !isProduct, err: err}"><div class="header"><h2>UPDATE {{isProduct ? \'ITEM\' : \'OPTION\'}} AVAILABILITY</h2><h1>{{ activeItemCopy.name }}</h1></div><div class="options-availability"><div class="container" ng-class="{selected: !activeItemCopy.invisible && !activeItemCopy.temporarilyInvisible}" ng-click="activeItemCopy.temporarilyInvisible = false; activeItemCopy.invisible = false; checkChanges()"><span class="options-radio"><span class="options-radio-selected" ng-show="!activeItemCopy.invisible && !activeItemCopy.temporarilyInvisible"></span> </span>Available</div><div class="container" ng-class="{selected: activeItemCopy.temporarilyInvisible}" ng-click="activeItemCopy.temporarilyInvisible = true; checkChanges()"><span class="options-radio"><span class="options-radio-selected" ng-show="activeItemCopy.temporarilyInvisible"></span> </span>Sold Out Today</div><div class="container" ng-class="{selected: activeItemCopy.invisible && !activeItemCopy.temporarilyInvisible}" ng-click="activeItemCopy.invisible = true; activeItemCopy.temporarilyInvisible = false; checkChanges()"><span class="options-radio"><span class="options-radio-selected" ng-show="activeItemCopy.invisible && !activeItemCopy.temporarilyInvisible"></span> </span>Sold Out Indefinitely</div></div><div class="options-notification" ng-show="itemAvailabilityChanged && !isProduct"><i class="fa fa-exclamation-triangle"></i>The change will affect all items that have this option.</div><div class="err" ng-if="err"><div>There was an error. Please try again.</div><i class="fa fa-exclamation-triangle"></i></div><div class="options-buttons"><div class="button cancel" ng-click="closeModal();">Cancel</div><div class="button submit" id="submit-button" ng-click="submit()" ng-disabled="!itemAvailabilityChanged">Confirm{{optionLoading ? \'ing\' : \'\'}}<div ng-if="optionLoading"><ion-spinner icon="ios"></ion-spinner></div></div></div></ion-modal-view>');
$templateCache.put('app/views/modals/auto-complete-modal-bar.html','<div class="bar bar-header item-input-inset z-bar-autocomplete" ng-class="{ \'dirty\': dinerAddressLookupVm.street && dinerAddressLookupVm.street !== \'\' }"><label class="item-input-wrapper"><i class="fa fa-search"></i> <input type="text" autocomplete="off" ng-model="dinerAddressLookupVm.street" ng-model-options="dinerAddressLookupVm.modelOptions" on-complete="dinerAddressLookupVm.onComplete(place, multipleLocations)" auto-complete><auto-complete-warnings error="dinerAddressLookupVm.autoComplete.error"></auto-complete-warnings></label> <button class="button button-clear" ng-click="dinerAddressLookupVm.autoCompleteModalBar.remove()">Cancel</button></div>');
$templateCache.put('app/views/modals/confirm-close.html','<ion-modal-view class="z-modal-confirm-close"><ion-content scroll="false"><div class="content"><p>Pause new orders?</p></div><p>You are currently <strong>accepting new orders</strong></p><div class="alert--friendly"><ul><li>You can start accepting orders again whenever you want</li><li>You will automatically reopen tomorrow if you remain closed for the rest of today</li></ul></div><div class="btn-wrapper"><button ng-click="toggleRestaurant()">Pause New Orders</button></div></ion-content></ion-modal-view>');
$templateCache.put('app/views/modals/confirm-open.html','<ion-modal-view class="z-modal-confirm-open" ng-class="{\'temp-pause-modal-large\' : isTempPaused(restaurantArray[0])}"><ion-content scroll="false"><div class="content"><p>Accept new orders?</p></div><div class="confirm-open-container"><p ng-if="isTempPaused(restaurantArray[0])">You are <strong>temporarily not accepting new orders</strong></p><div ng-if="isTempPaused(restaurantArray[0])" class="temp-pause-notif"><i class="fa fa-refresh"></i><div>You are set to automatically start accepting new orders at {{restaurantArray[0].reopenTime | date : "shortTime"}}</div></div><p ng-if="!isTempPaused(restaurantArray[0])">You are currently <strong>not accepting new orders</strong></p><div class="btn-wrapper"><button ng-disabled="disableOpenBtn" ng-click="toggleRestaurant()">Accept New Orders</button> <button class="cancel" ng-click="closeModal()">Cancel</button></div></div></ion-content></ion-modal-view>');
$templateCache.put('app/views/modals/confirm-return.html','<ion-modal-view class="z-modal z-modal-confirm-return" hide-nav-bar="true" ng-controller="OrdersQueueCtrl as OrdersQueueCtrl"><h2>Your driver has returned the following items to you.<br>Please confirm you received them.</h2><div class="return-order-contents"><div ng-repeat="item in order.items.users[0].items" ng-if="item.has_alcohol_restriction">{{item.name}}</div></div><div class="confirm" ng-click="OrdersQueueCtrl.confirmOrderReturn()">Confirm</div></ion-modal-view>');
$templateCache.put('app/views/modals/confirm-street-number.html','<ion-modal-view class="z-modal-street-number"><ion-content scroll="false"><p><i class="fa fa-exclamation-triangle"></i> We couldn\'t locate that exact address. If correct, please continue to enter the address manually.</p></ion-content><ion-footer-bar><button ng-click="dinerAddressLookupVm.setConfirmNoStreetNumber()" class="button button-block button-positive">Ok</button></ion-footer-bar></ion-modal-view>');
$templateCache.put('app/views/modals/customer-location.html','<ion-modal-view class="z-modal-order-location"><ion-header-bar><h1 class="title">Customer Location</h1></ion-header-bar><ion-content scroll="false"><order-leaflet-map ng-if="order.address" order="order"></order-leaflet-map></ion-content><ion-footer-bar><button ng-click="$ctrl.closeLocationModal()" class="button button-block button-positive">Close</button></ion-footer-bar></ion-modal-view>');
$templateCache.put('app/views/modals/existing-order.html','<ion-modal-view class="view-email-orders z-modal-email-orders z-modal-existing-external-order"><ion-header-bar><h1>We found <span ng-bind="$ctrl.existingExternalOrders.length"></span> similar <em ng-show="$ctrl.existingExternalOrders.length === 1">order</em> <em ng-show="$ctrl.existingExternalOrders.length > 1">orders</em> <strong>You can continue with this order, or close this window to go back.</strong></h1><a class="close-receipt-modal icon ion-ios-close-empty" ng-href="" ng-click="$ctrl.closeModal()"></a></ion-header-bar><z-ion-content class="existing-email-order-wrapper" on-scroll="$ctrl.onModalContentScroll(scrollTop, bounds)"><external-order ng-repeat="order in $ctrl.existingExternalOrders track by order.id" content-bounds="$ctrl.contentBounds" scroll-top="$ctrl.scrollTop" order="order"></external-order></z-ion-content></ion-modal-view>');
$templateCache.put('app/views/modals/gk-menus-select.html','<ion-modal-view class="z-modal-menu-select-gk"><div class="header"><div class="header-text">All Menus Availability</div><div class="menu-count">{{numOpen + numClosed + numPaused}} Menus</div></div><div class="menu-list-select"><div class="menu-li" ng-repeat="rest in restaurantArray" ng-click="goToMenuGK(rest.eatstreetId)"><div class="kitchen-info"><div class="kitchen-name">{{rest.restaurantName}}</div><div class="menu-info"><div class="sold-out"><i class="fa fa-eye-slash"></i> <strong>Sold Out:</strong></div><div class="invisible-menu-items"><span>{{rest.invisibilityCount}} Menu Items</span></div><i class="fa fa-circle small"></i><div class="invisible-ingredients"><span>{{rest.invisibleOptsCount}} Options</span></div></div></div><div class="manage-menu">Manage Menu <i class="fa fa-arrow-right"></i></div></div></div><div class="close-modal-button" ng-click="closeGKMenuModal()">Close Window</div></ion-modal-view>');
$templateCache.put('app/views/modals/loading-indicator.html','<ion-modal-view class="z-modal menu-loading-indicator"><div><ion-spinner icon="ios"></ion-spinner></div><div>Loading Menu</div></ion-modal-view>');
$templateCache.put('app/views/modals/oozo-details.html','<ion-modal-view class="z-modal-oozo-details"><ion-content scroll="false"><span class="z-order-status">OOZO</span><h3>Out of Zone Order</h3><p>The address associated with this order is outside the inner delivery radius.</p></ion-content><ion-footer-bar><button ng-click="$ctrl.closeModal()" class="button button-block button-positive">Ok</button></ion-footer-bar></ion-modal-view>');
$templateCache.put('app/views/modals/oozo-order-map.html','<ion-modal-view class="z-modal-order-location no-header"><ion-content scroll="false"><order-leaflet-map order="$ctrl.order" zones="$ctrl.deliveryZoneStatus.zones"></order-leaflet-map></ion-content></ion-modal-view><a ng-href="" ng-click="$ctrl.mapModal.remove()" class="close-receipt-modal icon ion-ios-close-empty"></a>');
$templateCache.put('app/views/modals/oozo-send-for-review.html','<ion-modal-view class="z-modal-confirm-oozo-review"><ion-content scroll="false"><i class="fa fa-paper-plane"></i><h1 class="title">Send Order for Review?</h1><p>Would you like to send it to EatStreet Support for review? Please tell us why below:</p><div ng-hide="$ctrl.showOtherTextarea"><a ng-href="" ng-click="$ctrl.setReviewReason(\'incorrectly_geo_located\')" ng-class="{ selected: $ctrl.order.oozo_review.review_reason === \'incorrectly_geo_located\' }"><i class="fa fa-check"></i> This address is geo-located incorrectly </a><a ng-href="" ng-click="$ctrl.setReviewReason(\'delivery_zone_should_include_address\')" ng-class="{ selected: $ctrl.order.oozo_review.review_reason === \'delivery_zone_should_include_address\' }"><i class="fa fa-check"></i> The delivery zone should include this address</a></div><a ng-href="" ng-click="$ctrl.setOtherReason()" ng-class="{ selected: $ctrl.showOtherTextarea }"><i class="fa fa-check"></i> Other</a><div class="textarea" ng-show="$ctrl.showOtherTextarea"><textarea ng-model="$ctrl.order.oozo_review.review_reason"></textarea></div></ion-content><ion-footer-bar><button ng-click="$ctrl.reset()" class="button button-block button-clear">Cancel</button> <button class="button button-block button-positive" ng-click="$ctrl.sendForReview()" ng-disabled="!$ctrl.order.oozo_review.review_reason">Yes Send for review</button></ion-footer-bar></ion-modal-view>');
$templateCache.put('app/views/modals/pause-unpause-ghost-kitchens.html','<ghost-kitchen-toggle-open restaurant-array="restaurantArray" confirm-modal="confirmModal"></ghost-kitchen-toggle-open>');
$templateCache.put('app/views/modals/print-receipt-modal.html','<ion-modal-view class="z-modal-print-receipt"><ion-content scroll="false"><p><ion-spinner class="col col-center text-center" icon="ios" ng-if="printStatus === \'Printing\'"></ion-spinner></p><span>{{printStatus}}</span></ion-content><ion-footer-bar ng-if="printStatus !== \'Printing\'"><button ng-click="closeModal()" class="button button-block button-positive">Ok</button></ion-footer-bar></ion-modal-view>');
$templateCache.put('app/views/modals/prompt-temp-pause-gk.html','<ion-modal-view class="z-modal z-modal-temp-pause-gk" ng-class="{\'large\': viewGhostKitchens}" hide-nav-bar="true" ng-controller="RbtButtonsCtrl"><div class="options"><h1>Temporarily pause new orders?</h1><h2><div>You seem busy right now! To maintain the diner experience, we recommend temporarily pausing incoming orders.</div><br><div>We will automatically un-pause you after the time period has ended.</div></h2></div><div class="gk-temp-pause"><h2>Pause accepting new orders temporarily:</h2><div class="active-kitchen" ng-if="rbtButtonsVm.activeKitchen.openStatus" ng-hide="viewGhostKitchens"><div class="active-kitchen-name">{{rbtButtonsVm.activeKitchen.restaurantName}}</div><div class="gk-pause-times"><button class="pause-button-gk" ng-if="!rbtButtonsVm.activeKitchen.pause30" ng-click="rbtButtonsVm.activeKitchen.pause30 = true; rbtButtonsVm.activeKitchen.pause60 = false; rbtButtonsVm.addPause30(rbtButtonsVm.activeKitchen.eatstreetId)">30 min pause</button> <button class="pause-button-gk selected" ng-if="rbtButtonsVm.activeKitchen.pause30" ng-click="rbtButtonsVm.activeKitchen.pause30 = false; rbtButtonsVm.rbtButtonsVm.unpause30(rbtButtonsVm.activeKitchen.eatstreetId)"><i class="fa fa-check-circle"></i> 30 min</button> <button class="pause-button-gk" ng-if="!rbtButtonsVm.activeKitchen.pause60" ng-click="rbtButtonsVm.activeKitchen.pause30 = false; rbtButtonsVm.activeKitchen.pause60 = true; rbtButtonsVm.addPause60(rbtButtonsVm.activeKitchen.eatstreetId)">60 min pause</button> <button class="pause-button-gk selected" ng-if="rbtButtonsVm.activeKitchen.pause60" ng-click="rbtButtonsVm.activeKitchen.pause60 = false; rbtButtonsVm.unpause60(rbtButtonsVm.activeKitchen.eatstreetId)"><i class="fa fa-check-circle"></i> 60 min</button></div></div><div class="active-kitchen" ng-if="!rbtButtonsVm.activeKitchen.openStatus" ng-hide="viewGhostKitchens">Kitchen for this order paused already!</div><div class="view-kitchens-toggle" ng-hide="viewGhostKitchens" ng-click="viewGhostKitchens = true">View Open Kitchens ({{openRestaurantArray.length}}) <i class="fa fa-chevron-down"></i></div><div class="temp-pause-gk-list" ng-show="viewGhostKitchens"><div ng-repeat="rest in openRestaurantArray" class="active-kitchen" ng-class-even="\'active-kitchen white-bg\'"><div class="active-kitchen-name">{{rest.restaurantName}}</div><div class="gk-pause-times"><button class="pause-button-gk" ng-if="!rest.pause30" ng-click="rest.pause30 = true; rest.pause60 = false; rbtButtonsVm.addPause30(rest.eatstreetId)">30 min pause</button> <button class="pause-button-gk selected" ng-if="rest.pause30" ng-click="rest.pause30 = false; rbtButtonsVm.unpause30(rest.eatstreetId)"><i class="fa fa-check-circle"></i> 30 min</button> <button class="pause-button-gk" ng-if="!rest.pause60" ng-click="rest.pause30 = false; rest.pause60 = true; rbtButtonsVm.addPause60(rest.eatstreetId)">60 min pause</button> <button class="pause-button-gk selected" ng-if="rest.pause60" ng-click="rest.pause60 = false; rbtButtonsVm.unpause60(rest.eatstreetId)"><i class="fa fa-check-circle"></i> 60 min</button></div></div></div><div class="pause-count"><div ng-if="!rbtButtonsVm.pauseCount()">No kitchen will be paused!</div><div ng-if="rbtButtonsVm.pauseCount()">Once confirmed, {{rbtButtonsVm.pauseCount()}} kitchen{{rbtButtonsVm.pauseCount() > 1 ? \'s\' : \'\'}} will be temporarily paused.</div></div><div class="buttons-gk"><div class="pause-button-gk clear" ng-click="rbtButtonsVm.closeModalVM()">Cancel</div><div class="pause-button-gk red" ng-click="rbtButtonsVm.setPauseTimeGk()">Confirm Changes</div></div></div></ion-modal-view>');
$templateCache.put('app/views/modals/prompt-temp-pause.html','<ion-modal-view class="z-modal z-modal-temp-pause" hide-nav-bar="true" ng-controller="RbtButtonsCtrl"><div class="header"><i class="fa fa-check-circle"></i> RBT set to {{rbtButtonsVm.rbt}} minutes.</div><div class="options"><h1>Temporarily pause new orders?</h1><h2><div>You seem busy right now! To maintain the diner experience, we recommend temporarily pausing incoming orders.</div><br><div>We will automatically un-pause you after the time period has ended.</div></h2><br><div class="buttons"><div class="pause-button blue" ng-click="rbtButtonsVm.setPauseTime(30)"><i class="fa fa-clock-o"></i> Pause for 30 minutes</div><div class="pause-button blue" ng-click="rbtButtonsVm.setPauseTime(60)"><i class="fa fa-clock-o"></i> Pause for 60 minutes</div><div class="pause-button clear" ng-click="rbtButtonsVm.closeModalVM()">No need to Pause</div></div></div></ion-modal-view>');
$templateCache.put('app/views/modals/receipt-details.html','<ion-modal-view class="z-modal-receipt-image" ng-controller="ReceiptModalCtrl as ReceiptModal" ng-class="ReceiptModal.rotationCls"><div class="rotate-images" ng-if="ReceiptModal.view === \'image\' || (selectedReceipt.image_urls.medium && !selectedReceipt.email_body_iframe)"><a ng-click="ReceiptModal.rotateReceipt(false)"><i class="fa fa-undo"></i> </a><a ng-click="ReceiptModal.rotateReceipt(true)"><i class="fa fa-repeat"></i></a></div><header class="row row-center"><div class="col col-40"><h4 ng-bind="\'Tip: \' + (selectedReceipt.tip | formatTipAmount)"></h4></div><div class="col col-60"><a class="button button-dark" ng-href="" ng-if="selectedReceipt.isDisputeEnabled()" ng-click="ReceiptModal.showDisputeModal()"><i class="fa fa-exclamation-circle"></i> <span ng-if="selectedReceipt.receipt_dispute && selectedReceipt.receipt_dispute.status === \'in_dispute\'" ng-bind="ReceiptModal.receiptDisputeTypes[selectedReceipt.receipt_dispute.dispute_type]"></span> <span ng-if="!(selectedReceipt.receipt_dispute && selectedReceipt.receipt_dispute.status === \'in_dispute\')">Report issue</span> </a><a class="button button-positive" ng-href="" ng-click="ReceiptModal.toggleCheck()"><i class="fa fa-refresh fa-spin" ng-if="ReceiptModal.togglingCheck"></i> <span ng-if="selectedReceipt.status === \'open_check\'">Close check</span> <span ng-if="selectedReceipt.status === \'closed_check\'">Re-open check</span></a></div></header><receipt-details-content ng-class="{ \'is-image\': ReceiptModal.view === \'image\' }"><img ng-if="ReceiptModal.view === \'image\'" ng-src="{{selectedReceipt.image_urls.original}}" ng-pinch-zoom><external-order-iframe ng-if="ReceiptModal.view === \'email\'" html="selectedReceipt.email_body_iframe"></external-order-iframe></receipt-details-content><ion-footer-bar ng-show="selectedReceipt.email_body_iframe && selectedReceipt.image_urls.medium"><a class="btn-image" style="background-image: url(\'{{selectedReceipt.image_urls.thumb}}\')" ng-href="" ng-click="ReceiptModal.toggleView(\'image\')" ng-class="{ selected: ReceiptModal.view === \'image\' }"></a> <a class="btn-details" ng-href="" ng-click="ReceiptModal.toggleView(\'email\')" ng-class="{ selected: ReceiptModal.view === \'email\' }"><i class="fa fa-list-ul"></i> <span>Order details</span></a></ion-footer-bar></ion-modal-view><a ng-href="" ng-click="closeModal()" class="close-receipt-modal icon ion-ios-close-empty"></a>');
$templateCache.put('app/views/orders/edit-specialorder.html','<form ion-view name="orderForm" ng-submit="EditCtrl.scheduledOrderSubmit()" novalidate><edit-order-nav-bar></edit-order-nav-bar><z-ion-content z-desktop-infinite-scroll="$broadcast(\'$editOrderNextPage\')"><div class="row edit-order-form"><customer-information></customer-information><div class="col-50"><order-driver-iou order="order"></order-driver-iou><order-size ng-if="$root.restaurant.hasBicycleSupport()" order="order"></order-size><large-order-toggle order="order"></large-order-toggle><order-pickup-selector order="order" form="orderForm"></order-pickup-selector><h4>Payment Method</h4><input type="hidden" name="doNotDeliver" ng-model="order.address.do_not_deliver" do-not-deliver-input> <input type="hidden" name="readyByTime" ng-model="order.ready_by_time" disabled="disabled" required ready-by-time-input><order-payment-method order="order"></order-payment-method><div ng-if="$root.features.checkEnabled(\'order_internal_id\')" order-internal-id-input="order"></div><h4>Delivery Notes and Order Description</h4><textarea class="edit-orders-special-notes" ng-model="order.delivery_notes" ng-disabled="order.isDeliveryInProgress" placeholder=""></textarea></div></div></z-ion-content></form>');
$templateCache.put('app/views/orders/edit.html','<form ion-view name="orderForm" ng-submit="EditCtrl.submit()"><edit-order-nav-bar></edit-order-nav-bar><z-ion-content z-desktop-infinite-scroll="$broadcast(\'$editOrderNextPage\')"><div class="row edit-order-form"><customer-information></customer-information><div class="col-50"><order-driver-iou order="order"></order-driver-iou><order-size ng-if="$root.restaurant.hasBicycleSupport()" on-select-extra-large="EditCtrl.redirectOrderAsSpecial()" order="order"></order-size><rbt-buttons class="edit-orders-rbts" ng-if="!$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')" order="order"></rbt-buttons><rbt-arbitrator-v1 ng-if="$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')" order="order" form="orderForm"></rbt-arbitrator-v1><input type="hidden" name="doNotDeliver" ng-model="order.address.do_not_deliver" do-not-deliver-input><div ng-if="$root.features.checkEnabled(\'order_internal_id\')" order-internal-id-input="order"></div><h4>Delivery Notes <sup>* Optional</sup></h4><textarea class="edit-orders-special-notes" ng-model="order.delivery_notes" ng-disabled="order.isDeliveryInProgress" placeholder=""></textarea></div></div></z-ion-content></form>');
$templateCache.put('app/views/orders/reorder.html','<form ion-view view-title="{{ (state.current.name === \'app.new-order\') ? \'New Re-order\' : \'Edit Re-order\'}}" name="orderForm" ng-submit="ReorderCtrl.submit()"><edit-order-nav-bar></edit-order-nav-bar><z-ion-content><div class="loading-reorder" ng-show="loading"><i class="fa fa-refresh fa-spin ng-animate-disabled"></i> Fetching order</div><div class="invalid-reorder" ng-if="isOutsideBusinessDay || order.deliver_at || order.large_order"><h4>Invalid re-order</h4><p ng-if="isOutsideBusinessDay">It appears this Order was originally made outside of EatStreet\'s current working day, so we cannot set this as a re-order. Sorry!</p><p ng-if="order.deliver_at || order.large_order">This order cannot be re-ordered. Sorry!</p><p><a class="button button-block button-positive" ng-href="#/app/orders">Go to orders</a></p></div><div ng-if="!isOutsideBusinessDay && !order.deliver_at && !order.large_order && !loading" class="row edit-order-form"><div class="col-50"><div class="reorder-details"><h4>Reorder for Customer</h4><h5><i class="fa fa-phone"></i> <span ng-bind="order.diner.phone_number | formatPhoneNumber"></span></h5><p><span ng-bind="order.address.address_1"></span><br><span ng-if="order.address.address_2"><span ng-bind="order.address.address_2"></span><br></span><span ng-bind="order.address.city"></span><br><span ng-bind="order.address.state_province_region"></span></p><h5 ng-switch="order.payment_method">Payment Method: <span ng-switch-when="credit_card">Credit card</span> <span ng-switch-when="cash">Cash</span> <span ng-switch-when="prepaid">Online prepaid</span></h5><h5 ng-if="restaurant.hasBicycleSupport() && order.size !== config.DEFAULT_ORDER_SIZE">Order size: <span ng-bind="order.size"></span></h5></div></div><div class="col-50"><input type="hidden" name="doNotDeliver" ng-model="order.address.do_not_deliver" do-not-deliver-input><rbt-buttons class="edit-orders-rbts" ng-if="!$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')" order="order"></rbt-buttons><rbt-arbitrator-v1 ng-if="$root.features.checkEnabled(\'restaurant_app_arbitrator_v1\')" order="order" form="orderForm"></rbt-arbitrator-v1><h4>Special Notes <sup>* Optional</sup></h4><textarea class="edit-orders-special-notes" ng-model="order.delivery_notes" placeholder=""></textarea></div></div></z-ion-content></form>');
$templateCache.put('app/views/orders/sub-header.html','<div class="bar bar-subheader"><a ng-href="#/app/orders/queue/pending" ng-class="vm.isCurrentState(\'pending\')" mix-panel="order-queue" menu-close>Queue <span class="badge badge-calm" ng-show="vm.ordersQueue.pending.$all.length" ng-bind="vm.ordersQueue.pending.$all.length"></span> </a><a ng-href="#/app/orders/queue/inProgress" ng-class="vm.isCurrentState(\'inProgress\')" mix-panel="in-progress" menu-close>On its way <span class="badge badge-calm" ng-show="vm.ordersQueue.inProgress.$all.length" ng-bind="vm.ordersQueue.inProgress.$all.length"></span> </a><a ng-href="#/app/orders/queue/delivered" ng-class="vm.isCurrentState(\'delivered\')" mix-panel="delivered" menu-close>Just delivered <span class="badge badge-calm" ng-show="vm.ordersQueue.delivered.$all.length" ng-bind="vm.ordersQueue.delivered.$all.length"></span> </a><a ng-href="#/app/orders/queue/specialOrders" ng-show="vm.ordersQueue.specialOrders.$all.length" ng-class="vm.isCurrentState(\'specialOrders\')" mix-panel="deliver-later" menu-close>Deliver later <span class="badge badge-calm" ng-bind="vm.ordersQueue.specialOrders.$all.length"></span> </a><a ng-href="#/app/orders/queue/ordersForReview" ng-show="vm.ordersQueue.ordersForReview.$all.length" ng-class="vm.isCurrentState(\'ordersForReview\')" mix-panel="under-review" menu-close>Under Review <span class="badge badge-calm badge-oozo" ng-bind="vm.ordersQueue.ordersForReview.$all.length"></span></a></div>');
$templateCache.put('app/views/orders/timeline.html','<div class="order-timeline-list"><div ng-if="order.timeline" ng-repeat="event in orderTimeline.data" ng-cloak class="order-timeline-item row"><div class="col flag"><span ng-if="event.event === \'ordered\' && orderTimeline.source" order-logo="order"></span> <i ng-if="event.event === \'delivery_attempt\' || event.event === \'not_ready_at\' || event.value === \'oozo_review_rejected\' || event.event === \'food_ready_now\'" class="warning fa fa-exclamation-circle"></i></div><div class="col detail"><span ng-if="event.event !== \'ordered\' && event.event !== \'status\'" ng-bind="event.parsedType"></span> <span ng-switch="event.event"><span ng-switch-when="ordered">Ordered</span> <span ng-switch-when="phone_number" ng-bind="event.parsedValue | formatPhoneNumber"></span> <span ng-switch-default ng-bind="event.parsedValue"></span></span></div><div class="col time text-right"><span ng-bind="event.timestamp |  date:\'h:mm a\'"></span></div></div></div>');
$templateCache.put('app/views/orders/view.html','<ion-view view-title="Order Details"><edit-order-nav-bar></edit-order-nav-bar><div class="bar bar-subheader bar-view-order"><div class="row"><div class="col col-center"><h5 ng-bind="\'Order #\' + order.id"></h5><span order-internal-id="order"></span> <span ng-if="selectedReceipt && selectedReceipt.status === \'open_check\'" class="badge">This order has an open receipt</span></div><div class="col col-center text-right"><a ng-if="selectedReceipt" ng-click="viewReceipt()" class="close-check"><span>View receipt</span></a></div></div></div><z-ion-content z-has-sub-header="true"><div class="view-order-loading" ng-show="ViewOrderCtrl.loading"><i class="fa fa-refresh fa-spin"></i> Loading order #{{ViewOrderCtrl.orderId}}...</div><div class="row view-order-wrapper" ng-show="!ViewOrderCtrl.loading"><div class="col col-75 view-order-history"><div class="print-header"><a class="button button-positive" ng-click="print()" ng-if="shouldShowPrint()">Print </a><a class="button button-positive" ng-if="order.id && !ViewOrderCtrl.utilities.orders.isReorderDisabled(order)" ng-href="#/app/orders/{{order.id}}/reorder/new" mix-panel="reorder" mix-panel-data="order">Re-order</a></div><div class="card card-summary"><div class="item item-divider">Summary</div><div class="item item-text-wrap row"><div class="col"><h6>Date</h6><span ng-bind="order.created_at | date:\'MMM dd, yyyy\'"></span></div><div class="col"><h6>Time</h6><span ng-bind="order.created_at | date:\'h:mm a\'"></span></div><div class="col" ng-if="!order.isPickupOrder()"><h6>Driver</h6><assigned-driver driver="order.driver_assigned"></assigned-driver></div><div class="col" ng-if="order.isPickupOrder()"><h6>Diner</h6><span class="fa fa-shopping-basket"></span> <span>Takeout order</span></div><div class="col"><h6>Delivery Time</h6><span ng-if="order.status === \'delivered\'" ng-bind="order.order.dropped_off_at | date: \'h:mm a\' ">Done</span> <span ng-if="order.status !== \'delivered\'">--</span></div></div></div><div class="card card-timeline" ng-if="order.timeline"><div class="item item-divider">History</div><div order-timeline class="item"></div></div></div><div class="col col-25 view-order-details"><div class="card-destination"><order-leaflet-map ng-if="order && !order.isPickupOrder() && ViewOrderCtrl.restaurant.info" order="order"></order-leaflet-map><div class="is-oozo-order" ng-show="ViewOrderCtrl.utilities.orders.isOozo(order)">Out of Zone Order</div><div class="is-pickup-order" ng-show="order.isPickupOrder()"><span class="fa fa-shopping-basket">&nbsp;Takeout order</span></div><h4 ng-if="!order.isPickupOrder()">Address</h4><h5 ng-if="!order.isPickupOrder()"><span ng-bind="order.address.address_1"></span> <span ng-if="order.address.address_2">, </span><span ng-bind="order.address.address_2"></span></h5><h4>Phone</h4><h5 ng-bind="order.diner.phone_number | formatPhoneNumber"></h5></div><div class="card-payment-details"><div ng-if="order.source && order.source !== \'Zoomer\'"><h4>Source</h4><div class="has-action"><a class="order-action view-receipt" ng-if="order.email_order_id" ng-click="ViewOrderCtrl.orderSourceModal.show(order.email_order_id)">View</a><h5 ng-bind="order.source"></h5></div></div><h4>Payment method</h4><h5 ng-switch="order.payment_method"><span ng-switch-when="cash">Cash</span> <span ng-switch-when="credit_card">Credit card</span> <span ng-switch-when="prepaid">Online / prepaid</span></h5><div ng-show="order.driver_iou"><h4 class="red">IOU</h4><div class="has-action"><span class="order-action remove-iou" ng-click="ViewOrderCtrl.removeIou(order)">Remove IOU</span><h5 ng-bind="order.driver_iou | currency"></h5></div></div><div class="text-center" ng-if="ViewOrderCtrl.loadingReceipt"><i class="fa fa-spin fa-refresh"></i></div><div ng-if="!ViewOrderCtrl.loadingReceipt && !ViewOrderCtrl.hasError && order.status === \'delivered\' && order.payment_method !== \'cash\'"><h4>Tip</h4><div class="has-action"><h5 ng-bind="selectedReceipt.tip | formatTipAmount"></h5></div><h4>Closed out?</h4><div class="has-action" ng-if="selectedReceipt.status === \'open_check\'"><h5>No</h5></div><div class="has-action" ng-if="selectedReceipt.status === \'closed_check\'"><h5>Yes</h5></div></div></div></div></div></z-ion-content></ion-view>');
$templateCache.put('app/views/popovers/oozo-popover-options.html','<div class="z-oozo-order-options-wrapper" ng-click-delay="0" ng-click="$ctrl.toggleOozoOptions()"><a ng-href=""><i class="fa fa-ellipsis-v"></i></a><div ng-cloak ng-show="$ctrl.showOozoOrderOptions"><div class="z-oozo-order-options-backdrop"></div><div class="z-oozo-order-options"><a mix-panel="oozo-view-on-map" mix-panel-data="order" ng-click="$ctrl.showOozoMapModal()" ng-href=""><i class="fa fa-map-marker"></i>View on map </a><a mix-panel="oozo-send-for-review" mix-panel-data="order" ng-click="$ctrl.confirmSendForReview()" ng-if="!$root.restaurant.isServiceHalted()" ng-href=""><i class="fa fa-paper-plane"></i> Send for review </a><em>Disagree that this order is out of zone? Request a review.</em></div></div></div>');
$templateCache.put('app/views/popovers/oozo-tooltip.html','<ion-popover-view class="z-popover z-popover-order-tooltip"><ion-content scroll="false" ng-click="$ctrl.openModal()"><p>What\'s This?</p></ion-content></ion-popover-view>');
$templateCache.put('app/views/popovers/order-tooltip.html','<ion-popover-view class="z-popover z-popover-order-tooltip"><ion-content scroll="false"><p ng-bind="$ctrl.tooltipText"></p></ion-content></ion-popover-view>');
$templateCache.put('app/views/popups/oozo-confirm-approved.html','<p>Order #{{oozo.order_id}} for delivery to<br><strong>{{oozo.address.address_1}}, {{oozo.address.address_2}}, {{oozo.address.city}}, {{oozo.address.state_province_region}}</strong><br>was approved by EatStreet Support.<br>Please confirm the details and place the order.</p>');
$templateCache.put('app/views/popups/oozo-confirm-rejected.html','<p>Order #{{oozo.order_id}} for delivery to<br><strong>{{oozo.address.address_1}}, {{oozo.address.address_2}}, {{oozo.address.city}}, {{oozo.address.state_province_region}}</strong><br>was reviewed by EatStreet Support and deemed to be <strong>outside</strong> the agreed deliver zone.</p>');
$templateCache.put('app/views/receipts/index.html','<form ion-view name="receiptsForm" ng-submit="ReceiptsCtrl.closeAllSelectedReceipts()" view-title="Receipts" class="view-receipts"><root-nav-bar></root-nav-bar><div class="bar bar-subheader bar-receipts" ng-class="{ \'is-loading\': ReceiptsCtrl.loading }"><div class="filter-payment-types"><a ng-href="" ng-class="{ selected: ReceiptsCtrl.type === \'prepaid\' }" ng-click="ReceiptsCtrl.show(\'prepaid\')">Online</a></div><div class="row row-center other-options"><div class="col col-filter-type filter-receipt-status"><a ng-href="" ng-class="{ selected: ReceiptsCtrl.showOpen }" ng-click="ReceiptsCtrl.toggleOpen(true)">Open </a><a ng-href="" ng-class="{ selected: !ReceiptsCtrl.showOpen }" ng-click="ReceiptsCtrl.toggleOpen()">Closed</a></div><date-range-filter show-all="true" iso-week="true" class="col col-history-period text-right"></date-range-filter></div></div><z-ion-content z-desktop-infinite-scroll="ReceiptsCtrl.nextPage()" z-has-sub-header="true"><input ng-model="ReceiptsCtrl.selectedReceipts" class="ng-hide" name="selectedReceipts" required><h6 ng-if="ReceiptsCtrl.receipts.length">Showing: <span ng-bind="ReceiptsCtrl.receipts.length"></span> of <span ng-bind="ReceiptsCtrl.totalReceipts"></span> orders</h6><ion-list class="receipts-table" ng-show="ReceiptsCtrl.receipts.length > 0"><div class="row header"><label class="col col-5" ng-if="ReceiptsCtrl.showOpen"><input name="selectAllReceipts" type="checkbox" ng-model="ReceiptsCtrl.selectAllReceipts" ng-change="ReceiptsCtrl.toggleAllSelectedReceipts()"></label><div class="col col-order-id">Order ID</div><div class="col col-20">Address</div><div class="col col-22">Ordered</div><div class="col col-15">Driver</div><div class="col">Tip<div class="total-tips" ng-switch="ReceiptsCtrl.type"><div ng-switch-when="credit_card">Credit Card Tips:</div><div ng-switch-when="prepaid">Prepaid Tips:</div>Total: <strong ng-bind="ReceiptsCtrl.totalTips | formatTipAmount"></strong></div></div></div><ion-item ng-repeat="receipt in ReceiptsCtrl.receipts track by receipt.id" ng-class="{ removed: !!receipt.removed }"><div class="row"><label class="col col-5" ng-if="ReceiptsCtrl.showOpen"><input type="checkbox" ng-model="receipt.selected" ng-change="ReceiptsCtrl.onReceiptToggled()"></label><div class="col col-order-id"><div>Z-{{receipt.order_id}}</div><span order-internal-id="receipt"></span></div><div class="col col-20"><span ng-bind="receipt.address.address_1"></span></div><div class="col col-22"><span ng-bind="receipt.created_at | date:\'MMM d yyyy hh:mm a\'"></span></div><div class="col col-15"><assigned-driver driver="receipt.driver"></assigned-driver></div><div class="col col-10"><span ng-bind="receipt.tip | formatTipAmount"></span></div><div class="col col-button"><i class="fa" ng-class="{ \'fa-exclamation-circle\': receipt.receipt_dispute.status === \'in_dispute\', \'fa-check-circle\': receipt.receipt_dispute.status === \'resolved\' }" ng-if="receipt.isDisputeEnabled() && receipt.receipt_dispute"></i> <a class="button button-positive" ng-href="" ng-if="receipt.status === \'open_check\'" ng-click="ReceiptsCtrl.viewModal(receipt)">View</a> <span ng-if="receipt.status === \'closed_check\'"><a class="button button-clear" ng-click="ReceiptsCtrl.viewModal(receipt)"><i class="fa fa-picture-o"></i> </a><a class="button button-positive" ng-href="" ng-click="ReceiptsCtrl.reOpenReceipt(receipt)">Re-open</a></span></div></div></ion-item></ion-list><div class="no-items no-receipts" ng-if="!ReceiptsCtrl.loading && !ReceiptsCtrl.receipts.length"><span class="no-items-icon"></span><p>No receipts found</p></div><div class="row loading" ng-if="ReceiptsCtrl.loading" ng-class="{ \'no-items\': !ReceiptsCtrl.receipts.length }"><div class="col text-center"><i class="fa fa-refresh fa-spin"></i></div></div><ion-infinite-scroll class="infinite-scroll-spinner" ng-if="isMobileDevice" distance="15%" immediate-check="false" on-infinite="ReceiptsCtrl.nextPage()"></ion-infinite-scroll></z-ion-content></form>');
$templateCache.put('app/views/settings/index.html','<div ion-view view-title="Settings"><root-nav-bar></root-nav-bar><z-ion-content><div class="settings-table" ng-if="SettingsCtrl.shouldShowThermalPrinterSettings()"><div class="card"><div class="row row-center"><label class="toggle toggle-positive"><input type="checkbox" ng-model="printEnabled" ng-change="SettingsCtrl.onPrintToggled()"><div class="track"><div class="handle"></div></div></label><h5>Allow Receipt Printing</h5><div class="receipt-selector"><span>Number of copies to auto-print<br>after selecting RBT </span><span class="selector-container"><a ng-click="(defaultNumberOfReceipts <= 1 || !printEnabled) || SettingsCtrl.subtractDefaultNumber()"><i ng-class="{ disabled: defaultNumberOfReceipts <= 1 || !printEnabled }" class="ion-minus receipt-selector-modifier"></i> </a><span class="number-of-receipts">{{ defaultNumberOfReceipts }}</span> <a ng-click="(defaultNumberOfReceipts >= 5 || !printEnabled) || SettingsCtrl.addDefaultNumber()"><i ng-class="{ disabled: defaultNumberOfReceipts >= 5 || !printEnabled }" class="ion-plus receipt-selector-modifier"></i></a></span></div></div></div><div class="card margin-bottom-40"><div class="row row-center"><i class="ion-information-circled"></i> <span class="text-italic">Currently supports the Star TSP100III and TSP143IIIU line of printers</span></div></div><h4 class="available-printers-header">Available Printers</h4><ion-spinner class="col col-center text-center" icon="ios" ng-if="loading"></ion-spinner><div ng-if="!loading && availablePrinters.length < 1" class="card">No printers found. Check that they\'re on and connected to your network or via Bluetooth</div><ion-list><ion-item class="card item item--printer" ng-repeat="printer in availablePrinters track by printer.portName"><div class="row row-center"><div class="col-40"><span>{{ printer.modelName }}</span></div><div class="col-40"><span ng-if="SettingsCtrl.isDefault(printer) && printEnabled"><i class="icon ion-checkmark-circled"></i> Connected</span> <span ng-if="!SettingsCtrl.isDefault(printer) || !printEnabled"><i class="icon ion-close-circled"></i> Not Connected</span></div><div class="col-20"><a ng-href="" class="button button-dark button-outline pull-right" ng-class="{ disabled: !printEnabled }" ng-if="!SettingsCtrl.isDefault(printer)" ng-click="SettingsCtrl.setDefault(printer)">Connect </a><a ng-href="" class="button button-dark icon-left ion-printer pull-right" ng-class="{ disabled: !printEnabled }" ng-if="SettingsCtrl.isDefault(printer)" ng-click="SettingsCtrl.testPrint()">Test</a></div></div></ion-item></ion-list></div><div class="settings-table" ng-if="!SettingsCtrl.shouldShowThermalPrinterSettings()"><h4>Thermal Printing</h4><div class="card"><div class="row row-center"><div class="col-10 print-not-enabled-container"><i class="ion-printer"></i></div><span><h5>Thermal printing is now available through EatStreet</h5>Please reach out to your rep for more information on how you can get thermal printing set up in your restaurant!</span></div></div></div></z-ion-content></div>');
$templateCache.put('app/support/states/helpDocs/address.html','<h2>The address finder isn\'t working.</h2><p>Let\'s make sure the wifi connection is working. First, toggle the Airplane Mode setting on/off.</p><p>If your wifi is still not working, please go into the Settings App and turn the wifi connection OFF. The iPad will automatically connect to Verizon LTE.</p><p>Retry the address now.</p><h2>I\'m unable to find the diner\'s address.</h2><p>Use Google Maps to find confirm the correct address, then enter that address into the app.</p><h2>I\'m still having address problems.</h2><p>Please try using our web version: . <a ng-href="" ng-click="$ctrl.openWebAppInBrowser()">www.zoomer-restaurants.eatstreet.com</a></p><p>If you\'ve tried the steps above and you\'re still having problems, call EatStreet and we\'ll gladly walk you through the process to enter a diner\'s address.</p>');
$templateCache.put('app/support/states/helpDocs/charging.html','<h2>My iPad\'s battery continues to drain or the iPad won\'t turn on, even when it\'s plugged in.</h2><p>Check to see if your iPad is plugged into a dedicated outlet with the provided charger and cable.</p><p>If you\'ve already done this and your iPad will not charge, then contact EatStreet and we\'ll have a new charger delivered to you.</p><h2>The charging block becomes hot.</h2><p>It\'s common for the charging block to be hot, since the iPad is constantly plugged in, but you shouldn\'t worry unless your iPad is not charging. Be sure to keep the charging block away from flammable materials.</p>');
$templateCache.put('app/support/states/helpDocs/password.html','<h2>I\'m being asked to sign in with an Apple ID or enter a passcode.</h2><p>EatStreet does not set up an Apple ID or passcode on our iPads. By default, everything should be unlocked.</p><p>If you are ever prompted to enter an Apple ID, you can bypass it by tapping "Cancel".</p><p>If you\'ve set up an Apple ID or passcode and cannot remember it, contact EatStreet and we\'ll reset the iPad for you.</p>');
$templateCache.put('app/views/orders/list/delivered.html','<ion-list class="card-wrapper"><header ng-if="vm.ordersQueue.delivered.$all.length"><div class="row"><div class="col col-15">ID</div><div class="col col-25">Customer</div><div class="col col-15">Picked up</div><div class="col col-15">Dropped off</div><div class="col col-15">Driver</div><div class="col">&nbsp;</div></div></header><ion-item class="card" ng-repeat="order in vm.ordersQueue.delivered.$all | sortOrders:\'dropped_off_at\':true track by order.id"><div class="row row-center"><div class="col col-15"><div class="z-order-id">Z-{{order.id}}</div><span order-internal-id="order"></span></div><div class="col col-25 col-address"><div ng-if="!order.isPickupOrder()"><span ng-bind="order.address.address_1"></span> <span ng-if="order.address.address_2">,</span> <span ng-bind="order.address.address_2"></span></div><div ng-if="order.isPickupOrder()"><span ng-bind="order.diner.phone_number"></span></div></div><div ng-if="!order.isPickupOrder()" class="col col-15"><span ng-bind="order.picked_up_at | date:\'h:mm a\'"></span></div><div ng-if="order.isPickupOrder()" class="col col-15"><span ng-bind="order.pickup_order_dismissed_at | date:\'h:mm a\'"></span></div><div class="col col-15"><span ng-bind="order.dropped_off_at | date:\'h:mm a\'"></span></div><div class="col col-15" ng-if="!order.isPickupOrder()"><assigned-driver driver="order.driver_assigned"></assigned-driver></div><div class="col col-15" ng-if="order.isPickupOrder()"><i class="fa fa-shopping-basket"></i> <span>Takeout order</span></div><div class="col"><orders-queue-info-icons order="order"></orders-queue-info-icons></div></div></ion-item><p class="see-more" ng-show="!vm.ordersQueue.delivered.loading && vm.ordersQueue.delivered.$all.length">Want to see more than the last 30 minutes? Check out the <a menu-close ng-href="#/app/history">order history</a></p></ion-list><div class="no-items no-orders" ng-if="!vm.ordersQueue.delivered.loading && !vm.ordersQueue.delivered.$all.length"><span class="no-items-icon"></span><p>No recently delivered orders</p></div><div class="row row-center row-loading" ng-if="vm.ordersQueue.delivered.loading"><ion-spinner class="col col-center text-center" icon="ios"></ion-spinner></div>');
$templateCache.put('app/views/orders/list/inProgress.html','<ion-list class="card-wrapper orders-in-progress"><header ng-if="vm.ordersQueue.inProgress.$all.length"><div class="row"><div class="col col-22">Address</div><div class="col col-17">Phone Number</div><div class="col col-10">Picked up</div><div class="col col-20" ng-if="features.checkEnabled(\'show_eta_in_restaurant_app\')">ETA</div><div class="col col-driver-assigned">Driver</div><div class="col">&nbsp;</div></div></header><ion-item class="card" ng-repeat="order in vm.ordersQueue.inProgress.$all | sortOrders track by order.id"><div class="row row-center"><div class="col col-22 col-address"><div><span ng-bind="order.address.address_1"></span> <span ng-if="order.address.address_2">,</span> <span ng-bind="order.address.address_2"></span></div><em>#Z-{{order.id}}</em> <span order-internal-id="order"></span></div><div class="col col-17"><span ng-bind="order.diner.phone_number | formatPhoneNumber"></span></div><div class="col col-10"><span ng-bind="order.picked_up_at | date:\'h:mm a\'"></span></div><div class="col col-20" ng-if="features.checkEnabled(\'show_eta_in_restaurant_app\')"><div ng-if="order.estimated_time_of_arrival">{{order.estimated_time_of_arrival_from | date:\'shortTime\'}} - {{order.estimated_time_of_arrival_to | date:\'shortTime\'}}</div></div><div class="col col-driver-assigned"><assigned-driver driver="order.driver_assigned"></assigned-driver></div><div class="col"><orders-queue-info-icons order="order"></orders-queue-info-icons></div></div></ion-item></ion-list><div class="no-items no-orders" ng-if="!vm.ordersQueue.inProgress.loading && !vm.ordersQueue.inProgress.$all.length"><span class="no-items-icon"></span><p>No orders on their way</p></div><div class="row row-center row-loading" ng-if="vm.ordersQueue.inProgress.loading"><ion-spinner class="col col-center text-center" icon="ios"></ion-spinner></div>');
$templateCache.put('app/views/orders/list/oozoForReview.html','<ion-list class="card-wrapper"><header ng-if="vm.ordersQueue.ordersForReview.$all.length"><div class="row"><div class="col col-15">ID</div><div class="col col-30">Address</div><div class="col col-15">Ordered</div><div class="col col-15">Status</div><div class="col">&nbsp;</div></div></header><ion-item class="card" ng-repeat="order in vm.ordersQueue.ordersForReview.$all | sortOrders track by order.id"><div class="row row-center"><div class="col col-15"><div class="z-order-id">Z-{{order.id}}</div><span order-internal-id="order"></span></div><div class="col col-30 col-address"><div><span ng-bind="order.address.address_1"></span> <span ng-if="order.address.address_2">,</span> <span ng-bind="order.address.address_2"></span></div><em>#{{order.id}}</em></div><div class="col col-15"><span ng-bind="order.created_at | date:\'h:mm a\'"></span></div><div class="col col-15">Under Review</div><div class="col"><orders-queue-info-icons order="order"></orders-queue-info-icons></div></div></ion-item></ion-list><div class="no-items no-orders" ng-if="!vm.ordersQueue.ordersForReview.loading && !vm.ordersQueue.ordersForReview.$all.length"><span class="no-items-icon"></span><p>No orders for review</p></div><div class="row row-center row-loading" ng-if="vm.ordersQueue.ordersForReview.loading"><ion-spinner class="col col-center text-center" icon="ios"></ion-spinner></div>');
$templateCache.put('app/views/orders/list/queue.html','<ion-list class="card-wrapper"><header ng-if="vm.ordersQueue.pending.$all.length"><div class="row"><div class="col col-15">ID</div><div class="col col-25">Customer</div><div class="col col-20">Ready By Time</div><div class="col col-20">Driver</div><div class="col col-20">&nbsp;</div></div></header><ion-item class="card" ng-repeat="order in vm.ordersQueue.pending.$all | sortOrders track by order.id" ng-click="vm.orderPopoverMenu.show($event, order)"><div class="row row-center"><div class="col col-15"><div class="z-order-id">Z-{{order.id}}</div><div order-internal-id="order"></div></div><div class="col col-25 col-address"><div ng-if="!order.isPickupOrder()"><span ng-bind="order.address.address_1"></span> <span ng-if="order.address.address_2">,</span> <span ng-bind="order.address.address_2"></span></div><div ng-if="order.isPickupOrder()"><span ng-bind="order.diner.phone_number"></span></div></div><div class="col col-20"><span order-eta order="order"></span> <span ng-show="order.food_ready_now" class="z-order-status z-food-ready-now">Now</span></div><div class="col col-20"><div ng-if="order.driver_assigned && order.driver_assigned.id"><assigned-driver driver="order.driver_assigned"></assigned-driver><driver-order-status></driver-order-status></div><div ng-if="!order.isPickupOrder() && order.isAssigningSoon()" class="assigning">Assigning</div><div ng-if="order.isPickupOrder()"><i class="fa fa-shopping-basket"></i> <span>Takeout order</span></div></div><div class="col col-20"><orders-queue-info-icons order="order"></orders-queue-info-icons></div></div><div ng-if="vm.ThermalPrinter.orderIdInProgress === order.remote_reference"><div class="print-row"><span><ion-spinner icon="ios"></ion-spinner></span><span class="print-in-progress-text">Printing</span></div></div><div class="print-row" ng-if="vm.ThermalPrinter.getPrintErrorMessage(order.remote_reference)"><span>Order failed to print</span> <span class="print-error-button"><a class="button button-positive" ng-click="vm.ThermalPrinter.printOrder(order, vm.restaurant.info)">Print</a></span></div></ion-item></ion-list><no-pending-orders-dashboard ng-if="!vm.ordersQueue.pending.loading && !vm.ordersQueue.pending.$all.length"></no-pending-orders-dashboard><div class="row row-center row-loading" ng-if="vm.ordersQueue.pending.loading"><ion-spinner class="col col-center text-center" icon="ios"></ion-spinner></div>');
$templateCache.put('app/views/orders/list/returning.html','<ion-list class="card-wrapper"><header ng-if="DropoffsCtrl.ordersQueue.returning.$all.length"><div class="row"><div class="col col-15">ID</div><div class="col col-25">Customer</div><div class="col col-20">Dropoff ETA</div><div class="col col-20">Driver</div><div class="col col-20">&nbsp;</div></div></header><ion-item class="card" ng-repeat="order in DropoffsCtrl.ordersQueue.returning.$all | sortOrders track by order.id"><div class="row row-center"><div class="col col-15"><div class="z-order-id">Z-{{order.id}}</div><div order-internal-id="order"></div></div><div class="col col-25 col-address"><div><span ng-bind="order.address.address_1"></span> <span ng-if="order.address.address_2">,</span> <span ng-bind="order.address.address_2"></span></div></div><div class="col col-20"><span><span ng-if="order.status === \'return_in_progress\'">Driver en route</span> <span ng-if="order.status === \'merchant_confirming_return\'">Returned ({{order.ready_by_time|date:\'h:mm a\'}})</span></span></div><div class="col col-15"><div ng-if="order.driver_assigned && order.driver_assigned.id"><assigned-driver driver="order.driver_assigned"></assigned-driver></div><div ng-if="!order.isPickupOrder() && order.isAssigningSoon()" class="assigning">Assigning</div></div><div class="col col-20"><div class="confirm-return" ng-if="order.status === \'merchant_confirming_return\'" ng-click="DropoffsCtrl.openConfirmReturnModal(order)">confirm</div></div><div class="col col-5"><orders-queue-info-icons order="order"></orders-queue-info-icons></div></div></ion-item></ion-list><no-pending-orders-dashboard ng-if="!DropoffsCtrl.ordersQueue.returning.loading && !DropoffsCtrl.ordersQueue.returning.$all.length"></no-pending-orders-dashboard><div class="row row-center row-loading" ng-if="DropoffsCtrl.ordersQueue.returning.loading"><ion-spinner class="col col-center text-center" icon="ios"></ion-spinner></div>');
$templateCache.put('app/views/orders/list/specialOrders.html','<ion-list class="card-wrapper"><header ng-if="vm.ordersQueue.specialOrders.$all.length"><div class="row"><div class="col col-15">ID</div><div class="col col-25">Customer Address</div><div class="col col-25">Ready By Time</div><div class="col col-20">Deliver By Time</div><div class="col">&nbsp;</div></div></header><ion-item class="card" ng-repeat="order in vm.ordersQueue.specialOrders.$all | sortOrders track by order.id"><div class="row row-center"><div class="col col-15"><div class="z-order-id">Z-{{order.id}}</div><span order-internal-id="order"></span></div><div class="col col-25 col-address"><div><span ng-bind="order.address.address_1"></span> <span ng-if="order.address.address_2">,</span> <span ng-bind="order.address.address_2"></span></div></div><div class="col col-25"><span ng-bind="order.ready_by_time | date: \'MM/dd/yyyy \\\'at\\\' h:mma\'"></span> <span ng-show="order.food_ready_now" class="z-order-status z-food-ready-now">Now</span></div><div class="col col-20"><span ng-bind="order.deliver_at | date: \'MM/dd/yyyy \\\'at\\\' h:mma\'"></span></div><div class="col"><orders-queue-info-icons order="order"></orders-queue-info-icons></div></div></ion-item></ion-list><div class="no-items no-orders" ng-if="!vm.ordersQueue.specialOrders.loading && !vm.ordersQueue.specialOrders.$all.length"><span class="no-items-icon"></span><p>No scheduled orders</p></div><div class="row row-center row-loading" ng-if="vm.ordersQueue.specialOrders.loading"><ion-spinner class="col col-center text-center" icon="ios"></ion-spinner></div>');}]);